var th = Object.defineProperty;
var rh = (i, e, t) => e in i ? th(i, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : i[e] = t;
var f = (i, e, t) => (rh(i, typeof e != "symbol" ? e + "" : e, t), t);
import { Base64 as ye } from "js-base64";
import * as _e from "@peculiar/x509";
import * as er from "tssrp6a";
import * as nh from "iso-8859-15";
import * as N from "asn1js";
import { fromBER as ro } from "asn1js";
import { Certificate as no, RecipientIdentifier as xs, IssuerAndSerialNumber as _i, Attribute as bn, RecipientInfo as mc, OriginatorInfo as wc, EncryptedContentInfo as sh, SignedData as ih, ContentInfo as yc } from "pkijs";
import * as Ac from "pako";
class oh {
  /**
   *
   * @param socket Socket that is used for the transport, overrides the "onmessage" callback.
   */
  constructor(e) {
    f(this, "socket");
    f(this, "LINE_DELIMITER", [13, 10]);
    f(this, "inputBuffer", []);
    f(this, "socketClosed", !1);
    f(this, "currentPosition", 0);
    f(this, "timeout", 6e4);
    f(this, "dataWaitResolve");
    f(this, "dataWaitReject");
    f(this, "decoder");
    f(this, "onDataReceived");
    f(this, "timeoutTimer");
    this.socket = e, this.socket.onmessage = (t) => this.receiveData(t.data), this.socket.onclose = () => {
      this.socketClosed = !0, this.triggerDataWaitPromise();
    }, this.decoder = new TextDecoder();
  }
  receiveData(e) {
    this.timeoutTimer && (window.clearTimeout(this.timeoutTimer), this.timeoutTimer = void 0), e instanceof Uint8Array ? this.inputBuffer.push(e) : this.inputBuffer.push(new Uint8Array(e)), this.triggerDataWaitPromise();
  }
  triggerDataWaitPromise() {
    var e;
    this.dataWaitResolve ? (this.dataWaitResolve(), this.dataWaitResolve = void 0, this.dataWaitReject = void 0) : (e = this.onDataReceived) == null || e.call(this);
  }
  getSocket() {
    return this.socket;
  }
  /**
   * Returns the complete input buffer stored within this reader
   * @returns
   */
  readRemainingInputBuffer() {
    let e = 0;
    for (const n of this.inputBuffer)
      e += n.length;
    e -= this.currentPosition;
    const t = new Uint8Array(e);
    let r = 0;
    for (let n of this.inputBuffer)
      r == 0 && (n = n.slice(this.currentPosition)), t.set(n, r), r += n.length;
    return t;
  }
  /**
   * Sets the read timeout in ms
   * @param timeout timeout in ms
   */
  setTimeoutRead(e) {
    this.timeout = e;
  }
  waitForData(e) {
    if (this.timeoutTimer)
      throw Error("Two consumers requested not read data from Socket");
    return new Promise((t, r) => {
      this.dataWaitResolve = t, this.dataWaitReject = r, this.initTimeout(e);
    });
  }
  initTimeout(e) {
    this.timeoutTimer && (window.clearTimeout(this.timeoutTimer), this.timeoutTimer = void 0), this.timeoutTimer = setTimeout(() => {
      const t = this.socket.getState();
      t.dataToOutputBuffer > 0 && !t.closed ? this.initTimeout(e) : this.dataWaitReject && (this.dataWaitReject("Timeout ocurred while reading data."), this.dataWaitResolve = void 0, this.dataWaitReject = void 0);
    }, e);
  }
  /**
   *
   * @param condition Data will be read until the condition returns true, or we get into the timeout.
   * @returns
   */
  async readByCondition(e) {
    let t;
    for (; ; ) {
      if (this.inputBuffer.length === 0) {
        if (this.socketClosed)
          return t || new Uint8Array(0);
        if (await this.waitForData(this.timeout), this.socketClosed)
          return t || new Uint8Array(0);
      }
      const r = this.currentPosition;
      let n = !1;
      for (; this.currentPosition < this.inputBuffer[0].byteLength; ) {
        if (e(this.inputBuffer[0])) {
          n = !0;
          break;
        }
        this.currentPosition++;
      }
      let s;
      if (r === 0 && this.currentPosition >= this.inputBuffer[0].byteLength ? s = this.inputBuffer[0] : (this.currentPosition++, s = this.inputBuffer[0].slice(r, this.currentPosition)), t === void 0)
        t = s;
      else {
        const o = new Uint8Array(t.byteLength + s.byteLength);
        o.set(new Uint8Array(t)), o.set(new Uint8Array(s), t.byteLength), t = o;
      }
      if (this.currentPosition >= this.inputBuffer[0].byteLength && (this.inputBuffer.shift(), this.currentPosition = 0), n)
        return t;
    }
  }
  async readByLength(e) {
    const t = new Uint8Array(e);
    let r = 0, n = 0, s = 0;
    for (; ; ) {
      if (this.inputBuffer.length === 0 && (this.socketClosed || (await this.waitForData(this.timeout), this.socketClosed)))
        return t;
      if (n = this.inputBuffer[0].byteLength - this.currentPosition, s = Math.min(n, e - r), this.currentPosition == 0 && n === s)
        t.set(this.inputBuffer[0], r);
      else {
        const o = this.inputBuffer[0].slice(this.currentPosition, this.currentPosition + s);
        t.set(o, r);
      }
      if (r += s, this.currentPosition += s, this.currentPosition >= this.inputBuffer[0].byteLength && (this.inputBuffer.shift(), this.currentPosition = 0), r === e)
        return t;
    }
  }
  /**
   * Reads the Complete Rest of the Socket until it is closed.
   * @returns Uint8Array with the remaining data. Can be Empty.
   */
  async readUntilEnd() {
    const e = () => !1;
    return this.readByCondition(e);
  }
  /**
   * Reads Data until next of the given token.
   * @param token A byte series used as delimiter token.
   * @param excludeToken When set to true the token will not be within the result. Default ist true
   * @returns Uint8Array with the data starting from the current position until the token.
   */
  async readByToken(e, t = !0) {
    const r = new Array(e.length), n = (o) => (r.shift(), r.push(o[this.currentPosition]), this.isArrayEqual(e, r)), s = await this.readByCondition(n);
    return t ? s.slice(0, s.byteLength - e.length) : s;
  }
  /**
   * Reads Data until next of the given token.
   * @param token A byte series used as delimiter token.
   * @param excludeToken When set to true the token will not be within the result. Default ist true
   * @returns Uint8Array with the data starting from the current position until the token.
   */
  async readByTokenOrLength(e, t, r = !0) {
    const n = new Array(e.length);
    let s = 0, o = !1;
    const u = (m) => (n.shift(), n.push(m[this.currentPosition]), s++, o = this.isArrayEqual(e, n), o || s >= t), l = await this.readByCondition(u);
    return r ? { buffer: l.slice(0, l.byteLength - e.length), found: o } : { buffer: l, found: o };
  }
  /**
   * Reads Data until next of the given token.
   * @param token A byte series used as delimiter token.
   * @returns String with the data starting from the current position until the token ( the token will not be included.)
   */
  async readStringByToken(e) {
    return this.decoder.decode(await this.readByToken(e));
  }
  /**
   * Reads Data until line end and returns as string.
   * @returns String with the data starting from the current position until the end of the line ( \r\n ).
   */
  async readStringLine() {
    return this.decoder.decode(await this.readByToken(this.LINE_DELIMITER));
  }
  async readStringByLength(e) {
    return this.decoder.decode(await this.readByLength(e));
  }
  isArrayEqual(e, t) {
    if (e.length !== t.length)
      return !1;
    for (let r = 0; r < e.length; r++)
      if (e[r] !== t[r])
        return !1;
    return !0;
  }
  hasData() {
    return this.inputBuffer.length > 0;
  }
}
class fi {
  constructor(e) {
    f(this, "socketProvider");
    f(this, "socket");
    f(this, "reader");
    f(this, "timeout", 6e4);
    /**
     * set to debug HttpClient with console.log
     */
    f(this, "debugEnabled", !1);
    /**
     * Hook method for double verify a connection aber the tls connection has been established.
     * @param socket the new opened tls connection.
     */
    f(this, "onVerifyTlsConnection", async (e) => {
    });
    this.socketProvider = e;
  }
  debug(...e) {
    this.debugEnabled && console.log(...e);
  }
  getReader() {
    if (!this.reader)
      throw new Error("TLS Socket Reader is not initialized.");
    return this.reader;
  }
  /**
   * Sets the read timeout in ms
   * @param timeout timeout in ms
   */
  setTimeoutRead(e) {
    this.timeout = e, this.reader && this.reader.setTimeoutRead(this.timeout);
  }
  getSocket() {
    if (!this.socket)
      throw new Error("TLS Socket is not initialized");
    return this.socket;
  }
  /**
   * Returns a PEM string containing of the certificate chain.
   * @returns PEM string.
   */
  getTlsCertificateChain() {
    if (!this.socket)
      throw new Error("TLS Socket is not initialized");
    return this.socket.getServerCertificate();
  }
  sendCommand(e) {
    if (this.socket)
      this.socket.send(e + `\r
`);
    else
      throw new Error("Socket not initialized");
  }
  /**
   * Waits for the WASM to be loaded, then starts the connection to the WebSocket after that tries to establish a tls connections.
   * @returns a Promise that resolves after the TLS connection is established, and rejects in case of an error
   */
  async connectTlsClient() {
    return this.socket = await this.socketProvider.getSocket(), this.reader = new oh(this.socket), this.reader.setTimeoutRead(this.timeout), new Promise((e, t) => {
      this.socket ? (this.socket.onopen = () => {
        this.socket ? this.onVerifyTlsConnection(this.socket).then(e).catch(t) : t("Socket is not available, maybe concurrency issue");
      }, this.socket.onerror = (r) => t(r)) : t("Socket is not available, maybe concurrency issue");
    });
  }
}
class me {
  /**
   * Concentrates multiple buffers into one.
   * @param bufferList
   * @returns
   */
  static concat(...e) {
    let t = 0, r = 0;
    e.forEach((o) => r += o.byteLength);
    const n = new ArrayBuffer(r), s = new Uint8Array(n);
    for (const o of e)
      s.set(new Uint8Array(o), t), t += o.byteLength;
    return n;
  }
  static concatUint8(...e) {
    let t = 0, r = 0;
    e.forEach((s) => r += s.byteLength);
    const n = new Uint8Array(r);
    for (const s of e)
      n.set(s, t), t += s.byteLength;
    return n;
  }
  static splitAtEmptyLine(e) {
    return me.splitAtSubArray(e, [13, 10, 13, 10]);
  }
  static splitAtSubArray(e, t) {
    const r = me.indexOfArray(e, t), n = e.slice(0, r), s = e.slice(r + 4);
    return { first: n, second: s };
  }
  static indexOfArray(e, t) {
    for (let r = 0; r < e.length - t.length; r++)
      if (e[r] === t[0] && me.isSubArrayAtIndex(e, t, r))
        return r;
    return -1;
  }
  static isSubArrayAtIndex(e, t, r) {
    for (let n = 1; n < t.length; n++)
      if (e[r + n] !== t[n])
        return !1;
    return !0;
  }
}
const pt = new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 62, 0, 62, 0, 63, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 0, 0, 0, 0, 0, 0, 0, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 0, 0, 0, 0, 63, 0, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51]);
function ah(i) {
  i = i.replaceAll(`\r
`, "");
  const e = i.length, t = e % 4, r = t && t - 1, n = (e >> 2) * 3 + r, s = new Uint8Array(n), o = i[e - 2] === "=" ? 2 : i[e - 1] === "=" ? 1 : 0, u = e - o & 4294967292;
  let l, m = 0, y = 0;
  for (; m < u; m += 4)
    l = pt[i.charCodeAt(m)] << 18 | pt[i.charCodeAt(m + 1)] << 12 | pt[i.charCodeAt(m + 2)] << 6 | pt[i.charCodeAt(m + 3)], s[y++] = l >> 16 & 255, s[y++] = l >> 8 & 255, s[y++] = l & 255;
  return o === 1 && (l = pt[i.charCodeAt(m)] << 10 | pt[i.charCodeAt(m + 1)] << 4 | pt[i.charCodeAt(m + 2)] >> 2, s[y++] = l >> 8 & 255, s[y++] = l & 255), o === 2 && (l = pt[i.charCodeAt(m)] << 2 | pt[i.charCodeAt(m + 1)] >> 4, s[y++] = l & 255), s;
}
class vt {
  /**
   * Checks if test ist a MIME Encoded word, if so it translates it to string
   * @param text Plaintext or MIME encoded Word
   * @returns Checks if test ist a MIME Encoded word,
   * @see https://en.wikipedia.org/wiki/MIME#Encoded-Word
   */
  static translateIfEncoded(e) {
    const t = /=\?([^?]+)\?([BQ])\?([^?]+)\?=/ig, r = /(\?=)([\s\r\n]+)(=\?)/ig;
    return e = e.replaceAll(r, "$1$3"), e = e.replaceAll(t, (n, s, o, u) => (s = s.toLowerCase(), o = o.toUpperCase(), o == "Q" ? (u = u.replaceAll("_", " "), vt.decodeQuotedPrintable(u, s)) : o == "B" ? new TextDecoder(s).decode(ye.toUint8Array(u)) : "invalid encoding")), e;
  }
  // https://en.wikipedia.org/wiki/Quoted-printable
  static decodeQuotedPrintable(e, t = "utf-8") {
    if (e = e.replaceAll(/[\t\x20]$/gm, "").replaceAll(/=\r\n/gm, ""), t.toLocaleLowerCase() === "utf-8") {
      const r = e.replace(/=([a-fA-F0-9]{2})/g, (n, s) => String.fromCharCode(parseInt(s, 16)));
      return this.mergeUtf8Chars(r);
    } else {
      const r = new TextDecoder(t);
      return e.replaceAll(/=([0-9A-Fa-f]{2})/g, (n, s) => r.decode(this.hexToBytes(s)));
    }
  }
  // @see https://stackoverflow.com/questions/25816578/javascript-decode-c3-b3-quoted-printable
  static mergeUtf8Chars(e) {
    const t = [];
    let r = 0, n = 0, s = 0, o = 0, u = 0, l = 0;
    for (; r < e.length; )
      s = e.charCodeAt(r), s <= 191 ? (t[n++] = String.fromCharCode(s), r++) : s <= 223 ? (o = e.charCodeAt(r + 1), t[n++] = String.fromCharCode((s & 31) << 6 | o & 63), r += 2) : s <= 239 ? (o = e.charCodeAt(r + 1), u = e.charCodeAt(r + 2), t[n++] = String.fromCharCode((s & 15) << 12 | (o & 63) << 6 | u & 63), r += 3) : (o = e.charCodeAt(r + 1), u = e.charCodeAt(r + 2), l = e.charCodeAt(r + 3), s = (s & 7) << 18 | (o & 63) << 12 | (u & 63) << 6 | l & 63, s -= 65536, t[n++] = String.fromCharCode(55296 | s >> 10 & 1023), t[n++] = String.fromCharCode(56320 | s & 1023), r += 4);
    return t.join("");
  }
  static hexToBytes(e) {
    const t = [];
    for (let r = 0; r < e.length; r += 2)
      t.push(Number.parseInt(e.substring(r, 2), 16));
    return new Uint8Array(t);
  }
  static containsUtf(e) {
    for (let t = 0; t < e.length; t++)
      if (e.charCodeAt(t) > 127)
        return !0;
    return !1;
  }
  static encodeMimeHeaderValue(e) {
    if (this.containsUtf(e)) {
      const t = new TextEncoder(), r = 40, n = e.length;
      let s = 0, o = "";
      for (; s < n; ) {
        const u = t.encode(e.substring(s, Math.min(s + r, n)));
        s > 0 && (o += `\r
	`), o += `=?utf-8?B?${ye.fromUint8Array(u)}?=`, s += r;
      }
      return o;
    } else
      return e;
  }
}
class q {
  constructor(e, t) {
    f(this, "rawValue");
    f(this, "_name");
    this._name = e, this.rawValue = vt.translateIfEncoded(t);
  }
  getParameter(e) {
    const r = new RegExp(`;\\s+${e}="?([^";]+)"?`).exec(this.rawValue);
    if (r)
      return vt.translateIfEncoded(r[1]);
  }
  setParameter(e, t) {
    const r = new RegExp(`;\\s+${e}="?([^";]+)"?(;?)`), n = t === void 0 ? "" : `; ${e}="${t}"`;
    r.exec(this.rawValue) ? this.rawValue = this.rawValue.replace(r, n) : this.rawValue += n;
  }
  get name() {
    return this._name;
  }
  get value() {
    return this.rawValue;
  }
  toMimeString() {
    const e = this.name === "Subject" ? vt.encodeMimeHeaderValue(this.value) : this.value;
    return `${this.name}: ${e}`;
  }
}
class rr extends q {
  constructor(e) {
    super("Content-Type", e);
  }
  get boundary() {
    return this.getParameter("boundary");
  }
  set boundary(e) {
    this.setParameter("boundary", e);
  }
  get charset() {
    return this.getParameter("charset");
  }
  set charset(e) {
    this.setParameter("charset", e);
  }
}
class Gs {
  constructor(e, t) {
    f(this, "name");
    f(this, "address");
    this.name = e, this.address = t;
  }
  static parse(e) {
    const t = e.trim().match(/([^<]+)<([^>]+)>/);
    return t ? new Gs(t[1].trim(), t[2].trim()) : new Gs(void 0, e.trim());
  }
  toMimeString() {
    return this.name ? vt.encodeMimeHeaderValue(this.name) + " <" + this.address + ">" : this.address;
  }
}
class wt extends q {
  constructor(t, r) {
    super(t, r);
    f(this, "addresses");
    this.addresses = this.rawValue.split(",").map((n) => Gs.parse(n)).filter((n) => n.address !== "");
  }
  get value() {
    return this.addresses.map((t) => t.toMimeString()).join(`,\r
 `);
  }
  toMimeString() {
    return `${this.name}: ${this.value}`;
  }
}
const Rr = class Rr {
  constructor() {
    f(this, "entries", []);
  }
  static parse(e) {
    const t = new Rr(), r = e.trim().split(`\r
`);
    let n = "", s = "";
    for (const o of r)
      if (o.startsWith("	") || o.startsWith(" "))
        n += o;
      else {
        s !== "" && t.add(this.createHeader(s, n));
        const u = o.indexOf(": ");
        u !== -1 ? (s = o.substring(0, u).trim(), n = o.substring(u + 2).trim()) : (s = "", n = "");
      }
    return s !== "" && t.add(this.createHeader(s, n)), t;
  }
  static createHeader(e, t) {
    const r = e.toLocaleLowerCase();
    return r === "content-type" ? new rr(t) : Rr.MAIL_ADDR_HEADER_NAMES.indexOf(r) > -1 ? new wt(e, t) : new q(e, t);
  }
  assertHeaderType(e) {
    const t = e.name.toLocaleLowerCase().trim();
    if (t === "content-type") {
      if (e instanceof rr)
        return;
      throw new Error("content-type must be of class ContentTypeHeader", { cause: e });
    } else if (Rr.MAIL_ADDR_HEADER_NAMES.indexOf(t) > -1) {
      if (e instanceof wt)
        return;
      throw new Error("Address Headers must be of class MailAddressHeader", { cause: e });
    }
  }
  add(e) {
    this.assertHeaderType(e), this.entries.push(e);
  }
  set(e) {
    this.assertHeaderType(e), this.delete(e.name), this.add(e);
  }
  delete(e) {
    let t = this.entries.findIndex((r) => r.name === e);
    for (; t !== -1; )
      this.entries.splice(t, 1), t = this.entries.findIndex((r) => r.name === e);
  }
  /**
   * Reads the Date header of the Mail.
   * @returns Returns the Date of the Mail.
   */
  get date() {
    return new Date(this.getHeaderByNameOrFallback("Date").value);
  }
  /**
   * Reads the From header of the Mail.
   * @returns Returns the sender of the mail
   */
  get from() {
    return this.getHeaderByName("From") || new wt("From", "");
  }
  get to() {
    return this.getHeaderByName("To") || new wt("To", "");
  }
  get cc() {
    return this.getHeaderByName("Cc") || new wt("Cc", "");
  }
  get bcc() {
    return this.getHeaderByName("Bcc") || new wt("Bcc", "");
  }
  /**
   * Reads the Subject header of the Mail.
   * @returns Returns the Subject of the mail
   */
  get subject() {
    return this.getHeaderByNameOrFallback("Subject").value;
  }
  get contentType() {
    return this.getHeaderByName("Content-Type") || new rr("");
  }
  get contentTransferEncoding() {
    return this.getHeaderByNameOrFallback("Content-Transfer-Encoding").value;
  }
  /**
   *
   * @returns The Mail id within this POP3 Session.
   */
  get messageId() {
    return this.getHeaderByNameOrFallback("Message-ID").value;
  }
  /**
   * Gets header by name.
   * @param name the header Name, case sensitive
   * @returns The header entry oder undefined if not found.
   */
  getHeaderByName(e) {
    return this.entries.find((t) => t.name.toLowerCase() === e.toLowerCase());
  }
  /**
   * Gets header by name.
   * @param name the header Name, case sensitive
   * @returns The header entry oder undefined if not found.
   */
  getHeadersByName(e) {
    return this.entries.filter((t) => t.name.toLowerCase() === e.toLowerCase());
  }
  getHeaderByNameOrFallback(e) {
    const t = this.getHeaderByName(e);
    return t === void 0 ? new q(e, "") : t;
  }
  toMimeString() {
    return this.entries.length > 0 ? this.entries.map((e) => e.toMimeString()).join(`\r
`) + `\r
` : "";
  }
};
f(Rr, "MAIL_ADDR_HEADER_NAMES", ["from", "sender", "reply-to", "to", "cc", "bcc", "resent-from", "resent-sender", "resent-to", "resent-cc", "resent-bcc"]);
let Te = Rr;
class Ee {
  constructor(e) {
    f(this, "headers");
    f(this, "contentType");
    f(this, "parts", []);
    f(this, "rawContent");
    typeof e == "string" && (e.length === 0 && (e = "text/plain"), e = new rr(e)), e instanceof Te ? (this.headers = e, this.headers.contentType ? this.contentType = this.headers.contentType : this.contentType = new rr("text/plain")) : (this.headers = new Te(), this.contentType = e, this.headers.set(e));
  }
  static parse(e, t) {
    const r = new Ee(t);
    return t.contentType.value.startsWith("multipart/") ? r.parts = Ee.parseMultipart(t.contentType, e) : r.setRawContent(e), r;
  }
  static parseMultipart(e, t) {
    const r = [], n = e.boundary || "boundary", s = Array.from(new TextEncoder().encode("--" + n));
    let o = me.indexOfArray(t, s);
    for (t = t.slice(o + s.length), o = me.indexOfArray(t, s); o !== -1; ) {
      const u = t.slice(0, o);
      r.push(Ee.parsePart(u)), t = t.slice(o + s.length), o = me.indexOfArray(t, s);
    }
    return (t[0] !== 45 || t[1] !== 45) && console.log("no last boundary"), r;
  }
  static parsePart(e) {
    const { first: t, second: r } = me.splitAtEmptyLine(e), n = Te.parse(new TextDecoder().decode(t));
    return Ee.parse(r, n);
  }
  static createHtmlPart(e) {
    const t = new Ee("text/html; charset=utf-8");
    return t.setContent(e), t;
  }
  static createTextPart(e) {
    const t = new Ee("text/plain; charset=utf-8");
    return t.setContent(e), t;
  }
  static createFilePart(e, t, r) {
    const n = new Ee(t);
    n.headers.set(new q("Content-Transfer-Encoding", "base64"));
    const s = new q("Content-Disposition", "attachment");
    return s.setParameter("filename", vt.encodeMimeHeaderValue(e)), n.headers.add(s), n.setRawContent(r), n;
  }
  static createAlternativeTextHtmlPart(e, t) {
    const r = new Ee("multipart/alternative");
    return r.parts = [this.createTextPart(e), this.createHtmlPart(t)], r;
  }
  static createAlternativesPart(e) {
    const t = new Ee("multipart/alternative");
    return t.parts = e, t;
  }
  static createMixedPart(e) {
    const t = new Ee("multipart/mixed");
    return t.parts = e, t;
  }
  setContent(e) {
    this.contentType.charset = "utf-8", this.headers.set(new q("Content-Transfer-Encoding", "base64")), this.rawContent = ye.toBase64(e);
  }
  getContentDecodedBinary() {
    if (!this.rawContent)
      return;
    if (this.headers.contentTransferEncoding === "base64")
      return ah(this.rawContent);
    const e = new TextEncoder();
    let t;
    return this.headers.contentTransferEncoding === "quoted-printable" ? t = vt.decodeQuotedPrintable(this.rawContent, this.headers.contentType.charset) : t = this.rawContent, e.encode(t);
  }
  getContentDecodedString() {
    if (this.rawContent)
      return this.headers.contentTransferEncoding === "base64" ? new TextDecoder(this.contentType.charset || "utf-8").decode(ye.toUint8Array(this.rawContent)) : this.headers.contentTransferEncoding === "quoted-printable" ? vt.decodeQuotedPrintable(this.rawContent, this.headers.contentType.charset) : this.rawContent;
  }
  setRawContent(e) {
    e === void 0 ? this.rawContent = void 0 : typeof e == "string" ? this.rawContent = e : this.rawContent = new TextDecoder(this.contentType.charset || "utf-8").decode(e);
  }
  getRawContent() {
    return this.rawContent;
  }
  toMimeString() {
    let e = "";
    if (this.parts.length > 0) {
      this.headers.contentType.boundary = crypto.randomUUID().replaceAll("-", "");
      for (const r of this.parts)
        e += "--" + this.headers.contentType.boundary + `\r
`, e += r.toMimeString();
      e += "--" + this.headers.contentType.boundary + `--\r
`;
    } else
      e = this.rawContent || "";
    if (e.length === 0)
      throw console.error(this), new Error("no content");
    const t = this.headers.toMimeString() || "";
    return `${t.length > 0 ? t + `\r
` : ""}${e}\r
`;
  }
}
class Nr extends Ee {
  static parseBuffer(e) {
    const { first: t, second: r } = me.splitAtEmptyLine(e), n = Te.parse(new TextDecoder().decode(t)), s = Ee.parse(r, n);
    return new Nr(s.headers, s.parts, s.getRawContent());
  }
  constructor(e, t, r) {
    super(e), this.parts = t, this.setRawContent(r);
  }
  /**
   * Includes To, Cc & Bcc Recipients
   * @returns Complete Recipient information
   */
  getAllRecipients() {
    const e = [];
    return e.push(...this.headers.to.addresses), e.push(...this.headers.cc.addresses), e.push(...this.headers.bcc.addresses), e;
  }
  /**
   * Includes To, Cc & Bcc Recipients
   * @returns Mail Addresses of recipients
   */
  getAllRecipientMailAddresses() {
    return this.getAllRecipients().map((e) => e.address);
  }
  /**
   * Includes all To recipients
   * @returns Complete Recipient information
   */
  getRecipients() {
    return this.headers.to.addresses;
  }
}
class ch {
  constructor(e, t, r) {
    f(this, "socket");
    f(this, "reader");
    f(this, "_mailAccount");
    this.socket = e, this.reader = t, this._mailAccount = r;
  }
  get mailAccount() {
    return this._mailAccount;
  }
  /**
   * Reads a list of all Mails.
   * The resulting mails will only contain the Mail Id and the Size.
   * @returns List of Mails
   */
  async listMails() {
    this.socket.send(`LIST\r
`);
    let e = await this.reader.readStringLine();
    if (!e.startsWith("+OK"))
      throw new Error(`Error while listing emails.
` + e);
    e = await this.reader.readStringLine();
    const t = [];
    for (; e != "."; ) {
      const r = e.split(" "), n = r[0], s = Number.parseInt(r[1], 10);
      t.push(new Sc(this.socket, this.reader, n, s, void 0)), e = await this.reader.readStringLine();
    }
    return t;
  }
  /**
   * Loads a list of all mails, directly load all Mail headers.
   * @returns Lit of Mails with initialized headers.
   */
  async listMailsWithHeaders() {
    const e = await this.listMails();
    for (const t of e)
      await t.getHeaders();
    return e;
  }
  async listUids() {
    this.socket.send(`UIDL\r
`);
    let e = await this.reader.readStringLine();
    if (!e.startsWith("+OK"))
      throw new Error(`Error while listing emails.
` + e);
    e = await this.reader.readStringLine();
    const t = [];
    for (; e != "."; ) {
      const r = e.split(" "), n = r[0], s = r[1];
      t.push(new Sc(this.socket, this.reader, n, void 0, s)), e = await this.reader.readStringLine(), e.startsWith(".") && e.length > 1 && (e = e.substring(1));
    }
    return t;
  }
  /**
   * Resets all "Mail Delete" flags in the the POP3 Session.
   */
  async reset() {
    this.socket.send(`RSET\r
`);
    const e = await this.reader.readStringLine();
    if (!e.startsWith("+OK"))
      throw new Error(`Error while resetting mail session.
` + e);
  }
  /**
   * Quits the current session.
   * This command will trigger the deletion of all "To Delete" flagged messages.
   */
  async quit() {
    this.socket.send(`QUIT\r
`);
    const e = await this.reader.readStringLine();
    if (this.socket.close(), !e.startsWith("+OK"))
      throw new Error(`Error while executing the quit command.
` + e);
  }
}
class Sc {
  constructor(e, t, r, n, s) {
    f(this, "socket");
    f(this, "reader");
    f(this, "id");
    f(this, "size");
    f(this, "uid");
    f(this, "headers");
    f(this, "SERVER_MESSAGE_END_TOKEN", [13, 10, 46, 13, 10]);
    this.socket = e, this.reader = t, this.id = r, this.size = n, this.uid = s;
  }
  getId() {
    return this.id;
  }
  getUid() {
    return this.uid;
  }
  async loadUid() {
    this.socket.send("UIDL " + this.id + `\r
`);
    const e = await this.reader.readStringLine();
    if (!e.startsWith("+OK"))
      throw new Error("Error while reading size of Mail:" + this.id + `
 ` + e);
    const t = e.split(" ");
    return this.uid = t[1], this.uid;
  }
  /**
   *
   * @returns Total size of the mail in bytes.
   */
  getSize() {
    return this.size;
  }
  async loadSize() {
    this.socket.send("LIST " + this.id + `\r
`);
    const e = await this.reader.readStringLine();
    if (!e.startsWith("+OK"))
      throw new Error("Error while reading size of Mail:" + this.id + `
 ` + e);
    const t = e.split(" ");
    return this.size = Number.parseInt(t[1], 10), this.size;
  }
  /**
   * States if Headers are loaded.
   * @returns true If headers are loaded
   */
  headersLoaded() {
    return this.headers !== void 0;
  }
  /**
   * Loads the headers of the Mail.
   * @returns Promise
   */
  async getHeaders() {
    if (this.headers)
      return this.headers;
    this.headers = new Te(), this.socket.send("TOP " + this.id + ` 0\r
`);
    const e = await this.reader.readStringLine();
    if (!e.startsWith("+OK"))
      throw new Error("Error while reading Mail Header of Mail:" + this.id + `
 ` + e);
    const t = await this.reader.readStringByToken(this.SERVER_MESSAGE_END_TOKEN);
    return this.headers = Te.parse(t), this.headers;
  }
  /**
   * Marks a Mail to be deleted at the end of the session.
   * This mail will only be deleted if you call quit on the {@link Pop3Session}
   */
  async delete() {
    this.socket.send("DELE " + this.id + `\r
`);
    const e = await this.reader.readStringLine();
    if (!e.startsWith("+OK"))
      throw new Error("Error while deleting Mail:" + this.id + ` 
` + e);
  }
  /**
   * Loads the complete MIME Mail as an one ArrayBuffer.
   * @returns Array Buffer containing the whole mail.
   */
  async getMail() {
    this.socket.send("RETR " + this.id + `\r
`);
    const e = await this.reader.readStringLine();
    if (!e.startsWith("+OK"))
      throw new Error("Error while reading Mail:" + this.id + `
 ` + e);
    const t = await this.reader.readByToken(this.SERVER_MESSAGE_END_TOKEN), r = Nr.parseBuffer(new Uint8Array(t));
    return this.headers = r.headers, r;
  }
  /**
   * Loads a mail in smaller buffer chunks.
   * This buffers have all the given size, besides the last one which can be smaller.
   * @param bufferSize The max size of the data buffer in bytes.
   * @param callback Method that will be called if one data buffer is ready. The new Buffer will be delivered after it has been resolved.
   */
  async getMailSplitted(e, t) {
    this.socket.send("RETR " + this.id + `\r
`);
    const r = await this.reader.readStringLine();
    if (!r.startsWith("+OK"))
      throw new Error("Error while reading Mail:" + this.id + `
 ` + r);
    let n = !1;
    for (; !n; ) {
      const s = await this.reader.readByTokenOrLength(this.SERVER_MESSAGE_END_TOKEN, e);
      n = s.found, await t(s.buffer);
    }
  }
}
class uh extends fi {
  constructor() {
    super(...arguments);
    f(this, "lastError", "none");
  }
  /**
   * Returns the last recorded error type while establishing an POP3Session.
   * @returns
   */
  getLastError() {
    return this.lastError;
  }
  /**
   * Establishes a connection to the POP3 Server and tries to login.
   * Creates a Pop3Session if successful.
   * @param username
   * @param password
   * @returns Pop3Session
   * @throws Error if any error occur. Use {@link getLastError} to determine the source of the error.
   */
  async login(t, r) {
    try {
      if (await this.connectTlsClient(), this.reader && this.socket) {
        let n = await this.reader.readStringLine();
        if (!n.startsWith("+OK"))
          throw this.lastError = "conn", new Error(`Error while connecting to the Server, expected +OK, got:
` + n);
        if (this.sendCommand("USER " + t), n = await this.reader.readStringLine(), !n.startsWith("+OK"))
          throw this.lastError = "user", new Error(`Error while sending username to the Server, expected +OK, got:
` + n);
        if (this.sendCommand("PASS " + r), n = await this.reader.readStringLine(), !n.startsWith("+OK"))
          throw this.lastError = "pass", new Error(`Error while sending password to the Server, expected +OK, got:
` + n);
        return this.lastError = "none", new ch(this.socket, this.reader, t);
      } else
        throw this.lastError = "conn", new Error("Tls Socket or Socket reader are not initialized.");
    } catch (n) {
      throw this.socket && this.socket.close(), this.lastError === "none" && (this.lastError = "conn"), n;
    }
  }
}
class vc {
  constructor(e, t) {
    f(this, "smtpClient");
    f(this, "_mailAccount");
    f(this, "reader");
    f(this, "requestDsnTypes", []);
    this.smtpClient = e, this._mailAccount = t, this.reader = this.smtpClient.getReader();
  }
  get mailAccount() {
    return this._mailAccount;
  }
  setRequestDsnTypes(e) {
    if (e.length > 1 && e.indexOf("NEVER") > -1)
      throw new Error("NEVER must be the only DSN request type");
    this.requestDsnTypes = e;
  }
  async expectServerMessage(e) {
    if (this.reader) {
      const t = await this.reader.readStringLine();
      if (!t.startsWith(e))
        throw new Error("Error from Server expected: '" + e + `' Got:
` + t);
    }
  }
  /**
   * Sends MIME mail content within a defined delivery envelope.
   * @param sender sender of the mail envelope. Please only use the plain Mail address of the logged in user.
   * @param recipients List of all recipient of the Mail Envelope (incl. To, CC and BCC ).
   * @param mimeMessage The actual MIME content of the mail.
   * @throws Rejects promise if the server returns an unexpected status code.
   */
  async sendMessage(e, t, r) {
    this.smtpClient.sendCommand("MAIL FROM:<" + e + ">"), await this.expectServerMessage("250");
    for (const n of t) {
      let s = "";
      this.smtpClient.hasExtension("DSN") && this.requestDsnTypes.length > 0 && (s = `NOTIFY=${this.requestDsnTypes.join(",")}`), this.smtpClient.sendCommand(`RCPT TO:<${n}> ${s}`.trim()), await this.expectServerMessage("250");
    }
    this.smtpClient.sendCommand("DATA"), await this.expectServerMessage("354"), this.smtpClient.getSocket().send(r.replaceAll(`\r
.`, `\r
..`)), this.smtpClient.getSocket().send(`\r
.\r
`), await this.expectServerMessage("250");
  }
  /**
   * Quits this SMTP Session.
   */
  async quit() {
    this.smtpClient.sendCommand("QUIT"), await this.expectServerMessage("221");
  }
}
class hh extends fi {
  constructor() {
    super(...arguments);
    f(this, "lastErrorType", "none");
    f(this, "smtpExtensions", []);
  }
  async expectServerMessage(t, r) {
    if (this.reader) {
      const n = await this.reader.readStringLine();
      if (!n.startsWith(t))
        throw this.lastErrorType = r, new Error("Error from Server expected: '" + t + `' Got:
` + n);
    }
  }
  hasExtension(t) {
    return this.smtpExtensions.indexOf(t) > -1;
  }
  /**
   *
   * @returns the type of the last error
   */
  getLastErrorType() {
    return this.lastErrorType;
  }
  /**
   * Starts the connection and tries to login.
   * @param username
   * @param password
   * @returns If successful it returns an Smtp Session.
   * @throws in case of an error the promise will be rejected. For category of the error see {@see getLastErrorType}
   */
  async login(t, r) {
    try {
      return await this.connectTlsClient(), this.debug("Connection to Server established"), await this.expectServerMessage("220", "conn"), this.debug("Server Ready received"), await this.loadExtensions(), this.debug("Start authentication"), await this.authenticate(t, r), this.debug("Authentication Done"), new vc(this, t);
    } catch (n) {
      throw this.socket && this.socket.close(), this.lastErrorType === "none" && (this.lastErrorType = "conn"), n;
    }
  }
  async loginAsServer() {
    try {
      return await this.connectTlsClient(), this.debug("Connection to Server established"), await this.expectServerMessage("220", "conn"), this.debug("Server Ready received"), this.sendCommand("HELO web.smtp.tls.client"), await this.expectServerMessage("250", "support"), this.debug("Authentication Done"), new vc(this, "");
    } catch (t) {
      throw this.socket && this.socket.close(), this.lastErrorType === "none" && (this.lastErrorType = "conn"), t;
    }
  }
  /**
   * Sends EHLO command and reads the SMTP Extensions provided by the server.
   * @see https://en.wikipedia.org/wiki/Simple_Mail_Transfer_Protocol#Extensions
   */
  async loadExtensions() {
    this.sendCommand("EHLO web.smtp.tls.client "), await this.expectServerMessage("250", "support"), this.debug("Server SMTP Extensions:");
    let t = "";
    do
      if (t = await this.getReader().readStringLine(), t.startsWith("250") && (this.smtpExtensions.push(t.substr(4)), this.debug(t)), t.startsWith("250 "))
        break;
    while (t.startsWith("250"));
    if (!this.hasExtension("8BITMIME"))
      throw this.lastErrorType = "support", new Error("Server does not support 8Bit MIME.");
  }
  /**
   * Starts the authentication
   * @param username
   * @param password
   */
  async authenticate(t, r) {
    const n = this.smtpExtensions.find((s) => s.startsWith("AUTH"));
    if (n) {
      const s = n.split(" ");
      if (s.shift(), s.indexOf("LOGIN") == -1)
        throw this.lastErrorType = "support", new Error("Server requires Authentication, currently the client only supports 'LOGIN' server only supports:" + s.toString());
      this.sendCommand("AUTH LOGIN"), await this.expectServerMessage("334", "support"), this.sendCommand(btoa(t)), await this.expectServerMessage("334", "login"), this.sendCommand(btoa(r)), await this.expectServerMessage("235", "login");
    }
  }
}
class lh {
  /**
   * Creates a TLS Client over WebSocket
   */
  constructor(e, t, r, n, s) {
    f(this, "connection");
    f(this, "backendServiceRequest");
    f(this, "hostname");
    f(this, "certificateAuthorityPem");
    f(this, "options");
    f(this, "tlsWebSocketPromise");
    this.connection = e, this.backendServiceRequest = t, this.hostname = r, this.certificateAuthorityPem = n, this.options = s;
  }
  /**
   * Waits for the WASM to be loaded, then starts the connection to the WebSocket after that tries to establish a tls connections.
   * @returns a Promise that resolves after the TLS connection is established, and rejects in case of an error
   */
  async getSocket() {
    const t = await (await import("./index-imvobcLT.js")).default(), r = await this.connection.createChannel(this.backendServiceRequest);
    let n = {
      ...this.options,
      debugPrefix: "Tls " + r.channelNumber + ": "
    };
    return new t.TlsWebSocket(this.hostname, r, this.certificateAuthorityPem, n);
  }
}
class dh {
  constructor(e, t, r) {
    f(this, "channelNumber");
    f(this, "provider");
    f(this, "binaryType", "arraybuffer");
    f(this, "readyState");
    f(this, "onclose", null);
    f(this, "onerror", null);
    f(this, "onmessage", null);
    f(this, "onopen", null);
    if (this.channelNumber = e, this.provider = t, e > 127)
      throw new Error(`Channel can not exceed 127, current value: ${e}`);
    this.readyState = r;
  }
  close() {
    this.provider.close(this.channelNumber), this.readyState = WebSocket.CLOSED;
  }
  send(e) {
    this.provider.send(this.channelNumber, e);
  }
}
class ph {
  /**
   * Creates a TLS Client over WebSocket
   */
  constructor(e) {
    f(this, "websocketUrl");
    f(this, "nativeWebSocket");
    f(this, "textEncoder", new TextEncoder());
    f(this, "channels", new Array(127));
    f(this, "channelCnt", -1);
    f(this, "webSocketOpenPromise");
    f(this, "webSocketOpenResolve");
    f(this, "debugEnabled", !1);
    this.websocketUrl = e, this.webSocketOpenPromise = new Promise((t) => {
      this.webSocketOpenResolve = t;
    }), this.nativeWebSocket = new WebSocket(e), this.nativeWebSocket.binaryType = "arraybuffer", this.nativeWebSocket.addEventListener("open", (t) => this.onSocketOpen(t)), this.nativeWebSocket.addEventListener("message", (t) => this.onMessageReceived(t)), this.nativeWebSocket.addEventListener("close", (t) => this.onSocketClose(t)), this.nativeWebSocket.addEventListener("error", (t) => this.onSocketError(t));
  }
  debug(e) {
    this.debugEnabled && console.log(e);
  }
  findNextChannelNumber() {
    let e = 0;
    for (; ; ) {
      if (this.channelCnt++, e++, this.channelCnt == 127 && (this.channelCnt = 0), !this.channels[this.channelCnt])
        return this.channelCnt;
      if (e > 128)
        throw new Error("All WebSocket Channels are in use, a new can not be opened.");
    }
  }
  onSocketClose(e) {
    this.debug("WebSocket Closed");
    for (const t of this.channels)
      t && (t.readyState = this.nativeWebSocket.readyState, t != null && t.onclose && t.onclose.apply(t, [e]));
  }
  onSocketError(e) {
    this.debug("WebSocket Error");
    for (const t of this.channels)
      t && (t.readyState = this.nativeWebSocket.readyState, t != null && t.onerror && t.onerror.apply(t, [e]));
  }
  onSocketOpen(e) {
    this.debug("WebSocket Open");
    for (const t of this.channels)
      t && (t.readyState = this.nativeWebSocket.readyState, t.onopen && t.onopen.apply(t, [e]));
    this.webSocketOpenResolve && (this.webSocketOpenResolve(), this.webSocketOpenResolve = void 0);
  }
  /**
   * Allows attachment of events to the underlying WebSocket
   */
  addEventListener(e, t, r) {
    this.nativeWebSocket.addEventListener(e, t, r);
  }
  /**
   * Allows remove of events to the underlying WebSocket
   */
  removeEventListener(e, t, r) {
    this.nativeWebSocket.removeEventListener(e, t, r);
  }
  onCloseChannel(e) {
    const t = this.channels[e];
    this.channels[e] = void 0, t && (t.onclose && t.onclose.apply(t, [new CloseEvent("close")]), t.readyState = WebSocket.CLOSED);
  }
  /**
   * Is WebSocket readyState set to open
   * @returns
   */
  isAlive() {
    return this.nativeWebSocket.readyState == WebSocket.OPEN;
  }
  onMessageReceived(e) {
    var u;
    let t, r;
    if (ArrayBuffer.isView(e.data))
      t = new DataView(e.data.buffer, e.data.byteOffset, 1).getUint8(0), r = new Uint8Array(e.data.buffer, e.data.byteOffset + 1, e.data.byteLength - 1);
    else if (e.data instanceof ArrayBuffer)
      t = new DataView(e.data, 0, 1).getUint8(0), r = new Uint8Array(e.data, 1, e.data.byteLength - 1);
    else
      throw new Error(`Undetected Datatype in message ${e.toString()}`);
    const n = t > 127, s = 127 & t;
    if (n) {
      this.onCloseChannel(s), this.debug(`WebSocket channel ${s} closed by backend`);
      return;
    }
    this.debug(`WebSocket channel ${s} received data`);
    const o = this.channels[s];
    o && ((u = o.onmessage) == null || u.apply(o, [new MessageEvent("message", { data: r })]));
  }
  /**
   * Sends a binary message over a Channel
   * @param channelNumber
   * @param data
   * @returns
   */
  send(e, t) {
    if (!this.channels[e])
      return;
    this.debug(`WebSocket channel ${e} send data`);
    let r;
    ArrayBuffer.isView(t) ? r = new Uint8Array(t.buffer, t.byteOffset, t.byteLength) : r = new Uint8Array(t);
    const n = new Uint8Array(t.byteLength + 1);
    n.set([e], 0), n.set(r, 1), this.nativeWebSocket.send(n);
  }
  /**
   * Sends command to the server to close the Channel.
   * Clean
   * @param channel
   */
  close(e) {
    if (this.channels[e]) {
      const t = 128 | e;
      this.nativeWebSocket.send(new Uint8Array([t])), this.onCloseChannel(e), this.debug(`WebSocket channel ${e} closed`);
    }
  }
  /**
   * create a new channel within the WebSocket.
   * @returns
   */
  async createChannel(e) {
    await this.webSocketOpenPromise;
    const t = this.findNextChannelNumber(), r = new dh(t, this, this.nativeWebSocket.readyState);
    return this.channels[t] = r, this.debug(`WebSocket channel ${t} opened`), this.send(t, this.textEncoder.encode(JSON.stringify(e))), r;
  }
  /**
   * Creates a TlsSocket Provider to an specific Service behind the WebSocketGateway.
   * @param backendServiceRequest Identify the Service name, so that the WebSocketGateway can init the route.
   * @param tlsHostname
   * @param tlsCertificateAuthorityPem
   * @param tlsOptions
   * @returns
   */
  getSocketProvider(e, t, r, n) {
    return new lh(this, e, t, r, n);
  }
}
class Gw {
  /**
   * Creates a TLS Client over WebSocket
   */
  constructor(e, t, r, n) {
    f(this, "hostname");
    f(this, "websocketUrl");
    f(this, "certificateAuthorityPem");
    f(this, "options");
    this.hostname = e, this.websocketUrl = t, this.certificateAuthorityPem = r, this.options = n;
  }
  /**
   * Waits for the WASM to be loaded, then starts the connection to the WebSocket after that tries to establish a tls connections.
   * @returns a Promise that resolves after the TLS connection is established, and rejects in case of an error
   */
  async getSocket() {
    const t = await (await import("./index-imvobcLT.js")).default(), r = new WebSocket(this.websocketUrl);
    return new t.TlsWebSocket(this.hostname, r, this.certificateAuthorityPem, this.options);
  }
}
const de = {
  filterOpCodes: 127,
  text: 1,
  binary: 2,
  close: 8,
  ping: 9,
  pong: 10
};
class gh {
  /**
   *
   * @param reader Takes over the Socket from this reader and discards the data
   * @param debugEnabled
   */
  constructor(e, t) {
    f(this, "debugEnabled");
    f(this, "socket");
    f(this, "onclose", null);
    f(this, "onerror", null);
    f(this, "onmessage", null);
    f(this, "onopen", null);
    f(this, "binaryType", "arraybuffer");
    f(this, "readyState", WebSocket.OPEN);
    if (this.debugEnabled = t, this.socket = e.getSocket(), this.socket.onmessage = (r) => this._receiveMessage(r.data), this.socket.onerror = (r) => this._handleError(r), e.hasData()) {
      const r = e.readRemainingInputBuffer();
      r.length > 0 && this._receiveMessage(r);
    }
  }
  _handleError(e) {
    this.onerror && this.onerror(new ErrorEvent("error", { error: e }));
  }
  debug(...e) {
    this.debugEnabled && console.debug("TunneledWebSocket", ...e);
  }
  _receiveMessage(e) {
    let t;
    e instanceof Uint8Array ? t = new DataView(e.buffer) : t = new DataView(e), this.debug("received Bytes:", t.byteLength);
    let r = 0, n = t.getInt8(r);
    if (!((n & 128) === 128))
      throw this.debug("received a multi frame message, these are not supported"), new Error("multi frame message not supported");
    const o = this.getOpCodes(n);
    r++, n = t.getInt8(r);
    const u = (n & 128) === 128;
    let l = n & 127;
    r++, l === 126 ? (l = t.getInt16(r), r += 2) : l === 127 && (l = Number(t.getBigUint64(r)), r += 8), this.debug("payload length:", l, "opCodes:", o);
    const m = new Uint8Array(4);
    if (u) {
      for (let A = 0; A <= 4; A++)
        m[A] = t.getUint8(r + A);
      r += 4;
    }
    const y = t.buffer.slice(r, r + l);
    if (u && this.unmaskData(y, m), o.text && this.debug(new TextDecoder().decode(y), y), o.ping) {
      this._send(y, { pong: !0 });
      return;
    }
    if (o.close) {
      this._closeReceived(y);
      return;
    }
    this.callOnMessage(y);
  }
  callOnMessage(e, t = 0) {
    this.onmessage ? this.binaryType === "blob" ? this.onmessage(new MessageEvent("message", { data: new Blob([e]) })) : this.onmessage(new MessageEvent("message", { data: e })) : t < 10 && (setTimeout(() => this.callOnMessage(e, t++), 1), console.warn(`received data without an registered on message event handler. Retry: ${t}`));
  }
  _closeReceived(e) {
    if (this.debug("close requested by server"), this.onclose) {
      let t;
      e.byteLength >= 2 && (t = new DataView(e, 0, 2).getUint16(0));
      let r;
      e.byteLength > 2 && (r = new TextDecoder().decode(e.slice(2))), this.onclose(new CloseEvent("close", { reason: r, code: t }));
    }
    this.socket.close();
  }
  close(e, t) {
    this.debug("close request by client");
    const r = [];
    if (e !== void 0) {
      const n = new Uint16Array(1);
      n[e] = e, r.push(n);
    }
    t && r.push(new TextEncoder().encode(t)), this._send(me.concat(...r), { close: !0 }), window.setTimeout(() => this.socket.close(), 100);
  }
  getOpCodes(e) {
    return e &= de.filterOpCodes, {
      text: (e & de.text) === de.text,
      binary: (e & de.binary) === de.binary,
      close: (e & de.close) === de.close,
      ping: (e & de.ping) === de.ping,
      pong: (e & de.pong) === de.pong
    };
  }
  setOpCode(e) {
    let t = 0;
    return e.text ? t |= de.text : t |= de.binary, e.close && (t |= de.close), e.ping && (t |= de.ping), e.pong && (t |= de.pong), t;
  }
  send(e) {
    let t;
    const r = {};
    typeof e == "string" ? (t = new TextEncoder().encode(e), r.text = !0) : (t = e, r.binary = !0), this._send(t, r);
  }
  _send(e, t) {
    const r = e.byteLength;
    let n = 10;
    r <= 125 ? n = 2 : r <= 65536 && (n = 4);
    const s = new Uint8Array(n);
    s[0] = 128, s[0] |= this.setOpCode(t), s[1] = 128, r <= 125 ? s[1] |= 127 & r : r <= 65536 ? (s[1] |= 126, new DataView(s.buffer, 2).setUint16(0, r)) : (s[1] |= 127, new DataView(s.buffer, 2).setBigUint64(0, BigInt(r)));
    const o = window.crypto.getRandomValues(new Uint8Array(4)), u = this.maskData(e, o);
    this.debug("send opcode", t, "length:", r), this.socket.send(me.concat(s, o, u));
  }
  maskData(e, t) {
    const r = new Uint8Array(e.byteLength);
    for (let n = 0; n < e.byteLength; n++)
      r[n] = e[n] ^ t[n & 3];
    return r;
  }
  unmaskData(e, t) {
    for (let r = 0; r < e.byteLength; r++)
      e[r] ^= t[r & 3];
  }
}
class xr {
  constructor() {
    f(this, "httpVersion", "");
    f(this, "statusCode", 0);
    f(this, "statusText", "");
    f(this, "headers", []);
    f(this, "data");
  }
  static async readResponseHeader(e) {
    const t = new xr();
    t.httpVersion = await e.readStringByToken([32]);
    const r = await e.readStringByToken([32]);
    for (t.statusCode = Number.parseInt(r, 10), Number.isNaN(t.statusCode) && console.warn("Http Response contains wrong Status Code:", r), t.statusText = await e.readStringLine(); ; ) {
      const n = await e.readStringLine();
      if (n.length == 0)
        break;
      const s = n.indexOf(":"), o = new Ae(n.substring(0, s), n.substring(s + 2));
      t.headers.push(o);
    }
    return t;
  }
  static async createByData(e) {
    const t = e.getReader(), r = await this.readResponseHeader(t), n = r.headers.find((o) => o.name === "Content-Length"), s = r.headers.find((o) => o.name === "Transfer-Encoding");
    if (e.debug("Response Headers:", r), n) {
      const o = Number.parseInt(n.value, 10);
      isNaN(o) || (r.data = await t.readByLength(o));
    } else if ((s == null ? void 0 : s.value) === "chunked") {
      const o = [];
      for (; ; ) {
        const u = await t.readStringLine(), l = Number.parseInt(u, 16);
        if (l <= 0 || isNaN(l))
          break;
        o.push(await t.readByLength(l)), await t.readByLength(2);
      }
      r.data = me.concatUint8(...o);
    } else
      r.data = await t.readUntilEnd();
    return r;
  }
}
class Ae {
  constructor(e, t) {
    f(this, "name");
    f(this, "value");
    this.name = e, this.value = t;
  }
}
class Qs extends fi {
  /**
   * Creates a TLS Client over WebSocket
   * @param hostname Hostname HttpHeader
   * @param tlsSocketProvider A Class that can Create an TlsWebSocket to the correct target.
   */
  constructor(t, r) {
    super(r);
    f(this, "hostname");
    f(this, "requestPending", !1);
    f(this, "headers", []);
    this.hostname = t, this.initClient();
  }
  initClient() {
    this.addHeader("Host", this.hostname), this.addHeader("User-Agent", "Yoshteq Browser Https Client 1.0.0"), this.addHeader("Connection", "close");
  }
  setHeader(t, r) {
    const n = this.headers.find((s) => s.name.toLowerCase() === t.toLowerCase());
    n ? n.value = r : this.headers.push(new Ae(t, r));
  }
  addHeader(t, r) {
    this.headers.push(new Ae(t, r));
  }
  getHeaders() {
    return this.headers;
  }
  removeHeader(t) {
    this.headers = this.headers.filter((r) => r.name !== t);
  }
  /**
   * Try to establish an Websocket connection threw the tls connection.
   * @param path Webserver path
   * @param protocols optional list of protocols for this socket.
   * @returns
   */
  async webSocket(t, r) {
    var n;
    if (this.requestPending)
      throw new Error("Please await pending Request before sending a new one.");
    this.requestPending = !0;
    try {
      if (await this.connectTlsClient(), !this.socket || !this.reader)
        throw new Error("Socket is not initialized.");
      let s = this.headers.slice();
      s = s.filter((y) => y.name !== "Connection"), s.push(new Ae("Connection", "Upgrade")), s.push(new Ae("Upgrade", "websocket"));
      const o = window.crypto.getRandomValues(new Uint8Array(16)), u = btoa(String.fromCharCode(...o));
      s.push(new Ae("Sec-WebSocket-Key", u)), s.push(new Ae("Sec-WebSocket-Version", "13")), r && s.push(new Ae("Sec-WebSocket-Protocol", r.join(", ")));
      const l = Qs.getHttpRequestString("GET", t, s);
      this.debug(l), this.socket.send(l);
      const m = await xr.readResponseHeader(this.reader);
      if (this.debug("Websocket response header:", m), m.statusCode === 101) {
        const y = new gh(this.reader, this.debugEnabled), A = (n = m.headers.find((w) => w.name === "Sec-WebSocket-Accept")) == null ? void 0 : n.value, P = new TextEncoder().encode(u + "258EAFA5-E914-47DA-95CA-C5AB0DC85B11"), M = new Uint8Array(await crypto.subtle.digest("SHA-1", P)), p = btoa(String.fromCharCode(...M));
        if (A !== p)
          throw y.close(), this.debug(A, p), new Error("Server returned invalid Sec-WebSocket-Accept");
        return y;
      }
      throw new Error(`Websocket could not be established Server returned status: ${m.statusCode}`);
    } finally {
      this.requestPending = !1;
    }
  }
  /**
   * Trigger a GET Request on the server.
   * @param path Path on the server, will be URL Encoded.
   * @returns HttpResponse
   */
  async get(t) {
    return this.fetch("GET", t);
  }
  /**
   * POST some Data to the server.
   * Please be aware that some Servers may require you to set the "Content-Type" header. This will not be done automatically.
   * @param path URI Path  (will be uri encoded)
   * @param data Binary data or String that should be send to the client.
   * @returns Response from the server
   */
  async post(t, r) {
    return this.fetch("POST", t, r);
  }
  /**
  * PUT some Data to the server.
  * Please be aware that some Servers may require you to set the "Content-Type" header. This will not be done automatically.
  * @param path URI Path  (will be uri encoded)
  * @param data Binary data or String that should be send to the client.
  * @returns Response from the server
  */
  async put(t, r) {
    return this.fetch("PUT", t, r);
  }
  /**
  * DELETE some Data to the server.
  * Please be aware that some Servers may require you to set the "Content-Type" header. This will not be done automatically.
  * @param path URI Path  (will be uri encoded)
  * @param data Binary data or String that should be send to the client.
  * @returns Response from the server
  */
  async delete(t, r) {
    return this.fetch("DELETE", t, r);
  }
  /**
  * OPTIONS some Data to the server.
  * Please be aware that some Servers may require you to set the "Content-Type" header. This will not be done automatically.
  * @param path URI Path  (will be uri encoded)
  * @param data Binary data or String that should be send to the client.
  * @returns Response from the server
  */
  async options(t) {
    return this.fetch("OPTIONS", t);
  }
  /**
  * HEAD some Data to the server.
  * Please be aware that some Servers may require you to set the "Content-Type" header. This will not be done automatically.
  * @param path URI Path  (will be uri encoded)
  * @param data Binary data or String that should be send to the client.
  * @returns Response from the server
  */
  async head(t) {
    return this.fetch("HEAD", t);
  }
  /**
   * PATCH some Data to the server.
   * Please be aware that some Servers may require you to set the "Content-Type" header. This will not be done automatically.
   * @param path URI Path  (will be uri encoded)
   * @param data Binary data or String that should be send to the client.
   * @returns Response from the server
   */
  async patch(t, r) {
    return this.fetch("PATCH", t, r);
  }
  async fetch(t, r, n) {
    if (this.requestPending)
      throw new Error("Please await pending Request before sending a new one.");
    this.requestPending = !0;
    try {
      if (await this.connectTlsClient(), !this.socket || !this.reader)
        throw new Error("Socket is not initialized.");
      typeof n == "string" && (n = new TextEncoder().encode(n));
      const s = this.headers.slice();
      this.addMissingHeaders(s), n && s.push(new Ae("Content-Length", n.byteLength.toString()));
      const o = Qs.getHttpRequestString(t, r, s);
      return this.debug(o), this.socket.send(o), n && this.socket.send(n), await xr.createByData(this);
    } finally {
      this.requestPending = !1;
    }
  }
  addMissingHeaders(t) {
    t.find((r) => r.name.toLowerCase() === "accept") || t.push(new Ae("Accept", "*/*")), t.find((r) => r.name.toLowerCase() === "cache-control") || t.push(new Ae("Cache-Control", "no-cache"));
  }
  /**
   * Builds the http Request String by parameter
   * @param method http method
   * @param url Uri
   * @param headers Headers used in this request
   * @returns Complete request string
   */
  static getHttpRequestString(t, r, n) {
    let s = n.map((u) => u.name + ": " + u.value).join(`\r
`);
    return s !== "" && (s += `\r
`), t + " " + encodeURI(r) + ` HTTP/1.1\r
` + s + `\r
`;
  }
}
var Ne;
(function(i) {
  i[i.and = 160] = "and", i[i.or = 161] = "or", i[i.not = 162] = "not", i[i.equalityMatch = 163] = "equalityMatch", i[i.substrings = 164] = "substrings", i[i.greaterOrEqual = 165] = "greaterOrEqual", i[i.lessOrEqual = 166] = "lessOrEqual", i[i.present = 135] = "present", i[i.approxMatch = 168] = "approxMatch", i[i.extensibleMatch = 169] = "extensibleMatch";
})(Ne || (Ne = {}));
class ct {
  write(e) {
    e.startSequence(this.type), this.writeFilter(e), e.endSequence();
  }
  /**
   * RFC 2254 Escaping of filter strings
   * Raw                     Escaped
   * (o=Parens (R Us))       (o=Parens \28R Us\29)
   * (cn=star*)              (cn=star\2A)
   * (filename=C:\MyFile)    (filename=C:\5cMyFile)
   *
   * @param {string|Buffer} input
   */
  escape(e) {
    let t = "";
    for (const r of e)
      switch (r) {
        case "*":
          t += "\\2a";
          break;
        case "(":
          t += "\\28";
          break;
        case ")":
          t += "\\29";
          break;
        case "\\":
          t += "\\5c";
          break;
        case "\0":
          t += "\\00";
          break;
        default:
          t += r;
          break;
      }
    return t;
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  writeFilter(e) {
  }
  getObjectValue(e, t, r) {
    let n;
    if (typeof e[t] < "u")
      n = t;
    else if (!r && t.toLowerCase() === "objectclass") {
      for (const s of Object.keys(e))
        if (s.toLowerCase() === t.toLowerCase()) {
          n = s;
          break;
        }
    }
    if (n)
      return e[n];
  }
}
class fh extends ct {
  constructor(t) {
    super();
    f(this, "type", Ne.and);
    f(this, "filters");
    this.filters = t.filters;
  }
  writeFilter(t) {
    for (const r of this.filters)
      r.write(t);
  }
  toString() {
    let t = "(&";
    for (const r of this.filters)
      t += r.toString();
    return t += ")", t;
  }
}
class mh extends ct {
  constructor(t = {}) {
    super();
    f(this, "type", Ne.approxMatch);
    f(this, "attribute");
    f(this, "value");
    this.attribute = t.attribute || "", this.value = t.value || "";
  }
  writeFilter(t) {
    t.writeString(this.attribute), t.writeString(this.value);
  }
  toString() {
    return `(${this.escape(this.attribute)}~=${this.escape(this.value)})`;
  }
}
class wh extends ct {
  constructor(t = {}) {
    super();
    f(this, "type", Ne.equalityMatch);
    f(this, "attribute");
    f(this, "value");
    this.attribute = t.attribute || "", this.value = t.value || "";
  }
  writeFilter(t) {
    t.writeString(this.attribute), t.writeString(this.value);
  }
  toString() {
    return `(${this.escape(this.attribute)}=${this.escape(this.value)})`;
  }
}
class yh extends ct {
  constructor(t = {}) {
    super();
    f(this, "type", Ne.extensibleMatch);
    f(this, "value");
    f(this, "rule");
    f(this, "matchType");
    f(this, "dnAttributes");
    this.matchType = t.matchType || "", this.rule = t.rule || "", this.dnAttributes = t.dnAttributes === !0, this.value = t.value || "";
  }
  writeFilter(t) {
    this.rule && t.writeString(this.rule, 129), this.matchType && t.writeString(this.matchType, 130), t.writeString(this.value, 131), this.dnAttributes && t.writeBoolean(this.dnAttributes, 132);
  }
  toString() {
    let t = `(${this.escape(this.matchType)}:`;
    return this.dnAttributes && (t += "dn:"), this.rule && (t += `${this.escape(this.rule)}:`), t += `=${this.escape(this.value)})`, t;
  }
}
class Ah extends ct {
  constructor(t = {}) {
    super();
    f(this, "type", Ne.greaterOrEqual);
    f(this, "attribute");
    f(this, "value");
    this.attribute = t.attribute || "", this.value = t.value || "";
  }
  writeFilter(t) {
    t.writeString(this.attribute), t.writeString(this.value);
  }
  toString() {
    return `(${this.escape(this.attribute)}>=${this.escape(this.value)})`;
  }
}
class Sh extends ct {
  constructor(t = {}) {
    super();
    f(this, "type", Ne.lessOrEqual);
    f(this, "attribute");
    f(this, "value");
    this.attribute = t.attribute || "", this.value = t.value || "";
  }
  writeFilter(t) {
    t.writeString(this.attribute), t.writeString(this.value);
  }
  toString() {
    return `(${this.escape(this.attribute)}<=${this.escape(this.value)})`;
  }
}
class vh extends ct {
  constructor(t) {
    super();
    f(this, "type", Ne.not);
    f(this, "filter");
    this.filter = t.filter;
  }
  writeFilter(t) {
    this.filter.write(t);
  }
  toString() {
    return `(!${this.filter.toString()})`;
  }
}
class bh extends ct {
  constructor(t) {
    super();
    f(this, "type", Ne.or);
    f(this, "filters");
    this.filters = t.filters;
  }
  writeFilter(t) {
    for (const r of this.filters)
      r.write(t);
  }
  toString() {
    let t = "(|";
    for (const r of this.filters)
      t += r.toString();
    return t += ")", t;
  }
}
class Ch extends ct {
  constructor(t = {}) {
    super();
    f(this, "type", Ne.present);
    f(this, "attribute");
    this.attribute = t.attribute || "";
  }
  writeFilter(t) {
    for (let r = 0; r < this.attribute.length; r += 1)
      t.writeByte(this.attribute.charCodeAt(r));
  }
  toString() {
    return `(${this.escape(this.attribute)}=*)`;
  }
}
class Eh extends ct {
  constructor(t = {}) {
    super();
    f(this, "type", Ne.substrings);
    f(this, "attribute");
    f(this, "initial");
    f(this, "any");
    f(this, "final");
    this.attribute = t.attribute || "", this.initial = t.initial || "", this.any = t.any || [], this.final = t.final || "";
  }
  writeFilter(t) {
    if (t.writeString(this.attribute), t.startSequence(), this.initial && t.writeString(this.initial, 128), this.any && this.any.length)
      for (const r of this.any)
        t.writeString(r, 129);
    this.final && t.writeString(this.final, 130), t.endSequence();
  }
  toString() {
    let t = `(${this.escape(this.attribute)}=${this.escape(this.initial)}*`;
    for (const r of this.any)
      t += `${this.escape(r)}*`;
    return t += `${this.escape(this.final)})`, t;
  }
  static _escapeRegExp(t) {
    return t.replace(/[-[\]/{}()*+?.\\^$|]/g, "\\$&");
  }
}
class he {
  static parseString(e) {
    if (!e)
      throw new Error("Filter cannot be empty");
    e.startsWith("(") || (e = `(${e})`);
    const t = he._parseString(e, 0, e), r = e.length - 1;
    if (t.end < r)
      throw new Error(`Unbalanced parens in filter string: ${e}`);
    return t.filter;
  }
  static _parseString(e, t, r) {
    let n = t;
    const { length: s } = e;
    let o;
    if (e[n] !== "(")
      throw new Error(`Missing paren: ${e}. Full string: ${r}`);
    switch (n += 1, e[n]) {
      case "&": {
        n += 1;
        const u = [];
        do {
          const l = he._parseString(e, n, r);
          u.push(l.filter), n = l.end + 1;
        } while (n < s && e[n] !== ")");
        o = new fh({
          filters: u
        });
        break;
      }
      case "|": {
        n += 1;
        const u = [];
        do {
          const l = he._parseString(e, n, r);
          u.push(l.filter), n = l.end + 1;
        } while (n < s && e[n] !== ")");
        o = new bh({
          filters: u
        });
        break;
      }
      case "!": {
        const u = he._parseString(e, n + 1, r);
        o = new vh({
          filter: u.filter
        }), n = u.end + 1;
        break;
      }
      default: {
        const u = e.indexOf(")", n);
        if (u === -1)
          throw new Error(`Unbalanced parens: ${e}. Full string: ${r}`);
        o = he._parseExpressionFilterFromString(e.substr(n, u - n)), n = u;
      }
    }
    return {
      end: n,
      filter: o
    };
  }
  static _parseExpressionFilterFromString(e) {
    let t, r;
    if (e.startsWith(":"))
      t = "", r = e;
    else {
      const n = /^[-\w]+/.exec(e);
      if (n && n.length)
        [t] = n, r = e.substr(t.length);
      else
        throw new Error(`Invalid attribute name: ${e}`);
    }
    if (r === "=*")
      return new Ch({
        attribute: t
      });
    if (r.startsWith("=")) {
      if (r = r.substr(1), r.includes("*")) {
        const n = he._unescapeSubstring(r);
        return new Eh({
          attribute: t,
          initial: n.initial,
          any: n.any,
          final: n.final
        });
      }
      return new wh({
        attribute: t,
        value: he._unescapeHexValues(r)
      });
    }
    if (r.startsWith(">") && r[1] === "=")
      return new Ah({
        attribute: t,
        value: he._unescapeHexValues(r.substr(2))
      });
    if (r.startsWith("<") && r[1] === "=")
      return new Sh({
        attribute: t,
        value: he._unescapeHexValues(r.substr(2))
      });
    if (r.startsWith("~") && r[1] === "=")
      return new mh({
        attribute: t,
        value: he._unescapeHexValues(r.substr(2))
      });
    if (r.startsWith(":"))
      return he._parseExtensibleFilterFromString(t, r);
    throw new Error(`Invalid expression: ${e}`);
  }
  static _parseExtensibleFilterFromString(e, t) {
    let r = !1, n;
    const s = t.split(":");
    if (s.length <= 1)
      throw new Error(`Invalid extensible filter: ${t}`);
    if (s.shift(), s[0].toLowerCase() === "dn" && (r = !0, s.shift()), s.length && !s[0].startsWith("=") && (n = s.shift()), s.length && !s[0].startsWith("="))
      throw new Error(`Missing := in extensible filter: ${t}`);
    const o = s.join(":").substr(1), u = {
      matchType: e,
      dnAttributes: r,
      rule: n,
      value: he._unescapeHexValues(o)
    };
    return new yh(u);
  }
  static _unescapeHexValues(e) {
    let t = 0;
    const r = e.length;
    let n = "";
    for (; t < r; ) {
      const s = e[t];
      switch (s) {
        case "(":
          throw new Error(`Illegal unescaped character: ${s} in value: ${e}`);
        case "\\": {
          const o = e.substr(t + 1, 2);
          if (/^[a-fA-F0-9]{2}$/.exec(o) === null)
            throw new Error(`Invalid escaped hex character: ${o} in value: ${e}`);
          n += String.fromCharCode(Number.parseInt(o, 16)), t += 3;
          break;
        }
        default:
          n += s, t += 1;
          break;
      }
    }
    return n;
  }
  static _unescapeSubstring(e) {
    const t = e.split("*");
    if (t.length < 2)
      throw new Error(`Wildcard missing: ${e}`);
    return {
      initial: he._unescapeHexValues(t.shift() || ""),
      final: he._unescapeHexValues(t.pop() || ""),
      any: t.map((r) => he._unescapeHexValues(r))
    };
  }
}
const qc = 1, Xc = 2, En = 4, Dh = 5, _c = 6, Jc = 10, Ih = 16, Bh = 32, Mh = 128;
function eu(i) {
  const e = new Error();
  return e.name = "InvalidAsn1Error", e.message = i || "", e;
}
const Br = eu;
class Ph {
  constructor(e) {
    f(this, "_buf");
    f(this, "_size");
    f(this, "_len");
    f(this, "_offset");
    this._buf = e, this._size = e.length, this._len = 0, this._offset = 0;
  }
  get length() {
    return this._len;
  }
  get offset() {
    return this._offset;
  }
  get remain() {
    return this._size - this._offset;
  }
  get buffer() {
    return this._buf.slice(this._offset);
  }
  readByte(e) {
    if (this._size - this._offset < 1)
      return null;
    const t = this._buf[this._offset] & 255;
    return e || (this._offset += 1), t;
  }
  peek() {
    return this.readByte(!0);
  }
  /**
   * Reads a (potentially) variable length off the BER buffer.  This call is
   * not really meant to be called directly, as callers have to manipulate
   * the internal buffer afterwards.
   *
   * As a result of this call, you can call `Reader.length`, until the
   * next thing called that does a readLength.
   *
   * @return {Number} the amount of offset to advance the buffer.
   * @throws {InvalidAsn1Error} on bad ASN.1
   */
  readLength(e) {
    if (e === void 0 && (e = this._offset), e >= this._size)
      return null;
    let t = this._buf[e++] & 255;
    if (t === null)
      return null;
    if ((t & 128) === 128) {
      if (t &= 127, t === 0)
        throw Br("Indefinite length not supported");
      if (t > 4)
        throw Br("encoding too long");
      if (this._size - e < t)
        return null;
      this._len = 0;
      for (let r = 0; r < t; r++)
        this._len = (this._len << 8) + (this._buf[e++] & 255);
    } else
      this._len = t;
    return e;
  }
  /**
  * Parses the next sequence in this BER buffer.
  *
  * To get the length of the sequence, call `Reader.length`.
  *
  * @return {Number} the sequence's tag.
  */
  readSequence(e) {
    const t = this.peek();
    if (t === null)
      return null;
    if (e !== void 0 && e !== t)
      throw Br("Expected 0x" + e.toString(16) + ": got 0x" + t.toString(16));
    const r = this.readLength(this._offset + 1);
    return r === null ? null : (this._offset = r, t);
  }
  readInt() {
    return this._readTag(Xc);
  }
  readBoolean() {
    return this._readTag(qc) !== 0;
  }
  readEnumeration() {
    return this._readTag(Jc);
  }
  readString(e = En, t = !1) {
    const r = this.peek();
    if (r === null)
      return null;
    if (r !== e)
      throw Br(`Expected 0x ${e.toString(16)}: got 0x${r.toString(16)}`);
    const n = this.readLength(this._offset + 1);
    if (n === null || this.length > this._size - n)
      return null;
    if (this._offset = n, this.length === 0)
      return t ? new Uint8Array(0) : "";
    const s = this._buf.slice(this._offset, this._offset + this.length);
    return this._offset += this.length, t ? s : new TextDecoder().decode(s);
  }
  readOID(e = _c) {
    const t = this.readString(e, !0);
    if (t === null)
      return null;
    const r = [];
    let n = 0;
    for (let s = 0; s < t.length; s++) {
      const o = t[s] & 255;
      n <<= 7, n += o & 127, o & 128 || (r.push(n), n = 0);
    }
    return n = r.shift() || 0, r.unshift(n % 40), r.unshift(n / 40 >> 0), r.join(".");
  }
  _readTag(e) {
    const t = this.peek();
    if (t === null)
      return null;
    if (t !== e)
      throw Br("Expected 0x" + e.toString(16) + ": got 0x" + t.toString(16));
    const r = this.readLength(this._offset + 1);
    if (r === null)
      return null;
    if (this.length > 4)
      throw Br(`Integer too long: ${this.length}`);
    if (this.length > this._size - r)
      return null;
    this._offset = r;
    const n = this._buf[this._offset];
    let s = 0;
    for (let o = 0; o < this.length; o++)
      s <<= 8, s |= this._buf[this._offset++] & 255;
    return (n & 128) === 128 && this.length !== 4 && (s -= 1 << this.length * 8), s >> 0;
  }
}
class Rh extends Error {
  constructor() {
    super(...arguments);
    f(this, "messageDetails");
  }
}
var ue;
(function(i) {
  i[i.LDAP_VERSION_3 = 3] = "LDAP_VERSION_3", i[i.LBER_SET = 49] = "LBER_SET", i[i.LDAP_CONTROLS = 160] = "LDAP_CONTROLS", i[i.LDAP_REQ_BIND = 96] = "LDAP_REQ_BIND", i[i.LDAP_REQ_BIND_SASL = 163] = "LDAP_REQ_BIND_SASL", i[i.LDAP_REQ_UNBIND = 66] = "LDAP_REQ_UNBIND", i[i.LDAP_REQ_SEARCH = 99] = "LDAP_REQ_SEARCH", i[i.LDAP_REQ_MODIFY = 102] = "LDAP_REQ_MODIFY", i[i.LDAP_REQ_ADD = 104] = "LDAP_REQ_ADD", i[i.LDAP_REQ_DELETE = 74] = "LDAP_REQ_DELETE", i[i.LDAP_REQ_MODRDN = 108] = "LDAP_REQ_MODRDN", i[i.LDAP_REQ_COMPARE = 110] = "LDAP_REQ_COMPARE", i[i.LDAP_REQ_ABANDON = 80] = "LDAP_REQ_ABANDON", i[i.LDAP_REQ_EXTENSION = 119] = "LDAP_REQ_EXTENSION", i[i.LDAP_RES_BIND = 97] = "LDAP_RES_BIND", i[i.LDAP_RES_SEARCH_ENTRY = 100] = "LDAP_RES_SEARCH_ENTRY", i[i.LDAP_RES_SEARCH_REF = 115] = "LDAP_RES_SEARCH_REF", i[i.LDAP_RES_SEARCH = 101] = "LDAP_RES_SEARCH", i[i.LDAP_RES_MODIFY = 103] = "LDAP_RES_MODIFY", i[i.LDAP_RES_ADD = 105] = "LDAP_RES_ADD", i[i.LDAP_RES_DELETE = 107] = "LDAP_RES_DELETE", i[i.LDAP_RES_MODRDN = 109] = "LDAP_RES_MODRDN", i[i.LDAP_RES_COMPARE = 111] = "LDAP_RES_COMPARE", i[i.LDAP_RES_EXTENSION = 120] = "LDAP_RES_EXTENSION";
})(ue || (ue = {}));
const Vs = eu;
class Oh {
  constructor() {
    f(this, "size", 1024);
    f(this, "growthFactor", 8);
  }
}
class Th {
  constructor(e) {
    f(this, "_options");
    f(this, "_buf");
    f(this, "_size");
    f(this, "_offset");
    f(this, "_seq");
    this._options = new Oh(), this._options.size = (e == null ? void 0 : e.size) || this._options.size, this._options.growthFactor = (e == null ? void 0 : e.growthFactor) || this._options.growthFactor, this._buf = new Uint8Array(this._options.size || 1024), this._size = this._buf.byteLength, this._offset = 0, this._seq = [];
  }
  writeByte(e) {
    this._ensure(1), this._buf[this._offset++] = e;
  }
  writeInt(e, t = Xc) {
    let r = 4;
    for (; (!(e & 4286578688) || (e & 4286578688) === -8388608) && r > 1; )
      r--, e <<= 8;
    if (r > 4)
      throw Vs("BER ints cannot be > 0xffffffff");
    for (this._ensure(2 + r), this._buf[this._offset++] = t, this._buf[this._offset++] = r; r-- > 0; )
      this._buf[this._offset++] = (e & 4278190080) >>> 24, e <<= 8;
  }
  writeNull() {
    this.writeByte(Dh), this.writeByte(0);
  }
  writeEnumeration(e, t = Jc) {
    this.writeInt(e, t);
  }
  writeBoolean(e, t = qc) {
    this._ensure(3), this._buf[this._offset++] = t, this._buf[this._offset++] = 1, this._buf[this._offset++] = e ? 255 : 0;
  }
  writeString(e, t = En) {
    const n = new TextEncoder().encode(e), s = n.length;
    this.writeByte(t), this.writeLength(s), s && (this._ensure(s), this.writeToBuffer(n), this._offset += s);
  }
  writeToBuffer(e) {
    this._buf.set(e, this._offset);
  }
  writeBuffer(e, t) {
    this.writeByte(t), this.writeLength(e.byteLength), this._ensure(e.byteLength), this.writeToBuffer(e);
  }
  writeStringArray(e) {
    e.forEach((t) => {
      this.writeString(t);
    });
  }
  // This is really to solve DER cases, but whatever for now
  writeOID(e, t = _c) {
    if (!/^([0-9]+\.){3,}[0-9]+$/.test(e))
      throw new Error("argument is not a valid OID string");
    const r = e.split("."), n = [];
    n.push(parseInt(r[0], 10) * 40 + parseInt(r[1], 10)), r.slice(2).forEach((s) => {
      this.encodeOctet(n, parseInt(s, 10));
    }), this._ensure(2 + n.length), this.writeByte(t), this.writeLength(n.length), n.forEach((s) => {
      this.writeByte(s);
    });
  }
  encodeOctet(e, t) {
    t < 128 ? e.push(t) : t < 16384 ? (e.push(t >>> 7 | 128), e.push(t & 127)) : t < 2097152 ? (e.push(t >>> 14 | 128), e.push((t >>> 7 | 128) & 255), e.push(t & 127)) : t < 268435456 ? (e.push(t >>> 21 | 128), e.push((t >>> 14 | 128) & 255), e.push((t >>> 7 | 128) & 255), e.push(t & 127)) : (e.push((t >>> 28 | 128) & 255), e.push((t >>> 21 | 128) & 255), e.push((t >>> 14 | 128) & 255), e.push((t >>> 7 | 128) & 255), e.push(t & 127));
  }
  writeLength(e) {
    if (this._ensure(4), e <= 127)
      this._buf[this._offset++] = e;
    else if (e <= 255)
      this._buf[this._offset++] = 129, this._buf[this._offset++] = e;
    else if (e <= 65535)
      this._buf[this._offset++] = 130, this._buf[this._offset++] = e >> 8, this._buf[this._offset++] = e;
    else if (e <= 16777215)
      this._buf[this._offset++] = 131, this._buf[this._offset++] = e >> 16, this._buf[this._offset++] = e >> 8, this._buf[this._offset++] = e;
    else
      throw Vs("Length too long (> 4 bytes)");
  }
  startSequence(e = Ih | Bh) {
    this.writeByte(e), this._seq.push(this._offset), this._ensure(3), this._offset += 3;
  }
  endSequence() {
    const e = this._seq.pop() || 0, t = e + 3, r = this._offset - t;
    if (r <= 127)
      this._shift(t, r, -2), this._buf[e] = r;
    else if (r <= 255)
      this._shift(t, r, -1), this._buf[e] = 129, this._buf[e + 1] = r;
    else if (r <= 65535)
      this._buf[e] = 130, this._buf[e + 1] = r >> 8, this._buf[e + 2] = r;
    else if (r <= 16777215)
      this._shift(t, r, 1), this._buf[e] = 131, this._buf[e + 1] = r >> 16, this._buf[e + 2] = r >> 8, this._buf[e + 3] = r;
    else
      throw Vs("Sequence too long");
  }
  _shift(e, t, r) {
    r < 0 ? this.shiftLeft(this._buf, e, t, -1 * r) : r > 0 && this.shiftRight(this._buf, e, t, r), this._offset += r;
  }
  shiftRight(e, t, r, n) {
    for (let s = t + r; s > t; s--)
      e[s] = e[s - n];
    return e;
  }
  shiftLeft(e, t, r, n) {
    const s = new Uint8Array(r);
    for (let o = 0; o < r; o++)
      s[o] = e[t + o];
    return e.set(s, t - n), e;
  }
  _ensure(e) {
    if (this._size - this._offset < e) {
      let t = this._size * this._options.growthFactor;
      t - this._offset < e && (t += e);
      const r = new Uint8Array(t);
      r.set(this._buf, 0), this._buf = r, this._size = t;
    }
  }
  get buffer() {
    if (this._seq.length)
      throw Vs("unended sequence(s)");
    return this._buf.slice(0, this._offset);
  }
}
class ko {
  constructor(e) {
    f(this, "version", ue.LDAP_VERSION_3);
    f(this, "messageId", 0);
    f(this, "controls");
    this.messageId = e.messageId, this.controls = e.controls;
  }
  write() {
    const e = new Th();
    if (e.startSequence(), e.writeInt(this.messageId), e.startSequence(this.protocolOperation), this.writeMessage(e), e.endSequence(), this.controls && this.controls.length) {
      e.startSequence(ue.LDAP_CONTROLS);
      for (const t of this.controls)
        t.write(e);
      e.endSequence();
    }
    return e.endSequence(), e.buffer;
  }
  toString() {
    return JSON.stringify({
      messageId: this.messageId,
      messageType: this.constructor.name
    }, null, 2);
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars 
  // protected parseMessage(_: BerReader): void {
  //   // Do nothing as the default action
  // }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  writeMessage(e) {
  }
}
class zo extends ko {
  constructor(t) {
    super(t);
    f(this, "status");
    f(this, "matchedDN");
    f(this, "errorMessage");
    this.status = t.status || 0, this.matchedDN = t.matchedDN || "", this.errorMessage = t.errorMessage || "";
  }
  parse(t) {
    this.controls = [], this.parseMessage(t);
  }
  parseMessage(t) {
    this.status = t.readEnumeration(), this.matchedDN = t.readString(), this.errorMessage = t.readString();
  }
}
class Nh extends zo {
  constructor(t) {
    super(t);
    f(this, "protocolOperation");
    this.protocolOperation = ue.LDAP_RES_BIND;
  }
}
let xh = class {
  constructor(e = {}) {
    f(this, "buffers", []);
    f(this, "type");
    f(this, "values");
    this.type = e.type || "", this.values = e.values || [];
  }
  get parsedBuffers() {
    return this.buffers;
  }
  write(e) {
    e.startSequence();
    const { type: t } = this;
    if (e.writeString(t), e.startSequence(ue.LBER_SET), this.values.length)
      for (const r of this.values)
        e.writeString(r);
    else if (this.buffers.length)
      for (const r of this.buffers)
        e.writeBuffer(r, En);
    else
      e.writeStringArray([]);
    e.endSequence(), e.endSequence();
  }
  parse(e) {
    e.readSequence(), this.type = e.readString();
    const t = this._isBinaryType();
    if (e.peek() === ue.LBER_SET && e.readSequence(ue.LBER_SET)) {
      const r = e.offset + e.length;
      for (; e.offset < r; )
        if (t) {
          const n = this.type.lastIndexOf(";");
          this.type = n > 0 ? this.type.substring(0, n) : this.type;
          const s = e.readString(En, !0) || new Uint8Array(0);
          this.buffers.push(s);
        } else {
          const n = e.readString(En, !1) || "";
          this.values.push(n);
        }
    }
  }
  _isBinaryType() {
    return this.type.endsWith(";binary");
  }
};
class Vh extends zo {
  constructor(t) {
    super(t);
    f(this, "protocolOperation");
    f(this, "name");
    f(this, "attributes");
    this.protocolOperation = ue.LDAP_RES_SEARCH_ENTRY, this.name = t.name || "", this.attributes = t.attributes || [];
  }
  parseMessage(t) {
    this.name = t.readString(), t.readSequence();
    const r = t.offset + t.length;
    for (; t.offset < r; ) {
      const n = new xh();
      n.parse(t), this.attributes.push(n);
    }
  }
  toObject() {
    const t = {
      dn: this.name
    };
    for (const r of this.attributes) {
      const { values: n, buffers: s } = r;
      n && n.length ? n.length === 1 ? t[r.type] = n[0] : t[r.type] = n : s && s.length ? s.length === 1 ? t[r.type] = s[0] : t[r.type] = s : t[r.type] = [];
    }
    return t;
  }
}
class Uh extends zo {
  constructor(t) {
    super(t);
    f(this, "protocolOperation");
    f(this, "searchEntries");
    f(this, "searchReferences");
    this.protocolOperation = ue.LDAP_RES_SEARCH, this.searchEntries = t.searchEntries || [], this.searchReferences = t.searchReferences || [];
  }
}
class bc {
  constructor() {
    f(this, "buffer");
    f(this, "onMessage");
    f(this, "onError");
  }
  read(e) {
    var u, l, m, y;
    let t;
    if (this.buffer) {
      const A = new Uint8Array(this.buffer.length + e.length);
      A.set(this.buffer, 0), A.set(e, this.buffer.length), this.buffer = A;
    } else
      this.buffer = e;
    const r = new Ph(this.buffer);
    let n = null;
    try {
      n = r.readSequence();
    } catch (A) {
      (u = this.onError) == null || u.call(this, A);
    }
    if (!n || r.remain < r.length)
      return;
    r.remain > r.length && (t = this.buffer.slice(r.offset + r.length), r._size = r.offset + r.length), delete this.buffer;
    let s, o;
    try {
      s = r.readInt(), o = r.readSequence();
      const A = this._getMessageFromProtocolOperation(s, o, r);
      A && ((l = this.onMessage) == null || l.call(this, A));
    } catch (A) {
      if (s) {
        const P = A;
        P.messageDetails = {
          messageId: s,
          protocolOperation: o
        }, (m = this.onError) == null || m.call(this, P);
        return;
      }
      (y = this.onError) == null || y.call(this, A);
      return;
    }
    t && this.read(t);
  }
  _getMessageFromProtocolOperation(e, t, r) {
    let n;
    switch (t) {
      case ue.LDAP_RES_BIND:
        n = new Nh({
          messageId: e
        });
        break;
      case ue.LDAP_RES_SEARCH:
        n = new Uh({
          messageId: e
        });
        break;
      case ue.LDAP_RES_SEARCH_ENTRY:
        n = new Vh({
          messageId: e
        });
        break;
      default: {
        const s = new Rh(`Protocol Operation not supported: 0x${t.toString(16)}`);
        throw s.messageDetails = {
          messageId: e,
          protocolOperation: t
        }, s;
      }
    }
    return n.parse(r), n;
  }
}
class Lh extends ko {
  constructor(t) {
    super(t);
    f(this, "protocolOperation");
    f(this, "dn");
    f(this, "password");
    f(this, "mechanism");
    this.protocolOperation = ue.LDAP_REQ_BIND, this.dn = t.dn || "", this.password = t.password || "", this.mechanism = t.mechanism;
  }
  writeMessage(t) {
    t.writeInt(this.version), t.writeString(this.dn), this.mechanism ? (t.startSequence(ue.LDAP_REQ_BIND_SASL), t.writeString(this.mechanism), t.writeString(this.password), t.endSequence()) : t.writeString(this.password, Mh);
  }
}
class Fh extends ko {
  constructor(t) {
    super(t);
    f(this, "protocolOperation");
    f(this, "baseDN");
    f(this, "scope");
    f(this, "derefAliases");
    f(this, "sizeLimit");
    f(this, "timeLimit");
    f(this, "returnAttributeValues");
    f(this, "filter");
    f(this, "attributes");
    f(this, "explicitBufferAttributes");
    this.protocolOperation = ue.LDAP_REQ_SEARCH, this.baseDN = t.baseDN ?? "", this.scope = t.scope ?? "sub", this.derefAliases = t.derefAliases ?? "never", this.sizeLimit = t.sizeLimit ?? 0, this.timeLimit = t.timeLimit ?? 10, this.returnAttributeValues = t.returnAttributeValues !== !1, this.filter = t.filter, this.attributes = t.attributes ?? [], this.explicitBufferAttributes = t.explicitBufferAttributes ?? [];
  }
  writeMessage(t) {
    switch (t.writeString(this.baseDN), this.scope) {
      case "base":
        t.writeEnumeration(0);
        break;
      case "one":
        t.writeEnumeration(1);
        break;
      case "sub":
        t.writeEnumeration(2);
        break;
      case "children":
        t.writeEnumeration(3);
        break;
      default:
        throw new Error(`Invalid search scope: ${this.scope}`);
    }
    switch (this.derefAliases) {
      case "never":
        t.writeEnumeration(0);
        break;
      case "search":
        t.writeEnumeration(1);
        break;
      case "find":
        t.writeEnumeration(2);
        break;
      case "always":
        t.writeEnumeration(3);
        break;
      default:
        throw new Error(`Invalid deref alias: ${this.derefAliases}`);
    }
    if (t.writeInt(this.sizeLimit), t.writeInt(this.timeLimit), t.writeBoolean(!this.returnAttributeValues), this.filter.write(t), t.startSequence(), this.attributes && this.attributes.length)
      for (const r of this.attributes)
        t.writeString(r);
    t.endSequence();
  }
}
class tu extends fi {
  constructor() {
    super(...arguments);
    f(this, "lastErrorType", "none");
    f(this, "smtpExtensions", []);
    f(this, "messageNumber", 1);
    f(this, "searchWaitResolve");
    f(this, "searchWaitReject");
  }
  /**
   *
   * @returns the type of the last error
   */
  getLastErrorType() {
    return this.lastErrorType;
  }
  async connect(t = "") {
    var r;
    try {
      await this.connectTlsClient();
      const s = new Lh({ dn: t, messageId: this.messageNumber++ }).write();
      (r = this.socket) == null || r.send(s);
      const o = await this.readResponse();
      new bc().read(o);
    } catch (n) {
      throw this.socket && this.socket.close(), this.lastErrorType === "none" && (this.lastErrorType = "conn"), n;
    }
  }
  /**
   * Escapes a string to be safely used within an LDAP Query.
   * Replaces chars:  ( ) & | = ! > < ~ * / \
   * With the corresponding \<ascii-code-in-hex>
   * @see http://www.ldapexplorer.com/en/manual/109010000-ldap-filter-syntax.htm
   *
   */
  static escape(t) {
    return t.replaceAll(/[\(\)\&\|\=\!\>\<\~\*\/\\]/igm, (r) => "\\" + r.charCodeAt(0).toString(16));
  }
  async search(t, r, n = { timeLimit: 0 }) {
    var s;
    if (!this.reader)
      throw new Error("reader not set");
    try {
      const o = [], u = new Fh({
        ...n,
        messageId: this.messageNumber++,
        baseDN: t,
        filter: he.parseString(r)
      }), l = new bc();
      l.onMessage = (y) => {
        var A;
        if (y.protocolOperation === ue.LDAP_RES_SEARCH) {
          const P = y;
          P.searchEntries = o, (A = this.searchWaitResolve) == null || A.call(this, P);
        } else
          y.protocolOperation === ue.LDAP_RES_SEARCH_ENTRY && o.push(y);
      }, l.onError = (y) => {
        var A;
        (A = this.searchWaitReject) == null || A.call(this, y);
      }, this.reader.onDataReceived = async () => {
        var y;
        for (; (y = this.reader) != null && y.hasData() && this.searchWaitResolve !== void 0; ) {
          const A = await this.readResponse();
          l.read(A);
        }
      }, (s = this.socket) == null || s.send(u.write());
      const m = n.timeLimit && n.timeLimit > 0 ? n.timeLimit * 1e3 : 1e4;
      return await this.waitForSearchResponse(m);
    } catch (o) {
      throw this.socket && this.socket.close(), this.lastErrorType === "none" && (this.lastErrorType = "conn"), o;
    }
  }
  waitForSearchResponse(t) {
    return new Promise((r, n) => {
      this.searchWaitResolve = r, this.searchWaitReject = n, setTimeout(() => {
        this.searchWaitReject && (this.searchWaitReject("Timeout ocurred while reading data."), this.searchWaitResolve = void 0, this.searchWaitReject = void 0);
      }, t);
    });
  }
  async readResponse() {
    const t = await this.readResponseHeader(), r = await this.readResponseMessageContent(t), n = new Uint8Array(t.length + r.length);
    return n.set(t, 0), n.set(r, t.length), n;
  }
  async readResponseHeader() {
    var s;
    const t = await ((s = this.reader) == null ? void 0 : s.readByLength(2)), r = new Uint8Array(t), n = await this.getLengthBytes(r[1]);
    if (n.length > 0) {
      const o = new Uint8Array(n.length + 2);
      return o.set(r, 0), o.set(n, 2), o;
    }
    return r;
  }
  async getLengthBytes(t) {
    var r;
    if ((t & 128) === 128) {
      const n = t & 127, s = await ((r = this.reader) == null ? void 0 : r.readByLength(n));
      return new Uint8Array(s);
    } else
      return new Uint8Array(0);
  }
  async readResponseMessageContent(t) {
    var s;
    const r = this.getMessageLength(t), n = await ((s = this.reader) == null ? void 0 : s.readByLength(r));
    return new Uint8Array(n);
  }
  logDebug(t) {
    console.log([...new Uint8Array(t)].map((r) => r.toString(16).padStart(2, "0")).join(""));
  }
  getMessageLength(t) {
    if (t.length === 2)
      return t[1];
    let r = 0;
    for (let n = 0; n < t.length - 2; n++)
      r = (r << 8) + (t[2 + n] & 255);
    return r;
  }
  isClosed() {
    var r;
    const t = (r = this.socket) == null ? void 0 : r.getState();
    return !t || t.closed;
  }
  closeConnection() {
    var t;
    (t = this.socket) == null || t.close();
  }
}
const hi = class hi {
  constructor() {
    this.passwordDerivationConfig = {
      name: "PBKDF2",
      iterations: 25e4,
      hash: "SHA-512"
    }, this.passwordBasedEncryptionConfig = {
      name: "AES-GCM",
      length: 256
    }, this.symmetricEncryptionConfig = {
      name: "AES-GCM",
      length: 256
    }, this.asymmetricEncryptionConfig = {
      name: "RSA-OAEP",
      modulusLength: 4096,
      hash: { name: "SHA-512" },
      publicExponent: new Uint8Array([1, 0, 1])
    }, this.connectorTlsCertificateConfig = {
      name: "ECDSA",
      namedCurve: "P-256"
    };
  }
};
hi.Default = new hi();
let so = hi;
const Bn = class Bn {
  static async createCertificateForKey(e, t, r) {
    const n = /* @__PURE__ */ new Date();
    n.setFullYear(n.getFullYear() + 15);
    const s = this.stringEncode(`${e}_${(/* @__PURE__ */ new Date()).getTime()}`), o = await crypto.subtle.digest("SHA-1", s), u = Array.from(new Uint8Array(o)).map((l) => l.toString(16).padStart(2, "0")).join("");
    return _e.X509CertificateGenerator.createSelfSigned({
      serialNumber: u,
      name: "CN=" + e + ", O=yoshteq, C=DE",
      notBefore: new Date((/* @__PURE__ */ new Date()).getTime() - 6 * 60 * 60 * 1e3),
      // vor 6h
      notAfter: n,
      signingAlgorithm: { name: "ECDSA", hash: { name: "SHA-256" } },
      keys: t,
      extensions: [
        new _e.BasicConstraintsExtension(!1, void 0, !0),
        new _e.ExtendedKeyUsageExtension(["1.3.6.1.5.5.7.3.2", "1.3.6.1.5.5.7.3.1"], !1),
        new _e.KeyUsagesExtension(_e.KeyUsageFlags.digitalSignature | _e.KeyUsageFlags.nonRepudiation | _e.KeyUsageFlags.keyEncipherment, !0),
        await _e.SubjectKeyIdentifierExtension.create(t.publicKey)
      ]
    });
  }
  static random(e) {
    return window.crypto.getRandomValues(new Uint8Array(e));
  }
  static uint8AsBase64(e) {
    return ye.fromUint8Array(new Uint8Array(e));
  }
  static uint8FromBase64(e) {
    return ye.toUint8Array(e);
  }
  static stringEncode(e) {
    return e = e.normalize("NFC"), this.textEncoder.encode(e);
  }
  static stringDecode(e) {
    return this.textDecoder.decode(e);
  }
  static async getPrivateKeyAsPEM(e) {
    const t = await window.crypto.subtle.exportKey("pkcs8", e);
    return `-----BEGIN PRIVATE KEY-----
${window.btoa(String.fromCharCode(...new Uint8Array(t)))}
-----END PRIVATE KEY-----`;
  }
  static async getPubicKeyAsPEM(e) {
    const t = await window.crypto.subtle.exportKey("spki", e.publicKey);
    return `-----BEGIN PUBLIC KEY-----
${window.btoa(String.fromCharCode(...new Uint8Array(t)))}
-----END PUBLIC KEY-----`;
  }
};
Bn.algorithms = so.Default, Bn.textEncoder = new TextEncoder(), Bn.textDecoder = new TextDecoder();
let V = Bn;
class Gh {
  constructor(e) {
    this.asymmetricKeyPair = e;
  }
  async wrapKey(e) {
    if (!e.algorithm.name.toLowerCase().startsWith("aes"))
      throw new Error("RSA-OEAP can only wrap AES Keys");
    const t = await window.crypto.subtle.wrapKey("jwk", e, this.asymmetricKeyPair.publicKey, V.algorithms.asymmetricEncryptionConfig);
    return V.uint8AsBase64(t);
  }
  async unwrapKey(e, t, r = ["decrypt", "unwrapKey"]) {
    return await window.crypto.subtle.unwrapKey(
      "jwk",
      V.uint8FromBase64(e),
      this.asymmetricKeyPair.privateKey,
      V.algorithms.asymmetricEncryptionConfig,
      t,
      !1,
      r
    );
  }
  async encryptString(e) {
    const t = V.stringEncode(e);
    if (t.length > 381)
      throw new Error("More than 380 Bytes can not be encrypted by RSA-OEAP + SHA-512");
    const r = await window.crypto.subtle.encrypt(
      V.algorithms.asymmetricEncryptionConfig,
      this.asymmetricKeyPair.publicKey,
      t
    );
    return V.uint8AsBase64(r);
  }
  async decryptString(e) {
    const t = await window.crypto.subtle.decrypt(
      V.algorithms.asymmetricEncryptionConfig,
      this.asymmetricKeyPair.privateKey,
      V.uint8FromBase64(e)
    );
    return V.stringDecode(t);
  }
}
class Vr {
  constructor(e) {
    this.symmetricKey = e;
  }
  /**
   * Creates a new Key exports it and wraps it directly with the private key of this instance
   * @returns 
   */
  async createNewKey() {
    const e = await Vr.createSymmetricEncryptionKey();
    return await this.wrapKey(e);
  }
  static createSymmetricEncryptionKey() {
    return window.crypto.subtle.generateKey(
      V.algorithms.symmetricEncryptionConfig,
      !0,
      ["decrypt", "unwrapKey", "encrypt", "wrapKey"]
    );
  }
  async wrapKey(e) {
    const t = {
      ...V.algorithms.symmetricEncryptionConfig,
      iv: V.random(12)
    }, r = await window.crypto.subtle.wrapKey("jwk", e, this.symmetricKey, t);
    return {
      iv: t.iv,
      uint8: r
    };
  }
  static algorithmForJwk(e) {
    if (e.kty === "RSA") {
      if (e.alg === "RS256")
        return { name: "RSASSA-PKCS1-v1_5", hash: { name: "SHA-256" } };
    } else if (e.kty === "EC" && e.crv)
      return { name: "ECDSA", namedCurve: e.crv };
    throw new Error("undefined JWK Algorithm");
  }
  async unwrapKey(e, t, r = ["decrypt", "unwrapKey"], n = !1) {
    const s = {
      ...V.algorithms.symmetricEncryptionConfig,
      iv: e.iv
    };
    if (t)
      return await window.crypto.subtle.unwrapKey(
        "jwk",
        e.uint8,
        this.symmetricKey,
        s,
        t,
        n,
        r
      );
    var o = await window.crypto.subtle.decrypt(s, this.symmetricKey, e.uint8), u = JSON.parse(new TextDecoder().decode(o));
    return await window.crypto.subtle.importKey(
      "jwk",
      u,
      Vr.algorithmForJwk(u),
      !0,
      u.key_ops
    );
  }
  async encrypt(e) {
    const t = {
      ...V.algorithms.symmetricEncryptionConfig,
      iv: V.random(12)
    }, r = await window.crypto.subtle.encrypt(
      t,
      this.symmetricKey,
      e
    );
    return {
      iv: t.iv,
      uint8: r
    };
  }
  async decrypt(e) {
    const t = {
      ...V.algorithms.symmetricEncryptionConfig,
      iv: e.iv
    };
    return await window.crypto.subtle.decrypt(
      t,
      this.symmetricKey,
      e.uint8
    );
  }
  async encryptBlob(e) {
    const t = {
      ...V.algorithms.symmetricEncryptionConfig,
      iv: V.random(12)
    }, r = await window.crypto.subtle.encrypt(
      t,
      this.symmetricKey,
      e
    );
    return new Blob([t.iv, r]);
  }
  async decryptBlob(e) {
    const t = new Uint8Array(e, 0, 12), r = new Uint8Array(e, 12), n = {
      ...V.algorithms.symmetricEncryptionConfig,
      iv: t
    };
    return await window.crypto.subtle.decrypt(
      n,
      this.symmetricKey,
      r
    );
  }
  async encryptString(e) {
    const t = V.stringEncode(e);
    return this.encrypt(t);
  }
  async decryptString(e) {
    const t = await this.decrypt(e);
    return V.stringDecode(t);
  }
}
class Or extends Vr {
  constructor(e) {
    super(e);
  }
  static async createCryptographySettings(e, t) {
    const r = V.random(32), n = await this.createPasswordBasedKey(t, r), s = {
      ...V.algorithms.passwordBasedEncryptionConfig,
      iv: V.random(12)
    }, o = await super.createSymmetricEncryptionKey(), u = await window.crypto.subtle.wrapKey("jwk", o, n, s), l = {
      iv: s.iv,
      uint8: u
    }, m = new Or(o), y = await this.createAsymmetricEncryptionKey(), A = await m.wrapKey(y.privateKey), P = await window.crypto.subtle.exportKey("jwk", y.publicKey), M = await this.createConnectorCertificateKey(), p = (await V.createCertificateForKey(e, M, V.algorithms.connectorTlsCertificateConfig)).toString("pem"), w = await m.wrapKey(M.privateKey);
    return {
      userCryptographySettings: {
        pbkdf2Salt: V.uint8AsBase64(r),
        symmetricKey: l,
        asymmetricPrivateKey: A,
        asymmetricPublicKey: P
      },
      connectorCryptographySettings: {
        connectorTlsPrivateKey: w,
        connectorTlsCertificate: p
      }
    };
  }
  static createAsymmetricEncryptionKey() {
    return window.crypto.subtle.generateKey(
      V.algorithms.asymmetricEncryptionConfig,
      !0,
      ["encrypt", "decrypt", "wrapKey", "unwrapKey"]
    );
  }
  static createConnectorCertificateKey() {
    return window.crypto.subtle.generateKey(
      V.algorithms.connectorTlsCertificateConfig,
      !0,
      ["sign", "verify"]
    );
  }
  static async createPasswordBasedKey(e, t) {
    const r = await window.crypto.subtle.importKey("raw", V.stringEncode(e), { name: "PBKDF2" }, !1, ["deriveBits", "deriveKey"]), n = {
      ...V.algorithms.passwordDerivationConfig,
      salt: t
    };
    return await window.crypto.subtle.deriveKey(n, r, V.algorithms.passwordBasedEncryptionConfig, !1, ["wrapKey", "unwrapKey", "encrypt", "decrypt"]);
  }
  static async loadKeys(e, t) {
    const r = await Or.createPasswordBasedKey(e, V.uint8FromBase64(t.cryptoSettings.pbkdf2Salt)), n = {
      ...V.algorithms.passwordBasedEncryptionConfig,
      iv: t.cryptoSettings.symmetricKey.iv
    }, s = await window.crypto.subtle.unwrapKey(
      "jwk",
      t.cryptoSettings.symmetricKey.uint8,
      r,
      n,
      V.algorithms.symmetricEncryptionConfig,
      !1,
      ["decrypt", "unwrapKey", "encrypt", "wrapKey"]
    ), o = new Or(s), u = await o.unwrapKey(t.cryptoSettings.asymmetricPrivateKey, V.algorithms.asymmetricEncryptionConfig, ["decrypt", "unwrapKey"]), l = await window.crypto.subtle.importKey("jwk", t.cryptoSettings.asymmetricPublicKey, V.algorithms.asymmetricEncryptionConfig, !1, ["encrypt", "wrapKey"]);
    return o.asymmetric = new Gh({ privateKey: u, publicKey: l }), o.connectorTlsPrivateKey = await o.unwrapKey(t.connectorSettings.cryptographySettings.connectorTlsPrivateKey, void 0, ["sign"], !0), o;
  }
  async getTlsKeyAsPem() {
    if (!this.connectorTlsPrivateKey)
      throw new Error("Connector TLS private key not available. It can only be read once.");
    const e = await V.getPrivateKeyAsPEM(this.connectorTlsPrivateKey);
    return this.connectorTlsPrivateKey = void 0, e;
  }
}
class jt {
  static get() {
    const e = window.localStorage.getItem("device-token");
    if (e)
      return e.toString();
    const t = crypto.randomUUID();
    return window.localStorage.setItem("device-token", t), t;
  }
  static reset() {
    window.localStorage.removeItem("device-token");
  }
}
const He = class He {
  static strinigfyReplace(e, t) {
    return He.base64Keys.indexOf(e) >= 0 ? V.uint8AsBase64(t) : t === void 0 ? null : t;
  }
  static parseReplace(e, t) {
    return He.base64Keys.indexOf(e) >= 0 ? V.uint8FromBase64(t) : typeof t == "string" && He.ISO_8601_DATE_REGEX.test(t) ? new Date(Date.parse(t)) : t;
  }
};
He.ISO_8601_DATE_REGEX = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?(Z|[+-]\d{2}:\d{2})$/, He.base64Keys = ["salt", "iv", "publicExponent", "uint8"], He.serialize = (e) => JSON.stringify(e, He.strinigfyReplace), He.deserialize = (e) => !e || e === "" ? {} : JSON.parse(e, He.parseReplace);
let X = He;
class Ft {
  static debug(e, ...t) {
    console.debug(e, t);
  }
  static info(e, ...t) {
    console.log(e, t);
  }
  static error(e, ...t) {
    console.error(e, t);
  }
}
const li = class li {
  constructor(e, t) {
    this.gatewayClient = e, this.jwt = t;
  }
  async getUserState() {
    return this.gatewayClient.post("/register/jwt", this.jwt);
  }
  async setMfaPhoneNumber(e) {
    const t = {
      jwt: this.jwt,
      userAgent: navigator.userAgent,
      deviceToken: jt.get(),
      phoneNumber: e
    };
    return this.gatewayClient.post("/register/mfa", t);
  }
  async registerUser(e, t, r) {
    const n = await Or.createCryptographySettings(e.username, t), s = new er.SRPRoutines(li.SRP_CONFIG), o = await er.createVerifierAndSalt(s, e.username, t), u = {
      ...n,
      jwt: this.jwt,
      deviceToken: jt.get(),
      devicePin: r,
      srpSalt: o.s.toString(),
      srpVerifier: o.v.toString()
    };
    return this.gatewayClient.post("/register/finish", u);
  }
};
li.SRP_CONFIG = new er.SRPParameters(er.SRPParameters.PrimeGroup[2048], er.SRPParameters.H.SHA512);
let js = li;
const le = class le {
};
le.RU = `-----BEGIN CERTIFICATE-----
MIIDGjCCAr+gAwIBAgIBFzAKBggqhkjOPQQDAjCBgTELMAkGA1UEBhMCREUxHzAd
BgNVBAoMFmdlbWF0aWsgR21iSCBOT1QtVkFMSUQxNDAyBgNVBAsMK1plbnRyYWxl
IFJvb3QtQ0EgZGVyIFRlbGVtYXRpa2luZnJhc3RydWt0dXIxGzAZBgNVBAMMEkdF
TS5SQ0EzIFRFU1QtT05MWTAeFw0xNzA4MzAxMTM2MjJaFw0yNTA4MjgxMTM2MjFa
MIGEMQswCQYDVQQGEwJERTEfMB0GA1UECgwWZ2VtYXRpayBHbWJIIE5PVC1WQUxJ
RDEyMDAGA1UECwwpS29tcG9uZW50ZW4tQ0EgZGVyIFRlbGVtYXRpa2luZnJhc3Ry
dWt0dXIxIDAeBgNVBAMMF0dFTS5LT01QLUNBMTAgVEVTVC1PTkxZMFowFAYHKoZI
zj0CAQYJKyQDAwIIAQEHA0IABDFinQgzfsT1CN0QWwdm7e2JiaDYHocCiy1TWpOP
yHwoPC54RULeUIBJeX199Qm1FFpgeIRP1E8cjbHGNsRbju6jggEgMIIBHDAdBgNV
HQ4EFgQUKPD45qnId8xDRduartc6g6wOD6gwHwYDVR0jBBgwFoAUB5AzLXVTXn/4
yDe/fskmV2jfONIwQgYIKwYBBQUHAQEENjA0MDIGCCsGAQUFBzABhiZodHRwOi8v
b2NzcC5yb290LWNhLnRpLWRpZW5zdGUuZGUvb2NzcDASBgNVHRMBAf8ECDAGAQH/
AgEAMA4GA1UdDwEB/wQEAwIBBjAVBgNVHSAEDjAMMAoGCCqCFABMBIEjMFsGA1Ud
EQRUMFKgUAYDVQQKoEkMR2dlbWF0aWsgR2VzZWxsc2NoYWZ0IGbDvHIgVGVsZW1h
dGlrYW53ZW5kdW5nZW4gZGVyIEdlc3VuZGhlaXRza2FydGUgbWJIMAoGCCqGSM49
BAMCA0kAMEYCIQCprLtIIRx1Y4mKHlNngOVAf6D7rkYSa723oRyX7J2qwgIhAKPi
9GSJyYp4gMTFeZkqvj8pcAqxNR9UKV7UYBlHrdxC
-----END CERTIFICATE-----
-----BEGIN CERTIFICATE-----
MIIDGDCCAr+gAwIBAgIBFjAKBggqhkjOPQQDAjCBgTELMAkGA1UEBhMCREUxHzAd
BgNVBAoMFmdlbWF0aWsgR21iSCBOT1QtVkFMSUQxNDAyBgNVBAsMK1plbnRyYWxl
IFJvb3QtQ0EgZGVyIFRlbGVtYXRpa2luZnJhc3RydWt0dXIxGzAZBgNVBAMMEkdF
TS5SQ0EzIFRFU1QtT05MWTAeFw0xNzA4MzAxMTM2MDhaFw0yNTA4MjgxMTM2MDda
MIGEMQswCQYDVQQGEwJERTEfMB0GA1UECgwWZ2VtYXRpayBHbWJIIE5PVC1WQUxJ
RDEyMDAGA1UECwwpS29tcG9uZW50ZW4tQ0EgZGVyIFRlbGVtYXRpa2luZnJhc3Ry
dWt0dXIxIDAeBgNVBAMMF0dFTS5LT01QLUNBMTEgVEVTVC1PTkxZMFowFAYHKoZI
zj0CAQYJKyQDAwIIAQEHA0IABGTK1hKec85JygijmQ2crZYDrpMqbxX73b9BUDQ/
b/zHoa1Liq6icJKrlCFTjJ1J7EAaAxLsGG0N/XjxWSxlBIGjggEgMIIBHDAdBgNV
HQ4EFgQUTBRlQvR625Hnyqqo6Q4ezy2L57owHwYDVR0jBBgwFoAUB5AzLXVTXn/4
yDe/fskmV2jfONIwQgYIKwYBBQUHAQEENjA0MDIGCCsGAQUFBzABhiZodHRwOi8v
b2NzcC5yb290LWNhLnRpLWRpZW5zdGUuZGUvb2NzcDASBgNVHRMBAf8ECDAGAQH/
AgEAMA4GA1UdDwEB/wQEAwIBBjAVBgNVHSAEDjAMMAoGCCqCFABMBIEjMFsGA1Ud
EQRUMFKgUAYDVQQKoEkMR2dlbWF0aWsgR2VzZWxsc2NoYWZ0IGbDvHIgVGVsZW1h
dGlrYW53ZW5kdW5nZW4gZGVyIEdlc3VuZGhlaXRza2FydGUgbWJIMAoGCCqGSM49
BAMCA0cAMEQCIHNbTALWZyWkNTfmVHlADw7lmjF/mPgk4cT0iIavuddAAiBqcZFt
l2T02k5YDqltLug2EYy+naFfl3gEI+qCS7fsAg==
-----END CERTIFICATE-----
-----BEGIN CERTIFICATE-----
MIIESjCCAzKgAwIBAgIBBDANBgkqhkiG9w0BAQsFADCBgTEbMBkGA1UEAwwSR0VN
LlJDQTEgVEVTVC1PTkxZMTQwMgYDVQQLDCtaZW50cmFsZSBSb290LUNBIGRlciBU
ZWxlbWF0aWtpbmZyYXN0cnVrdHVyMR8wHQYDVQQKDBZnZW1hdGlrIEdtYkggTk9U
LVZBTElEMQswCQYDVQQGEwJERTAeFw0xNDAyMjExNjM1MDBaFw0yMjAyMTkxNjM1
MDBaMIGDMR8wHQYDVQQDDBZHRU0uS09NUC1DQTEgVEVTVC1PTkxZMTIwMAYDVQQL
DClLb21wb25lbnRlbi1DQSBkZXIgVGVsZW1hdGlraW5mcmFzdHJ1a3R1cjEfMB0G
A1UECgwWZ2VtYXRpayBHbWJIIE5PVC1WQUxJRDELMAkGA1UEBhMCREUwggEgMAsG
CSqGSIb3DQEBAQOCAQ8AMIIBCgKCAQEAl3AsWQ2qITmuVOF86oomZLwu4AlXzOeD
p/JOj70UK+bDOX5HKAXkP/5DaqVHsmzxyLI0iZyWLZHd9m+52ca+MpRaqN9fRwyY
TdWP173VP7GYBo2lreVst3g+VNkZy0CcKRh9vIAbX+wSAzKrtdaymGjB6t1OQz9P
8SSniRbF9O96PIphzz6FPUSNbKJkJNBjqBox3u7oKTmyhDuKHg0OQSNDOToj03dM
kWsNfOMt839fyRQDlmYdg+D3+binkBv4/WWdNHQxI/veixMv72uTsKGB2XY7yHIB
lboPFWK2Ht+nQj9gQR2wnIC3QaYv0tJm+oKX2a8EPKQ9cBO02KPyuQIDAQABo4HK
MIHHMB0GA1UdDgQWBBRPzt6NONiw2gXFuujQ9TfIhi02vDAfBgNVHSMEGDAWgBSl
sScdgCYTCMJqOD+r5Rd5uxe4lzBKBggrBgEFBQcBAQQ+MDwwOgYIKwYBBQUHMAGG
Lmh0dHA6Ly9vY3NwLXRlc3RyZWYucm9vdC1jYS50aS1kaWVuc3RlLmRlL29jc3Aw
EgYDVR0TAQH/BAgwBgEB/wIBADAOBgNVHQ8BAf8EBAMCAQYwFQYDVR0gBA4wDDAK
BggqghQATASBIzANBgkqhkiG9w0BAQsFAAOCAQEAtF3RPJUk+Sk2XlMcu6HsKNWr
9IxOrsnqfM6xkA3vLVNOWTWZChHvmc2hZI7/5pAki8fEzdX4Cf4gW8yWoVa55X9j
Mu4kkdDsiqLpgPMymAdCFMZaGGPp7y6tiokaptGoEkZk+fp5kZZ7NyjuEr0gdDCd
RHHirQAkXdC/qZAN+ySZjhZliqlT+MdoLdToZYplKMynl5uwhOLg1cVeSLs1B3VC
zSiyknvByfle6zGeS7c1lC5cbMqqK/llGE+mWto759vfrpP10kqDQ+Dfb6B+paEI
cYHt/892BEWqAyK8bSHdHHDGHoUXmS1jiluw0SyvdsPxBpFLKiMa7nwdeww9EA==
-----END CERTIFICATE-----
-----BEGIN CERTIFICATE-----
MIIErDCCA5SgAwIBAgIBCTANBgkqhkiG9w0BAQsFADCBgTELMAkGA1UEBhMCREUx
HzAdBgNVBAoMFmdlbWF0aWsgR21iSCBOT1QtVkFMSUQxNDAyBgNVBAsMK1plbnRy
YWxlIFJvb3QtQ0EgZGVyIFRlbGVtYXRpa2luZnJhc3RydWt0dXIxGzAZBgNVBAMM
EkdFTS5SQ0EyIFRFU1QtT05MWTAeFw0xNjEyMTQxMDE3NTJaFw0yNDEyMTIxMDE3
NTFaMIGEMQswCQYDVQQGEwJERTEfMB0GA1UECgwWZ2VtYXRpayBHbWJIIE5PVC1W
QUxJRDEyMDAGA1UECwwpS29tcG9uZW50ZW4tQ0EgZGVyIFRlbGVtYXRpa2luZnJh
c3RydWt0dXIxIDAeBgNVBAMMF0dFTS5LT01QLUNBMjQgVEVTVC1PTkxZMIIBIjAN
BgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA7nGt2dCCcFbdhSr6m2oQw+VbbHNg
Ng6XSivv2xb4gJ658Nua7fJkNp1G9YpvK5l1dUxJPlXBAclgBpvq+dFv9eX4C0Lh
eThmL8HdGnpa7zMO4gXp8GLEHBR5l01GtYYIEeOlb1QH5V/ufQYam7nS54OShoDQ
yQDx6JQoL0Z0oS2VNPeV5HPQDN7gOfOkEWE8VS70W1cESf4xSVjgsPZvxpsE3O0A
5MsyYFyA0nwBY+e7T/KxUhR74B9HQGa7FX7k+pwQjdCgC+qMnTMbQL9bxVnUShzh
I+YETS66DTrJKOP8Ew6eXdepjCuoMkz+375IjSOLwl58SGbeXiXr0nZ9TwIDAQAB
o4IBKDCCASQwHQYDVR0OBBYEFD+2guJpWXnMOdLVUSeO4KZZCjGvMB8GA1UdIwQY
MBaAFC1pALuh9MyOA6Ilg5LJ0mPh2US4MEoGCCsGAQUFBwEBBD4wPDA6BggrBgEF
BQcwAYYuaHR0cDovL29jc3AtdGVzdHJlZi5yb290LWNhLnRpLWRpZW5zdGUuZGUv
b2NzcDASBgNVHRMBAf8ECDAGAQH/AgEAMA4GA1UdDwEB/wQEAwIBBjAVBgNVHSAE
DjAMMAoGCCqCFABMBIEjMFsGA1UdEQRUMFKgUAYDVQQKoEkMR2dlbWF0aWsgR2Vz
ZWxsc2NoYWZ0IGbDvHIgVGVsZW1hdGlrYW53ZW5kdW5nZW4gZGVyIEdlc3VuZGhl
aXRza2FydGUgbWJIMA0GCSqGSIb3DQEBCwUAA4IBAQCdpyJCzBbIou6BlZ+O1RF/
AAM03vLM+5tjFkv9M0QrK8afWwhUby3wxevYdrSs2pA4Lx2gdrXMsmML/tP5TTO5
W/YeBTktM3CDhUhTdE1raSkuBv3eGawW1wX4A24ejOjSwGZLjG3M5pYjEl0eUQMP
SmY/FY0P8uzaZ9N6n3ybBaKlGM0iyKe6jE9d0mpsmsl/myPRIbnOuNgGHoS3jVtx
2sK2GPMRsvRo4O3HQ3NTPyp9/E/ZbUGgnBmrqljFPkNqlH4YcTf1PJy4T/Tz8Ehx
esfH8lVOJ8NY3ZaABpIyp5ninEfJ41R6S9TvS7JN2fos4/5FyxW4fg+4YHDaLhBU
-----END CERTIFICATE-----
-----BEGIN CERTIFICATE-----
MIIErDCCA5SgAwIBAgIBCjANBgkqhkiG9w0BAQsFADCBgTELMAkGA1UEBhMCREUx
HzAdBgNVBAoMFmdlbWF0aWsgR21iSCBOT1QtVkFMSUQxNDAyBgNVBAsMK1plbnRy
YWxlIFJvb3QtQ0EgZGVyIFRlbGVtYXRpa2luZnJhc3RydWt0dXIxGzAZBgNVBAMM
EkdFTS5SQ0EyIFRFU1QtT05MWTAeFw0xNjEyMTQxMDE4MDJaFw0yNDEyMTIxMDE4
MDFaMIGEMQswCQYDVQQGEwJERTEfMB0GA1UECgwWZ2VtYXRpayBHbWJIIE5PVC1W
QUxJRDEyMDAGA1UECwwpS29tcG9uZW50ZW4tQ0EgZGVyIFRlbGVtYXRpa2luZnJh
c3RydWt0dXIxIDAeBgNVBAMMF0dFTS5LT01QLUNBMjUgVEVTVC1PTkxZMIIBIjAN
BgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA0fx5pjAxbHi+U2v6kEgLMCdtDlKo
ogRS08JXXXMWpTOP0BKUdKBMH2l0+GKiAuDctByhP4gPY95OTT8InuW1rrKY9JOa
2lId0z1qtyUbPT4TsqupxY2uJvya9rYCw7V9ErIV68R0jd9FkMH1UdGU7eMqIWqI
VJmXTJdtpBLRPldVwJtjgdgY54dXAKgakkq0nDt+Z+f1kryyKkB3Px+bNlPga6WL
J0kRglWsFspm6W6U1heoP8LleqiMwUmAxHLQqqBN1TPEmASlc1qlEN9uG+HIS63w
WmzGkqcffbZQVmZkK7Qcjy4iF/uSVNQHqDISLCEU0yMuOhlYccyvKdqFKwIDAQAB
o4IBKDCCASQwHQYDVR0OBBYEFCUq/l1vKaWUFz8gxOZdT9Ls0LB/MB8GA1UdIwQY
MBaAFC1pALuh9MyOA6Ilg5LJ0mPh2US4MEoGCCsGAQUFBwEBBD4wPDA6BggrBgEF
BQcwAYYuaHR0cDovL29jc3AtdGVzdHJlZi5yb290LWNhLnRpLWRpZW5zdGUuZGUv
b2NzcDASBgNVHRMBAf8ECDAGAQH/AgEAMA4GA1UdDwEB/wQEAwIBBjAVBgNVHSAE
DjAMMAoGCCqCFABMBIEjMFsGA1UdEQRUMFKgUAYDVQQKoEkMR2dlbWF0aWsgR2Vz
ZWxsc2NoYWZ0IGbDvHIgVGVsZW1hdGlrYW53ZW5kdW5nZW4gZGVyIEdlc3VuZGhl
aXRza2FydGUgbWJIMA0GCSqGSIb3DQEBCwUAA4IBAQCg4/w4hPP52D5Su/Yr/apZ
8W2SpDLNM37bXCOdm/NcmBowUNK1BvjrvgwfFvByBjncAZ7hHn2UbaGnbGouOPDx
tjCstQ4fHskoPUMFD7Kn6WAU2KZBpe7vr2z/hCGnGq7nxAih7NDMflBC+0zfzxb3
YdPs1RdrkSdwtQ9VqNB2V1nZAGqJ4GeCT25jJaLhFAuHS2JFAJOKZG0lZoYB/vnk
VlUPlvzZOQ7wiNCwoQzOc/wp8lh2mNUdo/h2+1o9hVb6o8zeCAJrjCfinwy9JCuo
7Sd13kPOmPgqHEcjeK4IshzxFad2NunZIN8bXZNR9tJgEvfmzlsOcCf10vXt3AQR
-----END CERTIFICATE-----
-----BEGIN CERTIFICATE-----
MIIEVDCCAzygAwIBAgIBEzANBgkqhkiG9w0BAQsFADCBgTELMAkGA1UEBhMCREUx
HzAdBgNVBAoMFmdlbWF0aWsgR21iSCBOT1QtVkFMSUQxNDAyBgNVBAsMK1plbnRy
YWxlIFJvb3QtQ0EgZGVyIFRlbGVtYXRpa2luZnJhc3RydWt0dXIxGzAZBgNVBAMM
EkdFTS5SQ0EyIFRFU1QtT05MWTAeFw0xNzA3MjcxMjIzMDBaFw0yNTA3MjUxMjIy
NTlaMIGLMQswCQYDVQQGEwJERTEmMCQGA1UECgwdYXJ2YXRvIFN5c3RlbXMgR21i
SCBOT1QtVkFMSUQxMjAwBgNVBAsMKUtvbXBvbmVudGVuLUNBIGRlciBUZWxlbWF0
aWtpbmZyYXN0cnVrdHVyMSAwHgYDVQQDDBdHRU0uS09NUC1DQTI2IFRFU1QtT05M
WTCCASIwDQYJKoZIhvcNAQEBBQADggEPADCCAQoCggEBALjGMlnKf5ML282QqNDZ
bLBUd3hUWjrVbOh3ht2ZR3HI63GEDgndCsAyRNWhvw9ub9rd8LYx0twpfx1QFley
iWIkzNg0u821BTnJ8jHf1Hv9pehN7Gjuep+opEn69z0Nm8B+gnXLp1IHgoHoTm2q
V2cjk86BYgNQJWLMqDVfN0lnTrNeGEqLqEO7V5bbUl1o6la2J9vNEBZttzBwmNLs
ABZ+aSJ9SofrychnDwMdlyOD1DFvMBP/5OHw6uipuPPgcmb3DE+Fql9MPlLQccKf
kKWMtmBp2f+YXAJ7wxrd1i4s1GnV6HrkmcFO8SlGk+Haf7+r1qHjmp20QtqF2WZw
MS0CAwEAAaOByjCBxzAdBgNVHQ4EFgQUsbdUauklBtyQWR9AnNyqNkQeEmYwHwYD
VR0jBBgwFoAULWkAu6H0zI4DoiWDksnSY+HZRLgwSgYIKwYBBQUHAQEEPjA8MDoG
CCsGAQUFBzABhi5odHRwOi8vb2NzcC10ZXN0cmVmLnJvb3QtY2EudGktZGllbnN0
ZS5kZS9vY3NwMBIGA1UdEwEB/wQIMAYBAf8CAQAwDgYDVR0PAQH/BAQDAgEGMBUG
A1UdIAQOMAwwCgYIKoIUAEwEgSMwDQYJKoZIhvcNAQELBQADggEBAI/NvwP5Q9OI
2ljWph1ewUtgJV2bQob0OWpuvWuEuKtE1sFm7wdgalRbpvvSHf7u3FJJeFzI/m7p
5jwYR/uIumnLkjYd1uO942JHmW1iRHOPLOD06vGr8gmGESM4eUayKqa+1SNp4GhH
ErqVhFQlfK3okYLPO/Ejz5xbyWk1Gj5/7IspMYLW6vgTMHvJElCc+pCoi5/WIY/t
Y6IpjYKCg2+OStn137tHq3uBmstrMB03LcPNtYXUCJjR8JMF79kcwimHp4Bbqnis
J7ffefPZxwbtncuuMBKccb87D+3umXq+NAiB+Y6zTsBq/w3riPW9H/uP4mn1cCbn
wbKa1SgL8OY=
-----END CERTIFICATE-----
-----BEGIN CERTIFICATE-----
MIIETTCCAzWgAwIBAgIBFzANBgkqhkiG9w0BAQsFADCBgTELMAkGA1UEBhMCREUx
HzAdBgNVBAoMFmdlbWF0aWsgR21iSCBOT1QtVkFMSUQxNDAyBgNVBAsMK1plbnRy
YWxlIFJvb3QtQ0EgZGVyIFRlbGVtYXRpa2luZnJhc3RydWt0dXIxGzAZBgNVBAMM
EkdFTS5SQ0EyIFRFU1QtT05MWTAeFw0xNzA3MzExNTIwNTJaFw0yNTA3MjkxNTIw
NTFaMIGEMQswCQYDVQQGEwJERTEfMB0GA1UECgwWZ2VtYXRpayBHbWJIIE5PVC1W
QUxJRDEyMDAGA1UECwwpS29tcG9uZW50ZW4tQ0EgZGVyIFRlbGVtYXRpa2luZnJh
c3RydWt0dXIxIDAeBgNVBAMMF0dFTS5LT01QLUNBMjcgVEVTVC1PTkxZMIIBIjAN
BgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAtX5gcTxty7nFCuPu/XWlYo+dfj7W
xErQ9Fd16/ss9+N4TN0ym4VM+a52q0Lnpm1ouIyXdW6+JFLhic0uBhZKC7iNqJcZ
+UnCzbT1BqXNUkskWHx0PEZXZESohR0Qqcq8q6P92aGFkp87DpS8tTlw7saViEP6
tbVmYug2qooPYbAhH1IhY99qJEsNYMp/VIxT85HNgarGZjD3bc4ojaLCua4xNhh2
06vGFreKtRFufWI315vqSrfM1rxMSA3rt8/lOrUPDN7kQyWOxg3XkDIqotGpJKUh
E4/eocMU7gXxTGK5ASEthAp/+YzEk2nrF4hPlVwr9CzcRuEBsGQv7/ZtZQIDAQAB
o4HKMIHHMB0GA1UdDgQWBBR9bWRDxYnwBKdi2QBq62TMXu13dDAfBgNVHSMEGDAW
gBQtaQC7ofTMjgOiJYOSydJj4dlEuDBKBggrBgEFBQcBAQQ+MDwwOgYIKwYBBQUH
MAGGLmh0dHA6Ly9vY3NwLXRlc3RyZWYucm9vdC1jYS50aS1kaWVuc3RlLmRlL29j
c3AwEgYDVR0TAQH/BAgwBgEB/wIBADAOBgNVHQ8BAf8EBAMCAQYwFQYDVR0gBA4w
DDAKBggqghQATASBIzANBgkqhkiG9w0BAQsFAAOCAQEAfa8WKjRrfdoanNrtCBp/
qpv+UZrLqWLOyizBI4NzIirbo2bDybi2M2HxoTgjxgYJYWqNQOTzsT7fT6TsKUN3
/KzU6Tr4nPnhLIaBT5XfCy4Z/H0SxKB9Wbe995e/rz4m8WPxuW0OC6+t/b8ubB5G
W1PW8zPyhEiNPSJIQtpeBRSp1T6CsZWmaJWj24qyZy/jYwJ1WBagHH2/D4q2EKHM
rO1TVlYsttna8mIiHYRV08+PCCDFsQ535k4rEir3HP4loEeTT1hWpFCUDUbMSEbJ
qe/8gcAtCTqkgKCxyNF18vBnJ+avZvbJogNC3m/SGwrEudXLBrjtse7blixB0SKT
wg==
-----END CERTIFICATE-----
-----BEGIN CERTIFICATE-----
MIIErDCCA5SgAwIBAgIBJDANBgkqhkiG9w0BAQsFADCBgTELMAkGA1UEBhMCREUx
HzAdBgNVBAoMFmdlbWF0aWsgR21iSCBOT1QtVkFMSUQxNDAyBgNVBAsMK1plbnRy
YWxlIFJvb3QtQ0EgZGVyIFRlbGVtYXRpa2luZnJhc3RydWt0dXIxGzAZBgNVBAMM
EkdFTS5SQ0EyIFRFU1QtT05MWTAeFw0xODA3MjYxMDI0MzRaFw0yNTEyMzExMDI0
MzNaMIGEMQswCQYDVQQGEwJERTEfMB0GA1UECgwWZ2VtYXRpayBHbWJIIE5PVC1W
QUxJRDEyMDAGA1UECwwpS29tcG9uZW50ZW4tQ0EgZGVyIFRlbGVtYXRpa2luZnJh
c3RydWt0dXIxIDAeBgNVBAMMF0dFTS5LT01QLUNBMjkgVEVTVC1PTkxZMIIBIjAN
BgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA0JU7O+buNXtA5ncforMz9zqL2Srm
5GlcOx0AZ4X6fBElPcFRINjYvUsCPRQIZoPPhLBgkh5DFPp52gkGuaBjmf48hqJQ
lOiaW5+O+fwR/EVmQPPI2xN1joh6eNEtWqEJ1Lz5QoM7UvcX8+vaNCpNoNpIXj2W
BjTqShi2ReIIlNL+0m6i0BibPDhzQEd6n9ewYZUlwvmbeMJr+IJYou7Fhgl41A0o
ukFPk12WGmxbyr2eg0j7MrRcrJrm2xmx4dbtntOlcbNGKKiuGgLPFUHsn2eZD+F+
t3pX16wbbwxU+SC6qah+7caa+IO1l+MdqIP9NHQDn0obBdShQhzhSSTZ8wIDAQAB
o4IBKDCCASQwHQYDVR0OBBYEFGpKkm4w2rH+V95hQvXYkerNNAUOMB8GA1UdIwQY
MBaAFC1pALuh9MyOA6Ilg5LJ0mPh2US4MEoGCCsGAQUFBwEBBD4wPDA6BggrBgEF
BQcwAYYuaHR0cDovL29jc3AtdGVzdHJlZi5yb290LWNhLnRpLWRpZW5zdGUuZGUv
b2NzcDASBgNVHRMBAf8ECDAGAQH/AgEAMA4GA1UdDwEB/wQEAwIBBjAVBgNVHSAE
DjAMMAoGCCqCFABMBIEjMFsGA1UdEQRUMFKgUAYDVQQKoEkMR2dlbWF0aWsgR2Vz
ZWxsc2NoYWZ0IGbDvHIgVGVsZW1hdGlrYW53ZW5kdW5nZW4gZGVyIEdlc3VuZGhl
aXRza2FydGUgbWJIMA0GCSqGSIb3DQEBCwUAA4IBAQCxvjYfFfsfvPHHsTKQaeJf
B3f4KvMzwyBjGC6Ihc1whhYBg+ahyvR7zrWIUM8Wrm636v9Hj9unM+gr8C1W7V9G
aw2L9Qh3oRJucIPfCRDSuzRoUnhzIfJOTpFGNnivLXNXVOz6JzY9P7GwzPBOIyW2
MRUorYW7iTIAnNc9UOcqdRv+fR+KR8RRsaOMdaqCGG8d6wBJ0lYQiXoJG6Vb15ht
EKfEHmmIM05IQ4wobiv/oiNhFsH0h+DnyfOBvNG0ON2P15JYNOlmyx272Kr5hGvt
zjZhkhfDCBMhYogeNAqE2AAtXkj13CVsjoIt4ZeJIyVnpFEN+L4ZxKznHCeeEswc
-----END CERTIFICATE-----
-----BEGIN CERTIFICATE-----
MIIDGDCCAr+gAwIBAgIBJjAKBggqhkjOPQQDAjCBgTELMAkGA1UEBhMCREUxHzAd
BgNVBAoMFmdlbWF0aWsgR21iSCBOT1QtVkFMSUQxNDAyBgNVBAsMK1plbnRyYWxl
IFJvb3QtQ0EgZGVyIFRlbGVtYXRpa2luZnJhc3RydWt0dXIxGzAZBgNVBAMMEkdF
TS5SQ0EzIFRFU1QtT05MWTAeFw0xODA3MjYxMDI3MzdaFw0yNTEyMzExMDI3MzZa
MIGEMQswCQYDVQQGEwJERTEfMB0GA1UECgwWZ2VtYXRpayBHbWJIIE5PVC1WQUxJ
RDEyMDAGA1UECwwpS29tcG9uZW50ZW4tQ0EgZGVyIFRlbGVtYXRpa2luZnJhc3Ry
dWt0dXIxIDAeBgNVBAMMF0dFTS5LT01QLUNBMzAgVEVTVC1PTkxZMFowFAYHKoZI
zj0CAQYJKyQDAwIIAQEHA0IABDxrcYavdbB+8cNE6WJuibkO2N1aPnf53FE75wMx
mto8lOcLfd9aSiWj74cv9zJicF8HNc1c7dCsiVvWmuaV7ECjggEgMIIBHDAdBgNV
HQ4EFgQUe1eK1NbM+PZWJzk62RlB5/M6tfIwHwYDVR0jBBgwFoAUB5AzLXVTXn/4
yDe/fskmV2jfONIwQgYIKwYBBQUHAQEENjA0MDIGCCsGAQUFBzABhiZodHRwOi8v
b2NzcC5yb290LWNhLnRpLWRpZW5zdGUuZGUvb2NzcDASBgNVHRMBAf8ECDAGAQH/
AgEAMA4GA1UdDwEB/wQEAwIBBjAVBgNVHSAEDjAMMAoGCCqCFABMBIEjMFsGA1Ud
EQRUMFKgUAYDVQQKoEkMR2dlbWF0aWsgR2VzZWxsc2NoYWZ0IGbDvHIgVGVsZW1h
dGlrYW53ZW5kdW5nZW4gZGVyIEdlc3VuZGhlaXRza2FydGUgbWJIMAoGCCqGSM49
BAMCA0cAMEQCIHkEtPypfVKQU1Ddsh4bo6k0riV86ifdgPshanB6heS1AiBA9fNR
+IhEvd379Ie4kTUjmENb/KX3R34g8HCckJQdXA==
-----END CERTIFICATE-----
-----BEGIN CERTIFICATE-----
MIIErDCCA5SgAwIBAgIBMDANBgkqhkiG9w0BAQsFADCBgTELMAkGA1UEBhMCREUx
HzAdBgNVBAoMFmdlbWF0aWsgR21iSCBOT1QtVkFMSUQxNDAyBgNVBAsMK1plbnRy
YWxlIFJvb3QtQ0EgZGVyIFRlbGVtYXRpa2luZnJhc3RydWt0dXIxGzAZBgNVBAMM
EkdFTS5SQ0EyIFRFU1QtT05MWTAeFw0xOTEwMTAxMDUyMThaFw0yNjExMTQxMDUy
MTdaMIGEMQswCQYDVQQGEwJERTEfMB0GA1UECgwWZ2VtYXRpayBHbWJIIE5PVC1W
QUxJRDEyMDAGA1UECwwpS29tcG9uZW50ZW4tQ0EgZGVyIFRlbGVtYXRpa2luZnJh
c3RydWt0dXIxIDAeBgNVBAMMF0dFTS5LT01QLUNBMzIgVEVTVC1PTkxZMIIBIjAN
BgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA4BDh5vgDVazOynjVJ2yUnlkSgT3C
e0oBzKVCiP5pfFdRPLuwnxX1cAGBgQELQYx9nHBk4DOdc+TkfGN7bgG0UArIBkST
syihbP9Bx3BSeiKw2ELHUx8OMnQZ5UZTwsxXpC4JMDHcK+tAqprofAttU/99xz9o
+mA5+vp/TEo9IuuZwNsj5UJHr7U9/31rt6+JolxD+0VBTS14Hk3FlTJRyXcD2B31
WNmgSP7WR54m8pAaHV6AnA8xN6RJE64CGcovUwIeM06pHuL34BhzRu2/1VDALljc
YcCV1BFvPvhbbJLMHo7FYJr3o8xtabI4KrAqt1V8GvRjzKX981qKergtiwIDAQAB
o4IBKDCCASQwHQYDVR0OBBYEFDu4JsmC7xjgYpsWED5bCWbHmlozMB8GA1UdIwQY
MBaAFC1pALuh9MyOA6Ilg5LJ0mPh2US4MEoGCCsGAQUFBwEBBD4wPDA6BggrBgEF
BQcwAYYuaHR0cDovL29jc3AtdGVzdHJlZi5yb290LWNhLnRpLWRpZW5zdGUuZGUv
b2NzcDASBgNVHRMBAf8ECDAGAQH/AgEAMA4GA1UdDwEB/wQEAwIBBjAVBgNVHSAE
DjAMMAoGCCqCFABMBIEjMFsGA1UdEQRUMFKgUAYDVQQKoEkMR2dlbWF0aWsgR2Vz
ZWxsc2NoYWZ0IGbDvHIgVGVsZW1hdGlrYW53ZW5kdW5nZW4gZGVyIEdlc3VuZGhl
aXRza2FydGUgbWJIMA0GCSqGSIb3DQEBCwUAA4IBAQC6KU/eyPEzjJ93I7zdH4B+
1IQJNCQpZLVrzQW91xpkrt1tFduZ8aOdTOyn3cNQGP9RIZNbu+nfiQ7Gr39zjbzM
5HwnXlS+E4SnL6GsqzM6nY2QudDLY6hEyMnf4GEhG/YT38WbKtxcvBUGUjEcXZ9W
9sTUg1lg4la1j2KdQcuqxrxB3wv/PWkmiw3FLR8mhGjYKDuGRYfD0DsHt8ca0BrS
zz0TPPSvW3cCVlwfb/xbrVJaUwrcD6kn3LjNgvTGG9quIAdBj1QddVlIz7A+C5Yb
nrCmp4N6Bt/IdyQmrQzF7G/7nLFmQLGaiDzUdzSt0sa8LCQ46os9xlzX8BjcmV/E
-----END CERTIFICATE-----
-----BEGIN CERTIFICATE-----
MIIDIDCCAsegAwIBAgIBAzAKBggqhkjOPQQDAjCBgTELMAkGA1UEBhMCREUxHzAd
BgNVBAoMFmdlbWF0aWsgR21iSCBOT1QtVkFMSUQxNDAyBgNVBAsMK1plbnRyYWxl
IFJvb3QtQ0EgZGVyIFRlbGVtYXRpa2luZnJhc3RydWt0dXIxGzAZBgNVBAMMEkdF
TS5SQ0E0IFRFU1QtT05MWTAeFw0xOTEwMTAxMDUzMTBaFw0yNzEwMDgxMDUzMDla
MIGEMQswCQYDVQQGEwJERTEfMB0GA1UECgwWZ2VtYXRpayBHbWJIIE5PVC1WQUxJ
RDEyMDAGA1UECwwpS29tcG9uZW50ZW4tQ0EgZGVyIFRlbGVtYXRpa2luZnJhc3Ry
dWt0dXIxIDAeBgNVBAMMF0dFTS5LT01QLUNBMzMgVEVTVC1PTkxZMFowFAYHKoZI
zj0CAQYJKyQDAwIIAQEHA0IABJItvYZGatQau5iOZiPvnqjdfe4BrFXQrTtqeXe9
XRO/E5DSXF22jNyt0twfPa2B6YbiRIi7CI4xqIvxUrh4pKKjggEoMIIBJDAdBgNV
HQ4EFgQUXB8GxhzenjhK7s/pncVEsEuppogwHwYDVR0jBBgwFoAUUdvZZkKzSis/
VyxUjYVzHedXz38wSgYIKwYBBQUHAQEEPjA8MDoGCCsGAQUFBzABhi5odHRwOi8v
b2NzcC10ZXN0cmVmLnJvb3QtY2EudGktZGllbnN0ZS5kZS9vY3NwMBIGA1UdEwEB
/wQIMAYBAf8CAQAwDgYDVR0PAQH/BAQDAgEGMBUGA1UdIAQOMAwwCgYIKoIUAEwE
gSMwWwYDVR0RBFQwUqBQBgNVBAqgSQxHZ2VtYXRpayBHZXNlbGxzY2hhZnQgZsO8
ciBUZWxlbWF0aWthbndlbmR1bmdlbiBkZXIgR2VzdW5kaGVpdHNrYXJ0ZSBtYkgw
CgYIKoZIzj0EAwIDRwAwRAIgd7zruLz3a6vT+IA4ROENgS2xfPjEmKcJaZTEYi/c
O/8CIDZWqFIfgP+M+HwG7ZZaTVmdxaIMvM4fqkjtoM4f5/fz
-----END CERTIFICATE-----
-----BEGIN CERTIFICATE-----
MIIErDCCA5SgAwIBAgIBNjANBgkqhkiG9w0BAQsFADCBgTELMAkGA1UEBhMCREUx
HzAdBgNVBAoMFmdlbWF0aWsgR21iSCBOT1QtVkFMSUQxNDAyBgNVBAsMK1plbnRy
YWxlIFJvb3QtQ0EgZGVyIFRlbGVtYXRpa2luZnJhc3RydWt0dXIxGzAZBgNVBAMM
EkdFTS5SQ0EyIFRFU1QtT05MWTAeFw0yMDAyMjcxMzU4NDVaFw0yNjExMTQxMzU4
NDRaMIGEMQswCQYDVQQGEwJERTEfMB0GA1UECgwWZ2VtYXRpayBHbWJIIE5PVC1W
QUxJRDEyMDAGA1UECwwpS29tcG9uZW50ZW4tQ0EgZGVyIFRlbGVtYXRpa2luZnJh
c3RydWt0dXIxIDAeBgNVBAMMF0dFTS5LT01QLUNBMzQgVEVTVC1PTkxZMIIBIjAN
BgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAmpXC2JgaJJUJuDUaaZHSBpSh4h1K
MBgCNYoK+w+8nmECJVyv+aD2+HDPLWYBej42oFuSN9bARb4yoT8qxzWBQ9JRZuP2
HZN4ud7o/UbG67yD/K/iJxmaFon6X24BVwxSa2fNEnMXDqUD6jtm8QAda2BZyfm9
sjl1Yn0778mxV4MH3WymszARjeXzOupSHFAaW3SaAv7XL0o+hx5U92+hU7XCvpmU
w9Gdz8B+ZPaXKVqFE6f221Gcl3fJBhhylQwhjruivbUZMb/UPnDYhB6XTnhVDzEL
r+aN/YCrPcLOfxZ9q4oENnu7Ia/enRyJUZ9Fx7TfDlXU0ZPGFXDYFI3ApwIDAQAB
o4IBKDCCASQwHQYDVR0OBBYEFIuTWfsnOPCkek6SO+2EQ9uLk0zEMB8GA1UdIwQY
MBaAFC1pALuh9MyOA6Ilg5LJ0mPh2US4MEoGCCsGAQUFBwEBBD4wPDA6BggrBgEF
BQcwAYYuaHR0cDovL29jc3AtdGVzdHJlZi5yb290LWNhLnRpLWRpZW5zdGUuZGUv
b2NzcDASBgNVHRMBAf8ECDAGAQH/AgEAMA4GA1UdDwEB/wQEAwIBBjAVBgNVHSAE
DjAMMAoGCCqCFABMBIEjMFsGA1UdEQRUMFKgUAYDVQQKoEkMR2dlbWF0aWsgR2Vz
ZWxsc2NoYWZ0IGbDvHIgVGVsZW1hdGlrYW53ZW5kdW5nZW4gZGVyIEdlc3VuZGhl
aXRza2FydGUgbWJIMA0GCSqGSIb3DQEBCwUAA4IBAQAAd4OwCKXkzMwUt0FVRszp
a/twme9o2TGaGs+/iCbAhs9chPRUSoLSotVjXzR3f1xqEi3kq6+PS32XU3Z19Jh7
r/Wu6APhax/9EBE7JTQrInmWp8e1aGFSFu6qmk99HQqdL89eSQ63tSh+qVYeGNTd
69q9XqaaaGltinnkflyB6rs6pZAEZs100Q2Ok1BKOiQn0eUpL9plXNDapnvbG2fY
hRfHDxju2hUZl///vsbbaeLb3NHfjtJ8oD0Thm+HPZidSgt0NfC5OckpxqXNJVWo
mpzwBDJG+E8PXVSU4JEwm5RoDRw7ROjfb3U2n0tBS9yfJxBy2TeHn+llex91qDYX
-----END CERTIFICATE-----
-----BEGIN CERTIFICATE-----
MIIDHzCCAsegAwIBAgIBCzAKBggqhkjOPQQDAjCBgTELMAkGA1UEBhMCREUxHzAd
BgNVBAoMFmdlbWF0aWsgR21iSCBOT1QtVkFMSUQxNDAyBgNVBAsMK1plbnRyYWxl
IFJvb3QtQ0EgZGVyIFRlbGVtYXRpa2luZnJhc3RydWt0dXIxGzAZBgNVBAMMEkdF
TS5SQ0E0IFRFU1QtT05MWTAeFw0yMDAyMjcxNDAyMjJaFw0yODAyMjUxNDAyMjFa
MIGEMQswCQYDVQQGEwJERTEfMB0GA1UECgwWZ2VtYXRpayBHbWJIIE5PVC1WQUxJ
RDEyMDAGA1UECwwpS29tcG9uZW50ZW4tQ0EgZGVyIFRlbGVtYXRpa2luZnJhc3Ry
dWt0dXIxIDAeBgNVBAMMF0dFTS5LT01QLUNBMzUgVEVTVC1PTkxZMFowFAYHKoZI
zj0CAQYJKyQDAwIIAQEHA0IABFb7TnDTxbzWkUGt5Bkbbn+gGAftVcFL53seaPU5
VOt/KTxFfk9NRq+vc6bbfjWPENeqL/0pxyQJGRlLMkPaDHmjggEoMIIBJDAdBgNV
HQ4EFgQUJ1Su+poWpTleTbEkJ3WQP48yV0AwHwYDVR0jBBgwFoAUUdvZZkKzSis/
VyxUjYVzHedXz38wSgYIKwYBBQUHAQEEPjA8MDoGCCsGAQUFBzABhi5odHRwOi8v
b2NzcC10ZXN0cmVmLnJvb3QtY2EudGktZGllbnN0ZS5kZS9vY3NwMBIGA1UdEwEB
/wQIMAYBAf8CAQAwDgYDVR0PAQH/BAQDAgEGMBUGA1UdIAQOMAwwCgYIKoIUAEwE
gSMwWwYDVR0RBFQwUqBQBgNVBAqgSQxHZ2VtYXRpayBHZXNlbGxzY2hhZnQgZsO8
ciBUZWxlbWF0aWthbndlbmR1bmdlbiBkZXIgR2VzdW5kaGVpdHNrYXJ0ZSBtYkgw
CgYIKoZIzj0EAwIDRgAwQwIfKOFJhfKqMjMYJ532CzyK74XanIReJx6WWW0BO9OP
xwIgGulcxyEmzM0IQukua3ChJfXgTalDLrHAax0JIRgvTYE=
-----END CERTIFICATE-----
-----BEGIN CERTIFICATE-----
MIIETDCCAzSgAwIBAgIBEzANBgkqhkiG9w0BAQsFADCBgTEbMBkGA1UEAwwSR0VN
LlJDQTEgVEVTVC1PTkxZMTQwMgYDVQQLDCtaZW50cmFsZSBSb290LUNBIGRlciBU
ZWxlbWF0aWtpbmZyYXN0cnVrdHVyMR8wHQYDVQQKDBZnZW1hdGlrIEdtYkggTk9U
LVZBTElEMQswCQYDVQQGEwJERTAeFw0xNDA4MDEwODU0NDNaFw0yMjA3MzAwODU0
NDNaMIGDMQswCQYDVQQGEwJERTEfMB0GA1UECgwWZ2VtYXRpayBHbWJIIE5PVC1W
QUxJRDEyMDAGA1UECwwpS29tcG9uZW50ZW4tQ0EgZGVyIFRlbGVtYXRpa2luZnJh
c3RydWt0dXIxHzAdBgNVBAMMFkdFTS5LT01QLUNBMyBURVNULU9OTFkwggEiMA0G
CSqGSIb3DQEBAQUAA4IBDwAwggEKAoIBAQCkxc2k1Lu7wC7AY3JE6Bkjs3EHmydh
Cqb4alOcdO8KA/L4xPl0GQcPTN6V4u4NH9viciD2lESA9MCmDMPSviba+T83WaEw
4Dl1dJtjeY+ofV/3N6pf8seD6s8mreUZbNFqB/jm26ZYdQF3fLD8YPuFuK+Gg3jF
6jk5DiosfoTwCb4kGZbNfO6hX3xmfUsXIlXpE1C3kNHMqnISHEC/CJl6fhniWG+n
PmWEk6KO9U1hkWW3xq7sEGilfhNxuxGIYxincHOKv9aszWf9zkuJ/8Sq4HeCK1xg
ufObZV9yROGkIUpFW/PmgVlOvIUI84GKXpqY1kRlRi7wPtEKSrnM0RVTAgMBAAGj
gcowgccwHQYDVR0OBBYEFHIRdByayNsIuClTLl5QE6oM5VBUMB8GA1UdIwQYMBaA
FKWxJx2AJhMIwmo4P6vlF3m7F7iXMEoGCCsGAQUFBwEBBD4wPDA6BggrBgEFBQcw
AYYuaHR0cDovL29jc3AtdGVzdHJlZi5yb290LWNhLnRpLWRpZW5zdGUuZGUvb2Nz
cDASBgNVHRMBAf8ECDAGAQH/AgEAMA4GA1UdDwEB/wQEAwIBBjAVBgNVHSAEDjAM
MAoGCCqCFABMBIEjMA0GCSqGSIb3DQEBCwUAA4IBAQA73NQ8Rvc1RtqGXORDfaD3
l4bpjSuMwCHWweJNb49uyh0bZM5/gkQJaF0Ny8myyR8wek8IBzLoreHjhCwSaxQ1
RQbfU6OqW1mQq1tceauuPTxSpRGcWzqwzxMWVpNIWWyfTILTAkyPWrq6QwAKRAIp
QNtpGL73rRy3GgZZ7c/bI1aDqsJOggB1Ihw4OvXQKk8FAiok1dt5PAero903e6HK
ilxDnrPtWJgXiLSAM2Mt67rWOwvjsdO9G0pULhf3shAUlgb+8i+IGRqG5JllFIlB
fvHqY4bxjJcvbGMT2PWp30RD7r4mBXe8K9tgUh0asCfsB0ZDqq3414mel/iLZroI
-----END CERTIFICATE-----
-----BEGIN CERTIFICATE-----
MIIDUjCCAvigAwIBAgIBJTAKBggqhkjOPQQDAjCBgTELMAkGA1UEBhMCREUxHzAd
BgNVBAoMFmdlbWF0aWsgR21iSCBOT1QtVkFMSUQxNDAyBgNVBAsMK1plbnRyYWxl
IFJvb3QtQ0EgZGVyIFRlbGVtYXRpa2luZnJhc3RydWt0dXIxGzAZBgNVBAMMEkdF
TS5SQ0E0IFRFU1QtT05MWTAeFw0yMTA2MTAxMDQ1MjJaFw0yOTA2MDgxMDQ1MjFa
MIGEMQswCQYDVQQGEwJERTEfMB0GA1UECgwWZ2VtYXRpayBHbWJIIE5PVC1WQUxJ
RDEyMDAGA1UECwwpS29tcG9uZW50ZW4tQ0EgZGVyIFRlbGVtYXRpa2luZnJhc3Ry
dWt0dXIxIDAeBgNVBAMMF0dFTS5LT01QLUNBNTAgVEVTVC1PTkxZMFowFAYHKoZI
zj0CAQYJKyQDAwIIAQEHA0IABGDIQ/rR6jYzxjGyPmesnz5SbWNShsVyV4xDAkTY
CqYrDCcsT8hYY7f/i9SvsePMTT4FiISKsE1i6TgnZmxW3OejggFZMIIBVTAdBgNV
HQ4EFgQUOuKqJZJOrKmUfc8ZaeoTBrmoMNMwHwYDVR0jBBgwFoAUUdvZZkKzSis/
VyxUjYVzHedXz38wSgYIKwYBBQUHAQEEPjA8MDoGCCsGAQUFBzABhi5odHRwOi8v
b2NzcC10ZXN0cmVmLnJvb3QtY2EudGktZGllbnN0ZS5kZS9vY3NwMA4GA1UdDwEB
/wQEAwIBBjBGBgNVHSAEPzA9MDsGCCqCFABMBIEjMC8wLQYIKwYBBQUHAgEWIWh0
dHA6Ly93d3cuZ2VtYXRpay5kZS9nby9wb2xpY2llczBbBgNVHREEVDBSoFAGA1UE
CqBJDEdnZW1hdGlrIEdlc2VsbHNjaGFmdCBmw7xyIFRlbGVtYXRpa2Fud2VuZHVu
Z2VuIGRlciBHZXN1bmRoZWl0c2thcnRlIG1iSDASBgNVHRMBAf8ECDAGAQH/AgEA
MAoGCCqGSM49BAMCA0gAMEUCIFon6V178kFN5t6+CyZG+QxZ2uM4J31/lVe7LZyG
2edMAiEAgNKUdc2aq8Sl32sDt46OAid4UWRGDwnkdij5dR1s5xA=
-----END CERTIFICATE-----
-----BEGIN CERTIFICATE-----
MIIC8zCCApmgAwIBAgIBCzAKBggqhkjOPQQDAjCBgTELMAkGA1UEBhMCREUxHzAd
BgNVBAoMFmdlbWF0aWsgR21iSCBOT1QtVkFMSUQxNDAyBgNVBAsMK1plbnRyYWxl
IFJvb3QtQ0EgZGVyIFRlbGVtYXRpa2luZnJhc3RydWt0dXIxGzAZBgNVBAMMEkdF
TS5SQ0E1IFRFU1QtT05MWTAeFw0yMTA5MDcwNTUwMjVaFw0yOTA5MDUwNTUwMjRa
MIGEMQswCQYDVQQGEwJERTEfMB0GA1UECgwWZ2VtYXRpayBHbWJIIE5PVC1WQUxJ
RDEyMDAGA1UECwwpS29tcG9uZW50ZW4tQ0EgZGVyIFRlbGVtYXRpa2luZnJhc3Ry
dWt0dXIxIDAeBgNVBAMMF0dFTS5LT01QLUNBNTMgVEVTVC1PTkxZMFowFAYHKoZI
zj0CAQYJKyQDAwIIAQEHA0IABIL6y4NefqdWoiVirPKBvUxT53/zuFTT0Dz1e5x9
7PrqKTWVtBICIcUZppovFZDlGbhSkpnoyY6tUqI1yHqX9X6jgfswgfgwHQYDVR0O
BBYEFBYQBzl1Ja7Y/jBOE17f0W9LpfQhMB8GA1UdIwQYMBaAFOGt4Af80iB5JPTc
l70yZM1rFIUJMEoGCCsGAQUFBwEBBD4wPDA6BggrBgEFBQcwAYYuaHR0cDovL29j
c3AtdGVzdHJlZi5yb290LWNhLnRpLWRpZW5zdGUuZGUvb2NzcDAOBgNVHQ8BAf8E
BAMCAQYwRgYDVR0gBD8wPTA7BggqghQATASBIzAvMC0GCCsGAQUFBwIBFiFodHRw
Oi8vd3d3LmdlbWF0aWsuZGUvZ28vcG9saWNpZXMwEgYDVR0TAQH/BAgwBgEB/wIB
ADAKBggqhkjOPQQDAgNIADBFAiA8apcaz1+W1+wNKkVkOb2w4+blkaxJPbuPdL6h
QgIAawIhAKmCokbAskoF6DYMVy3sE2/vnqhrfRLd87xycgmQLTbR
-----END CERTIFICATE-----
-----BEGIN CERTIFICATE-----
MIIEfjCCA2agAwIBAgIBHjANBgkqhkiG9w0BAQsFADCBgTELMAkGA1UEBhMCREUx
HzAdBgNVBAoMFmdlbWF0aWsgR21iSCBOT1QtVkFMSUQxNDAyBgNVBAsMK1plbnRy
YWxlIFJvb3QtQ0EgZGVyIFRlbGVtYXRpa2luZnJhc3RydWt0dXIxGzAZBgNVBAMM
EkdFTS5SQ0E2IFRFU1QtT05MWTAeFw0yMTExMjMxMDI3MjRaFw0yOTExMjExMDI3
MjNaMIGEMQswCQYDVQQGEwJERTEfMB0GA1UECgwWZ2VtYXRpayBHbWJIIE5PVC1W
QUxJRDEyMDAGA1UECwwpS29tcG9uZW50ZW4tQ0EgZGVyIFRlbGVtYXRpa2luZnJh
c3RydWt0dXIxIDAeBgNVBAMMF0dFTS5LT01QLUNBNTQgVEVTVC1PTkxZMIIBIjAN
BgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAoulzTBJFr7iJOnoX2b8rExhMwwCY
9Y13dZWcYiQexRq7hdKn+cdMcd2P0eKeB/Y/ppRgByaKgHAhhcLQwCd5i3NpTsRz
fbYCwDr5cdGKCBopoPwgDoM46OyIHFHIX4XVh7+/ijtjgVHJB7IesgoIHwMLOYwV
26bEfzO34zrxmvwm+H7wnRLfr5CloTfvt0z47gzkPK3xty4AYHHsEGMaZ1Ei1xqk
HmoTJROeWCNhc6sT+WXfq4w4/OW7HtOByhmW7UFqNQmDFRoEzdR/HxT0ds2Mheou
uRTdW5CX92eEOf5c/kM8nLM4blwKP7KOCXzxxZfAYjKMEoAc5Fl7PNBY5QIDAQAB
o4H7MIH4MB0GA1UdDgQWBBSkGuFQXQyl4faNhGMB8GMz3X69gzAfBgNVHSMEGDAW
gBRM9+BlWFWY5jmLyAd1PUymcCzPKTBKBggrBgEFBQcBAQQ+MDwwOgYIKwYBBQUH
MAGGLmh0dHA6Ly9vY3NwLXRlc3RyZWYucm9vdC1jYS50aS1kaWVuc3RlLmRlL29j
c3AwDgYDVR0PAQH/BAQDAgEGMEYGA1UdIAQ/MD0wOwYIKoIUAEwEgSMwLzAtBggr
BgEFBQcCARYhaHR0cDovL3d3dy5nZW1hdGlrLmRlL2dvL3BvbGljaWVzMBIGA1Ud
EwEB/wQIMAYBAf8CAQAwDQYJKoZIhvcNAQELBQADggEBAKqBcKKypm6gVJRUUe00
am1W8VA/Ddn8QxRBSMUB8+9gM8vsKw0owYamEUCzz8hLVl7B9AtG2qgbAlkZpiVG
qLAJo8y1VP4jeTSjEaWEP+ykOw+Ud0TWfIFDa8VIB6A7LBRA9/id6gk4gsJq0+f0
dQ06+gKxLR7gmtR1oR9AT6Y2ClKIgbu4k7jIN1l3MqH5q7TUCfmeMD4r7OLbz9KQ
i6WYw4qqXKX2CAT6syf5HRRiiQwUGT1nv9Q2r82nyN/zhyXtMnoBSrCBekHcj7i4
T927qLiQHBf2oU8xKjHTVdEYWNS+6f2jpsBcrvit/J20Mrg/id7rbqWvlmRpVflv
MMI=
-----END CERTIFICATE-----
-----BEGIN CERTIFICATE-----
MIIETDCCAzSgAwIBAgIBKDANBgkqhkiG9w0BAQsFADCBgTEbMBkGA1UEAwwSR0VN
LlJDQTEgVEVTVC1PTkxZMTQwMgYDVQQLDCtaZW50cmFsZSBSb290LUNBIGRlciBU
ZWxlbWF0aWtpbmZyYXN0cnVrdHVyMR8wHQYDVQQKDBZnZW1hdGlrIEdtYkggTk9U
LVZBTElEMQswCQYDVQQGEwJERTAeFw0xNDEyMTExMzIzNDlaFw0yMjEyMDkxMzIz
NDhaMIGDMQswCQYDVQQGEwJERTEfMB0GA1UECgwWZ2VtYXRpayBHbWJIIE5PVC1W
QUxJRDEyMDAGA1UECwwpS29tcG9uZW50ZW4tQ0EgZGVyIFRlbGVtYXRpa2luZnJh
c3RydWt0dXIxHzAdBgNVBAMMFkdFTS5LT01QLUNBOCBURVNULU9OTFkwggEiMA0G
CSqGSIb3DQEBAQUAA4IBDwAwggEKAoIBAQDaMBCQXjqmNSymLHnYIWUMk/iT/bkY
P3bBSHNyXBt/5QYNTSNsjTxOkv6/iEWTQjUmbGmWiNlKT/N+r8fIta0ZRUKFmr77
Ap/Fsi2eQCurbh6pJMJjQkaKRnemESGXZPnH53txFPljFh4NZ3SsukrqIGsdrrCi
VsWtj6WIdjUK/B1HwJnbDSW7nj2XCbhnnKFTE/j4zV82MhaoyrsLKd6EOljBUMgt
MpU0WgkD4KBGfBssBfYQcZYEyFdTk97mE80ScRcxF2F+V01vWtJeL15i96AL/Yin
lD2GDAnmtxlBkM4ajDoQopc9sk1ot+bSRA9pXKl5fZMFY8umdfT/TfDTAgMBAAGj
gcowgccwHQYDVR0OBBYEFCUwbRjVPLFBaQqXekN16ZUWAabSMB8GA1UdIwQYMBaA
FKWxJx2AJhMIwmo4P6vlF3m7F7iXMEoGCCsGAQUFBwEBBD4wPDA6BggrBgEFBQcw
AYYuaHR0cDovL29jc3AtdGVzdHJlZi5yb290LWNhLnRpLWRpZW5zdGUuZGUvb2Nz
cDASBgNVHRMBAf8ECDAGAQH/AgEAMA4GA1UdDwEB/wQEAwIBBjAVBgNVHSAEDjAM
MAoGCCqCFABMBIEjMA0GCSqGSIb3DQEBCwUAA4IBAQAjgqYC4K992hJlWPyR4Nca
yzwNcjcWYZyIDqlXe0S93xre7ZTVP9THaBZtfQtXCF/cMUGLAHLf8a8WRdCT/s/E
YTmJKFeKwNKQTUcSoVq7JVrrqpHahoCzBtkneyaMqP/IGIl72HN/lUDgucc4uApo
bhTaf9o0ngijJi/e6qsfP76yz9gBWFLXMN4cjOxxBzrR1x2OK2DsSV4/HaPInQj9
BWUkPEPbX5pSd+FSrlKxfOV8lRAJeRqWSObuExuzsnRkmgHrz1Aqb3Z5ggWki8Ds
Lezz53xrS2Q61iMo6lDquw3SxCZ1cGMtr8dnwqts+0czA3I3BrhY2naOL45NOHXn
-----END CERTIFICATE-----
-----BEGIN CERTIFICATE-----
MIIETDCCAzSgAwIBAgIBLzANBgkqhkiG9w0BAQsFADCBgTEbMBkGA1UEAwwSR0VN
LlJDQTEgVEVTVC1PTkxZMTQwMgYDVQQLDCtaZW50cmFsZSBSb290LUNBIGRlciBU
ZWxlbWF0aWtpbmZyYXN0cnVrdHVyMR8wHQYDVQQKDBZnZW1hdGlrIEdtYkggTk9U
LVZBTElEMQswCQYDVQQGEwJERTAeFw0xNDEyMjMxNjIzMTlaFw0yMjEyMjExNjIz
MThaMIGDMQswCQYDVQQGEwJERTEfMB0GA1UECgwWZ2VtYXRpayBHbWJIIE5PVC1W
QUxJRDEyMDAGA1UECwwpS29tcG9uZW50ZW4tQ0EgZGVyIFRlbGVtYXRpa2luZnJh
c3RydWt0dXIxHzAdBgNVBAMMFkdFTS5LT01QLUNBOSBURVNULU9OTFkwggEiMA0G
CSqGSIb3DQEBAQUAA4IBDwAwggEKAoIBAQC6Cyk+MreZ0yfRgzDzieVU+a2u8uuj
p8hyU740FHdjhuH51QLjbrYbWyGzVTVZ5Yr78HC3VKOFQAJGuZLl0hHGy/eE1JkE
N56GKTxYOyB69HjzG5Z+1vjFMZhv3V4asnzbyWTR3Gbj1s9ok17B5tLSn5TATGsH
/HVsLR1gMjio7lxrmIDUNKUXBh5/DTEWtgWZ6K3DDXo2TdR/F7T/iok9zGdl3FFs
W8O9PK8/mYzpC73kh36iX8XjwQTJfJ+MOJ0SEfE8qJCYvd8THBm2zaMjQyulTtYj
W37XImkP+LwRzKKfUlYoL9s6oBEEJcZIIWQltl1k0umaKEf38ugkANxxAgMBAAGj
gcowgccwHQYDVR0OBBYEFM+uNU5EoUsBm01lYJFJy6s1k/vkMB8GA1UdIwQYMBaA
FKWxJx2AJhMIwmo4P6vlF3m7F7iXMEoGCCsGAQUFBwEBBD4wPDA6BggrBgEFBQcw
AYYuaHR0cDovL29jc3AtdGVzdHJlZi5yb290LWNhLnRpLWRpZW5zdGUuZGUvb2Nz
cDASBgNVHRMBAf8ECDAGAQH/AgEAMA4GA1UdDwEB/wQEAwIBBjAVBgNVHSAEDjAM
MAoGCCqCFABMBIEjMA0GCSqGSIb3DQEBCwUAA4IBAQA0SW07JWC9s5OeMLJESOfp
BGd6ctCt1S5Xz6FQr6uqz5uWWJYRdPKQV4+vI7Fg6SrUNiZCIqaZEpwNbqDwH6EP
rMAo7rpJ6Zb5hGVSQYvpbawXLGwIgiDxD6oTsn38KJ4SkdqnEPNDkTtwWJ56SVyW
KkKPPUffhz/Yh7bYxkrayhjmLxvBr3mA2MTXix9lSQlGitBv55bvWeIvx169rv6q
7iYTVX2UR7ZUlEvEdNBfrvLL6R9OKRW84Dy44OmsvNIuih2PKqx/gXKF7w/2ppAZ
5pJ4Q5VliTYnsE7CFvs55wop03hLb0SuLqLN6p8wj4c1LTkq1fp5PXraVRAnASGs
-----END CERTIFICATE-----
-----BEGIN CERTIFICATE-----
MIICuTCCAmCgAwIBAgIBIjAKBggqhkjOPQQDAjCBgTELMAkGA1UEBhMCREUxHzAdBgNVBAoMFmdlbWF0aWsgR21iSCBOT1QtVkFMSUQxNDAyBgNVBAsMK1plbnRyYWxlIFJvb3QtQ0EgZGVyIFRlbGVtYXRpa2luZnJhc3RydWt0dXIxGzAZBgNVBAMMEkdFTS5SQ0EzIFRFU1QtT05MWTAeFw0xODA2MjAwOTQ5NTlaFw0yNjA2MTgwOTQ5NThaMIGEMQswCQYDVQQGEwJERTEfMB0GA1UECgwWZ2VtYXRpayBHbWJIIE5PVC1WQUxJRDEyMDAGA1UECwwpS29tcG9uZW50ZW4tQ0EgZGVyIFRlbGVtYXRpa2luZnJhc3RydWt0dXIxIDAeBgNVBAMMF0dFTS5LT01QLUNBMjggVEVTVC1PTkxZMFowFAYHKoZIzj0CAQYJKyQDAwIIAQEHA0IABFuRbiWZxMO8y+FvvQAPuAC+1NbkMRMTEyuFj9REDzkCYwFezS+WwbsCmsXgcDRnkDZ0lqFpQR0eS+T+/6etrtijgcIwgb8wHQYDVR0OBBYEFABqOJDzma4hj1La7sGMboCtYSLJMB8GA1UdIwQYMBaAFAeQMy11U15/+Mg3v37JJldo3zjSMEIGCCsGAQUFBwEBBDYwNDAyBggrBgEFBQcwAYYmaHR0cDovL29jc3Aucm9vdC1jYS50aS1kaWVuc3RlLmRlL29jc3AwEgYDVR0TAQH/BAgwBgEB/wIBADAOBgNVHQ8BAf8EBAMCAQYwFQYDVR0gBA4wDDAKBggqghQATASBIzAKBggqhkjOPQQDAgNHADBEAiBlbZRIayrzTk21ghnuni8u3trfhqwoNOHHRYpEMTTpLQIgdjiy1cKJSwLfRQ2RKI1NrI7ogEk/PQvw7c3iGbFVGMY=
-----END CERTIFICATE-----
        `, le.PU_KOMP_CA3 = "MIIEGjCCAwKgAwIBAgIBCTANBgkqhkiG9w0BAQsFADBtMQswCQYDVQQGEwJERTEVMBMGA1UECgwMZ2VtYXRpayBHbWJIMTQwMgYDVQQLDCtaZW50cmFsZSBSb290LUNBIGRlciBUZWxlbWF0aWtpbmZyYXN0cnVrdHVyMREwDwYDVQQDDAhHRU0uUkNBMjAeFw0xODAzMTYxMjIzMDdaFw0yNjAzMTQxMjIzMDZaMG8xCzAJBgNVBAYTAkRFMRUwEwYDVQQKDAxnZW1hdGlrIEdtYkgxMjAwBgNVBAsMKUtvbXBvbmVudGVuLUNBIGRlciBUZWxlbWF0aWtpbmZyYXN0cnVrdHVyMRUwEwYDVQQDDAxHRU0uS09NUC1DQTMwggEiMA0GCSqGSIb3DQEBAQUAA4IBDwAwggEKAoIBAQCoGcPUJ6nMehq9o9lc+Y4zZEnL74Q9xsXSMyM4h4KRAREGtppkYmQ+64x3fi3e7SS6pPkMKYsNZGxeL6WwkmYVuOdJCcP6xSOEcITRMTQAKG4J0i8b+qlMGH329wzto3SWQVyL0Df22UndpnqXnM2eCn233naJwpPPWHImHe73xhL9AWbzt4Sio95SX48gf9MDrlvnacK9wfchoWAO42NGF/MWUdrrlloejA//jMca4awpjuZgs+dtbxXhLD3U6Yqbm6k68bm4q2kZLlvtRWGTsu2RwQSB+xGh/hOg9fUBi7G9bOmRZKeWaBAWYkdoKwxSmH/MmAPFRJZ68iZux2GhAgMBAAGjgcIwgb8wHQYDVR0OBBYEFP21uRd5vbhrHilXIj3CubOJgc9NMB8GA1UdIwQYMBaAFOxcGOATtENsCYzf+jw8W35LcIRGMEIGCCsGAQUFBwEBBDYwNDAyBggrBgEFBQcwAYYmaHR0cDovL29jc3Aucm9vdC1jYS50aS1kaWVuc3RlLmRlL29jc3AwEgYDVR0TAQH/BAgwBgEB/wIBADAOBgNVHQ8BAf8EBAMCAQYwFQYDVR0gBA4wDDAKBggqghQATASBIzANBgkqhkiG9w0BAQsFAAOCAQEAR5izJQOlGTH6Q50vYeqkQ8hibqzlqO4ktpEpfWzFqnLI78SNGhHu3bK3d6CQSKDYf9iYFUTEtLsMt49bVv1kLS53XLVTzP1Qbo5t47rTI6NdiOpDFAydEE8fyq0MYfPx6FroyhNXRZyrF9vuZfzZcjmAjo8xw9gaWhappLKbui6KZ17L7tG6qaKe1JrU2D7sBT7cy2h8qcuzlpyvHWZiozOEAgeHVZnajVOtiwqkjzazauok0RIM7Qdx4r/Q5nKi8VL2ejyPRayONGrN6makoX10XfeLptUlyEJ16j+UiwK3JtL5VVX0KR9dL9Ym6pnuQrAAdaMqybNjKpzPm5NMLg==';", le.PU_KOMP_CA4 = "MIICjjCCAjWgAwIBAgIBBDAKBggqhkjOPQQDAjBtMQswCQYDVQQGEwJERTEVMBMGA1UECgwMZ2VtYXRpayBHbWJIMTQwMgYDVQQLDCtaZW50cmFsZSBSb290LUNBIGRlciBUZWxlbWF0aWtpbmZyYXN0cnVrdHVyMREwDwYDVQQDDAhHRU0uUkNBMzAeFw0xODA5MTMwOTI2MzJaFw0yNjA5MTEwOTI2MzFaMG8xCzAJBgNVBAYTAkRFMRUwEwYDVQQKDAxnZW1hdGlrIEdtYkgxMjAwBgNVBAsMKUtvbXBvbmVudGVuLUNBIGRlciBUZWxlbWF0aWtpbmZyYXN0cnVrdHVyMRUwEwYDVQQDDAxHRU0uS09NUC1DQTQwWjAUBgcqhkjOPQIBBgkrJAMDAggBAQcDQgAEMHrNkr8kZc7CekPUKEfFdr8olMKYCjf/swYznknkizF0WIqk/kKYAMT/nXFngy+vag+k1uCGJetwC2jOVfLS5KOBwjCBvzAdBgNVHQ4EFgQUAlXi2yHPtCsdra3YHvxEYf7jtbAwHwYDVR0jBBgwFoAU38O+db4l6xMyMC6nUIUInzcQ0OgwQgYIKwYBBQUHAQEENjA0MDIGCCsGAQUFBzABhiZodHRwOi8vb2NzcC5yb290LWNhLnRpLWRpZW5zdGUuZGUvb2NzcDASBgNVHRMBAf8ECDAGAQH/AgEAMA4GA1UdDwEB/wQEAwIBBjAVBgNVHSAEDjAMMAoGCCqCFABMBIEjMAoGCCqGSM49BAMCA0cAMEQCIDwsX6M1FxEFgqyhaTwfcue6UW/zchsfp88n3mQynKaWAiBa7PCgqmlUGk+kkC0qiOkHqTNAhjkI4XdTaMvdeBR4Rg==", le.PU_KOMP_CA5 = "MIIEGjCCAwKgAwIBAgIBFjANBgkqhkiG9w0BAQsFADBtMQswCQYDVQQGEwJERTEVMBMGA1UECgwMZ2VtYXRpayBHbWJIMTQwMgYDVQQLDCtaZW50cmFsZSBSb290LUNBIGRlciBUZWxlbWF0aWtpbmZyYXN0cnVrdHVyMREwDwYDVQQDDAhHRU0uUkNBMjAeFw0yMTAzMDMxMDQzMDZaFw0yNjEyMDcwODQxNTZaMG8xCzAJBgNVBAYTAkRFMRUwEwYDVQQKDAxnZW1hdGlrIEdtYkgxMjAwBgNVBAsMKUtvbXBvbmVudGVuLUNBIGRlciBUZWxlbWF0aWtpbmZyYXN0cnVrdHVyMRUwEwYDVQQDDAxHRU0uS09NUC1DQTUwggEiMA0GCSqGSIb3DQEBAQUAA4IBDwAwggEKAoIBAQCunOiYLAG2qQ64hRh/6csWp4l1WqfIBPl7EF52v560RXYB+xIA1iaMUq9VV7q+7bYP1gZDwr3vZyX+XL6K5je1iL4Sl1GvXI09AGogSiKeym1NmXC35AM2c1H0PzUGatVqiAF8SnEf8IgH5PQP+yudleDz3+5WqY+AarN2YLG4inGgWVKQ8kJA+LsL3ohtcnQbkJAvKKZDSJXx/4lh//t50TW7pLodRDdwjd0N7IWz5xbZOFePv8Ihx5xFpJ4gXiQq7O4LBIsnmieb5RGjYGHYctLk2dyfErRhlB46tT7p6597oLf0vlddx1++CEIXWWudWcYo+mWbJlPruG3GcHEPAgMBAAGjgcIwgb8wHQYDVR0OBBYEFJVUmz+9xDy0eMiRjP1oV4pkpDCXMB8GA1UdIwQYMBaAFOxcGOATtENsCYzf+jw8W35LcIRGMEIGCCsGAQUFBwEBBDYwNDAyBggrBgEFBQcwAYYmaHR0cDovL29jc3Aucm9vdC1jYS50aS1kaWVuc3RlLmRlL29jc3AwEgYDVR0TAQH/BAgwBgEB/wIBADAOBgNVHQ8BAf8EBAMCAQYwFQYDVR0gBA4wDDAKBggqghQATASBIzANBgkqhkiG9w0BAQsFAAOCAQEAe+JwpiwO+8tBw5EMEvQGceqbke9s5HzSSTJpXYaVO2GSIpFt37k9aDoyvGbttxY1pdznrWkfw9vPKaMuY0NQVYJ+EE2Es73q7Z6H2/pjNkdd7Dz0TSTw0BV+lHf5tHutT0MzA72LnJsW26ki/j+rHuxy3XHw6wpKC6cQtNSuZusmvLyLo1XUVuzxnyX4FaRV7nCXliK7zp8wvQiY7ycg1qYpamRXsVreVeqfZqCj3ynuMAFa0BkPi/hEPTHJvJ+g3c9a/FX4vrJ/wyRAi6KU/Yiv0RVREF162yGlu4J5A6BVTJfKsiKaLeNGQSeG9bj7AFyRnsguTPG79GqjjrFVBQ==", le.PU_KOMP_CA6 = "MIICwTCCAmagAwIBAgIBDzAKBggqhkjOPQQDAjBtMQswCQYDVQQGEwJERTEVMBMGA1UECgwMZ2VtYXRpayBHbWJIMTQwMgYDVQQLDCtaZW50cmFsZSBSb290LUNBIGRlciBUZWxlbWF0aWtpbmZyYXN0cnVrdHVyMREwDwYDVQQDDAhHRU0uUkNBNDAeFw0yMTA3MjIxMTAyNTRaFw0yOTA3MjAxMTAyNTNaMG8xCzAJBgNVBAYTAkRFMRUwEwYDVQQKDAxnZW1hdGlrIEdtYkgxMjAwBgNVBAsMKUtvbXBvbmVudGVuLUNBIGRlciBUZWxlbWF0aWtpbmZyYXN0cnVrdHVyMRUwEwYDVQQDDAxHRU0uS09NUC1DQTYwWjAUBgcqhkjOPQIBBgkrJAMDAggBAQcDQgAEU0sqwelht29DQfUO0jWkm33wC/SYu6IhbmhFU92l+KJGGEOmfgh+2SD7FXjC/2FI8jsD4QCV8OIg8Mz8Cq0zeaOB8zCB8DAdBgNVHQ4EFgQUMNLhNq9sV/Kxg5Xatjime7oxdMowHwYDVR0jBBgwFoAUgGFwGRw47eJr5KEuqyI+dcmU/n0wQgYIKwYBBQUHAQEENjA0MDIGCCsGAQUFBzABhiZodHRwOi8vb2NzcC5yb290LWNhLnRpLWRpZW5zdGUuZGUvb2NzcDAOBgNVHQ8BAf8EBAMCAQYwRgYDVR0gBD8wPTA7BggqghQATASBIzAvMC0GCCsGAQUFBwIBFiFodHRwOi8vd3d3LmdlbWF0aWsuZGUvZ28vcG9saWNpZXMwEgYDVR0TAQH/BAgwBgEB/wIBADAKBggqhkjOPQQDAgNJADBGAiEAoPMSKaLS7hMt86ZGuVZVm4eP2+WzVr/Ci7lycUmJtUICIQCbV7GmvYv17Hn1TyJV4NwUiDyEnnLt4f6GJg3Ge2aLrQ==", le.PU_KOMP_CA7 = "MIIESzCCAzOgAwIBAgIBDzANBgkqhkiG9w0BAQsFADBtMQswCQYDVQQGEwJERTEVMBMGA1UECgwMZ2VtYXRpayBHbWJIMTQwMgYDVQQLDCtaZW50cmFsZSBSb290LUNBIGRlciBUZWxlbWF0aWtpbmZyYXN0cnVrdHVyMREwDwYDVQQDDAhHRU0uUkNBNjAeFw0yMTEyMDIwODM1MjVaFw0yOTExMzAwODM1MjRaMG8xCzAJBgNVBAYTAkRFMRUwEwYDVQQKDAxnZW1hdGlrIEdtYkgxMjAwBgNVBAsMKUtvbXBvbmVudGVuLUNBIGRlciBUZWxlbWF0aWtpbmZyYXN0cnVrdHVyMRUwEwYDVQQDDAxHRU0uS09NUC1DQTcwggEiMA0GCSqGSIb3DQEBAQUAA4IBDwAwggEKAoIBAQD6SHESEtP/nbeKjfZV4p7bxJbcvBqxwnVa+5DknHKYAuayhaEGeMM3scRLpMLhlwnKC0x9uKZiuuDQxrjfWulIBn49IBX2Lp4rEF8L7YPshKHAcsCX0CGJMO3HGfNAHt0/Q313INB8F6mrKPD1OrmSGdtE96XzdFFkp/qyd24maYv8V67gdvl7rb17HDrMh1vHZhyzTLULm01z6sXli8CRS9LOTgY5RYSwZdHWh0jyMjORGWYDjPT7AQB/ynS9BIXcGCduXS3NLCPAgMUUHprhihQ8IJlf0s64GCV7otLggT0nv6qk1y3v4seBnvKfbHMLYn3CSDAG9PFxQgWuXYdXAgMBAAGjgfMwgfAwHQYDVR0OBBYEFASz9BYwRTt7kUrzfPCJ5QlOklGUMB8GA1UdIwQYMBaAFBhExNpmkzrvTzsqCWXk/iiQHlURMEIGCCsGAQUFBwEBBDYwNDAyBggrBgEFBQcwAYYmaHR0cDovL29jc3Aucm9vdC1jYS50aS1kaWVuc3RlLmRlL29jc3AwDgYDVR0PAQH/BAQDAgEGMEYGA1UdIAQ/MD0wOwYIKoIUAEwEgSMwLzAtBggrBgEFBQcCARYhaHR0cDovL3d3dy5nZW1hdGlrLmRlL2dvL3BvbGljaWVzMBIGA1UdEwEB/wQIMAYBAf8CAQAwDQYJKoZIhvcNAQELBQADggEBAC2JoOStUZx4xLsCY5SH+5ijNndZ7aihg4zy0woMWF58eWjwSg1PjMbJWKkbuyYlj5UaDB4Iemb+KaDeuPEmSBl0+WSVHMlzt5fc0kz7nJFcQu9eKucAeHvkN2l/p6QRcOlwvBIxlhSRe+ukzmK4J18kWkGD6nDRzN5zq6Sc3Qmr01UJBO6s6+GLRw9j0ZddOIsLeR6RZf8e94jpUQShYS13LSE4C72uo+z8Vq6LN7eAoMfMwA8czQt/fr6YOhQqTSev0nZB6LSBCLypGmxZt2Wg2vxVGt3jb4w7Z8NzCEEGI/THKql+5a4AWMXlCONDqrd1rfFu6s0/MS4If0FX9lg=", le.PU_KOMP_CA8 = "MIICvjCCAmWgAwIBAgIBBTAKBggqhkjOPQQDAjBtMQswCQYDVQQGEwJERTEVMBMGA1UECgwMZ2VtYXRpayBHbWJIMTQwMgYDVQQLDCtaZW50cmFsZSBSb290LUNBIGRlciBUZWxlbWF0aWtpbmZyYXN0cnVrdHVyMREwDwYDVQQDDAhHRU0uUkNBNzAeFw0yMzA3MTgxMTM3MjlaFw0zMTA3MTYxMTM3MjhaMG8xCzAJBgNVBAYTAkRFMRUwEwYDVQQKDAxnZW1hdGlrIEdtYkgxMjAwBgNVBAsMKUtvbXBvbmVudGVuLUNBIGRlciBUZWxlbWF0aWtpbmZyYXN0cnVrdHVyMRUwEwYDVQQDDAxHRU0uS09NUC1DQTgwWTATBgcqhkjOPQIBBggqhkjOPQMBBwNCAAQ+hw3/6kMN8rV5YsJuAMxT0nPTpeBCg8FC5i5vNGR3JSNk92GJuEJLTcNflU1I8AF3/iWE+a6HaYoK1EhKQALfo4HzMIHwMB0GA1UdDgQWBBT4buDJgny6hHcPBsNaofxUKYn/QDAfBgNVHSMEGDAWgBQTEHgeiHfbjeWr6C0A4DL47fUhVTBCBggrBgEFBQcBAQQ2MDQwMgYIKwYBBQUHMAGGJmh0dHA6Ly9vY3NwLnJvb3QtY2EudGktZGllbnN0ZS5kZS9vY3NwMA4GA1UdDwEB/wQEAwIBBjBGBgNVHSAEPzA9MDsGCCqCFABMBIEjMC8wLQYIKwYBBQUHAgEWIWh0dHA6Ly93d3cuZ2VtYXRpay5kZS9nby9wb2xpY2llczASBgNVHRMBAf8ECDAGAQH/AgEAMAoGCCqGSM49BAMCA0cAMEQCICHJMFsD6CYyOi8gHPVbMKwloOI1IoJ4/rNliMY+r2cIAiAlAx6wf7G1UrCLB65DriN5CA1/Frj4NoPF6Fg1swEUZQ==", le.PU = `
-----BEGIN CERTIFICATE-----
${le.PU_KOMP_CA3}
-----END CERTIFICATE-----
-----BEGIN CERTIFICATE-----
${le.PU_KOMP_CA4}
-----END CERTIFICATE-----
-----BEGIN CERTIFICATE-----
${le.PU_KOMP_CA5}
-----END CERTIFICATE-----
-----BEGIN CERTIFICATE-----
${le.PU_KOMP_CA6}
-----END CERTIFICATE-----
-----BEGIN CERTIFICATE-----
${le.PU_KOMP_CA7}
-----END CERTIFICATE-----
-----BEGIN CERTIFICATE-----
${le.PU_KOMP_CA8}
-----END CERTIFICATE-----
`, le.TITUS = `-----BEGIN CERTIFICATE-----
MIIFFjCCAv6gAwIBAgIRAJErCErPDBinU/bWLiWnX1owDQYJKoZIhvcNAQELBQAw
TzELMAkGA1UEBhMCVVMxKTAnBgNVBAoTIEludGVybmV0IFNlY3VyaXR5IFJlc2Vh
cmNoIEdyb3VwMRUwEwYDVQQDEwxJU1JHIFJvb3QgWDEwHhcNMjAwOTA0MDAwMDAw
WhcNMjUwOTE1MTYwMDAwWjAyMQswCQYDVQQGEwJVUzEWMBQGA1UEChMNTGV0J3Mg
RW5jcnlwdDELMAkGA1UEAxMCUjMwggEiMA0GCSqGSIb3DQEBAQUAA4IBDwAwggEK
AoIBAQC7AhUozPaglNMPEuyNVZLD+ILxmaZ6QoinXSaqtSu5xUyxr45r+XXIo9cP
R5QUVTVXjJ6oojkZ9YI8QqlObvU7wy7bjcCwXPNZOOftz2nwWgsbvsCUJCWH+jdx
sxPnHKzhm+/b5DtFUkWWqcFTzjTIUu61ru2P3mBw4qVUq7ZtDpelQDRrK9O8Zutm
NHz6a4uPVymZ+DAXXbpyb/uBxa3Shlg9F8fnCbvxK/eG3MHacV3URuPMrSXBiLxg
Z3Vms/EY96Jc5lP/Ooi2R6X/ExjqmAl3P51T+c8B5fWmcBcUr2Ok/5mzk53cU6cG
/kiFHaFpriV1uxPMUgP17VGhi9sVAgMBAAGjggEIMIIBBDAOBgNVHQ8BAf8EBAMC
AYYwHQYDVR0lBBYwFAYIKwYBBQUHAwIGCCsGAQUFBwMBMBIGA1UdEwEB/wQIMAYB
Af8CAQAwHQYDVR0OBBYEFBQusxe3WFbLrlAJQOYfr52LFMLGMB8GA1UdIwQYMBaA
FHm0WeZ7tuXkAXOACIjIGlj26ZtuMDIGCCsGAQUFBwEBBCYwJDAiBggrBgEFBQcw
AoYWaHR0cDovL3gxLmkubGVuY3Iub3JnLzAnBgNVHR8EIDAeMBygGqAYhhZodHRw
Oi8veDEuYy5sZW5jci5vcmcvMCIGA1UdIAQbMBkwCAYGZ4EMAQIBMA0GCysGAQQB
gt8TAQEBMA0GCSqGSIb3DQEBCwUAA4ICAQCFyk5HPqP3hUSFvNVneLKYY611TR6W
PTNlclQtgaDqw+34IL9fzLdwALduO/ZelN7kIJ+m74uyA+eitRY8kc607TkC53wl
ikfmZW4/RvTZ8M6UK+5UzhK8jCdLuMGYL6KvzXGRSgi3yLgjewQtCPkIVz6D2QQz
CkcheAmCJ8MqyJu5zlzyZMjAvnnAT45tRAxekrsu94sQ4egdRCnbWSDtY7kh+BIm
lJNXoB1lBMEKIq4QDUOXoRgffuDghje1WrG9ML+Hbisq/yFOGwXD9RiX8F6sw6W4
avAuvDszue5L3sz85K+EC4Y/wFVDNvZo4TYXao6Z0f+lQKc0t8DQYzk1OXVu8rp2
yJMC6alLbBfODALZvYH7n7do1AZls4I9d1P4jnkDrQoxB3UqQ9hVl3LEKQ73xF1O
yK5GhDDX8oVfGKF5u+decIsH4YaTw7mP3GFxJSqv3+0lUFJoi5Lc5da149p90Ids
hCExroL1+7mryIkXPeFM5TgO9r0rvZaBFOvV2z0gp35Z0+L4WPlbuEjN/lxPFin+
HlUjr8gRsI3qfJOQFy/9rKIJR0Y/8Omwt/8oTWgy1mdeHmmjk7j1nYsvC9JSQ6Zv
MldlTTKB3zhThV1+XWYp6rjd5JW1zbVWEkLNxE7GJThEUG3szgBVGP7pSWTUTsqX
nLRbwHOoq7hHwg==
-----END CERTIFICATE-----
`;
let Hs = le;
var h = /* @__PURE__ */ ((i) => (i.soap = "http://schemas.xmlsoap.org/soap/envelope/", i.ebXmlRmi3 = "urn:oasis:names:tc:ebxml-regrep:xsd:rim:3.0", i.ebXmlRmd = "urn:ihe:iti:rmd:2017", i.ebXmlQuery3 = "urn:oasis:names:tc:ebxml-regrep:xsd:query:3.0", i.ebXmlRlcm3 = "urn:oasis:names:tc:ebxml-regrep:xsd:lcm:3.0", i.ebXmlRs3 = "urn:oasis:names:tc:ebxml-regrep:xsd:rs:3.0", i.iheXdsb = "urn:ihe:iti:xds-b:2007", i.gemCard81 = "http://ws.gematik.de/conn/CardService/v8.1", i.gemCardCommon2 = "http://ws.gematik.de/conn/CardServiceCommon/v2.0", i.gemCardTerminal8 = "http://ws.gematik.de/conn/CardTerminalInfo/v8.0", i.gemCert6 = "http://ws.gematik.de/conn/CertificateService/v6.0", i.gemCertCommon2 = "http://ws.gematik.de/conn/CertificateServiceCommon/v2.0", i.gemError2 = "http://ws.gematik.de/tel/error/v2.0", i.gemEvent72 = "http://ws.gematik.de/conn/EventService/v7.2", i.gemCommon5 = "http://ws.gematik.de/conn/ConnectorCommon/v5.0", i.gemPhrMgt2 = "http://ws.gematik.de/conn/phrs/PHRManagementService/v2.0", i.gemPhr2 = "http://ws.gematik.de/conn/phrs/PHRService/v2.0", i.gemConCtx2 = "http://ws.gematik.de/conn/ConnectorContext/v2.0", i.gemEncrypt61 = "http://ws.gematik.de/conn/EncryptionService/v6.1", i.gemDecrypt61 = "http://ws.gematik.de/conn/crypt/EncryptionService/v6.1", i.gemVsd52 = "http://ws.gematik.de/conn/vsds/VSDService/v5.2", i.gemVsdPnw = "http://ws.gematik.de/fa/vsdm/pnw/v1.0", i.gemNfd10 = "http://ws.gematik.de/conn/nfds/NFDService/v1.0", i.gemAVersicherungsdaten52 = "http://ws.gematik.de/fa/vsdm/vsd/v5.2", i.gemSign74 = "http://ws.gematik.de/conn/SignatureService/v7.4", i.urnVerificationReport = "urn:oasis:names:tc:dss-x:1.0:profiles:verificationreport:schema#", i.oasisDss = "urn:oasis:names:tc:dss:1.0:core:schema", i.oasisDssSignPolicy = "urn:oasis:names:tc:dss-x:1.0:profiles:SignaturePolicy:schema#", i))(h || {});
const io = /* @__PURE__ */ new Map();
class Qh {
  constructor(e, t, r) {
    this.constructorFunction = e, this.name = t, this.namespace = r;
  }
}
class Wo {
  constructor(e, t, r, n, s, o, u, l = !1) {
    this.array = e, this.type = t, this.propertyKey = r, this.name = n, this.childName = s, this.namespace = o, this.bindElementContent = u, this.anyElement = l;
  }
}
function c(i, e, t, r = !1) {
  return function(n, s) {
    const o = n.__xmlElementBindings ?? [];
    o.push(new Wo(!1, i, s, e || s, void 0, t, !1, r)), n.__xmlElementBindings = o;
  };
}
function ru(i = String) {
  return function(e, t) {
    const r = e.__xmlElementBindings ?? [];
    r.push(new Wo(!1, i, t, "contentOfElement", void 0, void 0, !0, !1)), e.__xmlElementBindings = r;
  };
}
function b(i, e) {
  return function(t) {
    const r = new Qh(t, i, e);
    t.prototype.__xmlRootElement = r, io.set(e + "#" + i, r);
  };
}
class jh {
  constructor(e, t, r, n) {
    this.propertyKey = e, this.name = t, this.type = r, this.namespace = n;
  }
}
function x(i, e = String, t = void 0) {
  return function(r, n) {
    const s = r.__xmlAttributeBindings ?? [];
    s.push(new jh(n, i || n, e, t)), r.__xmlAttributeBindings = s;
  };
}
function z(i, e, t, r, n = !1) {
  return function(s, o) {
    const u = s.__xmlElementBindings ?? [];
    u.push(new Wo(!0, i, o, e || o, t, r, !1, n)), s.__xmlElementBindings = u;
  };
}
var Hh = Object.defineProperty, Kh = Object.getOwnPropertyDescriptor, mi = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? Kh(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && Hh(e, t, n), n;
};
class $ {
  constructor(e, t, r, n) {
    this.mandantId = e, this.clientSystemId = t, this.workplaceId = r, this.userId = n;
  }
}
mi([
  c(String, "MandantId", h.gemCommon5)
], $.prototype, "mandantId", 2);
mi([
  c(String, "ClientSystemId", h.gemCommon5)
], $.prototype, "clientSystemId", 2);
mi([
  c(String, "WorkplaceId", h.gemCommon5)
], $.prototype, "workplaceId", 2);
mi([
  c(String, "UserId", h.gemCommon5)
], $.prototype, "userId", 2);
var kh = Object.defineProperty, zh = Object.getOwnPropertyDescriptor, Zo = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? zh(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && kh(e, t, n), n;
};
let Ye = class {
};
Zo([
  c(Number, "Major")
], Ye.prototype, "major", 2);
Zo([
  c(Number, "Minor")
], Ye.prototype, "minor", 2);
Zo([
  c(Number, "Revision")
], Ye.prototype, "revision", 2);
var Wh = Object.defineProperty, Zh = Object.getOwnPropertyDescriptor, Xt = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? Zh(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && Wh(e, t, n), n;
};
class Tt {
}
Xt([
  c(Ye, "COSVersion")
], Tt.prototype, "cosVersion", 2);
Xt([
  c(Ye, "ObjectSystemVersion")
], Tt.prototype, "objectSystemVersion", 2);
Xt([
  c(Ye, "CardPTPersVersion")
], Tt.prototype, "cardPTPersVersion", 2);
Xt([
  c(Ye, "DataStructureVersion")
], Tt.prototype, "dataStructureVersion", 2);
Xt([
  c(Ye, "LoggingVersion")
], Tt.prototype, "loggingVersion", 2);
Xt([
  c(Ye, "ATRVersion")
], Tt.prototype, "atrVersion", 2);
Xt([
  c(Ye, "GDOVersion")
], Tt.prototype, "gdoVersion", 2);
Xt([
  c(Ye, "KeyInfoVersion")
], Tt.prototype, "keyInfoVersion", 2);
var Yh = Object.defineProperty, $h = Object.getOwnPropertyDescriptor, $e = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? $h(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && Yh(e, t, n), n;
}, _ = /* @__PURE__ */ ((i) => (i.EGK = "EGK", i.HBA_qSig = "HBA-qSig", i.HBA = "HBA", i.SMC_B = "SMC-B", i.HSM_B = "HSM-B", i.SMC_KT = "SMC-KT", i.KVK = "KVK", i.ZOD_2_0 = "ZOD_2.0", i.UNKNOWN = "UNKNOWN", i.HBAx = "HBAx", i.SM_B = "SM-B", i))(_ || {});
let Ie = class {
};
$e([
  c(String, "CardHandle", h.gemCommon5)
], Ie.prototype, "handle", 2);
$e([
  c(String, "CardType", h.gemCardCommon2)
], Ie.prototype, "type", 2);
$e([
  c(Tt, "CardVersion")
], Ie.prototype, "cardVersion", 2);
$e([
  c(String, "Iccsn", h.gemCardCommon2)
], Ie.prototype, "iccsn", 2);
$e([
  c(String, "CtId", h.gemCardCommon2)
], Ie.prototype, "ctId", 2);
$e([
  c(Number, "SlotId", h.gemCardCommon2)
], Ie.prototype, "slotId", 2);
$e([
  c(Date, "InsertTime")
], Ie.prototype, "insertTime", 2);
$e([
  c(String, "CardHolderName")
], Ie.prototype, "cardHolderName", 2);
$e([
  c(String, "Kvnr")
], Ie.prototype, "kvnr", 2);
$e([
  c(Date, "CertificateExpirationDate")
], Ie.prototype, "certificateExpirationDate", 2);
Ie = $e([
  b("Card", h.gemCard81)
], Ie);
var qh = Object.defineProperty, Xh = Object.getOwnPropertyDescriptor, wi = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? Xh(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && qh(e, t, n), n;
};
_.SMC_B, _.HBA, _.HBA;
let Ur = class {
  constructor(i, e, t) {
    this.context = i, this.cardHandle = e, this.pinTyp = t;
  }
};
wi([
  c($, "Context", h.gemConCtx2)
], Ur.prototype, "context", 2);
wi([
  c(String, "CardHandle", h.gemCommon5)
], Ur.prototype, "cardHandle", 2);
wi([
  c(String, "PinTyp", h.gemCardCommon2)
], Ur.prototype, "pinTyp", 2);
Ur = wi([
  b("ChangePin", h.gemCard81)
], Ur);
var _h = Object.defineProperty, Jh = Object.getOwnPropertyDescriptor, Me = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? Jh(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && _h(e, t, n), n;
};
class ut {
}
Me([
  c(String, "EventID")
], ut.prototype, "eventID", 2);
Me([
  c(String, "Instance")
], ut.prototype, "instance", 2);
Me([
  c(String, "LogReference")
], ut.prototype, "logReference", 2);
Me([
  c(String, "CompType")
], ut.prototype, "compType", 2);
Me([
  c(String, "Code")
], ut.prototype, "code", 2);
Me([
  c(String, "Severity")
], ut.prototype, "severity", 2);
Me([
  c(String, "ErrorType")
], ut.prototype, "errorType", 2);
Me([
  c(String, "ErrorText")
], ut.prototype, "errorText", 2);
Me([
  c(String, "Detail")
], ut.prototype, "detail", 2);
let rt = class {
};
Me([
  c(String, "MessageID")
], rt.prototype, "messageID", 2);
Me([
  c(Date, "Timestamp")
], rt.prototype, "timestamp", 2);
Me([
  c(ut, "Trace")
], rt.prototype, "trace", 2);
rt = Me([
  b("Error", h.gemError2)
], rt);
var el = Object.defineProperty, tl = Object.getOwnPropertyDescriptor, Yo = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? tl(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && el(e, t, n), n;
};
let re = class {
};
Yo([
  c(String, "Result")
], re.prototype, "result", 2);
Yo([
  c(rt, "Error", h.gemError2)
], re.prototype, "error", 2);
re = Yo([
  b("Status", h.gemCommon5)
], re);
var rl = Object.defineProperty, nl = Object.getOwnPropertyDescriptor, $o = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? nl(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && rl(e, t, n), n;
};
let Mn = class {
};
$o([
  c(re, "Status")
], Mn.prototype, "status", 2);
$o([
  c(String, "PinResult", h.gemCardCommon2)
], Mn.prototype, "pinStatus", 2);
Mn = $o([
  b("ChangePinResponse", h.gemCard81)
], Mn);
var sl = Object.defineProperty, il = Object.getOwnPropertyDescriptor, yi = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? il(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && sl(e, t, n), n;
};
let Lr = class {
  constructor(i, e, t) {
    this.context = i, this.cardHandle = e, this.pinTyp = t;
  }
};
yi([
  c($, "Context", h.gemConCtx2)
], Lr.prototype, "context", 2);
yi([
  c(String, "CardHandle", h.gemCommon5)
], Lr.prototype, "cardHandle", 2);
yi([
  c(String, "PinTyp", h.gemCardCommon2)
], Lr.prototype, "pinTyp", 2);
Lr = yi([
  b("GetPinStatus", h.gemCard81)
], Lr);
var ol = Object.defineProperty, al = Object.getOwnPropertyDescriptor, Ai = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? al(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && ol(e, t, n), n;
};
let Fr = class {
};
Ai([
  c(re, "Status")
], Fr.prototype, "status", 2);
Ai([
  c(String, "PinStatus")
], Fr.prototype, "pinStatus", 2);
Ai([
  c(Number, "LeftTries")
], Fr.prototype, "leftTries", 2);
Fr = Ai([
  b("GetPinStatusResponse", h.gemCard81)
], Fr);
var nu = /* @__PURE__ */ ((i) => (i.VERIFIED = "VERIFIED", i.TRANSPORT_PIN = "TRANSPORT_PIN", i.EMPTY_PIN = "EMPTY_PIN", i.BLOCKED = "BLOCKED", i.VERIFIABLE = "VERIFIABLE", i.DISABLED = "DISABLED", i))(nu || {}), cl = Object.defineProperty, ul = Object.getOwnPropertyDescriptor, As = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? ul(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && cl(e, t, n), n;
};
let sr = class {
  constructor(i, e, t, r) {
    this.context = i, this.cardHandle = e, this.pinTyp = t, this.setNewPin = r;
  }
};
As([
  c($, "Context", h.gemConCtx2)
], sr.prototype, "context", 2);
As([
  c(String, "CardHandle", h.gemCommon5)
], sr.prototype, "cardHandle", 2);
As([
  c(String, "PinTyp", h.gemCardCommon2)
], sr.prototype, "pinTyp", 2);
As([
  c(String, "SetNewPin", h.gemCard81)
], sr.prototype, "setNewPin", 2);
sr = As([
  b("UnblockPin", h.gemCard81)
], sr);
var hl = Object.defineProperty, ll = Object.getOwnPropertyDescriptor, Si = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? ll(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && hl(e, t, n), n;
};
let Gr = class {
};
Si([
  c(re, "Status")
], Gr.prototype, "status", 2);
Si([
  c(String, "PinResult", h.gemCardCommon2)
], Gr.prototype, "pinStatus", 2);
Si([
  c(Number, "LeftTries")
], Gr.prototype, "leftTries", 2);
Gr = Si([
  b("UnblockPinResponse", h.gemCard81)
], Gr);
var dl = Object.defineProperty, pl = Object.getOwnPropertyDescriptor, vi = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? pl(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && dl(e, t, n), n;
};
let Qr = class {
  constructor(i, e, t) {
    this.context = i, this.cardHandle = e, this.pinTyp = t;
  }
};
vi([
  c($, "Context", h.gemConCtx2)
], Qr.prototype, "context", 2);
vi([
  c(String, "CardHandle", h.gemCommon5)
], Qr.prototype, "cardHandle", 2);
vi([
  c(String, "PinTyp", h.gemCardCommon2)
], Qr.prototype, "pinTyp", 2);
Qr = vi([
  b("VerifyPin", h.gemCard81)
], Qr);
var gl = Object.defineProperty, fl = Object.getOwnPropertyDescriptor, bi = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? fl(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && gl(e, t, n), n;
};
let jr = class {
};
bi([
  c(re, "Status")
], jr.prototype, "status", 2);
bi([
  c(String, "PinResult", h.gemCardCommon2)
], jr.prototype, "pinStatus", 2);
bi([
  c(Number, "LeftTries")
], jr.prototype, "leftTries", 2);
jr = bi([
  b("VerifyPinResponse", h.gemCard81)
], jr);
let ml = class {
  constructor(e, t) {
    this.connector = e, this.url = t;
  }
  /**
   * Loads the State of the given card / pin Combination.
   * @param cardHandle
   * @param pinType
   * @returns
   */
  async getPinStatus(e, t) {
    const r = new Lr(this.connector.context, e, t);
    return new Fr().leftTries = 0, this.connector.soap11Post(h.gemCard81 + "#GetPinStatus", this.url, r);
  }
  /**
   * Triggers input of the Pin for a card and PinType
   * @param cardHandle
   * @param pinType
   * @returns
   */
  async verifyPin(e, t) {
    const r = new Qr(this.connector.context, e, t);
    return new jr().leftTries = 0, this.connector.soap11Post(h.gemCard81 + "#VerifyPin", this.url, r);
  }
  /**
   * Triggers change of the Pin for a card and PinType
   * @param cardHandle
   * @param pinType
   * @returns
   */
  async changePin(e, t) {
    const r = new Ur(this.connector.context, e, t);
    return new Mn(), this.connector.soap11Post(h.gemCard81 + "#ChangePin", this.url, r);
  }
  /**
   * Triggers unblock of the Pin for a card and PinType
   * @param cardHandle
   * @param pinType
   * @param setNewPin
   * @returns
   */
  async unblockPin(e, t, r) {
    const n = new sr(this.connector.context, e, t, r);
    return new Gr(), this.connector.soap11Post(h.gemCard81 + "#UnblockPin", this.url, n);
  }
};
var ir = /* @__PURE__ */ ((i) => (i.RSA = "RSA", i.ECC = "ECC", i))(ir || {}), wl = Object.defineProperty, yl = Object.getOwnPropertyDescriptor, Ss = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? yl(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && wl(e, t, n), n;
};
let or = class {
  constructor(i, e, t, r = ir.RSA) {
    this.context = i, this.cardHandle = e, this.certRefs = t, this.crypt = r;
  }
};
Ss([
  c(String, "CardHandle", h.gemCommon5)
], or.prototype, "cardHandle", 2);
Ss([
  c($, "Context", h.gemConCtx2)
], or.prototype, "context", 2);
Ss([
  z(String, "CertRefList", "CertRef", h.gemCert6)
], or.prototype, "certRefs", 2);
Ss([
  c(String, "Crypt", h.gemCert6)
], or.prototype, "crypt", 2);
or = Ss([
  b("ReadCardCertificate", h.gemCert6)
], or);
var Al = Object.defineProperty, Sl = Object.getOwnPropertyDescriptor, ht = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? Sl(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && Al(e, t, n), n;
};
let Pn = class {
};
ht([
  c(String, "X509IssuerName")
], Pn.prototype, "x509IssuerName", 2);
ht([
  c(String, "X509SerialNumber")
], Pn.prototype, "x509SerialNumber", 2);
Pn = ht([
  b("X509IssuerSerial", h.gemCertCommon2)
], Pn);
let Hr = class {
};
ht([
  c(Pn, "X509IssuerSerial")
], Hr.prototype, "x509IssuerSerial", 2);
ht([
  c(String, "X509SubjectName")
], Hr.prototype, "x509SubjectName", 2);
ht([
  c(String, "X509Certificate")
], Hr.prototype, "x509Certificate", 2);
Hr = ht([
  b("X509Data", h.gemCertCommon2)
], Hr);
let Kr = class {
};
ht([
  c(String, "CertRef", h.gemCertCommon2)
], Kr.prototype, "certRef", 2);
ht([
  c(Hr, "X509Data", h.gemCertCommon2)
], Kr.prototype, "x509Data", 2);
Kr = ht([
  b("X509DataInfo", h.gemCertCommon2)
], Kr);
var vl = Object.defineProperty, bl = Object.getOwnPropertyDescriptor, qo = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? bl(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && vl(e, t, n), n;
};
let Rn = class {
  constructor() {
    new Kr();
  }
};
qo([
  c(re, "Status")
], Rn.prototype, "status", 2);
qo([
  z(Kr, "X509DataInfoList", "X509DataInfo", h.gemCertCommon2)
], Rn.prototype, "x509DataInfoList", 2);
Rn = qo([
  b("ReadCardCertificateResponse", h.gemCert6)
], Rn);
var Cl = Object.defineProperty, El = Object.getOwnPropertyDescriptor, Xo = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? El(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && Cl(e, t, n), n;
};
let On = class {
  /**
   * 
   * @param context context
   * @param x509Certificate as base64 enc 
   */
  constructor(i, e) {
    this.context = i, this.x509Certificate = e;
  }
};
Xo([
  c($, "Context", h.gemConCtx2)
], On.prototype, "context", 2);
Xo([
  c(String, "X509Certificate", h.gemCertCommon2)
], On.prototype, "x509Certificate", 2);
On = Xo([
  b("VerifyCertificate", h.gemCert6)
], On);
var Dl = Object.defineProperty, Il = Object.getOwnPropertyDescriptor, _o = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? Il(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && Dl(e, t, n), n;
};
let Tn = class {
  constructor() {
  }
};
_o([
  c(String, "VerificationResult")
], Tn.prototype, "verificationResult", 2);
_o([
  c(String, "Error")
], Tn.prototype, "error", 2);
Tn = _o([
  b("VerificationStatus", h.gemCert6)
], Tn);
var Bl = Object.defineProperty, Ml = Object.getOwnPropertyDescriptor, Jo = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? Ml(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && Bl(e, t, n), n;
};
let Nn = class {
  constructor() {
  }
};
Jo([
  c(re, "Status")
], Nn.prototype, "status", 2);
Jo([
  c(Tn, "VerificationStatus")
], Nn.prototype, "verificationStatus", 2);
Nn = Jo([
  b("VerifyCertificateResponse", h.gemCert6)
], Nn);
let Pl = class {
  constructor(e, t) {
    this.connector = e, this.url = t;
  }
  /**
   * Verifies a Certificate on the Connector.
   * @param base64 base64 encoded String
   * @returns VerificationStatus
   */
  async verifyCertificate(e) {
    new Nn();
    const t = new On(this.connector.context, e);
    return (await this.connector.soap11Post(h.gemCert6 + "#VerifyCertificate", this.url, t)).verificationStatus;
  }
  /**
   * Reads Certificate information from a card.
   * @param readCardHandle Card that should be read.
   * @param certRefs Types of Certs to read.
   * @returns List of Certificate Information.
   */
  async readCardCertificate(e, t, r = ir.RSA) {
    new Rn();
    const n = new or(this.connector.context, e, t, r);
    return (await this.connector.soap11Post(h.gemCert6 + "#ReadCardCertificate", this.url, n)).x509DataInfoList;
  }
};
var Rl = Object.defineProperty, Ol = Object.getOwnPropertyDescriptor, un = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? Ol(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && Rl(e, t, n), n;
};
let Ks = class {
};
un([
  c(rt, "Error")
], Ks.prototype, "error", 2);
Ks = un([
  b("detail", h.soap)
], Ks);
let ze = class {
};
un([
  c(String, "faultcode")
], ze.prototype, "code", 2);
un([
  c(String, "faultstring")
], ze.prototype, "faultString", 2);
un([
  c(Ks, "detail")
], ze.prototype, "detail", 2);
ze = un([
  b("Fault", h.soap)
], ze);
class Q {
  static debugToConsole() {
    const e = (t) => console.log("StatusEvent:", t.detail);
    document.body.addEventListener("log", e), document.body.addEventListener("login", e), document.body.addEventListener("logout", e), document.body.addEventListener("smbc-locked", e), document.body.addEventListener("smbc-unlocked", e), document.body.addEventListener("hba-locked", e), document.body.addEventListener("hba-unlocked", e);
  }
  static login() {
    document.body.dispatchEvent(new CustomEvent("login", { bubbles: !0 }));
  }
  static logout() {
    document.body.dispatchEvent(new CustomEvent("logout", { bubbles: !0 }));
  }
  static smbcUnlocked() {
    document.body.dispatchEvent(new CustomEvent("smbc-unlocked", { bubbles: !0 }));
  }
  static smbcLocked() {
    document.body.dispatchEvent(new CustomEvent("smbc-locked", { bubbles: !0 }));
  }
  static addSmcbLockedListener(e) {
    document.body.addEventListener("smbc-locked", e);
  }
  static hbaLocked() {
    document.body.dispatchEvent(new CustomEvent("hba-locked", { bubbles: !0 }));
  }
  static hbaUnlocked() {
    document.body.dispatchEvent(new CustomEvent("hba-unlocked", { bubbles: !0 }));
  }
  static log(e) {
    document.body.dispatchEvent(new CustomEvent("log", { bubbles: !0, detail: e }));
  }
  static error(e) {
    document.body.dispatchEvent(new CustomEvent("log", { bubbles: !0, detail: e }));
  }
}
const Pr = {
  debugSoap: !1,
  debugTls: !1,
  debugWebsocket: !1,
  debugHttp: !0,
  debugKim: !0,
  debugTerminalLogin: !1,
  deleteMailAfterProcessing: !0
};
var Tl = Object.defineProperty, Nl = Object.getOwnPropertyDescriptor, xl = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? Nl(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && Tl(e, t, n), n;
};
let ea = class {
  constructor(e) {
    this.element = e;
  }
};
xl([
  c(void 0, void 0, void 0, !0)
], ea.prototype, "element", 2);
var Vl = Object.defineProperty, Ul = Object.getOwnPropertyDescriptor, su = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? Ul(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && Vl(e, t, n), n;
};
let ks = class {
  constructor(i) {
    this.body = new ea(i);
  }
};
su([
  c(ea, "Body", "http://schemas.xmlsoap.org/soap/envelope/")
], ks.prototype, "body", 2);
ks = su([
  b("Envelope", "http://schemas.xmlsoap.org/soap/envelope/")
], ks);
const Ll = Symbol("DateTime");
class Ke {
  static marshal(e) {
    const t = e.__xmlRootElement, r = window.document.implementation.createDocument(t.namespace ?? null, t.name);
    return this.marshalObject(e, r.documentElement, r), new XMLSerializer().serializeToString(r);
  }
  static marshalObject(e, t, r) {
    let n = e.__xmlAttributeBindings;
    for (const o of n || []) {
      const u = e[o.propertyKey];
      u !== void 0 && (o.namespace ? t.setAttributeNS(o.namespace, o.name, u) : t.setAttribute(o.name, u));
    }
    let s = e.__xmlElementBindings;
    for (const o of s || []) {
      let u = e[o.propertyKey];
      if (u === void 0)
        continue;
      Array.isArray(u) || (u = [u]);
      let l = t;
      if (o.array && o.childName !== void 0) {
        let m;
        o.namespace === void 0 || o.namespace === "" ? m = r.createElement(o.name) : m = r.createElementNS(o.namespace, o.name), l.appendChild(m), l = m;
      }
      for (const m of u) {
        let y;
        if (o.bindElementContent)
          y = l;
        else if (o.anyElement) {
          const A = m.__xmlRootElement;
          A.namespace === void 0 || A.namespace === "" ? y = r.createElement(A.name) : y = r.createElementNS(A.namespace ?? "", A.name);
        } else
          o.namespace === void 0 || o.namespace === "" ? y = r.createElement(o.childName || o.name) : y = r.createElementNS(o.namespace, o.childName || o.name);
        o.type === Date ? y.textContent = m.toISOString().substring(0, 10) : o.type === Ll ? y.textContent = m.toISOString() : o.type === Node ? y.appendChild(m) : typeof m == "object" ? this.marshalObject(m, y, r) : y.textContent = m, l !== y && l.appendChild(y);
      }
    }
  }
  static unmarshal(e) {
    const r = new DOMParser().parseFromString(e, "text/xml"), n = this.createObjectFromElement(r.documentElement);
    if (!n)
      throw new Error("Root not found");
    return this.unmarshalObject(r.documentElement, n), n;
  }
  static unmarshalObject(e, t) {
    const r = t.__xmlElementBindings;
    if (!r)
      return;
    let n = r.find((s) => s.bindElementContent);
    n && (t[n.propertyKey] = this.createObjectFromBinding(e, n));
    for (let s = 0; s < e.childElementCount; s++) {
      const o = e.children.item(s);
      let u = r.find((l) => l.name === o.localName);
      if (u || (u = r.find((l) => l.anyElement === !0)), u) {
        let l;
        u.anyElement ? l = this.createObjectFromElement(o) : l = this.createObjectFromBinding(o, u), this.unmarshalAttributes(o, l), u.array && u.childName === void 0 ? (t[u.propertyKey] || (t[u.propertyKey] = []), t[u.propertyKey].push(l)) : t[u.propertyKey] = l;
      }
    }
  }
  static createObjectFromBinding(e, t) {
    return t.array && t.childName !== void 0 ? this.unmarshalArray(e, t.childName, t) : this.createObjectFromType(e, t.type);
  }
  static createObjectFromType(e, t) {
    if (t === String)
      return e.textContent;
    if (t === Boolean)
      return e.textContent === "true";
    if (t === Number)
      return parseFloat(e.textContent ?? "");
    if (t === Date) {
      let r = e.textContent ?? "";
      const s = new RegExp(/^(\d{4})(0[0-9]|1[012])(0[0-9]|[12][0-9]|3[01])(([01][0-9]|2[0-3])([0-5][0-9])([0-5][0-9]))?$/).exec(r);
      if (s) {
        const o = s[2] === "00" ? "01" : s[2], u = s[3] === "00" ? "01" : s[3];
        s != null && s[4] ? r = s[1] + "-" + o + "-" + u + "T" + s[5] + ":" + s[6] + ":" + s[7] + "Z" : r = s[1] + "-" + o + "-" + u + "T00:00:00";
      }
      return /([0-9]{4}-[0-9]{2}-[0-9]{2})Z/.exec(r ?? "") && (r = r.replace("Z", "T00:00:00Z")), new Date(r);
    } else {
      if (t === null)
        return this.createObjectFromElement(e);
      {
        const r = new t();
        return this.unmarshalObject(e, r), r;
      }
    }
  }
  static unmarshalAttributes(e, t) {
    const r = t.__xmlAttributeBindings;
    if (r)
      for (const n of r) {
        const s = e.getAttribute(n.name);
        t[n.propertyKey] = s ?? void 0;
      }
  }
  static unmarshalArray(e, t, r) {
    const n = [];
    for (let s = 0; s < e.childElementCount; s++) {
      const o = e.children.item(s);
      if (o.localName === t) {
        const u = this.createObjectFromType(o, r.type);
        this.unmarshalAttributes(o, u), n.push(u);
      }
    }
    return n;
  }
  static createObjectFromElement(e) {
    const t = io.get(e.namespaceURI + "#" + e.localName);
    if (t) {
      const r = Object.create(t.constructorFunction.prototype);
      return this.unmarshalObject(e, r), r;
    }
    throw console.warn(io), new Error(
      "XML Root for '" + e.namespaceURI + "#" + e.localName + `' could not be found.
 Please ensure that the JS Class is loaded in the client and not only treated as type.`
    );
  }
}
class ta {
  constructor(e, t = []) {
    this.root = e, this.includes = t, this.boundary = "uuid:dfe40ed7-f2c6-4cb4-901d-c0a6cc4d72d3", this.rootContentId = "<root.message@cxf.apache.org>", this.action = this.root.header.action;
  }
  getContent() {
    const e = new TextEncoder(), t = [];
    t.push(e.encode(
      this.getContentHeader(`application/xop+xml; charset=UTF-8; type="application/soap+xml; action=\\"${this.action}\\""`, this.rootContentId) + Ke.marshal(this.root) + `\r
`
    ));
    for (var r of this.includes)
      t.push(e.encode(this.getContentHeader("application/octet-stream", r.contentId))), typeof r.content == "string" ? t.push(e.encode(r.content)) : t.push(r.content), t.push(e.encode(`\r
`));
    return t.push(e.encode("--" + this.boundary + `--\r
`)), ta.concatArrayBuffers(t);
  }
  static concatArrayBuffers(e) {
    let t = 0, r = 0;
    e.forEach((o) => r += o.byteLength);
    const n = new ArrayBuffer(r), s = new Uint8Array(n);
    for (const o of e)
      s.set(new Uint8Array(o), t), t += o.byteLength;
    return n;
  }
  getContentHeader(e, t) {
    return "--" + this.boundary + `\r
Content-Type: ${e}\r
Content-Transfer-Encoding: binary\r
Content-ID: ${t}\r
\r
`;
  }
  getContentType() {
    return `Multipart/Related;boundary="${this.boundary}";type="application/xop+xml";start="${this.rootContentId}";start-info="application/soap+xml";`;
  }
}
class Cc {
  /**
   *
   * @param socket Socket that is used for the transport, overrides the "onmessage" callback.
   */
  constructor(e) {
    this.inputBuffer = e, this.LINE_DELIMITER = [13, 10], this.currentPosition = 0, this.decoder = new TextDecoder();
  }
  /**
   *
   * @param condition Data will be read until the condition returns true, or we get into the timeout.
   * @returns
   */
  readByCondition(e) {
    const t = this.currentPosition;
    for (; this.currentPosition < this.inputBuffer.byteLength && !e(this.inputBuffer); )
      this.currentPosition++;
    return this.currentPosition++, this.inputBuffer.slice(t, this.currentPosition);
  }
  /**
   * Reads the Complete Rest of the Socket until it is closed.
   * @returns ArrayBuffer with the remaining data. Can be Empty.
   */
  readUntilEnd() {
    const e = () => !1;
    return this.readByCondition(e);
  }
  /**
   * Reads Data until next of the given token.
   * @param token A byte series used as delimiter token.
   * @param excludeToken When set to true the token will not be within the result. Default ist true
   * @returns ArrayBuffer with the data starting from the current position until the token.
   */
  readByToken(e, t = !0) {
    const r = new Array(e.length), n = (o) => (r.shift(), r.push(o[this.currentPosition]), this.isArrayEqual(e, r)), s = this.readByCondition(n);
    return t ? s.slice(0, s.byteLength - e.length) : s;
  }
  readByTokenOrLength(e, t, r = !0) {
    const n = new Array(e.length);
    let s = 0, o = !1;
    const u = (m) => (n.shift(), n.push(m[this.currentPosition]), s++, o = this.isArrayEqual(e, n), o || s >= t), l = this.readByCondition(u);
    return r ? { buffer: l.slice(0, l.byteLength - e.length), found: o } : { buffer: l, found: o };
  }
  /**
   * Reads Data until next of the given token.
   * @param token A byte series used as delimiter token.
   * @returns String with the data starting from the current position until the token ( the token will not be included.)
   */
  readStringByToken(e) {
    return this.decoder.decode(this.readByToken(e));
  }
  /**
   * Reads Data until line end and returns as string.
   * @returns String with the data starting from the current position until the end of the line ( \r\n ).
   */
  readStringLine() {
    return this.decoder.decode(this.readByToken(this.LINE_DELIMITER));
  }
  async readByLength(e) {
    let t = 0;
    const r = () => (t++, t >= e);
    return this.readByCondition(r);
  }
  async readStringByLength(e) {
    return this.decoder.decode(await this.readByLength(e));
  }
  isArrayEqual(e, t) {
    if (e.length !== t.length)
      return !1;
    for (let r = 0; r < e.length; r++)
      if (e[r] !== t[r])
        return !1;
    return !0;
  }
}
class Fl {
  constructor(e, t) {
    this.headers = e, this.content = t;
  }
}
class Ec {
  /**
   * Parses the Response and throws error if it is invalid.
   * @param response 
   */
  constructor(e) {
    this.contentParts = [];
    const t = e.headers.find((m) => m.name.toLocaleLowerCase() === "content-type"), r = /boundary="([^"]+)"/gmi.exec((t == null ? void 0 : t.value) || "");
    if (!r)
      throw new Error("Illegal MTOM Response, Content type does not contain boundary attribute:" + (t == null ? void 0 : t.value));
    const n = "--" + r[1], s = /start="([^"]+)"/gmi.exec((t == null ? void 0 : t.value) || "");
    if (!s)
      throw new Error("Illegal MTOM Response, Content type does not contain a start entry attribute:" + (t == null ? void 0 : t.value));
    this.startEntryContentId = s[1];
    const o = new Cc(e.data), u = Array.from(new TextEncoder().encode(n));
    o.readByToken(u, !0);
    let l = o.readByToken(u);
    for (; l; ) {
      if (l.byteLength == 0)
        return;
      const m = this.parseMultiPart(l);
      this.contentParts.push(m), l = o.readByToken(u);
    }
  }
  /**
   * is response of type multipart/related.
   * @param headers 
   * @returns 
   */
  static isMtomResponse(e) {
    for (const t of e)
      if (t.name.toLocaleLowerCase() === "content-type" && t.value.toLocaleLowerCase().startsWith("multipart/related;"))
        return !0;
    return !1;
  }
  /**
   * The main Soap entry
   * @returns 
   */
  getRootEntry() {
    return this.findEntry(this.startEntryContentId);
  }
  getRootContent() {
    const e = this.findEntry(this.startEntryContentId);
    return Ke.unmarshal(new TextDecoder().decode(e.content)).body.element;
  }
  findEntry(e) {
    e.startsWith("cid:") && (e = e.substring(4));
    const t = "<" + e + ">";
    for (const r of this.contentParts)
      if (r.headers.find((n) => n.name.toLocaleLowerCase() === "content-id" && (n.value === e || n.value == t)))
        return r;
    throw new Error("The MTO Response does not contain an entry with the content-id:" + e);
  }
  /**
   * parses header and content of multipart entry.
   * @param content 
   * @returns 
   */
  parseMultiPart(e) {
    const t = new Cc(e), r = [];
    t.readStringLine();
    let n = t.readStringLine();
    for (; n.length > 0; ) {
      const o = n.indexOf(": "), u = new Ae(n.substring(0, o), n.substring(o + 2));
      r.push(u), n = t.readStringLine();
    }
    return new Fl(r, t.readUntilEnd());
  }
}
class Gl {
  constructor() {
    this.pending = !1, this.pendingCalls = [];
  }
  /**
   * Queues a call and executes them directly or waits until the pending requests are resolved.
   * @param call function to execute
   * @returns Promise
   */
  async queue(e) {
    const t = new Promise(async (r, n) => {
      const s = async () => {
        try {
          r(await e());
        } catch (o) {
          n(o);
        }
      };
      this.pendingCalls.push(s);
    });
    if (this.pending)
      return t;
    try {
      for (this.pending = !0; this.pendingCalls.length > 0; ) {
        const r = this.pendingCalls.splice(0, 1)[0];
        await r();
      }
    } finally {
      this.pending = !1;
    }
    return t;
  }
}
class Tr extends Error {
  constructor(e, t, r, n, s) {
    super("Communication error of type: " + e), this.type = e, this.url = t, this.requestData = r, this.responseData = n, this.detail = s;
  }
}
class iu {
  constructor(e) {
    this.code = e;
  }
}
class Ql {
  constructor(e) {
    this.transportLayer = e, this.decoder = new TextDecoder(), this.tlsQueue = new Gl();
  }
  setTimeoutRead(e) {
    var t;
    this.transportLayer && ((t = this.transportLayer) == null || t.setTimeoutRead(e));
  }
  /**
   * Sets the mode of Data Transport.
   * @param transportLayer If undefined it uses fetch otherwise the given HttpsClient.
   */
  setTransportLayer(e) {
    this.transportLayer = e, new ze(), new rt();
  }
  /**
   * Sends a SOAP 1.1 Request
   * @param url 
   * @param request 
   * @returns 
   */
  async soap11Post(e, t, r) {
    const n = new ks(r), s = /* @__PURE__ */ new Map();
    return s.set("Content-Type", "text/xml; charset=UTF-8"), s.set("SOAPAction", e), this.soapPost(t, s, Ke.marshal(n));
  }
  /**
   * Sends a SOAP 1.2 Request
   * @param url 
   * @param request 
   * @returns 
   */
  async soap12Post(e, t) {
    const r = /* @__PURE__ */ new Map();
    return r.set("Content-Type", "application/soap+xml; charset=utf-8"), this.soapPost(e, r, Ke.marshal(t));
  }
  /**
   * Sends a SOAP MTOM Request
   * @param url 
   * @param request 
   * @returns 
   */
  async soapMTOMPost(e, t, r = []) {
    const n = /* @__PURE__ */ new Map(), s = new ta(t, r);
    n.set("Content-Type", s.getContentType());
    const o = s.getContent(), u = await this.sendPostRequest(e, n, o);
    if (Ec.isMtomResponse(u.headers))
      return new Ec(u);
    throw console.error(u), new Error("Server Response is not a MTOM Response of type multipart/related. ");
  }
  async getString(e) {
    const t = await this.sendGetRequest(e);
    return t.data ? this.decoder.decode(t.data) : "";
  }
  async sendGetRequest(e) {
    if (this.transportLayer)
      return this.tlsQueue.queue(async () => {
        const t = new URL(e).pathname;
        this.transportLayer.setHeader("Content-Type", "text/xml; charset=UTF-8");
        const r = await this.transportLayer.get(t);
        if (r.statusCode >= 200 && r.statusCode < 300)
          return r;
        throw new Error("Server returned Status: " + r.statusCode + `
` + (r.data ? this.decoder.decode(r.data) : ""));
      });
    {
      const t = await fetch(e), r = new xr();
      r.statusCode = t.status, r.headers = [];
      for (const n of t.headers)
        r.headers.push(new Ae(n[0], n[1]));
      return r.data = new Uint8Array(await t.arrayBuffer()), r;
    }
  }
  log(e, t, ...r) {
  }
  async sendPostRequest(e, t, r) {
    if (this.transportLayer)
      return this.tlsQueue.queue(() => {
        this.log("Request", r, e);
        const n = new URL(e).pathname;
        this.transportLayer.removeHeader("SOAPAction");
        for (const s of t)
          this.transportLayer.setHeader(s[0], s[1]);
        return this.transportLayer.post(n, r);
      });
    {
      this.log("Request", r, e + " - " + (/* @__PURE__ */ new Date()).getTime());
      const n = new Headers();
      for (const l of t)
        n.set(l[0], l[1]);
      const s = {
        method: "POST",
        headers: n,
        body: r,
        redirect: "follow"
      };
      this.log("Request", r, e + " - " + (/* @__PURE__ */ new Date()).getTime());
      const o = await fetch(e, s);
      this.log("Request", r, e + " - " + (/* @__PURE__ */ new Date()).getTime());
      const u = new xr();
      u.statusCode = o.status, u.headers = [];
      for (const l of o.headers)
        u.headers.push(new Ae(l[0], l[1]));
      return u.data = new Uint8Array(await o.arrayBuffer()), u;
    }
  }
  async soapPost(e, t, r) {
    var l, m, y, A;
    let n;
    const s = await this.sendPostRequest(e, t, r);
    s.data && (n = this.decoder.decode(s.data)), this.log("Response: ", n);
    const o = s.headers.find((P) => this.checkForXmlContentType(P.name, P.value)) !== void 0;
    if (s.statusCode < 200 || s.statusCode > 300) {
      if (n && o) {
        const P = Ke.unmarshal(n), M = (A = (y = (m = (l = P.body.element) == null ? void 0 : l.detail) == null ? void 0 : m.error) == null ? void 0 : y.trace) == null ? void 0 : A.code;
        throw M === "7208" || M === "4085" ? (Q.smbcLocked(), new iu(M)) : new Tr("GEMATIK_FAULT", e, { headerMap: t, requestString: r }, s, P.body.element);
      }
      throw new Tr("UNKNOWN", e, { headerMap: t, requestString: r }, s, n || "");
    }
    if (!n)
      throw new Tr("EMPTY", e, { headerMap: t, requestString: r }, s);
    return Ke.unmarshal(n).body.element;
  }
  checkForXmlContentType(e, t) {
    return e.toLocaleLowerCase() === "content-type" && t.toLocaleLowerCase().indexOf("xml") != -1;
  }
}
var jl = Object.defineProperty, Hl = Object.getOwnPropertyDescriptor, Ci = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? Hl(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && jl(e, t, n), n;
};
class Ar {
  constructor(e, t) {
    this.identifier = e, this.value = t;
  }
}
Ci([
  c(String, "Identifier", h.oasisDss)
], Ar.prototype, "identifier", 2);
Ci([
  c(Node, "Value", h.oasisDss)
], Ar.prototype, "value", 2);
let ar = class {
  constructor(i) {
    this.property = i;
  }
};
Ci([
  c(Ar, "Property", h.oasisDss)
], ar.prototype, "property", 2);
ar = Ci([
  b("Property", h.oasisDss)
], ar);
var Kl = Object.defineProperty, kl = Object.getOwnPropertyDescriptor, hn = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? kl(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && Kl(e, t, n), n;
};
let oe = class {
  constructor(i, e) {
    this.base64Data = i, this.base64XML = e;
  }
};
hn([
  x("ID")
], oe.prototype, "id", 2);
hn([
  x("RefURI")
], oe.prototype, "refURI", 2);
hn([
  x("ShortText")
], oe.prototype, "shortText", 2);
hn([
  c(String, "Base64XML", h.gemCommon5)
], oe.prototype, "base64XML", 2);
hn([
  c(String, "Base64Data", h.oasisDss)
], oe.prototype, "base64Data", 2);
oe = hn([
  b("Document", h.gemCommon5)
], oe);
var Pe = /* @__PURE__ */ ((i) => (i.C_AUT = "C.AUT", i.C_ENC = "C.ENC", i.C_SIG = "C.SIG", i.C_QES = "C.QES", i))(Pe || {}), zl = Object.defineProperty, Wl = Object.getOwnPropertyDescriptor, ra = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? Wl(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && zl(e, t, n), n;
};
class Sr {
  constructor(e) {
    this.keyReference = Pe.C_ENC, this.cardHandle = e;
  }
}
ra([
  c(String, "CardHandle", h.gemCommon5)
], Sr.prototype, "cardHandle", 2);
ra([
  c(String, "KeyReference", h.gemEncrypt61)
], Sr.prototype, "keyReference", 2);
ra([
  c(String, "Crypt", h.gemEncrypt61)
], Sr.prototype, "crypt", 2);
var Zl = Object.defineProperty, Yl = Object.getOwnPropertyDescriptor, Ei = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? Yl(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && Zl(e, t, n), n;
};
let kr = class {
  constructor(i, e, t) {
    this.context = i, this.certificateOnCard = new Sr(e), this.document = t;
  }
};
Ei([
  c($, "Context", h.gemConCtx2)
], kr.prototype, "context", 2);
Ei([
  c(Sr, "PrivateKeyOnCard", h.gemEncrypt61)
], kr.prototype, "certificateOnCard", 2);
Ei([
  c(oe, "Document", h.gemCommon5)
], kr.prototype, "document", 2);
kr = Ei([
  b("DecryptDocument", h.gemEncrypt61)
], kr);
var $l = Object.defineProperty, ql = Object.getOwnPropertyDescriptor, na = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? ql(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && $l(e, t, n), n;
};
let xn = class {
  constructor() {
    this.document = [];
  }
};
na([
  c(re, "Status", h.gemCommon5)
], xn.prototype, "status", 2);
na([
  z(oe, "Document", void 0, h.gemCommon5)
], xn.prototype, "document", 2);
xn = na([
  b("DecryptDocumentResponse", h.gemEncrypt61)
], xn);
var Xl = Object.defineProperty, _l = Object.getOwnPropertyDescriptor, ou = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? _l(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && Xl(e, t, n), n;
};
class Vn {
  constructor(e, t) {
    this.certificates = e, this.certificateOnCard = t;
  }
}
ou([
  c(Sr, "CertificateOnCard", h.gemEncrypt61)
], Vn.prototype, "certificateOnCard", 2);
ou([
  z(String, "Certificate", void 0, h.gemEncrypt61)
], Vn.prototype, "certificates", 2);
var Jl = Object.defineProperty, ed = Object.getOwnPropertyDescriptor, _t = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? ed(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && Jl(e, t, n), n;
};
let zr = class {
};
_t([
  c(String, "EncryptionType", h.gemEncrypt61)
], zr.prototype, "encryptionType", 2);
_t([
  c(ar, "UnprotectedProperties", h.gemEncrypt61)
], zr.prototype, "unprotectedProperties", 2);
zr = _t([
  b("OptionalInputs", h.gemEncrypt61)
], zr);
let kt = class {
  constructor(i, e, t) {
    this.context = i, this.recipientKeys = e, this.document = t;
  }
};
_t([
  c($, "Context", h.gemConCtx2)
], kt.prototype, "context", 2);
_t([
  c(Vn, "RecipientKeys", h.gemEncrypt61)
], kt.prototype, "recipientKeys", 2);
_t([
  c(oe, "Document", h.gemCommon5)
], kt.prototype, "document", 2);
_t([
  c(zr, "OptionalInputs", h.gemEncrypt61)
], kt.prototype, "optionalInputs", 2);
kt = _t([
  b("EncryptDocument", h.gemEncrypt61)
], kt);
var td = Object.defineProperty, rd = Object.getOwnPropertyDescriptor, sa = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? rd(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && td(e, t, n), n;
};
let Wr = class {
  constructor() {
    this.document = [];
  }
};
sa([
  c(re, "Status", h.gemCommon5)
], Wr.prototype, "status", 2);
sa([
  z(oe, "Document", void 0, h.gemCommon5)
], Wr.prototype, "document", 2);
Wr = sa([
  b("EncryptDocumentResponse", h.gemEncrypt61)
], Wr);
class nd {
  constructor(e, t) {
    this.connector = e, this.url = t;
  }
  /**
   * Encrypts base64 Data.
   * @param base64Content 
   * @param cardHandle If it should be encrypted with a card define it here.
   * @param publicKeys List of DER Encoded Keys in base64 format, in which the content should be encrypted
   * @returns 
   */
  async encrypt(e, t, r) {
    Q.log("Konnektor verschlüsselt Daten."), new Wr();
    let n;
    t && (n = new Sr(t));
    const s = new Vn(r, n), o = new oe(e, void 0), u = new kt(this.connector.context, s, o);
    return this.connector.soap11Post(h.gemEncrypt61 + "#EncryptDocument", this.url, u);
  }
  async encryptMimeMessage(e, t, r) {
    Q.log("Konnektor verschlüsselt Daten."), new Wr();
    const n = new Vn(e), s = new oe(t), o = window.document.createElementNS(null, "CMSAttribute");
    o.textContent = r;
    const u = new zr();
    u.encryptionType = "urn:ietf:rfc:5652", u.unprotectedProperties = [new ar(new Ar("RecipientEmailsAttribute", o))];
    const l = new kt(this.connector.context, n, s);
    return l.optionalInputs = u, this.connector.soap11Post(h.gemEncrypt61 + "#EncryptDocument", this.url, l);
  }
  /**
  * Decrypts base64 Data.
  * @param base64Content 
  * @param cardHandle If it should be decrypted with a card define it here.
  * @returns 
  */
  async decrypt(e, t) {
    Q.log("Konnektor entschlüsselt Daten."), new xn();
    const r = new oe(e, void 0), n = new kr(this.connector.context, t, r);
    return this.connector.soap11Post(h.gemDecrypt61 + "#DecryptDocument", this.url, n);
  }
}
var sd = Object.defineProperty, id = Object.getOwnPropertyDescriptor, ia = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? id(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && sd(e, t, n), n;
};
let Un = class {
  constructor(i, e = !1) {
    this.context = i, this.mandantWide = e;
  }
};
ia([
  c($, "Context", h.gemConCtx2)
], Un.prototype, "context", 2);
ia([
  x("mandant-wide", Boolean)
], Un.prototype, "mandantWide", 2);
Un = ia([
  b("GetCardTerminals", h.gemEvent72)
], Un);
var od = Object.defineProperty, ad = Object.getOwnPropertyDescriptor, au = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? ad(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && od(e, t, n), n;
};
class oa {
}
au([
  c(String, "HWVersion")
], oa.prototype, "hwVersion", 2);
au([
  c(String, "FWVersion")
], oa.prototype, "fwVersion", 2);
var cd = Object.defineProperty, ud = Object.getOwnPropertyDescriptor, cu = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? ud(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && cd(e, t, n), n;
};
class aa {
}
cu([
  c(oa, "Local")
], aa.prototype, "local", 2);
cu([
  c(String, "Central")
], aa.prototype, "central", 2);
var hd = Object.defineProperty, ld = Object.getOwnPropertyDescriptor, ca = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? ld(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && hd(e, t, n), n;
};
class Di {
}
ca([
  c(String, "ProductVendorID")
], Di.prototype, "productVendorID", 2);
ca([
  c(String, "ProductCode")
], Di.prototype, "productCode", 2);
ca([
  c(aa, "ProductVersion")
], Di.prototype, "productVersion", 2);
var dd = Object.defineProperty, pd = Object.getOwnPropertyDescriptor, uu = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? pd(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && dd(e, t, n), n;
};
class ua {
}
uu([
  c(String, "ProductVendorName")
], ua.prototype, "productVendorName", 2);
uu([
  c(String, "ProductName")
], ua.prototype, "productName", 2);
var gd = Object.defineProperty, fd = Object.getOwnPropertyDescriptor, hu = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? fd(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && gd(e, t, n), n;
};
class ha {
}
hu([
  c(String, "ProductType")
], ha.prototype, "productType", 2);
hu([
  c(String, "ProductTypeVersion")
], ha.prototype, "productTypeVersion", 2);
var md = Object.defineProperty, wd = Object.getOwnPropertyDescriptor, vs = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? wd(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && md(e, t, n), n;
};
let zt = class {
};
vs([
  c(Date, "InformationDate")
], zt.prototype, "informationDate", 2);
vs([
  c(ha, "ProductTypeInformation")
], zt.prototype, "productTypeInformation", 2);
vs([
  c(Di, "ProductIdentification")
], zt.prototype, "productIdentification", 2);
vs([
  c(ua, "ProductMiscellaneous")
], zt.prototype, "productMiscellaneous", 2);
zt = vs([
  b("ProductInformation", "http://ws.gematik.de/int/version/ProductInformation/v1.1")
], zt);
var yd = Object.defineProperty, Ad = Object.getOwnPropertyDescriptor, Ue = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? Ad(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && yd(e, t, n), n;
};
class la {
}
Ue([
  c(String, "IPV4Address")
], la.prototype, "ipv4Address", 2);
Ue([
  c(String, "IPV6Address")
], la.prototype, "ipv6Address", 2);
let xe = class {
};
Ue([
  c(zt, "ProductInformation", "http://ws.gematik.de/int/version/ProductInformation/v1.1")
], xe.prototype, "productInformation", 2);
Ue([
  c(String, "CtId", h.gemCardCommon2)
], xe.prototype, "ctId", 2);
Ue([
  z(String, "WorkplaceIds", "WorkplaceId", h.gemCommon5)
], xe.prototype, "workplaceIds", 2);
Ue([
  c(String, "Name")
], xe.prototype, "name", 2);
Ue([
  c(String, "MacAddress")
], xe.prototype, "macAddress", 2);
Ue([
  c(la, "IPAddress")
], xe.prototype, "ipAddress", 2);
Ue([
  c(Number, "Slots")
], xe.prototype, "slots", 2);
Ue([
  c(Boolean, "IS_PHYSICAL")
], xe.prototype, "isPhysical", 2);
Ue([
  c(Boolean, "Connected")
], xe.prototype, "isConnected", 2);
xe = Ue([
  b("CardTerminal", h.gemCardTerminal8)
], xe);
var Sd = Object.defineProperty, vd = Object.getOwnPropertyDescriptor, da = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? vd(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && Sd(e, t, n), n;
};
let Ln = class {
};
da([
  c(re, "Status", h.gemCommon5)
], Ln.prototype, "status", 2);
da([
  z(xe, "CardTerminals", "CardTerminal", h.gemCardTerminal8)
], Ln.prototype, "cardTerminals", 2);
Ln = da([
  b("GetCardTerminalsResponse", h.gemEvent72)
], Ln);
var bd = Object.defineProperty, Cd = Object.getOwnPropertyDescriptor, Ii = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? Cd(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && bd(e, t, n), n;
};
let Zr = class {
  constructor(i) {
    this.context = i;
  }
};
Ii([
  c($, "Context", h.gemConCtx2)
], Zr.prototype, "context", 2);
Ii([
  c(String, "CtId", h.gemCardCommon2)
], Zr.prototype, "ctId", 2);
Ii([
  c(String, "SlotId", h.gemCardCommon2)
], Zr.prototype, "slotId", 2);
Zr = Ii([
  b("GetCards", h.gemEvent72)
], Zr);
var Ed = Object.defineProperty, Dd = Object.getOwnPropertyDescriptor, pa = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? Dd(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && Ed(e, t, n), n;
};
let Fn = class {
};
pa([
  c(re, "Status")
], Fn.prototype, "status", 2);
pa([
  z(Ie, "Cards", "Card")
], Fn.prototype, "cards", 2);
Fn = pa([
  b("GetCardsResponse", h.gemEvent72)
], Fn);
var Id = Object.defineProperty, Bd = Object.getOwnPropertyDescriptor, lu = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? Bd(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && Id(e, t, n), n;
};
let zs = class {
  constructor(i) {
    this.context = i;
  }
};
lu([
  c($, "Context", h.gemConCtx2)
], zs.prototype, "context", 2);
zs = lu([
  b("GetResourceInformation", h.gemEvent72)
], zs);
var Md = Object.defineProperty, Pd = Object.getOwnPropertyDescriptor, ga = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? Pd(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && Md(e, t, n), n;
}, Rd = /* @__PURE__ */ ((i) => (i.ONLINE = "Online", i.OFFLINE = "Offline", i))(Rd || {});
let Gn = class {
};
ga([
  c(String, "ConnectionStatus", h.gemCardCommon2)
], Gn.prototype, "connectionStatus", 2);
ga([
  c(Date, "Timestamp")
], Gn.prototype, "timeStamp", 2);
Gn = ga([
  b("VPNTIStatus", h.gemCommon5)
], Gn);
var Od = Object.defineProperty, Td = Object.getOwnPropertyDescriptor, du = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? Td(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && Od(e, t, n), n;
};
let Ws = class {
};
du([
  c(Gn, "VPNTIStatus", h.gemCommon5)
], Ws.prototype, "vpnTiStatus", 2);
Ws = du([
  b("Connector", h.gemCommon5)
], Ws);
var Nd = Object.defineProperty, xd = Object.getOwnPropertyDescriptor, fa = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? xd(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && Nd(e, t, n), n;
};
let Qn = class {
};
fa([
  c(re, "Status")
], Qn.prototype, "status", 2);
fa([
  c(Ws, "Connector", h.gemCommon5)
], Qn.prototype, "connector", 2);
Qn = fa([
  b("GetResourceInformationResponse", h.gemEvent72)
], Qn);
class Vd {
  constructor(e, t) {
    this.connector = e, this.url = t;
  }
  async getCards() {
    const e = new Zr(this.connector.context);
    return new Fn().cards = [], this.connector.soap11Post(h.gemEvent72 + "#GetCards", this.url, e);
  }
  async getCardTerminals() {
    const e = new Un(this.connector.context, !0);
    return new Ln().cardTerminals = [], this.connector.soap11Post(h.gemEvent72 + "#GetCardTerminals", this.url, e);
  }
  async getResourceInformation() {
    const e = new zs(this.connector.context);
    return new Qn(), this.connector.soap11Post(h.gemEvent72 + "#GetResourceInformation", this.url, e);
  }
}
var Ud = Object.defineProperty, Ld = Object.getOwnPropertyDescriptor, Fd = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? Ld(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && Ud(e, t, n), n;
};
class ma {
  constructor(e) {
    this.element = e;
  }
}
Fd([
  c(void 0, void 0, void 0, !0)
], ma.prototype, "element", 2);
var Gd = Object.defineProperty, Qd = Object.getOwnPropertyDescriptor, wa = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? Qd(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && Gd(e, t, n), n;
};
let Wt = class {
  constructor(i) {
    this.root = "1.2.276.0.76.4.8", this.insurantId = i;
  }
  getQueryString() {
    return `${this.insurantId}^^^&${this.root}&ISO`;
  }
};
wa([
  x("root", String)
], Wt.prototype, "root", 2);
wa([
  x("extension", String)
], Wt.prototype, "insurantId", 2);
Wt = wa([
  b("InsurantId", "http://ws.gematik.de/fa/phr/v1.1")
], Wt);
var jd = Object.defineProperty, Hd = Object.getOwnPropertyDescriptor, ya = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? Hd(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && jd(e, t, n), n;
};
let bt = class {
  constructor(i, e) {
    this.insurantId = new Wt(i), this.homeCommunityId = e;
  }
};
ya([
  c(Wt, "InsurantId", "http://ws.gematik.de/fa/phr/v1.1")
], bt.prototype, "insurantId", 2);
ya([
  c(String, "HomeCommunityId", "http://ws.gematik.de/fa/phr/v1.1")
], bt.prototype, "homeCommunityId", 2);
bt = ya([
  b("RecordIdentifier", h.gemPhrMgt2)
], bt);
var Kd = Object.defineProperty, kd = Object.getOwnPropertyDescriptor, Aa = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? kd(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && Kd(e, t, n), n;
};
let Re = class {
  constructor(i, e) {
    this.context = i, this.recordIdentifier = e;
  }
};
Aa([
  c($, "Context", h.gemConCtx2)
], Re.prototype, "context", 2);
Aa([
  c(bt, "RecordIdentifier", h.gemPhr2)
], Re.prototype, "recordIdentifier", 2);
Re = Aa([
  b("ContextHeader", h.gemPhr2)
], Re);
var zd = Object.defineProperty, Wd = Object.getOwnPropertyDescriptor, Zd = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? Wd(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && zd(e, t, n), n;
};
class Sa {
  constructor(e) {
    this.homeCommunityId = e;
  }
}
Zd([
  c(String, "homeCommunityId", "urn:ihe:iti:xdr:2014")
], Sa.prototype, "homeCommunityId", 2);
var Yd = Object.defineProperty, $d = Object.getOwnPropertyDescriptor, Bi = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? $d(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && Yd(e, t, n), n;
};
class ln {
  constructor(e) {
    this.messageID = crypto.randomUUID(), this.action = e;
  }
}
Bi([
  c(String, "Action", "http://www.w3.org/2005/08/addressing")
], ln.prototype, "action", 2);
Bi([
  c(String, "MessageID", "http://www.w3.org/2005/08/addressing")
], ln.prototype, "messageID", 2);
Bi([
  c(Re, "ContextHeader", h.gemPhr2)
], ln.prototype, "contextHeader", 2);
Bi([
  c(Sa, "homeCommunityBlock", "urn:ihe:iti:xdr:2014")
], ln.prototype, "homeCommunityBlock", 2);
var qd = Object.defineProperty, Xd = Object.getOwnPropertyDescriptor, va = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? Xd(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && qd(e, t, n), n;
};
let ge = class {
  constructor(i, e) {
    this.header = new ln(i), this.body = new ma(e);
  }
};
va([
  c(ln, "Header", "http://www.w3.org/2003/05/soap-envelope")
], ge.prototype, "header", 2);
va([
  c(ma, "Body", "http://www.w3.org/2003/05/soap-envelope")
], ge.prototype, "body", 2);
ge = va([
  b("Envelope", "http://www.w3.org/2003/05/soap-envelope")
], ge);
var _d = Object.defineProperty, Jd = Object.getOwnPropertyDescriptor, Mi = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? Jd(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && _d(e, t, n), n;
};
let Yr = class {
  constructor(i, e, t) {
    this.context = i, this.ehcHandle = e, this.recordIdentifier = t;
  }
};
Mi([
  c($, "Context", h.gemConCtx2)
], Yr.prototype, "context", 2);
Mi([
  c(String, "EhcHandle", h.gemCommon5)
], Yr.prototype, "ehcHandle", 2);
Mi([
  c(void 0, void 0, void 0, !0)
], Yr.prototype, "recordIdentifier", 2);
Yr = Mi([
  b("ActivateAccount", h.gemPhrMgt2)
], Yr);
var ep = Object.defineProperty, tp = Object.getOwnPropertyDescriptor, pu = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? tp(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && ep(e, t, n), n;
};
let jn = class {
};
pu([
  c(void 0, void 0, void 0, !0)
], jn.prototype, "status", 2);
jn = pu([
  b("ActivateAccountResponse", h.gemPhrMgt2)
], jn);
var rp = Object.defineProperty, np = Object.getOwnPropertyDescriptor, gu = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? np(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && rp(e, t, n), n;
};
let Zs = class {
  constructor(i) {
    this.context = i;
  }
};
gu([
  c($, "Context", h.gemConCtx2)
], Zs.prototype, "context", 2);
Zs = gu([
  b("GetAuthorizationList", h.gemPhrMgt2)
], Zs);
var sp = Object.defineProperty, ip = Object.getOwnPropertyDescriptor, ba = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? ip(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && sp(e, t, n), n;
};
let Hn = class {
};
ba([
  c(Date, "ValidTo")
], Hn.prototype, "validTo", 2);
ba([
  c(bt, "RecordIdentifier", h.gemPhrMgt2)
], Hn.prototype, "recordIdentifier", 2);
Hn = ba([
  b("AuthorizationEntry", h.gemPhrMgt2)
], Hn);
var op = Object.defineProperty, ap = Object.getOwnPropertyDescriptor, Ca = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? ap(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && op(e, t, n), n;
};
let Kn = class {
  constructor() {
    this.authorizationEntries = [];
  }
};
Ca([
  c(re, "Status", h.gemCommon5)
], Kn.prototype, "status", 2);
Ca([
  z(Hn, "AuthorizationList", "AuthorizationEntry", "http://ws.gematik.de/conn/phrs/PHRManagementService/v1.3")
], Kn.prototype, "authorizationEntries", 2);
Kn = Ca([
  b("GetAuthorizationListResponse", h.gemPhrMgt2)
], Kn);
var cp = Object.defineProperty, up = Object.getOwnPropertyDescriptor, Ea = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? up(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && cp(e, t, n), n;
};
let kn = class {
  constructor(i, e) {
    this.context = i, this.insurantID = new Wt(e);
  }
};
Ea([
  c($, "Context", h.gemConCtx2)
], kn.prototype, "context", 2);
Ea([
  c(Wt, "InsurantID", h.gemPhrMgt2)
], kn.prototype, "insurantID", 2);
kn = Ea([
  b("GetHomeCommunityID", h.gemPhrMgt2)
], kn);
var hp = Object.defineProperty, lp = Object.getOwnPropertyDescriptor, Da = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? lp(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && hp(e, t, n), n;
};
let zn = class {
};
Da([
  c(re, "Status")
], zn.prototype, "status", 2);
Da([
  c(String, "HomeCommunityID", h.gemPhrMgt2)
], zn.prototype, "HomeCommunityId", 2);
zn = Da([
  b("GetHomeCommunityIDResponse", h.gemPhrMgt2)
], zn);
var dp = Object.defineProperty, pp = Object.getOwnPropertyDescriptor, vr = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? pp(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && dp(e, t, n), n;
};
let Ct = class {
  constructor(i, e, t, r, n, s) {
    this.context = i, this.recordIdentifier = t, this.ehcHandle = e, this.authorizationConfiguration = r, this.organizationName = n, this.insurantName = s;
  }
};
vr([
  c($, "Context", h.gemConCtx2)
], Ct.prototype, "context", 2);
vr([
  c(String, "EhcHandle", h.gemCommon5)
], Ct.prototype, "ehcHandle", 2);
vr([
  c(void 0, void 0, void 0, !0)
], Ct.prototype, "authorizationConfiguration", 2);
vr([
  c(void 0, void 0, void 0, !0)
], Ct.prototype, "recordIdentifier", 2);
vr([
  c(String, "OrganizationName", h.gemPhrMgt2)
], Ct.prototype, "organizationName", 2);
vr([
  c(void 0, void 0, void 0, !0)
], Ct.prototype, "insurantName", 2);
Ct = vr([
  b("RequestFacilityAuthorization", h.gemPhrMgt2)
], Ct);
var gp = Object.defineProperty, fp = Object.getOwnPropertyDescriptor, fu = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? fp(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && gp(e, t, n), n;
};
let Wn = class {
};
fu([
  c(void 0, void 0, void 0, !0)
], Wn.prototype, "status", 2);
Wn = fu([
  b("RequestFacilityAuthorizationResponse", h.gemPhrMgt2)
], Wn);
class mp {
  constructor(e, t) {
    this.connector = e, this.url = t;
  }
  async getHomeCommunityID(e) {
    new zn();
    const t = new ge("http://ws.gematik.de/conn/phrs/PHRManagementService/v2.0/GetHomeCommunityID", new kn(this.connector.context, e)), r = await this.connector.communicationService.soap12Post(this.url, t);
    return new bt(e, r.HomeCommunityId || "");
  }
  /**
   * reads ALL Permissions. Can only be called once every 10 Minutes.
   * @returns 
   */
  async getAuthorizationList() {
    new Kn();
    const e = new ge("http://ws.gematik.de/conn/phrs/PHRManagementService/v2.0/GetAuthorizationList", new Zs(this.connector.context));
    return this.connector.communicationService.soap12Post(this.url, e);
  }
  async requestAdhocAccess(e, t, r, n, s) {
    new Wn(), Q.log("Beantrage Zugriff auf ePA, siehe Karten Terminal."), new Wn();
    const o = new ge("http://ws.gematik.de/conn/phrs/PHRManagementService/v2.0/RequestFacilityAuthorization", new Ct(this.connector.context, e, t, r, n, s));
    return this.connector.communicationService.soap12Post(this.url, o);
  }
  async activateAccount(e, t) {
    new jn(), Q.log("Beantrage Aktivierung der ePA, siehe Karten Terminal."), new jn();
    const r = new ge("http://ws.gematik.de/conn/phrs/PHRManagementService/v2.0/ActivateAccount", new Yr(this.connector.context, e, t)), n = await this.connector.communicationService.soap12Post(this.url, r);
    if (n instanceof rt) {
      if (n.trace.code === "7402")
        return;
      throw Q.error("Das Aktenkonto konnte aus einem unbekannten Grund nicht aktiviert werden."), n;
    }
  }
}
var wp = Object.defineProperty, yp = Object.getOwnPropertyDescriptor, mu = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? yp(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && wp(e, t, n), n;
};
let Zn = class {
  constructor(i) {
    this.content = i, this.contentId = crypto.randomUUID() + "@yoshteq.de", this.href = "cid:" + this.contentId;
  }
};
mu([
  x("href")
], Zn.prototype, "href", 2);
Zn = mu([
  b("Include", "http://www.w3.org/2004/08/xop/include")
], Zn);
function Ji() {
  return `2.25.${BigInt(`0x${crypto.randomUUID().replace(/-/g, "")}`).toString()}`;
}
function bs() {
  return "urn:uuid:" + crypto.randomUUID();
}
function Dc(i) {
  return i.toISOString().substring(0, 19).replaceAll(/[-T:]/g, "");
}
function wu(i) {
  if (i === void 0 || i.length == 0)
    return;
  const t = /^(\d{4})(\d{2})?(\d{2})?(\d{2})?(\d{2})?(\d{2})?$/gm.exec(i);
  if (t) {
    const r = +t[1], n = +(t[2] || "01"), s = +(t[3] || "01"), o = +(t[4] || "00"), u = +(t[5] || "00"), l = +(t[6] || "00");
    return t[4] === void 0 ? new Date(r, n - 1, s) : new Date(Date.UTC(r, n - 1, s, o, u, l));
  }
}
class Ap {
  constructor(e, t) {
    this.info = e, this.content = t;
  }
}
var Sp = Object.defineProperty, vp = Object.getOwnPropertyDescriptor, Ia = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? vp(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && Sp(e, t, n), n;
};
class Cs {
  constructor(e) {
    this.lang = "de-DE", this.charset = "UTF-8", this.value = e;
  }
}
Ia([
  x("lang", String, "http://www.w3.org/XML/1998/namespace")
], Cs.prototype, "lang", 2);
Ia([
  x("charset")
], Cs.prototype, "charset", 2);
Ia([
  x("value")
], Cs.prototype, "value", 2);
var bp = Object.defineProperty, Cp = Object.getOwnPropertyDescriptor, Ep = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? Cp(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && bp(e, t, n), n;
};
class nt {
  constructor(e) {
    this.localizedString = new Cs(e);
  }
}
Ep([
  c(Cs, "LocalizedString", h.ebXmlRmi3)
], nt.prototype, "localizedString", 2);
var Dp = Object.defineProperty, Ip = Object.getOwnPropertyDescriptor, Ba = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? Ip(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && Dp(e, t, n), n;
};
let W = class {
  constructor(i, e) {
    this.values = [], this.name = i, typeof e == "string" && (e = [e]), this.values = e;
  }
  getValue() {
    return this.values[0];
  }
};
Ba([
  x("name")
], W.prototype, "name", 2);
Ba([
  z(String, "ValueList", "Value", h.ebXmlRmi3)
], W.prototype, "values", 2);
W = Ba([
  b("Slot", h.ebXmlRmi3)
], W);
var Bp = Object.defineProperty, Mp = Object.getOwnPropertyDescriptor, Nt = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? Mp(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && Bp(e, t, n), n;
};
let ie = class {
  constructor(i) {
    this.objectType = "urn:oasis:names:tc:ebxml-regrep:ObjectType:RegistryObject:Classification", this.id = bs(), this.slots = [], typeof i == "string" ? this.classifiedObject = i : i && i.id && (this.classifiedObject = i.id, i.classifications.push(this));
  }
};
Nt([
  x("classificationScheme")
], ie.prototype, "classificationScheme", 2);
Nt([
  x("classifiedObject")
], ie.prototype, "classifiedObject", 2);
Nt([
  x("classificationNode")
], ie.prototype, "classificationNode", 2);
Nt([
  x("nodeRepresentation")
], ie.prototype, "nodeRepresentation", 2);
Nt([
  x("objectType")
], ie.prototype, "objectType", 2);
Nt([
  x("id")
], ie.prototype, "id", 2);
Nt([
  z(W, "Slot", void 0, h.ebXmlRmi3)
], ie.prototype, "slots", 2);
Nt([
  c(nt, "Name", h.ebXmlRmi3)
], ie.prototype, "name", 2);
ie = Nt([
  b("Classification", h.ebXmlRmi3)
], ie);
class se {
  constructor(e, t, r, n) {
    this.classificationScheme = e, this.schemeOid = t, this.nodeRepresentation = r, this.name = n;
  }
  getUrn() {
    return "urn:" + this.schemeOid + "#" + this.nodeRepresentation;
  }
  setClassificationToObject(e) {
    const t = new ie(e);
    return t.classificationScheme = this.classificationScheme, t.nodeRepresentation = this.nodeRepresentation, t.slots = [
      new W("codingScheme", this.schemeOid)
    ], t.name = new nt(this.name), t;
  }
  getQueryString() {
    return `${this.nodeRepresentation}^^${this.schemeOid}`;
  }
  matchesClassification(e) {
    var t;
    return e.classificationScheme === this.classificationScheme && e.nodeRepresentation === this.nodeRepresentation && ((t = e.slots[0]) == null ? void 0 : t.getValue()) === this.schemeOid;
  }
  /**
   * Searches the static ClassificationCodeScheme that matches the classification
   * Warning: this is currently not type save!
   * @param extObj 
   * @param classificationScheme 
   * @param codeScheme 
   * @returns 
   */
  static findScheme(e, t, r) {
    const n = e.classifications.find((s) => s.classificationScheme === t);
    if (n) {
      const s = Object.getOwnPropertyNames(r);
      for (const o of s) {
        const u = r[o];
        if (u instanceof se && u.matchesClassification(n))
          return r[o];
      }
    }
  }
}
var a = /* @__PURE__ */ ((i) => (i.SubmissionSetAuthor = "urn:uuid:a7058bb9-b4e4-4307-ba5b-e3f0ab85e12d", i.SubmissionSetContentTypeCode = "urn:uuid:aa543740-bdda-424e-8c96-df4873be8500", i.FolderCodeList = "urn:uuid:1ba97051-7806-41a8-a48b-8fce7af683c5", i.DocumentKind = "urn:uuid:41a5887f-8865-4c09-adf7-e362475b143a", i.DocumentConfidentialityCode = "urn:uuid:f4f85eac-e6cb-4883-b524-f2705394840f", i.DocumentEventCode = "urn:uuid:2c6b8cb7-8b2a-4051-b291-b1ae6a575ef4", i.DocumentFormatCode = "urn:uuid:a09d5840-386c-46f2-b5ad-9c3699a4309d", i.DocumentHealthcareFacilityTypeCode = "urn:uuid:f33fb8ac-18af-42cc-ae0e-ed0b0bdb91e1", i.DocumentPracticeSettingCode = "urn:uuid:cccf5598-8b07-4b77-a05e-ae952c785ead", i.DocumentTypeCode = "urn:uuid:f0306f51-975f-434e-a61c-c59651d33983", i.DocumentAuthor = "urn:uuid:93606bcf-9494-43ec-9b4e-a7748d1a838d", i))(a || {});
const te = class te extends se {
};
te.LEI = new te(a.DocumentConfidentialityCode, "1.2.276.0.76.5.491", "LEI", "Dokument einer Leistungserbringerinstitution"), te.KTR = new te(a.DocumentConfidentialityCode, "1.2.276.0.76.5.491", "KTR", "Dokument eines Kostenträgers"), te.PAT = new te(a.DocumentConfidentialityCode, "1.2.276.0.76.5.491", "PAT", "Dokument eines Versicherten"), te.LEAe = new te(a.DocumentConfidentialityCode, "1.2.276.0.76.5.491", "LEÄ", "Leistungserbringeräquivalentes Dokument eines Versicherten oder Kostenträgers"), te.N = new te(a.DocumentConfidentialityCode, "2.16.840.1.113883.5.25", "N", "normal"), te.R = new te(a.DocumentConfidentialityCode, "2.16.840.1.113883.5.25", "R", "vertraulich"), te.V = new te(a.DocumentConfidentialityCode, "2.16.840.1.113883.5.25", "V", "streng vertraulich"), te.PV = new te(a.DocumentConfidentialityCode, "1.3.6.1.4.1.19376.3.276.1.5.10", "PV", "gesperrt"), te.PR = new te(a.DocumentConfidentialityCode, "1.3.6.1.4.1.19376.3.276.1.5.10", "PR", "erhöhte Vertraulichkeit"), te.PN = new te(a.DocumentConfidentialityCode, "1.3.6.1.4.1.19376.3.276.1.5.10", "PN", "übliche Vertraulichkeit");
let oo = te;
const d = class d extends se {
};
d.MedicalSummariesXDSMS = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.1.2.3", "urn:ihe:pcc:xds-ms:2007", "Medical Summaries (XDS-MS)"), d.ExchangeOfPersonalHealthRecordsXPHR = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.1.2.3", "urn:ihe:pcc:xphr:2007", "Exchange of Personal Health Records (XPHR)"), d.EmergencyDepartmentReferralEDR = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.1.2.3", "urn:ihe:pcc:edr:2007", "Emergency Department Referral (EDR)"), d.AntepartumSummaryAPS = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.1.2.3", "urn:ihe:pcc:aps:2007", "Antepartum Summary (APS)"), d.EmergencyDepartmentEncounterSummaryEDES = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.1.2.3", "urn:ihe:pcc:edes:2007", "Emergency Department Encounter Summary (EDES)"), d.AntepartumHistoryAndPhysicalAPHP = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.1.2.3", "urn:ihe:pcc:aphp:2008", "Antepartum History and Physical (APHP)"), d.AntepartumLaboratoryAPL = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.1.2.3", "urn:ihe:pcc:apl:2008", "Antepartum Laboratory (APL)"), d.AntepartumEducationAPE = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.1.2.3", "urn:ihe:pcc:ape:2008", "Antepartum Education (APE)"), d.ImmunizationContentIC = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.1.2.3", "urn:ihe:pcc:ic:2009", "Immunization Content (IC)"), d.CareManagementCM = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.1.2.3", "urn:ihe:pcc:cm:2008", "Care Management (CM)"), d.urnihepcctn2007 = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.1.2.3", "urn:ihe:pcc:tn:2007", "??? (urn:ihe:pcc:tn:2007)"), d.urnihepccnn2007 = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.1.2.3", "urn:ihe:pcc:nn:2007", "??? (urn:ihe:pcc:nn:2007)"), d.urnihepccctn2007 = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.1.2.3", "urn:ihe:pcc:ctn:2007", "??? (urn:ihe:pcc:ctn:2007)"), d.urnihepccedpn2007 = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.1.2.3", "urn:ihe:pcc:edpn:2007", "??? (urn:ihe:pcc:edpn:2007)"), d.urnihepcchp2008 = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.1.2.3", "urn:ihe:pcc:hp:2008", "??? (urn:ihe:pcc:hp:2008)"), d.urnihepccldhp2009 = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.1.2.3", "urn:ihe:pcc:ldhp:2009", "??? (urn:ihe:pcc:ldhp:2009)"), d.urnihepcclds2009 = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.1.2.3", "urn:ihe:pcc:lds:2009", "??? (urn:ihe:pcc:lds:2009)"), d.urnihepccmds2009 = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.1.2.3", "urn:ihe:pcc:mds:2009", "??? (urn:ihe:pcc:mds:2009)"), d.urnihepccnds2010 = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.1.2.3", "urn:ihe:pcc:nds:2010", "??? (urn:ihe:pcc:nds:2010)"), d.urnihepccppvs2010 = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.1.2.3", "urn:ihe:pcc:ppvs:2010", "??? (urn:ihe:pcc:ppvs:2010)"), d.urnihepcctrs2011 = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.1.2.3", "urn:ihe:pcc:trs:2011", "??? (urn:ihe:pcc:trs:2011)"), d.urnihepccets2011 = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.1.2.3", "urn:ihe:pcc:ets:2011", "??? (urn:ihe:pcc:ets:2011)"), d.urnihepccits2011 = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.1.2.3", "urn:ihe:pcc:its:2011", "??? (urn:ihe:pcc:its:2011)"), d.ScannedDocumentsPDF = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.1.2.3", "urn:ihe:iti:xds-sd:pdf:2008", "Scanned Documents (PDF)"), d.ScannedDocumentstext = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.1.2.3", "urn:ihe:iti:xds-sd:text:2008", "Scanned Documents (text)"), d.BasicPatientPrivacyConsents = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.1.2.3", "urn:ihe:iti:bppc:2007", "Basic Patient Privacy Consents"), d.BasicPatientPrivacyConsentsWithScannedDocument = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.1.2.3", "urn:ihe:iti:bppc-sd:2007", "Basic Patient Privacy Consents with Scanned Document"), d.APPCPrivacyConsentDocument = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.1.2.3", "urn:ihe:iti:appc:2016:consent", "APPC Privacy Consent Document"), d.XDWWorkflowDocument = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.1.2.3", "urn:ihe:iti:xdw:2011:workflowDoc", "XDW Workflow Document"), d.DSGDetachedDocument = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.1.2.3", "urn:ihe:iti:dsg:detached:2014", "DSG Detached Document"), d.DSGEnvelopingDocument = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.1.2.3", "urn:ihe:iti:dsg:enveloping:2014", "DSG Enveloping Document"), d.CDALaboratoryReport = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.1.2.3", "urn:ihe:lab:xd-lab:2008", "CDA Laboratory Report"), d.XDSICDAWrappedTextReportXDSI = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.1.2.3", "urn:ihe:rad:TEXT", "XDS-I CDA Wrapped Text Report (XDS-I)"), d.XDSIPDFXDSI = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.1.2.3", "urn:ihe:rad:PDF", "XDS-I PDF (XDS-I)"), d.XDSIImagingReportWithStructuredHeadingsXDSI = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.1.2.3", "urn:ihe:rad:CDA:ImagingReportStructuredHeadings:2013", "XDS-I Imaging Report with Structured Headings (XDS-I)"), d.CardiologyCRC = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.1.2.3", "urn:ihe:card:CRC:2012", "Cardiology ??? (CRC)"), d.CardiologyEPRCIE = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.1.2.3", "urn:ihe:card:EPRC-IE:2014", "Cardiology ??? (EPRC-IE)"), d.CardiacImagingReport = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.1.2.3", "urn:ihe:card:imaging:2011", "Cardiac Imaging Report"), d.DentalCDAWrappedTextReportDENT = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.1.2.3", "urn:ihe:dent:TEXT", "Dental CDA Wrapped Text Report (DENT)"), d.DentalPDFDENT = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.1.2.3", "urn:ihe:dent:PDF", "Dental PDF (DENT)"), d.DentalImagingReportWithStructuredHeadingsDENT = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.1.2.3", "urn:ihe:dent:CDA:ImagingReportStructuredHeadings:2013", "Dental Imaging Report with Structured Headings (DENT)"), d.AnatomicPathologyStructuredReportAPSR = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.1.2.3", "urn:ihe:palm:apsr:2016", "Anatomic Pathology Structured Report (APSR)"), d.Pharmacyurnihepharmpre2010 = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.1.2.3", "urn:ihe:pharm:pre:2010", "Pharmacy ??? (urn:ihe:pharm:pre:2010)"), d.Pharmacyurnihepharmpadv2010 = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.1.2.3", "urn:ihe:pharm:padv:2010", "Pharmacy ??? (urn:ihe:pharm:padv:2010)"), d.Pharmacyurnihepharmdis2010 = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.1.2.3", "urn:ihe:pharm:dis:2010", "Pharmacy ??? (urn:ihe:pharm:dis:2010)"), d.Pharmacyurnihepharmpml2013 = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.1.2.3", "urn:ihe:pharm:pml:2013", "Pharmacy ??? (urn:ihe:pharm:pml:2013)"), d.MIMETypeAbleitbar = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.1.2.3", "urn:ihe:iti:xds:2017:mimeTypeSufficient", "Format aus MIME Type ableitbar"), d.Entlassmanagementbrief = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.3.276.1.5.6", "urn:ihe-d:ig:Entlassmanagementbrief:2018", "Entlassmanagementbrief"), d.NotaufnahmeregisterTraumamodul = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.3.276.1.5.6", "urn:ihe-d:ig:NotaufnahmeregisterTraumaModul:2017", "NotaufnahmeregisterTraumamodul"), d.NotaufnahmeregisterBasismodul = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.3.276.1.5.6", "urn:ihe-d:ig:NotaufnahmeregisterBasisModul:2017", "NotaufnahmeregisterBasismodul"), d.MeldepflichtigeKrankheitenLabormeldung = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.3.276.1.5.6", "urn:ihe-d:ig:MeldepflichtigeKrankheitenLabor:2014", "Meldepflichtige Krankheiten: Labormeldung"), d.UebermittlungMeldepflichtigerKrankheitenArztmeldung = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.3.276.1.5.6", "urn:ihe-d:ig:MeldepflichtigeKrankheitenArzt:2013", "Übermittlung meldepflichtiger Krankheiten – Arztmeldung"), d.AerztlicherRehaEntlassungsbericht = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.3.276.1.5.6", "urn:ihe-d:ig:RehaEntlassbrief:2009", "Ärztlicher Reha-Entlassungsbericht"), d.UeberleitungsmanagementAerztlicherKurzberichtUeberDenKrankenhausaufenthalt = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.3.276.1.5.6", "urn:ihe-d:ig:KurzberichtUeberleitungKrankenhaus:2016", "Überleitungsmanagement Ärztlicher Kurzbericht über den Krankenhausaufenthalt"), d.UeberleitungsmanagementAerztlicherKurzberichtDesNiedergelassenenArztes = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.3.276.1.5.6", "urn:ihe-d:ig:KurzberichtUeberleitungNiedergelassenerArzt:2016", "Überleitungsmanagement Ärztlicher Kurzbericht des niedergelassenen Arztes"), d.Medikationsplan = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.3.276.1.5.6", "urn:ihe-d:ig:Medikationsplan:2015", "Medikationsplan"), d.ArztbriefPlus = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.3.276.1.5.6", "urn:ihe-d:ig:Arztbriefplus:2017", "Arztbrief plus"), d.Arztbrief2014 = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.3.276.1.5.6", "urn:ihe-d:ig:arztbrief:2014:nonXmlBody", "Arztbrief 2014"), d.EnhancedPatientPrivacyConsentGermany = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.3.276.1.5.6", "urn:ihe-d:ig:eppc-g:2015", "Enhanced Patient Privacy Consent - Germany"), d.EnhancedPatientPrivacyConsentGermanyScannedDocumentOption = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.3.276.1.5.6", "urn:ihe-d:ig:eppc-g-sd:2015", "Enhanced Patient Privacy Consent - Germany - Scanned Document Option"), d.PDFA1 = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.3.276.1.5.6", "urn:ihe-d:spec:PDF_A1:2005", "PDF/A-1"), d.PDFA2 = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.3.276.1.5.6", "urn:ihe-d:spec:PDF_A2:2011", "PDF/A-2"), d.PDFA3 = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.3.276.1.5.6", "urn:ihe-d:spec:PDF_A3:2012", "PDF/A-3"), d.PDFUA = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.3.276.1.5.6", "urn:ihe-d:spec:PDF_UA:2008", "PDF/UA"), d.MIMETypeBeschriebenObsolete = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.3.276.1.5.6", "urn:ihe-d:mime", "durch MIME Type beschrieben"), d.Arztbrief291fSGBV = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.3.276.1.5.6", "urn:gematik:ig:Arztbrief:r3.1", "Arztbrief § 291f SGB V"), d.Medikationsplan31 = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.3.276.1.5.6", "urn:gematik:ig:Medikationsplan:r3.1", "Medikationsplan (gematik)"), d.Notfalldatensatz = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.3.276.1.5.6", "urn:gematik:ig:Notfalldatensatz:r3.1", "Notfalldatensatz"), d.DatensatzFuerPersoenlicheErklaerungen = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.3.276.1.5.6", "urn:gematik:ig:DatensatzPersoenlicheErklaerungen:r3.1", "Datensatz für persönliche Erklärungen (gematik)"), d.Impfausweis = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.3.276.1.5.6", "urn:gematik:ig:Impfausweis:r4.0", "Impfausweis (gematik)"), d.Impfausweis110 = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.3.276.1.5.6", "urn:gematik:ig:Impfausweis:v1.1.0", "Impfausweis (gematik)"), d.Mutterpass = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.3.276.1.5.6", "urn:gematik:ig:Mutterpass:r4.0", "Mutterpass (gematik)"), d.Mutterpass100 = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.3.276.1.5.6", "urn:gematik:ig:Mutterpass:v1.0.0", "Mutterpass (gematik)"), d.Mutterpass110 = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.3.276.1.5.6", "urn:gematik:ig:Mutterpass:v1.1.0", "Mutterpass (gematik)"), d.Kinderuntersuchungsheft = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.3.276.1.5.6", "urn:gematik:ig:Kinderuntersuchungsheft:r4.0", "Kinderuntersuchungsheft (gematik)"), d.Kinderuntersuchungsheft100 = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.3.276.1.5.6", "urn:gematik:ig:Kinderuntersuchungsheft:v1.0.0", "Kinderuntersuchungsheft (gematik)"), d.Arbeitsunfaehigkeitsbescheinigung = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.3.276.1.5.6", "urn:gematik:ig:Arbeitsunfaehigkeitsbescheinigung:r4.0", "Arbeitsunfähigkeitsbescheinigung (gematik)"), d.VerordnungsdatensatzMedikation = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.3.276.1.5.6", "urn:gematik:ig:VerordnungsdatensatzMedikation:r4.0", "Verordnungsdatensatz Medikation (gematik)"), d.VerordnungsdatensatzMedikation102 = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.3.276.1.5.6", "urn:gematik:ig:VerordnungsdatensatzMedikation:v1.0.2", "Verordnungsdatensatz Medikation (gematik)"), d.UntersuchungenKinderuntersuchungsheft = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.3.276.1.5.6", "urn:gematik:ig:KinderuntersuchungsheftUntersuchungen:v1.0.0", "Untersuchungen Kinderuntersuchungsheft"), d.UntersuchungenKinderuntersuchungsheft101 = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.3.276.1.5.6", "urn:gematik:ig:KinderuntersuchungsheftUntersuchungen:v1.0.1", "Untersuchungen Kinderuntersuchungsheft"), d.TeilnahmekarteKinderuntersuchungsheft = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.3.276.1.5.6", "urn:gematik:ig:KinderuntersuchungsheftTeilnahmekarte:v1.0.0", "Teilnahmekarte Kinderuntersuchungsheft"), d.TeilnahmekarteKinderuntersuchungsheft101 = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.3.276.1.5.6", "urn:gematik:ig:KinderuntersuchungsheftTeilnahmekarte:v1.0.1", "Teilnahmekarte Kinderuntersuchungsheft"), d.NotizenKinderuntersuchungsheft = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.3.276.1.5.6", "urn:gematik:ig:KinderuntersuchungsheftNotizen:v1.0.0", "Notizen Kinderuntersuchungsheft"), d.NotizenKinderuntersuchungsheft101 = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.3.276.1.5.6", "urn:gematik:ig:KinderuntersuchungsheftNotizen:v1.0.1", "Notizen Kinderuntersuchungsheft"), d.DGUVStationaererEntlassbrief = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.3.276.1.5.6", "urn:hl7-de:DGUV-StatEntlassbrief:2020", "DGUV Stationärer Entlassbrief"), d.Zahnbonusheft = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.3.276.1.5.6", "urn:gematik:ig:Zahnbonusheft:r4.0", "Zahnbonusheft (gematik)"), d.Zahnbonusheft100 = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.3.276.1.5.6", "urn:gematik:ig:Zahnbonusheft:v1.0.0", "Zahnbonusheft (gematik)"), d.Zahnbonusheft110 = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.3.276.1.5.6", "urn:gematik:ig:Zahnbonusheft:v1.1.0", "Zahnbonusheft (gematik)"), d.DiGA = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.3.276.1.5.6", "urn:gematik:ig:diga:v1.0", "DiGA (gematik)"), d.eDMPAsthma = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.3.276.1.5.6", "urn:gematik:ig:DMP-Asthma:v4", "eDMP Asthma (gematik)"), d.eDMPBrustkrebs = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.3.276.1.5.6", "urn:gematik:ig:DMP-BRK:v4", "eDMP Brustkrebs (gematik)"), d.eDMPChronicObstrusivePulmonaryDisease = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.3.276.1.5.6", "urn:gematik:ig:DMP-COPD:v4", "eDMP Chronic Obstrusive Pulmonary Disease (gematik)"), d.eDMPRueckenschmerz = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.3.276.1.5.6", "urn:gematik:ig:DMP-Rueckenschmerz:v1", "eDMP Rückenschmerz (gematik)"), d.eDMPDepression = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.3.276.1.5.6", "urn:gematik:ig:DMP-Depression:v1", "eDMP Depression (gematik)"), d.eDMPDiabetesMellitusTyp1 = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.3.276.1.5.6", "urn:gematik:ig:DMP-DM1:v5", "eDMP Diabetes mellitus Typ 1 (gematik)"), d.eDMPDiabetesMellitusTyp2 = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.3.276.1.5.6", "urn:gematik:ig:DMP-DM2:v6", "eDMP Diabetes mellitus Typ 2 (gematik)"), d.eDMPHerzinsuffizienz = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.3.276.1.5.6", "urn:gematik:ig:DMP-HI:v1", "eDMP Herzinsuffizienz (gematik)"), d.eDMPKoronareHerzkrankheit = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.3.276.1.5.6", "urn:gematik:ig:DMP-KHK:v4", "eDMP Koronare Herzkrankheit (gematik)"), d.eDMPOsteoporose = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.3.276.1.5.6", "urn:gematik:ig:DMP-OST:v1", "eDMP Osteoporose (gematik)"), d.TelemedizinischesMonitoring = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.3.276.1.5.6", "urn:gematik:ig:Telemedizinisches-Monitoring:v1.0", "Telemedizinisches Monitoring (gematik)"), d.Pflegeueberleitungsbogen = new d(a.DocumentFormatCode, "1.3.6.1.4.1.19376.3.276.1.5.6", "urn:gematik:ig:Pflegeueberleitungsbogen:v1.0", "Pflegeüberleitungsbogen (gematik)"), d.DICOMManifestDICOMKOSSOPClassUID = new d(a.DocumentFormatCode, "1.2.840.10008.2.6.1", "1.2.840.10008.5.1.4.1.1.88.59", "DICOM Manifest (DICOM KOS SOP Class UID)");
let ao = d;
const K = class K extends se {
};
K.P570168 = new K(a.DocumentKind, "2.16.840.1.113883.6.1", "57016-8", "Patienteneinverständniserklärung"), K.ADM = new K(a.DocumentKind, "1.3.6.1.4.1.19376.3.276.1.5.8", "ADM", "Administratives Dokument"), K.ANF = new K(a.DocumentKind, "1.3.6.1.4.1.19376.3.276.1.5.8", "ANF", "Anforderung"), K.ASM = new K(a.DocumentKind, "1.3.6.1.4.1.19376.3.276.1.5.8", "ASM", "Assessment"), K.BEF = new K(a.DocumentKind, "1.3.6.1.4.1.19376.3.276.1.5.8", "BEF", "Befundbericht"), K.BIL = new K(a.DocumentKind, "1.3.6.1.4.1.19376.3.276.1.5.8", "BIL", "Bilddaten"), K.BRI = new K(a.DocumentKind, "1.3.6.1.4.1.19376.3.276.1.5.8", "BRI", "Brief"), K.DOK = new K(a.DocumentKind, "1.3.6.1.4.1.19376.3.276.1.5.8", "DOK", "Dokumente ohne besondere Form (Notizen)"), K.DUR = new K(a.DocumentKind, "1.3.6.1.4.1.19376.3.276.1.5.8", "DUR", "Durchführungsprotokoll"), K.FOR = new K(a.DocumentKind, "1.3.6.1.4.1.19376.3.276.1.5.8", "FOR", "Forschung"), K.GUT = new K(a.DocumentKind, "1.3.6.1.4.1.19376.3.276.1.5.8", "GUT", "Gutachten und Qualitätsmanagement"), K.LAB = new K(a.DocumentKind, "1.3.6.1.4.1.19376.3.276.1.5.8", "LAB", "Laborergebnisse"), K.AUS = new K(a.DocumentKind, "1.3.6.1.4.1.19376.3.276.1.5.8", "AUS", "Medizinischer Ausweis"), K.PLA = new K(a.DocumentKind, "1.3.6.1.4.1.19376.3.276.1.5.8", "PLA", "Planungsdokument"), K.VER = new K(a.DocumentKind, "1.3.6.1.4.1.19376.3.276.1.5.8", "VER", "Verordnung"), K.VID = new K(a.DocumentKind, "1.3.6.1.4.1.19376.3.276.1.5.8", "VID", "Videodaten"), K.MED = new K(a.DocumentKind, "1.3.6.1.4.1.19376.3.276.1.5.8", "MED", "Medikation");
let co = K;
const T = class T extends se {
};
T.ABRE = new T(a.DocumentTypeCode, "1.3.6.1.4.1.19376.3.276.1.5.9", "ABRE", "Abrechnungsdokumente"), T.ADCH = new T(a.DocumentTypeCode, "1.3.6.1.4.1.19376.3.276.1.5.9", "ADCH", "Administrative Checklisten"), T.ANTR = new T(a.DocumentTypeCode, "1.3.6.1.4.1.19376.3.276.1.5.9", "ANTR", "Anträge und deren Bescheide"), T.ANAE = new T(a.DocumentTypeCode, "1.3.6.1.4.1.19376.3.276.1.5.9", "ANAE", "Anästhesiedokumente"), T.BERI = new T(a.DocumentTypeCode, "1.3.6.1.4.1.19376.3.276.1.5.9", "BERI", "Arztberichte"), T.BESC = new T(a.DocumentTypeCode, "1.3.6.1.4.1.19376.3.276.1.5.9", "BESC", "Ärztliche Bescheinigungen"), T.BEFU = new T(a.DocumentTypeCode, "1.3.6.1.4.1.19376.3.276.1.5.9", "BEFU", "Ergebnisse Diagnostik"), T.BSTR = new T(a.DocumentTypeCode, "1.3.6.1.4.1.19376.3.276.1.5.9", "BSTR", "Bestrahlungsdokumentation"), T.AUFN = new T(a.DocumentTypeCode, "1.3.6.1.4.1.19376.3.276.1.5.9", "AUFN", "Einweisungs- und Aufnahmedokumente"), T.EINW = new T(a.DocumentTypeCode, "1.3.6.1.4.1.19376.3.276.1.5.9", "EINW", "Einwilligungen/Aufklärungen"), T.FUNK = new T(a.DocumentTypeCode, "1.3.6.1.4.1.19376.3.276.1.5.9", "FUNK", "Ergebnisse Funktionsdiagnostik"), T.BILD = new T(a.DocumentTypeCode, "1.3.6.1.4.1.19376.3.276.1.5.9", "BILD", "Ergebnisse bildgebender Diagnostik"), T.FALL = new T(a.DocumentTypeCode, "1.3.6.1.4.1.19376.3.276.1.5.9", "FALL", "Fallbesprechungen"), T.FOTO = new T(a.DocumentTypeCode, "1.3.6.1.4.1.19376.3.276.1.5.9", "FOTO", "Fotodokumentation"), T.FPRO = new T(a.DocumentTypeCode, "1.3.6.1.4.1.19376.3.276.1.5.9", "FPRO", "Therapiedokumentation"), T.IMMU = new T(a.DocumentTypeCode, "1.3.6.1.4.1.19376.3.276.1.5.9", "IMMU", "Ergebnisse Immunologie"), T.INTS = new T(a.DocumentTypeCode, "1.3.6.1.4.1.19376.3.276.1.5.9", "INTS", "Intensivmedizinische Dokumente"), T.KOMP = new T(a.DocumentTypeCode, "1.3.6.1.4.1.19376.3.276.1.5.9", "KOMP", "Komplexbehandlungsbögen"), T.MEDI = new T(a.DocumentTypeCode, "1.3.6.1.4.1.19376.3.276.1.5.9", "MEDI", "Medikamentöse Therapien"), T.MKRO = new T(a.DocumentTypeCode, "1.3.6.1.4.1.19376.3.276.1.5.9", "MKRO", "Ergebnisse Mikrobiologie"), T.OPDK = new T(a.DocumentTypeCode, "1.3.6.1.4.1.19376.3.276.1.5.9", "OPDK", "OP-Dokumente"), T.ONKO = new T(a.DocumentTypeCode, "1.3.6.1.4.1.19376.3.276.1.5.9", "ONKO", "Onkologische Dokumente"), T.PATH = new T(a.DocumentTypeCode, "1.3.6.1.4.1.19376.3.276.1.5.9", "PATH", "Pathologiebefundberichte"), T.PATD = new T(a.DocumentTypeCode, "1.3.6.1.4.1.19376.3.276.1.5.9", "PATD", "Patienteneigene Dokumente"), T.PATI = new T(a.DocumentTypeCode, "1.3.6.1.4.1.19376.3.276.1.5.9", "PATI", "Patienteninformationen"), T.PFLG = new T(a.DocumentTypeCode, "1.3.6.1.4.1.19376.3.276.1.5.9", "PFLG", "Pflegedokumentation"), T.QUAL = new T(a.DocumentTypeCode, "1.3.6.1.4.1.19376.3.276.1.5.9", "QUAL", "Qualitätssicherung"), T.RETT = new T(a.DocumentTypeCode, "1.3.6.1.4.1.19376.3.276.1.5.9", "RETT", "Rettungsdienstliche Dokumente"), T.SCHR = new T(a.DocumentTypeCode, "1.3.6.1.4.1.19376.3.276.1.5.9", "SCHR", "Schriftwechsel (administrativ)"), T.GEBU = new T(a.DocumentTypeCode, "1.3.6.1.4.1.19376.3.276.1.5.9", "GEBU", "Schwangerschafts- und Geburtsdokumentation"), T.SOZI = new T(a.DocumentTypeCode, "1.3.6.1.4.1.19376.3.276.1.5.9", "SOZI", "Sozialdienstdokumente"), T.STUD = new T(a.DocumentTypeCode, "1.3.6.1.4.1.19376.3.276.1.5.9", "STUD", "Studiendokumente"), T.TRFU = new T(a.DocumentTypeCode, "1.3.6.1.4.1.19376.3.276.1.5.9", "TRFU", "Transfusionsdokumente"), T.TRPL = new T(a.DocumentTypeCode, "1.3.6.1.4.1.19376.3.276.1.5.9", "TRPL", "Transplantationsdokumente"), T.VERO = new T(a.DocumentTypeCode, "1.3.6.1.4.1.19376.3.276.1.5.9", "VERO", "Verordnungen"), T.VERT = new T(a.DocumentTypeCode, "1.3.6.1.4.1.19376.3.276.1.5.9", "VERT", "Verträge"), T.VIRO = new T(a.DocumentTypeCode, "1.3.6.1.4.1.19376.3.276.1.5.9", "VIRO", "Ergebnisse Virologie"), T.WUND = new T(a.DocumentTypeCode, "1.3.6.1.4.1.19376.3.276.1.5.9", "WUND", "Wunddokumentation"), T.Patienteneinverstaendniserklaerung = new T(a.DocumentTypeCode, "2.16.840.1.113883.6.1", "57016-8", "Patienteneinverständniserklärung");
let uo = T;
const v = class v extends se {
};
v.BDUS = new v(a.DocumentEventCode, "1.2.840.10008.6.1.19", "BDUS", "Ultrasound Bone Densitometry"), v.BMD = new v(a.DocumentEventCode, "1.2.840.10008.6.1.19", "BMD", "Bone Mineral Densitometry"), v.CR = new v(a.DocumentEventCode, "1.2.840.10008.6.1.19", "CR", "Computed Radiography"), v.CT = new v(a.DocumentEventCode, "1.2.840.10008.6.1.19", "CT", "Computed Tomography"), v.DX = new v(a.DocumentEventCode, "1.2.840.10008.6.1.19", "DX", "Digital Radiography"), v.ES = new v(a.DocumentEventCode, "1.2.840.10008.6.1.19", "ES", "Endoscopy"), v.GM = new v(a.DocumentEventCode, "1.2.840.10008.6.1.19", "GM", "General Microscopy"), v.IO = new v(a.DocumentEventCode, "1.2.840.10008.6.1.19", "IO", "Intra-oral Radiography"), v.IVOCT = new v(a.DocumentEventCode, "1.2.840.10008.6.1.19", "IVOCT", "Intravascular Optical Coherence Tomography"), v.IVUS = new v(a.DocumentEventCode, "1.2.840.10008.6.1.19", "IVUS", "Intravascular Ultrasound"), v.MG = new v(a.DocumentEventCode, "1.2.840.10008.6.1.19", "MG", "Mammography"), v.MR = new v(a.DocumentEventCode, "1.2.840.10008.6.1.19", "MR", "Magnetic Resonance"), v.NM = new v(a.DocumentEventCode, "1.2.840.10008.6.1.19", "NM", "Nuclear Medicine"), v.OCT = new v(a.DocumentEventCode, "1.2.840.10008.6.1.19", "OCT", "Optical Coherence Tomography"), v.OP = new v(a.DocumentEventCode, "1.2.840.10008.6.1.19", "OP", "Ophthalmic Photography"), v.OPT = new v(a.DocumentEventCode, "1.2.840.10008.6.1.19", "OPT", "Ophthalmic Tomography"), v.OPTENF = new v(a.DocumentEventCode, "1.2.840.10008.6.1.19", "OPTENF", "Ophthalmic Tomography En Face"), v.PT = new v(a.DocumentEventCode, "1.2.840.10008.6.1.19", "PT", "Positron emission tomography"), v.PX = new v(a.DocumentEventCode, "1.2.840.10008.6.1.19", "PX", "Panoramic X-Ray"), v.RF = new v(a.DocumentEventCode, "1.2.840.10008.6.1.19", "RF", "Radiofluoroscopy"), v.RG = new v(a.DocumentEventCode, "1.2.840.10008.6.1.19", "RG", "Radiographic imaging"), v.SM = new v(a.DocumentEventCode, "1.2.840.10008.6.1.19", "SM", "Slide Microscopy"), v.US = new v(a.DocumentEventCode, "1.2.840.10008.6.1.19", "US", "Ultrasound"), v.XA = new v(a.DocumentEventCode, "1.2.840.10008.6.1.19", "XA", "X-Ray Angiography"), v.XC = new v(a.DocumentEventCode, "1.2.840.10008.6.1.19", "XC", "External-camera Photography"), v.E100 = new v(a.DocumentEventCode, "1.3.6.1.4.1.19376.3.276.1.5.16", "E100", "ambulanter Kontakt"), v.E110 = new v(a.DocumentEventCode, "1.3.6.1.4.1.19376.3.276.1.5.16", "E110", "ambulante OP"), v.E200 = new v(a.DocumentEventCode, "1.3.6.1.4.1.19376.3.276.1.5.16", "E200", "stationärer Aufenthalt"), v.E210 = new v(a.DocumentEventCode, "1.3.6.1.4.1.19376.3.276.1.5.16", "E210", "stationäre Aufnahme"), v.E211 = new v(a.DocumentEventCode, "1.3.6.1.4.1.19376.3.276.1.5.16", "E211", "Aufnahme vollstationär"), v.E212 = new v(a.DocumentEventCode, "1.3.6.1.4.1.19376.3.276.1.5.16", "E212", "Aufnahme/Wiederaufnahme teilstationär"), v.E213 = new v(a.DocumentEventCode, "1.3.6.1.4.1.19376.3.276.1.5.16", "E213", "Aufnahme Entbindung stationär"), v.E214 = new v(a.DocumentEventCode, "1.3.6.1.4.1.19376.3.276.1.5.16", "E214", "Aufnahme eines Neugeborenen"), v.E215 = new v(a.DocumentEventCode, "1.3.6.1.4.1.19376.3.276.1.5.16", "E215", "Aufnahme des Spenders zur Organentnahme"), v.E230 = new v(a.DocumentEventCode, "1.3.6.1.4.1.19376.3.276.1.5.16", "E230", "stationäre Entlassung"), v.E231 = new v(a.DocumentEventCode, "1.3.6.1.4.1.19376.3.276.1.5.16", "E231", "stationäre Entlassung nach Hause"), v.E232 = new v(a.DocumentEventCode, "1.3.6.1.4.1.19376.3.276.1.5.16", "E232", "stationäre Entlassung in eine Rehabilitationseinrichtung"), v.E233 = new v(a.DocumentEventCode, "1.3.6.1.4.1.19376.3.276.1.5.16", "E233", "stationäre Entlassung in eine Pflegeeinrichtung/Hospiz"), v.E234 = new v(a.DocumentEventCode, "1.3.6.1.4.1.19376.3.276.1.5.16", "E234", "Entlassung zur nachstationären Behandlung"), v.E235 = new v(a.DocumentEventCode, "1.3.6.1.4.1.19376.3.276.1.5.16", "E235", "Patient während stationärem Aufenthalt verstorben"), v.E250 = new v(a.DocumentEventCode, "1.3.6.1.4.1.19376.3.276.1.5.16", "E250", "stationäre Verlegung"), v.E251 = new v(a.DocumentEventCode, "1.3.6.1.4.1.19376.3.276.1.5.16", "E251", "Verlegung innerhalb eines Krankenhauses"), v.E252 = new v(a.DocumentEventCode, "1.3.6.1.4.1.19376.3.276.1.5.16", "E252", "Verlegung in ein anderes Krankenhaus"), v.E253 = new v(a.DocumentEventCode, "1.3.6.1.4.1.19376.3.276.1.5.16", "E253", "externe Verlegung in Psychiatrie"), v.E270 = new v(a.DocumentEventCode, "1.3.6.1.4.1.19376.3.276.1.5.16", "E270", "kurzzeitige Unterbrechung einer stationären Behandlung"), v.E280 = new v(a.DocumentEventCode, "1.3.6.1.4.1.19376.3.276.1.5.16", "E280", "Konsil"), v.E300 = new v(a.DocumentEventCode, "1.3.6.1.4.1.19376.3.276.1.5.16", "E300", "Behandlung im häuslichen Umfeld"), v.E400 = new v(a.DocumentEventCode, "1.3.6.1.4.1.19376.3.276.1.5.16", "E400", "Virtual Encounter"), v.H1 = new v(a.DocumentEventCode, "1.3.6.1.4.1.19376.3.276.1.5.15", "H1", "vom Patienten mitgebracht"), v.H2 = new v(a.DocumentEventCode, "1.3.6.1.4.1.19376.3.276.1.5.15", "H2", "noch nicht mit Patient besprochen"), v.H3 = new v(a.DocumentEventCode, "1.3.6.1.4.1.19376.3.276.1.5.15", "H3", "eventuell veraltete Daten"), v.H4 = new v(a.DocumentEventCode, "1.3.6.1.4.1.19376.3.276.1.5.15", "H4", "vorläufiges Dokument"), v.WorkflowOffen = new v(a.DocumentEventCode, "1.3.6.1.4.1.19376.1.2.3", "urn:ihe:iti:xdw:2011:eventCode:open", "Workflow offen"), v.WorkflowAbgeschlossen = new v(a.DocumentEventCode, "1.3.6.1.4.1.19376.1.2.3", "urn:ihe:iti:xdw:2011:eventCode:closed", "Workflow abgeschlossen"), v.nichtGesetzt = new v(a.DocumentEventCode, "1.2.276.0.76.5.223", "00", "nicht gesetzt"), v.DM2 = new v(a.DocumentEventCode, "1.2.276.0.76.5.223", "01", "DM2"), v.BRK = new v(a.DocumentEventCode, "1.2.276.0.76.5.223", "02", "BRK"), v.KHK = new v(a.DocumentEventCode, "1.2.276.0.76.5.223", "03", "KHK"), v.DM1 = new v(a.DocumentEventCode, "1.2.276.0.76.5.223", "04", "DM1"), v.Asthma = new v(a.DocumentEventCode, "1.2.276.0.76.5.223", "05", "Asthma"), v.COPD = new v(a.DocumentEventCode, "1.2.276.0.76.5.223", "06", "COPD"), v.HI = new v(a.DocumentEventCode, "1.2.276.0.76.5.223", "07", "HI"), v.Depression = new v(a.DocumentEventCode, "1.2.276.0.76.5.223", "08", "Depression"), v.Rueckenschmerz = new v(a.DocumentEventCode, "1.2.276.0.76.5.223", "09", "Rueckenschmerz"), v.Rheuma = new v(a.DocumentEventCode, "1.2.276.0.76.5.223", "10", "Rheuma"), v.Osteoporose = new v(a.DocumentEventCode, "1.2.276.0.76.5.223", "11", "Osteoporose");
let ho = v;
const L = class L extends se {
};
L.APD = new L(a.DocumentHealthcareFacilityTypeCode, "1.3.6.1.4.1.19376.3.276.1.5.2", "APD", "Ambulanter Pflegedienst"), L.APO = new L(a.DocumentHealthcareFacilityTypeCode, "1.3.6.1.4.1.19376.3.276.1.5.2", "APO", "Apotheke"), L.BER = new L(a.DocumentHealthcareFacilityTypeCode, "1.3.6.1.4.1.19376.3.276.1.5.2", "BER", "Ärztlicher Bereitschaftsdienst"), L.PRA = new L(a.DocumentHealthcareFacilityTypeCode, "1.3.6.1.4.1.19376.3.276.1.5.2", "PRA", "Arztpraxis"), L.BAA = new L(a.DocumentHealthcareFacilityTypeCode, "1.3.6.1.4.1.19376.3.276.1.5.2", "BAA", "Betriebsärztliche Abteilung"), L.BHR = new L(a.DocumentHealthcareFacilityTypeCode, "1.3.6.1.4.1.19376.3.276.1.5.2", "BHR", "Gesundheitsbehörde"), L.HEB = new L(a.DocumentHealthcareFacilityTypeCode, "1.3.6.1.4.1.19376.3.276.1.5.2", "HEB", "Hebamme/Geburtshaus"), L.HOS = new L(a.DocumentHealthcareFacilityTypeCode, "1.3.6.1.4.1.19376.3.276.1.5.2", "HOS", "Hospiz"), L.KHS = new L(a.DocumentHealthcareFacilityTypeCode, "1.3.6.1.4.1.19376.3.276.1.5.2", "KHS", "Krankenhaus"), L.MVZ = new L(a.DocumentHealthcareFacilityTypeCode, "1.3.6.1.4.1.19376.3.276.1.5.2", "MVZ", "Medizinisches Versorgungszentrum"), L.HAN = new L(a.DocumentHealthcareFacilityTypeCode, "1.3.6.1.4.1.19376.3.276.1.5.2", "HAN", "Medizinisch-technisches Handwerk"), L.REH = new L(a.DocumentHealthcareFacilityTypeCode, "1.3.6.1.4.1.19376.3.276.1.5.2", "REH", "Medizinische Rehabilitation"), L.HEI = new L(a.DocumentHealthcareFacilityTypeCode, "1.3.6.1.4.1.19376.3.276.1.5.2", "HEI", "Nicht-ärztliche Heilberufs-Praxis"), L.PFL = new L(a.DocumentHealthcareFacilityTypeCode, "1.3.6.1.4.1.19376.3.276.1.5.2", "PFL", "Pflegeheim"), L.RTN = new L(a.DocumentHealthcareFacilityTypeCode, "1.3.6.1.4.1.19376.3.276.1.5.2", "RTN", "Rettungsdienst"), L.SEL = new L(a.DocumentHealthcareFacilityTypeCode, "1.3.6.1.4.1.19376.3.276.1.5.2", "SEL", "Selbsthilfe"), L.TMZ = new L(a.DocumentHealthcareFacilityTypeCode, "1.3.6.1.4.1.19376.3.276.1.5.2", "TMZ", "Telemedizinisches Zentrum"), L.BIL = new L(a.DocumentHealthcareFacilityTypeCode, "1.3.6.1.4.1.19376.3.276.1.5.3", "BIL", "Bildungseinrichtung"), L.FOR = new L(a.DocumentHealthcareFacilityTypeCode, "1.3.6.1.4.1.19376.3.276.1.5.3", "FOR", "Forschungseinrichtung"), L.GEN = new L(a.DocumentHealthcareFacilityTypeCode, "1.3.6.1.4.1.19376.3.276.1.5.3", "GEN", "Gen-Analysedienste"), L.MDK = new L(a.DocumentHealthcareFacilityTypeCode, "1.3.6.1.4.1.19376.3.276.1.5.3", "MDK", "Medizinischer Dienst der Krankenversicherung"), L.PAT = new L(a.DocumentHealthcareFacilityTypeCode, "1.3.6.1.4.1.19376.3.276.1.5.3", "PAT", "Patient außerhalb der Betreuung"), L.SPE = new L(a.DocumentHealthcareFacilityTypeCode, "1.3.6.1.4.1.19376.3.276.1.5.3", "SPE", "Spendedienste"), L.VER = new L(a.DocumentHealthcareFacilityTypeCode, "1.3.6.1.4.1.19376.3.276.1.5.3", "VER", "Versicherungsträger");
let lo = L;
const g = class g extends se {
};
g.ALLG = new g(a.DocumentPracticeSettingCode, "1.3.6.1.4.1.19376.3.276.1.5.4", "ALLG", "Allgemeinmedizin"), g.ANAE = new g(a.DocumentPracticeSettingCode, "1.3.6.1.4.1.19376.3.276.1.5.4", "ANAE", "Anästhesiologie"), g.ARBE = new g(a.DocumentPracticeSettingCode, "1.3.6.1.4.1.19376.3.276.1.5.4", "ARBE", "Arbeitsmedizin"), g.AUGE = new g(a.DocumentPracticeSettingCode, "1.3.6.1.4.1.19376.3.276.1.5.4", "AUGE", "Augenheilkunde"), g.CHIR = new g(a.DocumentPracticeSettingCode, "1.3.6.1.4.1.19376.3.276.1.5.4", "CHIR", "Chirurgie"), g.ALCH = new g(a.DocumentPracticeSettingCode, "1.3.6.1.4.1.19376.3.276.1.5.4", "ALCH", "Allgemeinchirurgie"), g.GFCH = new g(a.DocumentPracticeSettingCode, "1.3.6.1.4.1.19376.3.276.1.5.4", "GFCH", "Gefäßchirurgie"), g.HZCH = new g(a.DocumentPracticeSettingCode, "1.3.6.1.4.1.19376.3.276.1.5.4", "HZCH", "Herzchirurgie"), g.KDCH = new g(a.DocumentPracticeSettingCode, "1.3.6.1.4.1.19376.3.276.1.5.4", "KDCH", "Kinderchirurgie"), g.ORTH = new g(a.DocumentPracticeSettingCode, "1.3.6.1.4.1.19376.3.276.1.5.4", "ORTH", "Orthopädie"), g.PLCH = new g(a.DocumentPracticeSettingCode, "1.3.6.1.4.1.19376.3.276.1.5.4", "PLCH", "Plastische und Ästhetische Chirurgie"), g.THCH = new g(a.DocumentPracticeSettingCode, "1.3.6.1.4.1.19376.3.276.1.5.4", "THCH", "Thoraxchirurgie"), g.UNFC = new g(a.DocumentPracticeSettingCode, "1.3.6.1.4.1.19376.3.276.1.5.4", "UNFC", "Unfallchirurgie"), g.VICH = new g(a.DocumentPracticeSettingCode, "1.3.6.1.4.1.19376.3.276.1.5.4", "VICH", "Viszeralchirurgie"), g.FRAU = new g(a.DocumentPracticeSettingCode, "1.3.6.1.4.1.19376.3.276.1.5.4", "FRAU", "Frauenheilkunde und Geburtshilfe"), g.GEND = new g(a.DocumentPracticeSettingCode, "1.3.6.1.4.1.19376.3.276.1.5.4", "GEND", "Gynäkologische Endokrinologie und Reproduktionsmedizin"), g.GONK = new g(a.DocumentPracticeSettingCode, "1.3.6.1.4.1.19376.3.276.1.5.4", "GONK", "Gynäkologische Onkologie"), g.PERI = new g(a.DocumentPracticeSettingCode, "1.3.6.1.4.1.19376.3.276.1.5.4", "PERI", "Perinatalmedizin"), g.GERI = new g(a.DocumentPracticeSettingCode, "1.3.6.1.4.1.19376.3.276.1.5.4", "GERI", "Geriatrie"), g.HNOH = new g(a.DocumentPracticeSettingCode, "1.3.6.1.4.1.19376.3.276.1.5.4", "HNOH", "Hals-Nasen-Ohrenheilkunde"), g.HRST = new g(a.DocumentPracticeSettingCode, "1.3.6.1.4.1.19376.3.276.1.5.4", "HRST", "Sprach-, Stimm- und kindliche Hörstörungen"), g.HAUT = new g(a.DocumentPracticeSettingCode, "1.3.6.1.4.1.19376.3.276.1.5.4", "HAUT", "Haut- und Geschlechtskrankheiten"), g.HIST = new g(a.DocumentPracticeSettingCode, "1.3.6.1.4.1.19376.3.276.1.5.4", "HIST", "Histologie / Zytologie"), g.HUMA = new g(a.DocumentPracticeSettingCode, "1.3.6.1.4.1.19376.3.276.1.5.4", "HUMA", "Humangenetik"), g.HYGI = new g(a.DocumentPracticeSettingCode, "1.3.6.1.4.1.19376.3.276.1.5.4", "HYGI", "Hygiene und Umweltmedizin"), g.INNE = new g(a.DocumentPracticeSettingCode, "1.3.6.1.4.1.19376.3.276.1.5.4", "INNE", "Innere Medizin"), g.ANGI = new g(a.DocumentPracticeSettingCode, "1.3.6.1.4.1.19376.3.276.1.5.4", "ANGI", "Angiologie"), g.ENDO = new g(a.DocumentPracticeSettingCode, "1.3.6.1.4.1.19376.3.276.1.5.4", "ENDO", "Endokrinologie und Diabetologie"), g.GAST = new g(a.DocumentPracticeSettingCode, "1.3.6.1.4.1.19376.3.276.1.5.4", "GAST", "Gastroenterologie"), g.HAEM = new g(a.DocumentPracticeSettingCode, "1.3.6.1.4.1.19376.3.276.1.5.4", "HAEM", "Hämatologie und internistische Onkologie"), g.KARD = new g(a.DocumentPracticeSettingCode, "1.3.6.1.4.1.19376.3.276.1.5.4", "KARD", "Kardiologie"), g.NEPH = new g(a.DocumentPracticeSettingCode, "1.3.6.1.4.1.19376.3.276.1.5.4", "NEPH", "Nephrologie"), g.PNEU = new g(a.DocumentPracticeSettingCode, "1.3.6.1.4.1.19376.3.276.1.5.4", "PNEU", "Pneumologie"), g.RHEU = new g(a.DocumentPracticeSettingCode, "1.3.6.1.4.1.19376.3.276.1.5.4", "RHEU", "Rheumatologie"), g.INTM = new g(a.DocumentPracticeSettingCode, "1.3.6.1.4.1.19376.3.276.1.5.4", "INTM", "Intensivmedizin"), g.INTZ = new g(a.DocumentPracticeSettingCode, "1.3.6.1.4.1.19376.3.276.1.5.4", "INTZ", "Interdisziplinäre Zusammenarbeit"), g.INTO = new g(a.DocumentPracticeSettingCode, "1.3.6.1.4.1.19376.3.276.1.5.4", "INTO", "Interdisziplinäre Onkologie"), g.INTS = new g(a.DocumentPracticeSettingCode, "1.3.6.1.4.1.19376.3.276.1.5.4", "INTS", "Interdisziplinäre Schmerzmedizin"), g.TRPL = new g(a.DocumentPracticeSettingCode, "1.3.6.1.4.1.19376.3.276.1.5.4", "TRPL", "Transplantationsmedizin"), g.SELT = new g(a.DocumentPracticeSettingCode, "1.3.6.1.4.1.19376.3.276.1.5.4", "SELT", "seltene Erkrankungen"), g.KIJU = new g(a.DocumentPracticeSettingCode, "1.3.6.1.4.1.19376.3.276.1.5.4", "KIJU", "Kinder- und Jugendmedizin"), g.KONK = new g(a.DocumentPracticeSettingCode, "1.3.6.1.4.1.19376.3.276.1.5.4", "KONK", "Kinder-Hämatologie und -Onkologie"), g.KKAR = new g(a.DocumentPracticeSettingCode, "1.3.6.1.4.1.19376.3.276.1.5.4", "KKAR", "Kinder-Kardiologie"), g.NNAT = new g(a.DocumentPracticeSettingCode, "1.3.6.1.4.1.19376.3.276.1.5.4", "NNAT", "Neonatologie"), g.NPAE = new g(a.DocumentPracticeSettingCode, "1.3.6.1.4.1.19376.3.276.1.5.4", "NPAE", "Neuropädiatrie"), g.KPSY = new g(a.DocumentPracticeSettingCode, "1.3.6.1.4.1.19376.3.276.1.5.4", "KPSY", "Kinder- und Jugendpsychiatrie und -psychotherapie"), g.LABO = new g(a.DocumentPracticeSettingCode, "1.3.6.1.4.1.19376.3.276.1.5.4", "LABO", "Laboratoriumsmedizin"), g.MIKR = new g(a.DocumentPracticeSettingCode, "1.3.6.1.4.1.19376.3.276.1.5.4", "MIKR", "Mikrobiologie, Virologie und Infektionsepidemiologie"), g.MKGC = new g(a.DocumentPracticeSettingCode, "1.3.6.1.4.1.19376.3.276.1.5.4", "MKGC", "Mund-Kiefer-Gesichtschirurgie"), g.NATU = new g(a.DocumentPracticeSettingCode, "1.3.6.1.4.1.19376.3.276.1.5.4", "NATU", "Naturheilverfahren und alternative Heilmethoden"), g.NOTF = new g(a.DocumentPracticeSettingCode, "1.3.6.1.4.1.19376.3.276.1.5.4", "NOTF", "Notfallmedizin"), g.NRCH = new g(a.DocumentPracticeSettingCode, "1.3.6.1.4.1.19376.3.276.1.5.4", "NRCH", "Neurochirurgie"), g.NEUR = new g(a.DocumentPracticeSettingCode, "1.3.6.1.4.1.19376.3.276.1.5.4", "NEUR", "Neurologie"), g.NUKL = new g(a.DocumentPracticeSettingCode, "1.3.6.1.4.1.19376.3.276.1.5.4", "NUKL", "Nuklearmedizin"), g.GESU = new g(a.DocumentPracticeSettingCode, "1.3.6.1.4.1.19376.3.276.1.5.4", "GESU", "Öffentliches Gesundheitswesen"), g.PALL = new g(a.DocumentPracticeSettingCode, "1.3.6.1.4.1.19376.3.276.1.5.4", "PALL", "Palliativmedizin"), g.PATH = new g(a.DocumentPracticeSettingCode, "1.3.6.1.4.1.19376.3.276.1.5.4", "PATH", "Pathologie"), g.NPAT = new g(a.DocumentPracticeSettingCode, "1.3.6.1.4.1.19376.3.276.1.5.4", "NPAT", "Neuropathologie"), g.PHAR = new g(a.DocumentPracticeSettingCode, "1.3.6.1.4.1.19376.3.276.1.5.4", "PHAR", "Pharmakologie"), g.TOXI = new g(a.DocumentPracticeSettingCode, "1.3.6.1.4.1.19376.3.276.1.5.4", "TOXI", "Toxikologie"), g.REHA = new g(a.DocumentPracticeSettingCode, "1.3.6.1.4.1.19376.3.276.1.5.4", "REHA", "Physikalische und Rehabilitative Medizin"), g.PSYC = new g(a.DocumentPracticeSettingCode, "1.3.6.1.4.1.19376.3.276.1.5.4", "PSYC", "Psychiatrie und Psychotherapie"), g.FPSY = new g(a.DocumentPracticeSettingCode, "1.3.6.1.4.1.19376.3.276.1.5.4", "FPSY", "Forensische Psychiatrie"), g.PSYM = new g(a.DocumentPracticeSettingCode, "1.3.6.1.4.1.19376.3.276.1.5.4", "PSYM", "Psychosomatische Medizin und Psychotherapie"), g.RADI = new g(a.DocumentPracticeSettingCode, "1.3.6.1.4.1.19376.3.276.1.5.4", "RADI", "Radiologie"), g.KRAD = new g(a.DocumentPracticeSettingCode, "1.3.6.1.4.1.19376.3.276.1.5.4", "KRAD", "Kinderradiologie"), g.NRAD = new g(a.DocumentPracticeSettingCode, "1.3.6.1.4.1.19376.3.276.1.5.4", "NRAD", "Neuroradiologie"), g.RECH = new g(a.DocumentPracticeSettingCode, "1.3.6.1.4.1.19376.3.276.1.5.4", "RECH", "Rechtsmedizin"), g.SCHL = new g(a.DocumentPracticeSettingCode, "1.3.6.1.4.1.19376.3.276.1.5.4", "SCHL", "Schlafmedizin"), g.SPOR = new g(a.DocumentPracticeSettingCode, "1.3.6.1.4.1.19376.3.276.1.5.4", "SPOR", "Sport- und Bewegungsmedizin"), g.STRA = new g(a.DocumentPracticeSettingCode, "1.3.6.1.4.1.19376.3.276.1.5.4", "STRA", "Strahlentherapie"), g.TRAN = new g(a.DocumentPracticeSettingCode, "1.3.6.1.4.1.19376.3.276.1.5.4", "TRAN", "Transfusionsmedizin"), g.TROP = new g(a.DocumentPracticeSettingCode, "1.3.6.1.4.1.19376.3.276.1.5.4", "TROP", "Tropen-/Reisemedizin"), g.UROL = new g(a.DocumentPracticeSettingCode, "1.3.6.1.4.1.19376.3.276.1.5.4", "UROL", "Urologie"), g.MZKH = new g(a.DocumentPracticeSettingCode, "1.3.6.1.4.1.19376.3.276.1.5.4", "MZKH", "Zahnmedizin"), g.ORAL = new g(a.DocumentPracticeSettingCode, "1.3.6.1.4.1.19376.3.276.1.5.4", "ORAL", "Oralchirurgie"), g.KIEF = new g(a.DocumentPracticeSettingCode, "1.3.6.1.4.1.19376.3.276.1.5.4", "KIEF", "Kieferorthopädie"), g.PARO = new g(a.DocumentPracticeSettingCode, "1.3.6.1.4.1.19376.3.276.1.5.4", "PARO", "Parodontologie"), g.MZAH = new g(a.DocumentPracticeSettingCode, "1.2.276.0.76.5.494", "MZAH", "Allgemeine Zahnheilkunde"), g.ZGES = new g(a.DocumentPracticeSettingCode, "1.2.276.0.76.5.494", "ZGES", "Öffentliches Gesundheitswesen"), g.ERG = new g(a.DocumentPracticeSettingCode, "1.3.6.1.4.1.19376.3.276.1.5.5", "ERG", "Ergotherapie"), g.ERN = new g(a.DocumentPracticeSettingCode, "1.3.6.1.4.1.19376.3.276.1.5.5", "ERN", "Ernährung und Diätetik"), g.FOR = new g(a.DocumentPracticeSettingCode, "1.3.6.1.4.1.19376.3.276.1.5.5", "FOR", "Forschung"), g.PFL = new g(a.DocumentPracticeSettingCode, "1.3.6.1.4.1.19376.3.276.1.5.5", "PFL", "Pflege und Betreuung"), g.ALT = new g(a.DocumentPracticeSettingCode, "1.3.6.1.4.1.19376.3.276.1.5.5", "ALT", "Altenpflege"), g.KIN = new g(a.DocumentPracticeSettingCode, "1.3.6.1.4.1.19376.3.276.1.5.5", "KIN", "Kinderpflege"), g.PAT = new g(a.DocumentPracticeSettingCode, "1.3.6.1.4.1.19376.3.276.1.5.5", "PAT", "Patient außerhalb der Betreuung"), g.PHZ = new g(a.DocumentPracticeSettingCode, "1.3.6.1.4.1.19376.3.276.1.5.5", "PHZ", "Pharmazeutik"), g.POD = new g(a.DocumentPracticeSettingCode, "1.3.6.1.4.1.19376.3.276.1.5.5", "POD", "Podologie"), g.PRV = new g(a.DocumentPracticeSettingCode, "1.3.6.1.4.1.19376.3.276.1.5.5", "PRV", "Prävention"), g.SOZ = new g(a.DocumentPracticeSettingCode, "1.3.6.1.4.1.19376.3.276.1.5.5", "SOZ", "Sozialwesen"), g.SPR = new g(a.DocumentPracticeSettingCode, "1.3.6.1.4.1.19376.3.276.1.5.5", "SPR", "Sprachtherapie"), g.VKO = new g(a.DocumentPracticeSettingCode, "1.3.6.1.4.1.19376.3.276.1.5.5", "VKO", "Versorgungskoordination"), g.VER = new g(a.DocumentPracticeSettingCode, "1.3.6.1.4.1.19376.3.276.1.5.5", "VER", "Verwaltung"), g.PST = new g(a.DocumentPracticeSettingCode, "1.3.6.1.4.1.19376.3.276.1.5.5", "PST", "Psychotherapie");
let po = g;
const U = class U {
  constructor(e, t, r) {
    this.code = e, this.name = t, this.systemCode = r;
  }
  static parse(e) {
    const t = e.split("^"), r = Object.getOwnPropertyNames(U);
    for (const n of r) {
      const s = U[n];
      if (s instanceof U && s.code === t[0])
        return s;
    }
    return this.Unbekannt;
  }
  toString() {
    return this.code + "^^^&" + this.systemCode + "&ISO";
  }
};
U.Einweiser = new U("1", "Einweiser", "1.3.6.1.4.1.19376.3.276.1.5.13"), U.Entlassender = new U("2", "Entlassender", "1.3.6.1.4.1.19376.3.276.1.5.13"), U.Überweiser = new U("3", "Überweiser", "1.3.6.1.4.1.19376.3.276.1.5.13"), U.Durchfuehrender = new U("4", "Durchführender", "1.3.6.1.4.1.19376.3.276.1.5.13"), U.durchfuehrendes = new U("5", "durchführendes Gerät", "1.3.6.1.4.1.19376.3.276.1.5.13"), U.Betreuer = new U("6", "Betreuer", "1.3.6.1.4.1.19376.3.276.1.5.13"), U.Pflegender = new U("7", "Pflegender", "1.3.6.1.4.1.19376.3.276.1.5.13"), U.Begutachtender = new U("17", "Begutachtender", "1.3.6.1.4.1.19376.3.276.1.5.13"), U.Behandler = new U("8", "Behandler", "1.3.6.1.4.1.19376.3.276.1.5.13"), U.ErstbehandlerAusserhalbEinerEinrichtung = new U("9", "Erstbehandler außerhalb einer Einrichtung", "1.3.6.1.4.1.19376.3.276.1.5.13"), U.Bereitstellender = new U("10", "Bereitstellender", "1.3.6.1.4.1.19376.3.276.1.5.13"), U.Dokumentierender = new U("11", "Dokumentierender", "1.3.6.1.4.1.19376.3.276.1.5.13"), U.DokumentierendesGeraet = new U("12", "dokumentierendes Gerät", "1.3.6.1.4.1.19376.3.276.1.5.13"), U.Validierer = new U("13", "Validierer", "1.3.6.1.4.1.19376.3.276.1.5.13"), U.GesetzlichVerantwortlicher = new U("14", "Gesetzlich Verantwortlicher", "1.3.6.1.4.1.19376.3.276.1.5.13"), U.Beratender = new U("15", "Beratender", "1.3.6.1.4.1.19376.3.276.1.5.13"), U.Informierender = new U("16", "Informierender", "1.3.6.1.4.1.19376.3.276.1.5.13"), U.Hausarzt = new U("101", "Hausarzt", "1.3.6.1.4.1.19376.3.276.1.5.14"), U.Patient = new U("102", "Patient", "1.3.6.1.4.1.19376.3.276.1.5.14"), U.Arbeitgebervertreter = new U("103", "Arbeitgebervertreter", "1.3.6.1.4.1.19376.3.276.1.5.14"), U.Primaerbetreuer = new U("104", "Primärbetreuer (langfristig)", "1.3.6.1.4.1.19376.3.276.1.5.14"), U.Kostentraegerverteter = new U("105", "Kostenträgerverteter", "1.3.6.1.4.1.19376.3.276.1.5.14"), U.Unbekannt = new U("-1", "Unbekannt", "0");
let Ys = U;
var Je = /* @__PURE__ */ ((i) => (i.SubmissionSetPatientID = "urn:uuid:6b5aea1a-874d-4603-a4bc-96a0a7b38446", i.SubmissionSetUniqueID = "urn:uuid:96fdda7c-d067-4183-912e-bf5ee74998a8", i.FolderUniqueID = "urn:uuid:75df8f67-9973-4fbe-a900-df66cefecc5a", i.FolderPatientID = "urn:uuid:f64ffdf0-4b97-4e06-b79f-a52b38ec2f8a", i.DocumentPatientID = "urn:uuid:58a6f841-87b3-4a3e-92fd-a8ffeff98427", i.DocumentUniqueID = "urn:uuid:2e82c1f6-a085-4c72-9da3-8640a32e42ab", i))(Je || {});
class Pi {
  constructor(e, t) {
    this.praxisName = e, this.telematikId = t;
  }
  static parse(e) {
    const t = e.split("^");
    return new Pi(t[0] || "", t[9] || "");
  }
  toString() {
    return `${this.praxisName}^^^^^&1.2.276.0.76.4.188&ISO^^^^${this.telematikId}`;
  }
  equals(e) {
    return this.telematikId === e.telematikId;
  }
}
class Ri {
  constructor(e, t) {
    this.vorname = e, this.nachname = t, this.lebenslangeArztNummer = "", this.titel = "", this.namensZusatz = "", this.vorname2 = "";
  }
  static parse(e) {
    const t = e.split("^"), r = new Ri(t[2] || "", t[1] || "");
    return r.lebenslangeArztNummer = t[0] || "", r.vorname2 = t[3] || "", r.namensZusatz = t[4] || "", r.titel = t[5] || "", r;
  }
  toXdsString() {
    return this.lebenslangeArztNummer.length > 0 ? this.lebenslangeArztNummer + "^" + this.nachname + "^" + this.vorname + "^" + this.vorname2 + "^" + this.namensZusatz + "^" + this.titel + "^^^&1.2.276.0.76.4.16&ISO" : "^" + this.nachname + "^" + this.vorname + "^" + this.vorname2 + "^" + this.namensZusatz + "^" + this.titel + "^^^";
  }
  equals(e) {
    return this.lebenslangeArztNummer.toLocaleUpperCase() === e.lebenslangeArztNummer.toLocaleUpperCase() && this.nachname.toLocaleUpperCase() === e.nachname.toLocaleUpperCase() && this.vorname.toLocaleUpperCase() === e.vorname.toLocaleUpperCase() && this.titel.toLocaleUpperCase() === e.titel.toLocaleUpperCase();
  }
}
class $s {
  constructor(e, t, r) {
    this.person = e, this.institution = t, this.role = r;
  }
  static createFromClassification(e) {
    var l, m, y;
    const t = ((l = e.slots.find((A) => A.name === "authorPerson")) == null ? void 0 : l.values[0]) || "^^^^^^^^", r = Ri.parse(t), n = ((m = e.slots.find((A) => A.name === "authorInstitution")) == null ? void 0 : m.values[0]) || "^^^^^^^^^", s = Pi.parse(n), o = ((y = e.slots.find((A) => A.name === "authorRole")) == null ? void 0 : y.values[0]) || "^^^^^^^^^", u = Ys.parse(o);
    return new $s(r, s, u);
  }
}
class go {
  constructor(e) {
    var m, y, A, P, M, p, w;
    this.name = ((m = e.name) == null ? void 0 : m.localizedString.value) || "Ohne Name";
    const t = e.slots.find((C) => C.name === "URI");
    this.filename = (t == null ? void 0 : t.getValue()) || "";
    const r = e.slots.find((C) => C.name === "creationTime");
    this.lastUpdated = wu(r == null ? void 0 : r.getValue()) || /* @__PURE__ */ new Date();
    const n = (y = e.externalIdentifiers.find((C) => C.identificationScheme === Je.DocumentUniqueID)) == null ? void 0 : y.value;
    if (n === void 0)
      throw console.error(e), new Error("Folder has no unique id");
    this.oUuId = n, this.id = e.id;
    const s = e.classifications.find((C) => C.classificationScheme === a.DocumentAuthor);
    s ? this.author = $s.createFromClassification(s) : this.author = new $s(new Ri("Unbekannt", ""), new Pi("Unbekannt", ""), Ys.Unbekannt);
    const u = (((A = e.externalIdentifiers.find((C) => C.identificationScheme === Je.DocumentPatientID)) == null ? void 0 : A.value) || "").substring(0, 10);
    this.recordIdentifier = new bt(u, e.home);
    const l = (P = e.slots.find((C) => C.name === "repositoryUniqueId")) == null ? void 0 : P.getValue();
    if (!l)
      throw console.error(e), new Error("Epa Entry does not have a repositoryUniqueId");
    this.repositoryUniqueId = l, this.size = Number.parseInt(((M = e.slots.find((C) => C.name === "size")) == null ? void 0 : M.getValue()) || "-1", 10), this.mimeType = e.mimeType, this.description = (w = (p = e.description) == null ? void 0 : p.localizedString) == null ? void 0 : w.value, this.classCode = se.findScheme(e, a.DocumentKind, co), this.confidentiality = se.findScheme(e, a.DocumentConfidentialityCode, oo), this.format = se.findScheme(e, a.DocumentFormatCode, ao), this.event = se.findScheme(e, a.DocumentEventCode, ho), this.healthcareFacilityType = se.findScheme(e, a.DocumentHealthcareFacilityTypeCode, lo), this.practiceSetting = se.findScheme(e, a.DocumentPracticeSettingCode, po), this.type = se.findScheme(e, a.DocumentTypeCode, uo);
  }
}
class Pp extends go {
  constructor(e) {
    super(e), this.folders = [];
  }
  static mapByFolder(e) {
    const t = /* @__PURE__ */ new Map();
    for (const r of e)
      for (const n of r.folders) {
        let s = t.get(n);
        s === void 0 && (s = [], t.set(n, s)), s.push(r);
      }
    return t;
  }
  static mapByAuthor(e) {
    const t = /* @__PURE__ */ new Map();
    for (const r of e) {
      let n = !1;
      for (const s of t)
        if (s[0].equals(r.author.person)) {
          s[1].push(r), n = !0;
          break;
        }
      n || t.set(r.author.person, [r]);
    }
    return t;
  }
}
const G = class G extends se {
};
G.Mutterpass = new G(a.FolderCodeList, "1.2.276.0.76.5.512", "mothersrecord", "Mutterpass"), G.UHeft = new G(a.FolderCodeList, "1.2.276.0.76.5.512", "childsrecord", "Kinderuntersuchungsheft"), G.Hausarzt = new G(a.FolderCodeList, "1.2.276.0.76.5.511", "practitioner", "Hausarzt/ Hausärztin"), G.Krankenhaus = new G(a.FolderCodeList, "1.2.276.0.76.5.511", "hospital", "Krankenhaus"), G.Labor = new G(a.FolderCodeList, "1.2.276.0.76.5.511", "laboratory", "Labor und Humangenetik"), G.Physiotherapeut = new G(a.FolderCodeList, "1.2.276.0.76.5.511", "physiotherapy", "Physiotherapeut"), G.Psychotherapeut = new G(a.FolderCodeList, "1.2.276.0.76.5.511", "psychotherapy", "Psychotherapeut"), G.Urologie = new G(a.FolderCodeList, "1.2.276.0.76.5.511", "gynaecology_urology", "Urologie/Gynäkologie"), G.Zahnheilkunde = new G(a.FolderCodeList, "1.2.276.0.76.5.511", "dentistry_oms", "Zahnheilkunde und Mund-Kiefer-Gesichtschirurgie"), G.AndererFacharzt = new G(a.FolderCodeList, "1.2.276.0.76.5.511", "other_medical", "Weitere Fachärzte/ Fachärztinnen"), G.NichtAertztlich = new G(a.FolderCodeList, "1.2.276.0.76.5.511", "other_non_medical", "Weitere nicht-ärztliche Berufe"), G.Medikationsplan = new G(a.FolderCodeList, "1.2.276.0.76.5.512", "emp", "Medikationsplan"), G.Notfalldaten = new G(a.FolderCodeList, "1.2.276.0.76.5.512", "nfd", "Notfalldaten"), G.eArztbrief = new G(a.FolderCodeList, "1.2.276.0.76.5.512", "eab", "eArztbrief"), G.Zahnbonusheft = new G(a.FolderCodeList, "1.2.276.0.76.5.512", "dentalrecord", "Zahnbonusheft"), G.Impfpass = new G(a.FolderCodeList, "1.2.276.0.76.5.512", "vaccination", "Impfpass"), G.VomVersicherten = new G(a.FolderCodeList, "1.2.276.0.76.5.512", "patientdoc", "Vom Versicherten eingestellte Daten"), G.eGaDaten = new G(a.FolderCodeList, "1.2.276.0.76.5.512", "ega", "eGA -Daten"), G.Quittungen = new G(a.FolderCodeList, "1.2.276.0.76.5.512", "receipt", "Quittungen (bei den   gespeicherte Daten über die in Anspruch genommenen Leistungen des Versicherten)"), G.Pflegedokumente = new G(a.FolderCodeList, "1.2.276.0.76.5.512", "care", "Pflegedokumente"), G.Rezept = new G(a.FolderCodeList, "1.2.276.0.76.5.512", "prescription", "Rezept"), G.Arbeitsunfähigkeit = new G(a.FolderCodeList, "1.2.276.0.76.5.512", "eau", "Arbeitsunfähigkeitsbescheinigungheinigungt"), G.Sonstige = new G(a.FolderCodeList, "1.2.276.0.76.5.511", "other", " sonstige von den Leistungserbringern für den Versicherten bereitgestellte Daten");
let fo = G;
class Ic {
  constructor(e) {
    var s, o;
    const t = e.slots.find((u) => u.name === "lastUpdateTime");
    this.lastUpdated = wu(t == null ? void 0 : t.getValue()) || /* @__PURE__ */ new Date();
    const n = (((s = e.externalIdentifiers.find((u) => u.identificationScheme === Je.FolderPatientID)) == null ? void 0 : s.value) || "").substring(0, 10);
    this.recordIdentifier = new bt(n, e.home), this.name = ((o = e.name) == null ? void 0 : o.localizedString.value) || "Ohne Name", this.id = e.id, this.folderType = se.findScheme(e, a.FolderCodeList, fo);
  }
}
class Rp {
  constructor(e, t) {
    this.name = e, this.type = t;
  }
}
var Op = Object.defineProperty, Tp = Object.getOwnPropertyDescriptor, Oi = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? Tp(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && Op(e, t, n), n;
};
let et = class {
  constructor(i, e, t) {
    this.id = i, this.home = e, this.slots = t;
  }
};
Oi([
  x("id")
], et.prototype, "id", 2);
Oi([
  x("home")
], et.prototype, "home", 2);
Oi([
  z(W, "Slot", void 0, h.ebXmlRmi3)
], et.prototype, "slots", 2);
et = Oi([
  b("AdhocQuery", h.ebXmlRmi3)
], et);
var Np = Object.defineProperty, xp = Object.getOwnPropertyDescriptor, Ma = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? xp(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && Np(e, t, n), n;
};
let At = class {
  constructor() {
    this.returnType = "LeafClass", this.returnComposedObjects = !0;
  }
};
Ma([
  x("returnType")
], At.prototype, "returnType", 2);
Ma([
  x("returnComposedObjects")
], At.prototype, "returnComposedObjects", 2);
At = Ma([
  b("ResponseOption", h.ebXmlQuery3)
], At);
var Vp = Object.defineProperty, Up = Object.getOwnPropertyDescriptor, dn = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? Up(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && Vp(e, t, n), n;
};
let ke = class {
  constructor(i, e) {
    this.federated = !1, this.startIndex = 0, this.maxResults = -1, this.responseOption = i, this.adhocQuery = e;
  }
};
dn([
  x("federated")
], ke.prototype, "federated", 2);
dn([
  x("startIndex")
], ke.prototype, "startIndex", 2);
dn([
  x("maxResults")
], ke.prototype, "maxResults", 2);
dn([
  c(At, "ResponseOption", h.ebXmlQuery3)
], ke.prototype, "responseOption", 2);
dn([
  c(et, "AdhocQuery", h.ebXmlRmi3)
], ke.prototype, "adhocQuery", 2);
ke = dn([
  b("AdhocQueryRequest", h.ebXmlQuery3)
], ke);
var Lp = Object.defineProperty, Fp = Object.getOwnPropertyDescriptor, Es = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? Fp(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && Lp(e, t, n), n;
};
let Et = class {
};
Es([
  x("codeContext")
], Et.prototype, "codeContext", 2);
Es([
  x("errorCode")
], Et.prototype, "errorCode", 2);
Es([
  x("severity")
], Et.prototype, "severity", 2);
Es([
  x("location")
], Et.prototype, "location", 2);
Et = Es([
  b("RegistryError", h.ebXmlRs3)
], Et);
var Gp = Object.defineProperty, Qp = Object.getOwnPropertyDescriptor, pn = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? Qp(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && Gp(e, t, n), n;
};
let Oe = class {
  constructor(i, e) {
    this.associationType = "urn:oasis:names:tc:ebxml-regrep:AssociationType:HasMember", this.id = bs(), this.slots = [], this.sourceObject = i, this.targetObject = e;
  }
};
pn([
  x("associationType")
], Oe.prototype, "associationType", 2);
pn([
  x("sourceObject")
], Oe.prototype, "sourceObject", 2);
pn([
  x("targetObject")
], Oe.prototype, "targetObject", 2);
pn([
  x("id")
], Oe.prototype, "id", 2);
pn([
  z(W, "Slot", void 0, h.ebXmlRmi3)
], Oe.prototype, "slots", 2);
Oe = pn([
  b("Association", h.ebXmlRmi3)
], Oe);
var jp = Object.defineProperty, Hp = Object.getOwnPropertyDescriptor, gn = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? Hp(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && jp(e, t, n), n;
};
let fe = class {
  constructor(i, e, t, r) {
    this.objectType = "urn:oasis:names:tc:ebxml-regrep:ObjectType:RegistryObject:ExternalIdentifier", this.id = bs(), this.registryObject = i, this.identificationScheme = e, this.value = t, this.name = new nt(r);
  }
};
gn([
  x("registryObject")
], fe.prototype, "registryObject", 2);
gn([
  x("identificationScheme")
], fe.prototype, "identificationScheme", 2);
gn([
  x("value")
], fe.prototype, "value", 2);
gn([
  x("objectType")
], fe.prototype, "objectType", 2);
gn([
  x("id")
], fe.prototype, "id", 2);
fe = gn([
  b("ExternalIdentifier", h.ebXmlRmi3)
], fe);
var Kp = Object.defineProperty, kp = Object.getOwnPropertyDescriptor, qe = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? kp(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && Kp(e, t, n), n;
};
let ve = class {
  constructor(i, e, t, r, n) {
    this.isOpaque = "false", this.id = bs(), this.slots = [], this.classifications = [], this.externalIdentifiers = [], this.mimeType = i, this.objectType = e, this.home = t, this.name = new nt(r), n && (this.description = new nt(n));
  }
};
qe([
  x("mimeType")
], ve.prototype, "mimeType", 2);
qe([
  x("isOpaque")
], ve.prototype, "isOpaque", 2);
qe([
  x("objectType")
], ve.prototype, "objectType", 2);
qe([
  x("id")
], ve.prototype, "id", 2);
qe([
  x("home")
], ve.prototype, "home", 2);
qe([
  z(W, "Slot", void 0, h.ebXmlRmi3)
], ve.prototype, "slots", 2);
qe([
  c(nt, "Name", h.ebXmlRmi3)
], ve.prototype, "name", 2);
qe([
  c(nt, "Description", h.ebXmlRmi3)
], ve.prototype, "description", 2);
qe([
  z(ie, "Classification", void 0, h.ebXmlRmi3)
], ve.prototype, "classifications", 2);
qe([
  z(fe, "ExternalIdentifier", void 0, h.ebXmlRmi3)
], ve.prototype, "externalIdentifiers", 2);
ve = qe([
  b("ExtrinsicObject", h.ebXmlRmi3)
], ve);
var zp = Object.defineProperty, Wp = Object.getOwnPropertyDescriptor, xt = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? Wp(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && zp(e, t, n), n;
};
let Be = class {
  constructor(i) {
    this.objectType = "urn:oasis:names:tc:ebxml-regrep:ObjectType:RegistryObject:RegistryPackage", this.id = bs(), this.slots = [], this.classifications = [], this.externalIdentifiers = [], this.home = i;
  }
};
xt([
  x("objectType")
], Be.prototype, "objectType", 2);
xt([
  x("status")
], Be.prototype, "status", 2);
xt([
  x("id")
], Be.prototype, "id", 2);
xt([
  x("home")
], Be.prototype, "home", 2);
xt([
  z(W, "Slot", void 0, h.ebXmlRmi3)
], Be.prototype, "slots", 2);
xt([
  c(nt, "Name", h.ebXmlRmi3)
], Be.prototype, "name", 2);
xt([
  z(ie, "Classification", void 0, h.ebXmlRmi3)
], Be.prototype, "classifications", 2);
xt([
  z(fe, "ExternalIdentifier", void 0, h.ebXmlRmi3)
], Be.prototype, "externalIdentifiers", 2);
Be = xt([
  b("RegistryPackage", h.ebXmlRmi3)
], Be);
var Zp = Object.defineProperty, Yp = Object.getOwnPropertyDescriptor, Ti = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? Yp(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && Zp(e, t, n), n;
};
class br {
  constructor() {
    this.registryPackages = [], this.associations = [], this.extrinsicObjects = [], this.classifications = [];
  }
}
Ti([
  z(Be, "RegistryPackage", void 0, h.ebXmlRmi3)
], br.prototype, "registryPackages", 2);
Ti([
  z(Oe, "Association", void 0, h.ebXmlRmi3)
], br.prototype, "associations", 2);
Ti([
  z(ve, "ExtrinsicObject", void 0, h.ebXmlRmi3)
], br.prototype, "extrinsicObjects", 2);
Ti([
  z(ie, "Classification", void 0, h.ebXmlRmi3)
], br.prototype, "classifications", 2);
var $p = Object.defineProperty, qp = Object.getOwnPropertyDescriptor, Ni = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? qp(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && $p(e, t, n), n;
};
let Se = class {
};
Ni([
  z(Et, "RegistryErrorList", "RegistryError")
], Se.prototype, "registryErrors", 2);
Ni([
  x("status")
], Se.prototype, "status", 2);
Ni([
  c(br, "RegistryObjectList")
], Se.prototype, "registryObjectList", 2);
Se = Ni([
  b("AdhocQueryResponse", h.ebXmlQuery3)
], Se);
var Ls = /* @__PURE__ */ ((i) => (i.SubmissionSet = "urn:uuid:a54d6aa5-d40d-43f9-88c5-b4633d873bdd", i.FolderSet = "urn:uuid:d9d542f3-6cc4-48b6-8870-ea235fbc94c2", i))(Ls || {});
const J = class J extends se {
};
J.Patientenkontakt = new J(a.SubmissionSetContentTypeCode, "1.3.6.1.4.1.19376.3.276.1.5.12", "1", "Patientenkontakt"), J.Verlegung = new J(a.SubmissionSetContentTypeCode, "1.3.6.1.4.1.19376.3.276.1.5.12", "2", "Verlegung"), J.Entlassung = new J(a.SubmissionSetContentTypeCode, "1.3.6.1.4.1.19376.3.276.1.5.12", "3", "Entlassung"), J.Ueberweisung = new J(a.SubmissionSetContentTypeCode, "1.3.6.1.4.1.19376.3.276.1.5.12", "4", "Überweisung/Einweisung"), J.Aufnahme = new J(a.SubmissionSetContentTypeCode, "1.3.6.1.4.1.19376.3.276.1.5.12", "5", "Aufnahme"), J.Anforderung = new J(a.SubmissionSetContentTypeCode, "1.3.6.1.4.1.19376.3.276.1.5.12", "6", "Anforderung"), J.Anfrage = new J(a.SubmissionSetContentTypeCode, "1.3.6.1.4.1.19376.3.276.1.5.12", "7", "Auf Anfrage"), J.VeranlassungDurchPatient = new J(a.SubmissionSetContentTypeCode, "1.3.6.1.4.1.19376.3.276.1.5.12", "8", "Veranlassung durch Patient"), J.Zweitmeinung = new J(a.SubmissionSetContentTypeCode, "1.3.6.1.4.1.19376.3.276.1.5.12", "9", "Konsil/Zweitmeinung"), J.Systemwechsel = new J(a.SubmissionSetContentTypeCode, "1.3.6.1.4.1.19376.3.276.1.5.12", "10", "Systemwechsel/Archivierung"), J.Monitoring = new J(a.SubmissionSetContentTypeCode, "1.3.6.1.4.1.19376.3.276.1.5.12", "11", "Monitoring");
let mo = J;
var Xp = Object.defineProperty, _p = Object.getOwnPropertyDescriptor, xi = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? _p(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && Xp(e, t, n), n;
};
let Zt = class {
  constructor(i, e, t) {
    this.homeCommunityId = i, this.repositoryUniqueId = e, this.documentUniqueId = t;
  }
};
xi([
  c(String, "HomeCommunityId", h.iheXdsb)
], Zt.prototype, "homeCommunityId", 2);
xi([
  c(String, "RepositoryUniqueId", h.iheXdsb)
], Zt.prototype, "repositoryUniqueId", 2);
xi([
  c(String, "DocumentUniqueId", h.iheXdsb)
], Zt.prototype, "documentUniqueId", 2);
Zt = xi([
  b("DocumentRequest", h.iheXdsb)
], Zt);
var Cn = /* @__PURE__ */ ((i) => (i.FindFolders = "urn:uuid:958f3006-baad-4929-a4de-ff1114824431", i.FindDocuments = "urn:uuid:14d4debf-8f97-4251-9a74-a90016b0af0d", i.FindSubmissionSets = "urn:uuid:f26abbcb-ac74-4422-8a30-edb644bbc1a9", i.GetSubmissionSetAndContents = "urn:uuid:e8e3cb2c-e39c-46b9-99e4-c12f57260b83", i.GetRelatedDocuments = "urn:uuid:d90e5407-b356-4d91-a89f-873917b4b0e6", i.GetDocumentsAndAssociations = "urn:uuid:bab9529a-4a10-40b3-a01f-f68a615d247a", i.GetFoldersAndContents = "urn:uuid:b909a503-523d-4517-8acf-8e5834dfc4c7", i.GetAssociations = "urn:uuid:a7ae438b-4bc2-4642-93e9-be891f7bb155", i.GetDocuments = "urn:uuid:5c4f972b-d56b-40ac-a5fc-c8ca9b40b9d4", i.GetFolders = "urn:uuid:5737b14c-8a1a-4539-b659-e03a34a5e1e4", i.GetSubmissionSets = "urn:uuid:51224314-5390-4169-9b91-b1980040715a", i.GetFoldersForDocument = "urn:uuid:10cae35a-c7f9-4cf5-b61e-fc3278ffb578", i.GetAll = "urn:uuid:10b545ea-725c-446d-9b95-8aeb444eddf3", i))(Cn || {}), Mr = /* @__PURE__ */ ((i) => (i.Approved = "urn:oasis:names:tc:ebxml-regrep:StatusType:Approved", i.Deprecated = "urn:oasis:names:tc:ebxml-regrep:StatusType:Deprecated", i))(Mr || {}), yu = /* @__PURE__ */ ((i) => (i.XDSDocumentEntry = "urn:uuid:7edca82f-054d-47f2-a032-9b2a5b5186c1", i))(yu || {}), Lt = /* @__PURE__ */ ((i) => (i.Success = "urn:oasis:names:tc:ebxml-regrep:ResponseStatusType:Success", i.Failure = "urn:oasis:names:tc:ebxml-regrep:ResponseStatusType:Failure", i))(Lt || {}), Jp = Object.defineProperty, eg = Object.getOwnPropertyDescriptor, Pa = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? eg(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && Jp(e, t, n), n;
};
let $r = class {
  constructor(i, e) {
    this.id = i, this.include = e;
  }
};
Pa([
  x("id")
], $r.prototype, "id", 2);
Pa([
  c(Zn, "Include", "http://www.w3.org/2004/08/xop/include")
], $r.prototype, "include", 2);
$r = Pa([
  b("Document", h.iheXdsb)
], $r);
var tg = Object.defineProperty, rg = Object.getOwnPropertyDescriptor, Au = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? rg(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && tg(e, t, n), n;
};
let Yn = class {
  constructor(i) {
    this.slots = [], this.slots = i;
  }
};
Au([
  z(W, "Slot", void 0, h.ebXmlRmi3)
], Yn.prototype, "slots", 2);
Yn = Au([
  b("RequestSlotList", h.ebXmlRmi3)
], Yn);
var ng = Object.defineProperty, sg = Object.getOwnPropertyDescriptor, Su = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? sg(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && ng(e, t, n), n;
};
let $n = class {
  constructor(i) {
    this.id = i;
  }
};
Su([
  x("id")
], $n.prototype, "id", 2);
$n = Su([
  b("ObjectRef", h.ebXmlRmi3)
], $n);
var ig = Object.defineProperty, og = Object.getOwnPropertyDescriptor, Ra = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? og(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && ig(e, t, n), n;
};
let qn = class {
  constructor(i, e) {
    this.submitObjectsRequest = i, this.document = e;
  }
};
Ra([
  c(Document, "SubmitObjectsRequest", h.ebXmlRlcm3)
], qn.prototype, "submitObjectsRequest", 2);
Ra([
  c(Document, "Document", h.iheXdsb)
], qn.prototype, "document", 2);
qn = Ra([
  b("ProvideAndRegisterDocumentSetRequest", h.iheXdsb)
], qn);
var ag = Object.defineProperty, cg = Object.getOwnPropertyDescriptor, Oa = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? cg(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && ag(e, t, n), n;
};
let cr = class {
};
Oa([
  x("status")
], cr.prototype, "status", 2);
Oa([
  z(Et, "RegistryErrorList", "RegistryError")
], cr.prototype, "registryErrors", 2);
cr = Oa([
  b("RegistryResponse", h.ebXmlRs3)
], cr);
var ug = Object.defineProperty, hg = Object.getOwnPropertyDescriptor, vu = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? hg(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && ug(e, t, n), n;
};
let qs = class {
  constructor(i) {
    this.objectRef = [], i && (this.objectRef = i);
  }
};
vu([
  z($n, "ObjectRefList", "ObjectRef", h.ebXmlRmi3)
], qs.prototype, "objectRef", 2);
qs = vu([
  b("RemoveObjectsRequest", h.ebXmlRlcm3)
], qs);
var lg = Object.defineProperty, dg = Object.getOwnPropertyDescriptor, bu = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? dg(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && lg(e, t, n), n;
};
let Xs = class {
  constructor(i) {
    this.documentRequests = i;
  }
};
bu([
  z(Zt, "DocumentRequest", void 0, h.iheXdsb)
], Xs.prototype, "documentRequests", 2);
Xs = bu([
  b("RetrieveDocumentSetRequest", h.iheXdsb)
], Xs);
var pg = Object.defineProperty, gg = Object.getOwnPropertyDescriptor, Ta = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? gg(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && pg(e, t, n), n;
};
let Xn = class extends Zt {
};
Ta([
  c(String, "mimeType", h.iheXdsb)
], Xn.prototype, "mimeType", 2);
Ta([
  c($r, "Document", h.iheXdsb)
], Xn.prototype, "document", 2);
Xn = Ta([
  b("DocumentResponse", h.iheXdsb)
], Xn);
var fg = Object.defineProperty, mg = Object.getOwnPropertyDescriptor, Na = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? mg(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && fg(e, t, n), n;
};
let _n = class {
  constructor() {
    this.documentResponses = [];
  }
};
Na([
  c(cr, "RegistryResponse", h.ebXmlRs3)
], _n.prototype, "registryResponse", 2);
Na([
  z(Xn, "DocumentResponse", void 0, h.iheXdsb)
], _n.prototype, "documentResponses", 2);
_n = Na([
  b("RetrieveDocumentSetResponse", h.iheXdsb)
], _n);
var wg = Object.defineProperty, yg = Object.getOwnPropertyDescriptor, xa = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? yg(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && wg(e, t, n), n;
};
let Jn = class {
  constructor(i, e) {
    this.requestSlotList = i, this.registryObjectList = e;
  }
};
xa([
  c(Yn, "RequestSlotList", h.ebXmlRs3)
], Jn.prototype, "requestSlotList", 2);
xa([
  c(br, "RegistryObjectList", h.ebXmlRmi3)
], Jn.prototype, "registryObjectList", 2);
Jn = xa([
  b("SubmitObjectsRequest", h.ebXmlRlcm3)
], Jn);
class Ag {
  constructor(e, t) {
    this.connector = e, this.url = t;
  }
  /**
   * Finds all folders of the given type for one RecordIdentifier. 
   *  Attention: If you do not have the Access Permissions, the Connector will return an Empty Result. Even if there are any Errors. 
   * @param recordIdentifier 
   * @param folderType 
   * @returns 
   */
  async listFolders(e, t) {
    Q.log("Lade ePA Ordner Übersicht."), new Se();
    const r = [
      new W("$XDSFolderStatus", `('${Mr.Approved}')`),
      new W("$XDSFolderPatientId", `('${e.insurantId.getQueryString()}')`)
    ];
    t && r.push(new W("$XDSFolderCodeList", `('${t.getQueryString()}')`));
    const n = new et(Cn.FindFolders, e.homeCommunityId, r), s = new ke(new At(), n), o = new ge("urn:ihe:iti:2007:RegistryStoredQuery", s);
    o.header.contextHeader = new Re(this.connector.context, e);
    const u = await this.connector.communicationService.soap12Post(this.url, o);
    if (u instanceof Se && u.status == Lt.Success)
      return u.registryObjectList.registryPackages.map((l) => new Ic(l));
    throw console.error(u), Q.error("Der die Ordner Übersicht der ePA konnte nicht geladen werden."), new Error("There has been an error while querying the folders");
  }
  /**
   * Lists all approved Documents within the ePA.
   * @param recordIdentifier 
   * @returns 
   */
  async listDocuments(e) {
    Q.log("Lade ePA Dokumente."), new Se();
    const t = [
      new W("$XDSDocumentEntryStatus", `('${Mr.Approved}')`),
      new W("$XDSFolderPatientId", `('${e.insurantId.getQueryString()}')`)
    ], r = new et(Cn.FindDocuments, e.homeCommunityId, t), n = new ke(new At(), r), s = new ge("urn:ihe:iti:2007:RegistryStoredQuery", n);
    s.header.contextHeader = new Re(this.connector.context, e);
    const o = await this.connector.communicationService.soap12Post(this.url, s);
    if (o instanceof Se && o.status == Lt.Success)
      return o.registryObjectList.extrinsicObjects ? o.registryObjectList.extrinsicObjects.map((u) => new go(u)) : [];
    throw console.error(o), Q.error("Der Inhalt der ePA konnte nicht geladen werden."), new Error("There has been an error while querying the ePa content");
  }
  /**
   * Lists all Approved data within this ePA. Including Folders, Associations, Documents, SubmissionSets ... 
   * @param recordIdentifier 
   * @returns 
   */
  async listAll(e, t = !1) {
    Q.log("Lade Datenübersicht für ePA."), new Se();
    const r = [
      new W("$XDSSubmissionSetStatus", "('urn:oasis:names:tc:ebxml-regrep:StatusType:NoSubmissionSets')"),
      new W("$XDSFolderStatus", `('${Mr.Approved}')`),
      new W("$XDSDocumentEntryStatus", `('${Mr.Approved}')`),
      new W("$patientId", `('${e.insurantId.getQueryString()}')`)
    ], n = new et(Cn.GetAll, e.homeCommunityId, r), s = new ke(new At(), n), o = new ge("urn:ihe:iti:2007:RegistryStoredQuery", s);
    o.header.contextHeader = new Re(this.connector.context, e);
    const u = await this.connector.communicationService.soap12Post(this.url, o);
    if (u instanceof Se && u.status == Lt.Success) {
      if (!u.registryObjectList.extrinsicObjects)
        return [];
      const l = (A) => !!A.classifications.find((P) => P.classificationScheme === a.FolderCodeList), m = u.registryObjectList.registryPackages.filter(l).map((A) => new Ic(A)), y = u.registryObjectList.extrinsicObjects.map((A) => new Pp(A));
      for (const A of u.registryObjectList.associations) {
        const P = m.find((p) => p.id == A.sourceObject), M = y.find((p) => p.id == A.targetObject);
        P && (P.fileCount = (P.fileCount || 0) + 1, M == null || M.folders.push(P));
      }
      return y;
    }
    if (u instanceof Se && u.status == Lt.Failure && u.registryErrors[0].errorCode === "7404") {
      if (t)
        throw Q.error("ePA Aktenkonto ist beim Aktenanbieter nicht verfügbar. "), console.error(u), new Error("There has been an error while querying the ePA content");
      Q.log("ePA ist möglicherweise zu einem anderen Anbieter umgezogen, erneute Prüfung");
      const l = await this.connector.getPhrManagementService().getHomeCommunityID(e.insurantId.insurantId);
      if (console.log(l, e), l)
        return this.listAll(l, !0);
    }
    throw console.error(u), Q.error("Der Inhalt der ePA konnte nicht geladen werden."), new Error("There has been an error while querying the ePA content");
  }
  /**
   * List all {@Link EpaFileInfo} within an folder.
   * @param recordIdentifier 
   * @param folderId 
   * @returns 
   */
  async listFolderContent(e, t) {
    Q.log("Lade ePA Dokumente in Ordner."), new Se();
    const r = [
      new W("$XDSFolderEntryUUID", `'${t}'`)
    ], n = new et(Cn.GetFoldersAndContents, e.homeCommunityId, r), s = new ke(new At(), n), o = new ge("urn:ihe:iti:2007:RegistryStoredQuery", s);
    o.header.contextHeader = new Re(this.connector.context, e);
    const u = await this.connector.communicationService.soap12Post(this.url, o);
    if (u instanceof Se && u.status == Lt.Success)
      return u.registryObjectList.extrinsicObjects ? u.registryObjectList.extrinsicObjects.map((l) => new go(l)) : [];
    throw console.error(u), Q.error("Inhalt des Ordners konnte nicht vom Aktensystem geladen werden."), new Error("There has been an error while querying the folder content");
  }
  /**
   * Requests the content of files and merges the {@link EpaFileInfo} with the content to an {@link EpaFile}
   * @param fileInfos the files that should be loaded.
   * @returns 
   */
  async getDocuments(e) {
    if (Q.log("Lade Daten von ePA Dokument."), e.length == 0)
      return [];
    const t = e[0].recordIdentifier, r = e.map((o) => new Zt(t.homeCommunityId, o.repositoryUniqueId, o.oUuId)), n = await this.getDocumentsNativ(t, r), s = [];
    for (const o of n.getRootContent().documentResponses) {
      const u = e.find((m) => m.id === o.documentUniqueId), l = n.findEntry(o.document.include.href);
      s.push(new Ap(u, l.content));
    }
    return s;
  }
  async deleteDocuments(...e) {
    if (e.length > 1 ? Q.log("Lösche ePA Dokumente.") : Q.log("Lösche ePA Dokument."), e.length == 0)
      return new cr();
    const t = e[0].recordIdentifier, r = e.map((u) => new $n(u.id)), n = new ge("urn:ihe:iti:2010:DeleteDocumentSet", new qs(r));
    n.header.contextHeader = new Re(this.connector.context, t);
    const o = (await this.connector.communicationService.soapMTOMPost(this.url, n)).getRootContent();
    if (o.status === Lt.Failure)
      throw console.error(o), Q.error("Das Dokument konnte nicht aus der Akte gelöscht werden."), new Error("File could not be deleted.");
    return o;
  }
  /**
   * Download one file from ePA as a Binary Blob.
   * @param fileInfo 
   * @returns 
   */
  async getDocumentBlob(e) {
    const t = await this.getDocuments([e]);
    return new Blob([t[0].content], { type: e.mimeType || "" });
  }
  /**
   * converts base64 to Blob
   * @param b64Data 
   * @param contentType 
   * @param sliceSize 
   * @returns 
   */
  base64toBlob(e, t, r = 512) {
    const n = atob(e), s = [];
    for (let o = 0; o < n.length; o += r) {
      const u = n.slice(o, o + r), l = new Array(u.length);
      for (let y = 0; y < u.length; y++)
        l[y] = u.charCodeAt(y);
      const m = new Uint8Array(l);
      s.push(m);
    }
    return new Blob(s, { type: t });
  }
  /**
   * Load Document data as returned by the connector.
   * File can be requested with only a few information. 
   * @param recordIdentifier 
   * @param documentRequests 
   * @returns 
   */
  async getDocumentsNativ(e, t) {
    new _n();
    const r = new ge("urn:ihe:iti:2007:RetrieveDocumentSet", new Xs(t));
    return r.header.contextHeader = new Re(this.connector.context, e), this.connector.communicationService.soapMTOMPost(this.url, r);
  }
  /**
   * Stores a File in the ePA can also create a new Folder if needed.
   * Attention: If you do not have the right permission this will trow an ambiguous 7400 Error.
   * @param epaFile Information about the file being stored.
   * @param author Author Information
   * @param folder Existing Folder oUuId or all Information for a new Folder.
   * @param content The Content that should be stored.
   * @returns Server Response for saving the data.
   */
  async storeDocument(e, t, r, n) {
    Q.log("Speichere Dokument in der ePA."), new cr(), new Et();
    const s = e.recordIdentifier, o = new br(), u = new Jn(new Yn([new W("homeCommunityId", s.homeCommunityId)]), o), l = this.createSubmissionSet(s, t);
    o.registryPackages.push(l);
    let m;
    if (typeof r == "string")
      m = r;
    else if (r instanceof Rp) {
      const R = this.createFolderSet(s, r.name, r.type);
      o.registryPackages.push(R), r.id = R.id, m = R.id;
    }
    const y = this.createDocumentEntry(e, t);
    o.extrinsicObjects.push(y);
    const A = new ie(l.id);
    A.classificationNode = Ls.SubmissionSet, A.objectType = "urn:oasis:names:tc:ebxml-regrep:ObjectType:RegistryObject:Classification", o.classifications.push(A), this.createAssociations(l, m, y, o), u.registryObjectList = o;
    const P = new Zn(n), M = new $r(y.id, P), p = new qn(u, M), w = new ge("urn:ihe:iti:2007:ProvideAndRegisterDocumentSet-b", p);
    w.header.contextHeader = new Re(this.connector.context, s), w.header.homeCommunityBlock = new Sa(s.homeCommunityId);
    const D = (await this.connector.communicationService.soapMTOMPost(this.url, w, [P])).getRootContent();
    if (D.status === Lt.Failure)
      throw console.error(D), Q.error("Das Dokument konnte nicht in der Akte gespeichert werden."), new Error("File could not be stored.");
    return D;
  }
  createAssociations(e, t, r, n) {
    if (t !== void 0) {
      const o = new Oe(e.id, t), u = new Oe(t, r.id), l = new Oe(e.id, u.id);
      n.associations.push(o, u, l);
    }
    const s = new Oe(e.id, r.id);
    s.slots.push(new W("SubmissionSetStatus", "Original")), n.associations.push(s);
  }
  createDocumentEntry(e, t) {
    var u, l, m, y, A, P, M;
    const r = new ve(
      e.mimeType,
      yu.XDSDocumentEntry,
      e.recordIdentifier.homeCommunityId,
      e.name,
      e.description
    );
    r.slots.push(
      new W("creationTime", Dc(/* @__PURE__ */ new Date())),
      new W("languageCode", "de-DE"),
      new W("URI", e.filename)
    ), (u = e.classCode) == null || u.setClassificationToObject(r), (l = e.confidentiality) == null || l.setClassificationToObject(r), (m = e.event) == null || m.setClassificationToObject(r), (y = e.format) == null || y.setClassificationToObject(r), (A = e.healthcareFacilityType) == null || A.setClassificationToObject(r), (P = e.practiceSetting) == null || P.setClassificationToObject(r), (M = e.type) == null || M.setClassificationToObject(r);
    const n = new ie(r);
    n.classificationScheme = a.DocumentAuthor, this.setAuthorData(n, t);
    const s = new fe(r.id, Je.DocumentPatientID, `${e.recordIdentifier.insurantId.getQueryString()}`, "XDSDocumentEntry.patientId");
    r.externalIdentifiers.push(s);
    const o = new fe(r.id, Je.DocumentUniqueID, Ji(), "XDSDocumentEntry.uniqueId");
    return r.externalIdentifiers.push(o), r;
  }
  createFolderSet(e, t, r) {
    const n = new Be(e.homeCommunityId);
    n.status = Mr.Approved, n.name = new nt(t), r.setClassificationToObject(n);
    const s = new ie(n);
    s.classificationNode = Ls.FolderSet;
    const o = new fe(n.id, Je.FolderUniqueID, Ji(), "XDSFolder.uniqueId");
    n.externalIdentifiers.push(o);
    const u = new fe(n.id, Je.FolderPatientID, `${e.insurantId.getQueryString()}`, "XDSFolder.patientId");
    return n.externalIdentifiers.push(u), n;
  }
  setAuthorData(e, t) {
    t.role && e.slots.push(new W("authorRole", `${t.role.toString()}`)), e.slots.push(
      new W("authorPerson", t.person.toXdsString()),
      new W("authorInstitution", t.institution.toString())
    );
  }
  createSubmissionSet(e, t) {
    const r = new Be(e.homeCommunityId);
    r.slots.push(new W("submissionTime", Dc(/* @__PURE__ */ new Date())));
    const n = new ie(r);
    n.classificationScheme = a.SubmissionSetAuthor, this.setAuthorData(n, t), mo.VeranlassungDurchPatient.setClassificationToObject(r);
    const s = new ie(r);
    s.classificationNode = Ls.SubmissionSet;
    const o = new fe(r.id, Je.SubmissionSetPatientID, `${e.insurantId.getQueryString()}`, "XDSSubmissionSet.patientId");
    r.externalIdentifiers.push(o);
    const u = new fe(r.id, Je.SubmissionSetUniqueID, Ji(), "XDSSubmissionSet.uniqueId");
    return r.externalIdentifiers.push(u), r;
  }
}
var Sg = Object.defineProperty, vg = Object.getOwnPropertyDescriptor, Cu = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? vg(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && Sg(e, t, n), n;
};
let es = class {
};
Cu([
  c(String, "SignaturePolicyIdentifier", h.oasisDssSignPolicy)
], es.prototype, "signaturePolicyIdentifier", 2);
es = Cu([
  b("GenerateUnderSignaturePolicy", h.oasisDssSignPolicy)
], es);
var bg = Object.defineProperty, Cg = Object.getOwnPropertyDescriptor, Eu = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? Cg(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && bg(e, t, n), n;
};
let _s = class {
  constructor(i) {
    this.context = i;
  }
};
Eu([
  c($, "Context", h.gemConCtx2)
], _s.prototype, "context", 2);
_s = Eu([
  b("GetJobNumber", h.gemSign74)
], _s);
var Eg = Object.defineProperty, Dg = Object.getOwnPropertyDescriptor, Va = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? Dg(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && Eg(e, t, n), n;
};
let ts = class {
};
Va([
  c(String, "JobNumber", h.gemSign74)
], ts.prototype, "jobNumber", 2);
Va([
  c(re, "Status", h.gemCommon5)
], ts.prototype, "status", 2);
ts = Va([
  b("GetJobNumberResponse", h.gemSign74)
], ts);
var Ig = Object.defineProperty, Bg = Object.getOwnPropertyDescriptor, Vi = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? Bg(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && Ig(e, t, n), n;
};
let ur = class {
};
Vi([
  x("WhichDocument", String)
], ur.prototype, "whichDocument", 2);
Vi([
  x("CreateEnvelopedSignature", Boolean)
], ur.prototype, "createEnvelopedSignature", 2);
Vi([
  c(String, "XPathFirstChildOf", h.oasisDss)
], ur.prototype, "xPathFirstChildOf", 2);
ur = Vi([
  b("SignaturePlacement", h.oasisDss)
], ur);
var Mg = Object.defineProperty, Pg = Object.getOwnPropertyDescriptor, be = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? Pg(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && Mg(e, t, n), n;
};
let qr = class {
  constructor(i, e) {
    this.signedProperties = i == null ? void 0 : i.map((t) => new ar(t)), this.unsignedProperties = e == null ? void 0 : e.map((t) => new ar(t));
  }
};
be([
  c(Ar, "SignedProperties", h.oasisDss)
], qr.prototype, "signedProperties", 2);
be([
  c(Ar, "UnsignedProperties", h.oasisDss)
], qr.prototype, "unsignedProperties", 2);
qr = be([
  b("Properties", h.oasisDss)
], qr);
let st = class {
};
be([
  c(String, "SignatureType", h.oasisDss)
], st.prototype, "signatureType", 2);
be([
  c(qr, "Properties", h.oasisDss)
], st.prototype, "properties", 2);
be([
  c(Boolean, "IncludeEContent", h.gemSign74)
], st.prototype, "includeEContent", 2);
be([
  c(ur, "SignaturePlacement", h.oasisDss)
], st.prototype, "signaturePlacement", 2);
be([
  c(es, "GenerateUnderSignaturePolicy", h.oasisDssSignPolicy)
], st.prototype, "generateUnderSignaturePolicy", 2);
st = be([
  b("OptionalInputs", h.gemSign74)
], st);
let Dt = class {
  constructor(i, e) {
    this.includeRevocationInfo = !1, this.requestId = i, this.document = e;
  }
};
be([
  x("RequestID")
], Dt.prototype, "requestId", 2);
be([
  c(st, "OptionalInputs", h.gemSign74)
], Dt.prototype, "optionalInputs", 2);
be([
  c(oe, "Document", h.gemSign74)
], Dt.prototype, "document", 2);
be([
  c(Boolean, "IncludeRevocationInfo", h.gemSign74)
], Dt.prototype, "includeRevocationInfo", 2);
Dt = be([
  b("SignRequest", h.gemSign74)
], Dt);
var Rg = Object.defineProperty, Og = Object.getOwnPropertyDescriptor, Cr = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? Og(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && Rg(e, t, n), n;
};
let We = class {
  constructor(i, e, t, r) {
    this.tvMode = "NONE", this.signRequests = [], this.context = i, this.cardHandle = e, this.signRequests = r, this.jobNumber = t;
  }
  static createMimeSignatureRequest(i, e, t, r, n) {
    const s = "REQ_" + t, o = new oe(r);
    o.shortText = "KIM Mailmessage", o.id = s;
    const u = new st();
    u.includeEContent = !0, u.signatureType = "urn:ietf:rfc:5652";
    const l = window.document.createElementNS(null, "CMSAttribute");
    l.textContent = n, u.properties = new qr([new Ar("RecipientEmailsAttribute", l)]);
    const m = new Dt(s, o);
    return m.includeRevocationInfo = !1, m.optionalInputs = u, new We(i, e, t, [m]);
  }
};
Cr([
  c(String, "CardHandle", h.gemCommon5)
], We.prototype, "cardHandle", 2);
Cr([
  c($, "Context", h.gemConCtx2)
], We.prototype, "context", 2);
Cr([
  c(String, "Crypt", h.gemSign74)
], We.prototype, "crypt", 2);
Cr([
  c(String, "TvMode", h.gemSign74)
], We.prototype, "tvMode", 2);
Cr([
  c(String, "JobNumber", h.gemSign74)
], We.prototype, "jobNumber", 2);
Cr([
  z(Dt, "SignRequest", void 0, h.gemSign74)
], We.prototype, "signRequests", 2);
We = Cr([
  b("SignDocument", h.gemSign74)
], We);
var Tg = Object.defineProperty, Ng = Object.getOwnPropertyDescriptor, xg = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? Ng(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && Tg(e, t, n), n;
};
class Du {
}
xg([
  c(oe, "DocumentWithSignature", h.gemSign74)
], Du.prototype, "documentWithSignature", 2);
var Vg = Object.defineProperty, Ug = Object.getOwnPropertyDescriptor, Ua = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? Ug(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && Vg(e, t, n), n;
};
let Xr = class {
  constructor(i, e) {
    this.type = i, this.base64Signature = e;
  }
};
Ua([
  x("Type", String)
], Xr.prototype, "type", 2);
Ua([
  ru()
], Xr.prototype, "base64Signature", 2);
Xr = Ua([
  b("Base64Signature", h.oasisDss)
], Xr);
var Lg = Object.defineProperty, Fg = Object.getOwnPropertyDescriptor, Iu = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? Fg(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && Lg(e, t, n), n;
};
let hr = class {
  constructor(i) {
    this.base64Signature = i;
  }
};
Iu([
  c(Xr, "Base64Signature", h.oasisDss)
], hr.prototype, "base64Signature", 2);
hr = Iu([
  b("SignatureObject", h.oasisDss)
], hr);
var Gg = Object.defineProperty, Qg = Object.getOwnPropertyDescriptor, Ui = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? Qg(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && Gg(e, t, n), n;
};
class Ds {
}
Ui([
  x("RequestID")
], Ds.prototype, "requestId", 2);
Ui([
  c(re, "Status", h.gemCommon5)
], Ds.prototype, "status", 2);
Ui([
  c(Du, "OptionalOutputs", h.gemSign74)
], Ds.prototype, "optionalOutputs", 2);
Ui([
  c(hr, "SignatureObject", h.oasisDss)
], Ds.prototype, "signatureObject", 2);
var jg = Object.defineProperty, Hg = Object.getOwnPropertyDescriptor, Bu = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? Hg(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && jg(e, t, n), n;
};
let rs = class {
  constructor() {
    this.signResponses = [];
  }
};
Bu([
  z(Ds, "SignResponse", void 0, h.gemSign74)
], rs.prototype, "signResponses", 2);
rs = Bu([
  b("SignDocumentResponse", h.gemSign74)
], rs);
var Kg = Object.defineProperty, kg = Object.getOwnPropertyDescriptor, fn = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? kg(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && Kg(e, t, n), n;
};
let It = class {
  constructor() {
    this.includeVerifier = !1, this.includeCertificateValues = !0, this.includeRevocationValues = !0, this.expandBinaryValues = !1, this.reportDetailLevel = "urn:oasis:names:tc:dss:1.0:profiles:verificationreport:reportdetail:allDetails";
  }
};
fn([
  c(Boolean, "IncludeVerifier", h.urnVerificationReport)
], It.prototype, "includeVerifier", 2);
fn([
  c(Boolean, "IncludeCertificateValues", h.urnVerificationReport)
], It.prototype, "includeCertificateValues", 2);
fn([
  c(Boolean, "IncludeRevocationValues", h.urnVerificationReport)
], It.prototype, "includeRevocationValues", 2);
fn([
  c(Boolean, "ExpandBinaryValues", h.urnVerificationReport)
], It.prototype, "expandBinaryValues", 2);
fn([
  c(String, "ReportDetailLevel", h.urnVerificationReport)
], It.prototype, "reportDetailLevel", 2);
It = fn([
  b("VerificationResult", h.urnVerificationReport)
], It);
var zg = Object.defineProperty, Wg = Object.getOwnPropertyDescriptor, Vt = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? Wg(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && zg(e, t, n), n;
};
let ns = class {
};
Vt([
  c(It, "ReturnVerificationReport", h.urnVerificationReport)
], ns.prototype, "returnVerificationReport", 2);
ns = Vt([
  b("OptionalInputs", h.gemSign74)
], ns);
let it = class {
  constructor(i, e, t) {
    this.includeRevocationInfo = !1, this.context = i, this.document = t, this.signatureObject = e;
  }
  static createCMSVerificationRequest(i, e) {
    const t = new Xr("urn:ietf:rfc:5652", e), r = new it(i, new hr(t));
    return r.optionalInputs = new ns(), r.optionalInputs.returnVerificationReport = new It(), r;
  }
};
Vt([
  c($, "Context", h.gemConCtx2)
], it.prototype, "context", 2);
Vt([
  c(ns, "OptionalInputs", h.gemSign74)
], it.prototype, "optionalInputs", 2);
Vt([
  c(String, "TvMode", h.gemSign74)
], it.prototype, "tvMode", 2);
Vt([
  c(oe, "Document", h.gemSign74)
], it.prototype, "document", 2);
Vt([
  c(hr, "SignatureObject", h.oasisDss)
], it.prototype, "signatureObject", 2);
Vt([
  c(Boolean, "IncludeRevocationInfo", h.gemSign74)
], it.prototype, "includeRevocationInfo", 2);
it = Vt([
  b("VerifyDocument", h.gemSign74)
], it);
var Zg = Object.defineProperty, Yg = Object.getOwnPropertyDescriptor, Li = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? Yg(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && Zg(e, t, n), n;
}, Mu = /* @__PURE__ */ ((i) => (i.VALID = "VALID", i.INVALID = "INVALID", i))(Mu || {});
let lr = class {
};
Li([
  c(String, "HighLevelResult", h.gemSign74)
], lr.prototype, "highLevelResult", 2);
Li([
  c(String, "TimestampType", h.gemSign74)
], lr.prototype, "timestampType", 2);
Li([
  c(Date, "Timestamp", h.gemSign74)
], lr.prototype, "timestamp", 2);
lr = Li([
  b("VerificationResult", h.gemSign74)
], lr);
var $g = Object.defineProperty, qg = Object.getOwnPropertyDescriptor, La = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? qg(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && $g(e, t, n), n;
};
let ss = class {
};
La([
  c(re, "Status", h.gemCommon5)
], ss.prototype, "status", 2);
La([
  c(lr, "VerificationResult", h.gemSign74)
], ss.prototype, "verificationResult", 2);
ss = La([
  b("VerifyDocumentResponse", h.gemSign74)
], ss);
class Xg {
  constructor(e, t) {
    this.connector = e, this.url = t;
  }
  /**
   * Gets a unique signing job number from the connector.
   * @returns 
   */
  async getJobNumber() {
    new ts();
    const e = new _s(this.connector.context);
    return (await this.connector.soap11Post(h.gemSign74 + "#GetJobNumber", this.url, e)).jobNumber;
  }
  async signMimeMessage(e, t, r) {
    var u;
    Q.log("Konnektor signiert Daten."), new rs(), new ze();
    const n = await this.getJobNumber(), s = We.createMimeSignatureRequest(this.connector.context, e, n, t, r), o = await this.connector.soap11Post(h.gemSign74 + "#SignDocument", this.url, s);
    return (u = o == null ? void 0 : o.signResponses[0]) == null ? void 0 : u.signatureObject;
  }
  /**
   * Signs an NFD Record
   * @param cardHandle CardHandle used for signing
   * @param base64Content base64 encoded NFD Record
   * @param nfdRefUri RefUri is a selector that identifies the Record to be signed, normaly it is the query selector by the id of the NFD.
   * @param remotePin If a pin is given and remote pin is supported the remote pin is uses.
   * @returns CommonDocument for the signature
   */
  async signNFD(e, t, r, n) {
    var M;
    Q.log("Konnektor signiert Daten."), new rs(), new ze();
    const s = await this.getJobNumber(), o = new oe(void 0, t);
    o.id = "NFD_DOC_ID", o.refURI = r, o.shortText = "NFD";
    const u = new ur();
    u.whichDocument = o.id, u.createEnvelopedSignature = !1, u.xPathFirstChildOf = "/*[local-name()='NFD_Document']/*[local-name()='SignatureArzt']";
    const l = new Dt("req_" + s, o);
    l.optionalInputs = new st(), l.optionalInputs.signatureType = "urn:ietf:rfc:3275", l.optionalInputs.signaturePlacement = u, l.optionalInputs.generateUnderSignaturePolicy = new es(), l.optionalInputs.generateUnderSignaturePolicy.signaturePolicyIdentifier = "urn:gematik:fa:sak:nfdm:r1:v1", l.includeRevocationInfo = !0;
    const m = new We(this.connector.context, e, s, [l]), y = () => this.connector.soap11Post(h.gemSign74 + "#SignDocument", this.url, m);
    let A;
    A = y();
    const P = await A;
    return (M = P == null ? void 0 : P.signResponses[0]) == null ? void 0 : M.optionalOutputs.documentWithSignature;
  }
  async verifyCMSMessage(e) {
    Q.log("Konnektor prüft Daten-Signatur."), new ss();
    const t = it.createCMSVerificationRequest(this.connector.context, e);
    return await this.connector.soap11Post(h.gemSign74 + "#VerifyDocument", this.url, t);
  }
}
var _g = Object.defineProperty, Jg = Object.getOwnPropertyDescriptor, Le = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? Jg(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && _g(e, t, n), n;
};
class Fi {
}
Le([
  x("Location")
], Fi.prototype, "location", 2);
let Bt = class {
};
Le([
  c(String, "Abstract")
], Bt.prototype, "abstract", 2);
Le([
  c(Fi, "Endpoint")
], Bt.prototype, "endpoint", 2);
Le([
  c(Fi, "EndpointTLS")
], Bt.prototype, "endpointTLS", 2);
Le([
  c(Fi, "WSDL")
], Bt.prototype, "wsdl", 2);
Le([
  x("TargetNamespace")
], Bt.prototype, "targetNamespace", 2);
Le([
  x("Version")
], Bt.prototype, "version", 2);
Bt = Le([
  b("Version", "http://ws.gematik.de/conn/ServiceInformation/v2.0")
], Bt);
let _r = class {
};
Le([
  c(String, "Abstract")
], _r.prototype, "abstract", 2);
Le([
  z(Bt, "Versions", "Version")
], _r.prototype, "versions", 2);
Le([
  x("Name")
], _r.prototype, "name", 2);
_r = Le([
  b("Service", "http://ws.gematik.de/conn/ServiceInformation/v2.0")
], _r);
var ef = Object.defineProperty, tf = Object.getOwnPropertyDescriptor, Is = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? tf(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && ef(e, t, n), n;
};
let Jr = class {
};
Is([
  c(zt, "ProductInformation")
], Jr.prototype, "productInformation", 2);
Is([
  c(Boolean, "TLSMandatory")
], Jr.prototype, "tlsMandatory", 2);
Is([
  c(Boolean, "ClientAutMandatory")
], Jr.prototype, "clientAutMandatory", 2);
Is([
  z(_r, "ServiceInformation", "Service", "http://ws.gematik.de/conn/ServiceInformation/v2.0")
], Jr.prototype, "serviceInformation", 2);
Jr = Is([
  b("ConnectorServices", "http://ws.gematik.de/conn/ServiceDirectory/v3.1")
], Jr);
const gc = class gc {
  static set(e, t, r) {
    if (r === void 0) {
      window.localStorage.removeItem(e + this.DELIMITER + t);
      return;
    }
    typeof r == "object" && (r = JSON.stringify(r)), window.localStorage.setItem(e + this.DELIMITER + t, r);
  }
  static get(e, t) {
    const r = window.localStorage.getItem(e + this.DELIMITER + t);
    if (r !== null)
      return r;
  }
  static getObject(e, t) {
    const r = this.get(e, t);
    if (r !== void 0)
      try {
        return JSON.parse(r);
      } catch (n) {
        console.warn("invalid Json data within the Cache", n);
        return;
      }
  }
};
gc.DELIMITER = "~_~";
let Js = gc;
var rf = Object.defineProperty, nf = Object.getOwnPropertyDescriptor, Er = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? nf(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && rf(e, t, n), n;
};
class Pu {
}
Er([
  c(String, "Value")
], Pu.prototype, "value", 2);
class Ru {
}
Er([
  c(String, "Text")
], Ru.prototype, "text", 2);
class Ou {
}
Er([
  c(void 0, void 0, void 0, !0)
], Ou.prototype, "element", 2);
let dr = class {
};
Er([
  c(Pu, "Code")
], dr.prototype, "code", 2);
Er([
  c(Ru, "Reason")
], dr.prototype, "reason", 2);
Er([
  c(Ou, "Detail")
], dr.prototype, "detail", 2);
dr = Er([
  b("Fault", "http://www.w3.org/2003/05/soap-envelope")
], dr);
var sf = Object.defineProperty, of = Object.getOwnPropertyDescriptor, mn = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? of(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && sf(e, t, n), n;
};
let Yt = class {
  constructor(i, e, t, r = !1, n = !1) {
    this.context = i, this.ehcHandle = e, this.hpcHandle = t, this.performOnlineCheck = r, this.readOnlineReceipt = n;
  }
};
mn([
  c(String, "EhcHandle", h.gemVsd52)
], Yt.prototype, "ehcHandle", 2);
mn([
  c(String, "HpcHandle", h.gemVsd52)
], Yt.prototype, "hpcHandle", 2);
mn([
  c(String, "PerformOnlineCheck", h.gemVsd52)
], Yt.prototype, "performOnlineCheck", 2);
mn([
  c(String, "ReadOnlineReceipt", h.gemVsd52)
], Yt.prototype, "readOnlineReceipt", 2);
mn([
  c($, "Context", h.gemConCtx2)
], Yt.prototype, "context", 2);
Yt = mn([
  b("ReadVSD", h.gemVsd52)
], Yt);
var af = Object.defineProperty, cf = Object.getOwnPropertyDescriptor, wn = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? cf(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && af(e, t, n), n;
};
let $t = class {
};
wn([
  c(String, "PersoenlicheVersichertendaten", h.gemVsd52)
], $t.prototype, "persoenlicheVersichertendaten", 2);
wn([
  c(String, "AllgemeineVersicherungsdaten", h.gemVsd52)
], $t.prototype, "allgemeineVersicherungsdaten", 2);
wn([
  c(String, "GeschuetzteVersichertendaten", h.gemVsd52)
], $t.prototype, "geschuetzteVersichertendaten", 2);
wn([
  c(String, "Pruefungsnachweis", h.gemVsd52)
], $t.prototype, "pruefungsnachweis", 2);
wn([
  c(String, "VSD_Status", h.gemVsd52)
], $t.prototype, "status", 2);
$t = wn([
  b("ReadVSDResponse", h.gemVsd52)
], $t);
class uf {
  constructor(e, t) {
    this.connector = e, this.url = t;
  }
  /**
   * Plain implementation of  the  connector interface to read the Information of the electronic health card.
   * @param ehcHandle Handle of the health card
   * @param hpcHandle  Handle of SMCB, this needs to be unlocked.
   * @param onlineCheck Verify the card online, and may update new data.
   * @param readOnlineReceipt Return the receipt from the online check
   * @returns 
   */
  async readVsd(e, t, r = !1, n = !1) {
    var o, u, l;
    const s = new Yt(this.connector.context, e, t, r, n);
    new $t().status = 0;
    try {
      return await this.connector.soap11Post(h.gemVsd52 + "#ReadVSD", this.url, s);
    } catch (m) {
      throw m instanceof dr && ((l = (u = (o = m.detail) == null ? void 0 : o.element) == null ? void 0 : u.trace) == null ? void 0 : l.code) === "3041" && (Q.smbcLocked(), Q.log("Bitte entsperren Sie die SMC-B um die Versichertendaten auszulesen")), m;
    }
  }
}
var hf = Object.defineProperty, lf = Object.getOwnPropertyDescriptor, yn = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? lf(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && hf(e, t, n), n;
};
let qt = class {
  /**
   * 
   * @param context 
   * @param ehcHandle Verweis auf die eGK, von der der NFD gelesen werden soll.
   * @param hpcHandle Verweis auf die HBA/SMC-B, die zum Zugriff auf die eGK verwendet werden soll.
   * @param emergencyIndicator Gibt an, ob die Operation im Rahmen eines Notfalls aufgerufen wird.
   * @param updateIndicator Gibt an, ob die Operation im Rahmen einer Aktualisierung des NFD aufgerufen wird.
   */
  constructor(i, e, t, r = !1, n = !1) {
    this.emergencyIndicator = !1, this.updateIndicator = !0, this.context = i, this.ehcHandle = e, this.hpcHandle = t, this.emergencyIndicator = r, this.updateIndicator = n;
  }
};
yn([
  c($, "Context", h.gemConCtx2)
], qt.prototype, "context", 2);
yn([
  c(String, "EhcHandle", h.gemCommon5)
], qt.prototype, "ehcHandle", 2);
yn([
  c(String, "HpcHandle", h.gemCommon5)
], qt.prototype, "hpcHandle", 2);
yn([
  c(Boolean, "EmergencyIndicator", h.gemNfd10)
], qt.prototype, "emergencyIndicator", 2);
yn([
  c(Boolean, "UpdateIndicator", h.gemNfd10)
], qt.prototype, "updateIndicator", 2);
qt = yn([
  b("ReadNFD", h.gemNfd10)
], qt);
var df = Object.defineProperty, pf = Object.getOwnPropertyDescriptor, Fa = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? pf(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && df(e, t, n), n;
};
let en = class {
};
Fa([
  c(String, "Result", h.gemNfd10)
], en.prototype, "result", 2);
Fa([
  c(rt, "Error", h.gemError2)
], en.prototype, "error", 2);
en = Fa([
  b("Status", h.gemNfd10)
], en);
var gf = Object.defineProperty, ff = Object.getOwnPropertyDescriptor, Gi = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? ff(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && gf(e, t, n), n;
};
let tn = class {
};
Gi([
  c(en, "Status", h.gemNfd10)
], tn.prototype, "status", 2);
Gi([
  c(String, "NFDDocument", h.gemNfd10)
], tn.prototype, "nfdDocument", 2);
Gi([
  c(lr, "VerificationResult", h.gemSign74)
], tn.prototype, "verificationResult", 2);
tn = Gi([
  b("ReadNFDResponse", h.gemNfd10)
], tn);
var mf = Object.defineProperty, wf = Object.getOwnPropertyDescriptor, Bs = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? wf(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && mf(e, t, n), n;
};
let pr = class {
  /**
   * 
   * @param context 
   * @param ehcHandle Verweis auf die eGK, von der der NFD gelesen werden soll.
   * @param hpcHandle Verweis auf die HBA/SMC-B, die zum Zugriff auf die eGK verwendet werden soll.
   * @param nfdDocument Auf die eGK des Versicherten zu schreibender NFD inkl. QES. XML encoded as Base64.
   */
  constructor(i, e, t, r) {
    this.context = i, this.ehcHandle = e, this.hpcHandle = t, this.nfdDocument = r;
  }
};
Bs([
  c($, "Context", h.gemConCtx2)
], pr.prototype, "context", 2);
Bs([
  c(String, "EhcHandle", h.gemCommon5)
], pr.prototype, "ehcHandle", 2);
Bs([
  c(String, "HpcHandle", h.gemCommon5)
], pr.prototype, "hpcHandle", 2);
Bs([
  c(String, "NFDDocument", h.gemNfd10)
], pr.prototype, "nfdDocument", 2);
pr = Bs([
  b("WriteNFD", h.gemNfd10)
], pr);
var yf = Object.defineProperty, Af = Object.getOwnPropertyDescriptor, Tu = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? Af(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && yf(e, t, n), n;
};
let ei = class {
};
Tu([
  c(en, "Status", h.gemNfd10)
], ei.prototype, "status", 2);
ei = Tu([
  b("WriteNFDResponse", h.gemNfd10)
], ei);
class Sf {
  constructor(e, t) {
    this.connector = e, this.url = t, this.lastUpdateRead = 0, this.lastUpdateReadCard = "";
  }
  /**
   * Reads the NFD Record from the card. 
   * 
   * @param ehcHandle Card handle where the nfd is stores
   * @param hbaHandle Card handle of the hba responsible reading the record.
   * @param emergencyIndicator Only to been set if the nfd is read in an emergency 
   * @param updateIndicator Syncs the nfd with the online information from the insurance. This has to be done before a write of a new nfd !
   * @returns 
   */
  async readNfd(e, t, r = !1, n = !1) {
    var o, u, l, m, y, A, P, M, p;
    Q.log("Lese Notfalldatensatz von eGK");
    const s = new qt(this.connector.context, e, t, r, n);
    new tn().nfdDocument = "";
    try {
      const w = await this.connector.soap11Post(h.gemNfd10 + "#ReadNFD", this.url, s);
      return n && (this.lastUpdateRead = (/* @__PURE__ */ new Date()).getTime(), this.lastUpdateReadCard = e), w;
    } catch (w) {
      if (w instanceof ze) {
        if (((l = (u = (o = w.detail) == null ? void 0 : o.error) == null ? void 0 : u.trace) == null ? void 0 : l.code) === "5020") {
          Q.log("Der Notfalldatensatz ist verborgen");
          return;
        }
        if (((A = (y = (m = w.detail) == null ? void 0 : m.error) == null ? void 0 : y.trace) == null ? void 0 : A.code) === "5021") {
          Q.log("Es ist kein Notfalldatensatz auf der eGK gespeichert");
          return;
        }
        ((p = (M = (P = w.detail) == null ? void 0 : P.error) == null ? void 0 : M.trace) == null ? void 0 : p.code) === "5001" && (Q.smbcLocked(), Q.log("Bitte entsperren Sie die SMC-B um die Notfalldatensatz auszulesen"));
      }
      throw w;
    }
  }
  /**
   * Ensures NFS is iso-8859-15 within an base64 encoded string
   * @param nfdDocumentXmlString 
   * @returns 
   */
  convertNfdToBase64(e) {
    e = e.replace(/ encoding="[uU][tT][fF]-8"/, ' encoding="ISO-8859-15"');
    const t = nh.encode(e), r = new Uint8Array(t.length);
    for (let n = 0; n < t.length; n++)
      r[n] = t[n];
    return ye.fromUint8Array(r);
  }
  /**
   * Stores an NFD Record on the EHC.
   * @param ehcHandle Handle of the card the NFD will be written to
   * @param hbaHandle Handle of the hba card used for singing.
   * @param nfdDocumentXmlString the new nfd record
   * @param nfdRefQueryString A Query selector that selects the root of the nfd record ( eg. "#nfd-id")
   * @param hbaRemotePin optional remote pin for the hba. If this is given the pin entry will be automated.
   * @returns 
   */
  async writeNfd(e, t, r, n, s) {
    var A, P, M;
    Q.log("Schreibe Notfalldatensatz auf eGK");
    const o = this.convertNfdToBase64(r), u = this.connector.getSignatureService();
    s && (await this.connector.getCardService().getPinStatus(t || "", "PIN.CH")).pinStatus == nu.VERIFIABLE;
    const l = (/* @__PURE__ */ new Date()).getTime() - 1e3 * 60 * 5;
    (this.lastUpdateReadCard != e || this.lastUpdateRead < l) && await this.readNfd(e, t, !1, !0);
    let m = await u.signNFD(t, o, n, s);
    const y = new pr(this.connector.context, e, t, m.base64XML);
    new ei();
    try {
      return await this.connector.soap11Post(h.gemNfd10 + "#WriteNFD", this.url, y);
    } catch (p) {
      throw p instanceof ze && ((M = (P = (A = p.detail) == null ? void 0 : A.error) == null ? void 0 : P.trace) == null ? void 0 : M.code) === "5001" && (Q.hbaLocked(), Q.log("Bitte entsperren Sie deb HBA bevor Sie einen Notfalldatensatz schreiben.")), p;
    }
  }
}
var vf = Object.defineProperty, bf = Object.getOwnPropertyDescriptor, Ga = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? bf(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && vf(e, t, n), n;
};
let rn = class {
  constructor(i, e = "application/octet-stream") {
    this.mimeType = "application/octet-stream", this.base64Data = i, this.mimeType = e;
  }
};
Ga([
  x("MimeType", h.oasisDss)
], rn.prototype, "mimeType", 2);
Ga([
  ru()
], rn.prototype, "base64Data", 2);
rn = Ga([
  b("Base64Data", h.oasisDss)
], rn);
var Cf = Object.defineProperty, Ef = Object.getOwnPropertyDescriptor, Nu = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? Ef(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && Cf(e, t, n), n;
};
let is = class {
  constructor(i) {
    this.base64Data = i;
  }
};
Nu([
  c(rn, "Base64Data", h.oasisDss)
], is.prototype, "base64Data", 2);
is = Nu([
  b("BinaryString", h.gemSign74)
], is);
var Df = Object.defineProperty, If = Object.getOwnPropertyDescriptor, Jt = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? If(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && Df(e, t, n), n;
};
let os = class {
};
Jt([
  c(String, "SignatureType", h.oasisDss)
], os.prototype, "signatureType", 2);
Jt([
  c(String, "SignatureScheme", h.oasisDss)
], os.prototype, "signatureScheme", 2);
os = Jt([
  b("OptionalInputs", h.gemSign74)
], os);
let gr = class {
  constructor(i, e, t, r) {
    this.cardHandle = i, this.context = e, this.binaryString = t, this.optionalInputs = r;
  }
};
Jt([
  c(String, "CardHandle", h.gemCommon5)
], gr.prototype, "cardHandle", 2);
Jt([
  c($, "Context", h.gemConCtx2)
], gr.prototype, "context", 2);
Jt([
  c(os, "OptionalInputs", h.gemSign74)
], gr.prototype, "optionalInputs", 2);
Jt([
  c(is, "BinaryString", h.gemSign74)
], gr.prototype, "binaryString", 2);
gr = Jt([
  b("ExternalAuthenticate", h.gemSign74)
], gr);
var Bf = Object.defineProperty, Mf = Object.getOwnPropertyDescriptor, Qa = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? Mf(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && Bf(e, t, n), n;
};
let as = class {
};
Qa([
  c(re, "Status", h.gemCommon5)
], as.prototype, "status", 2);
Qa([
  c(hr, "SignatureObject", h.oasisDss)
], as.prototype, "signatureObject", 2);
as = Qa([
  b("ExternalAuthenticateResponse", h.gemSign74)
], as);
class Pf {
  constructor(e, t) {
    this.connector = e, this.url = t;
  }
  async externalAuthenticate(e, t) {
    Q.log("Konnektor signiert Daten."), new as(), new dr();
    const r = new gr(e, this.connector.context, new is(new rn(t))), n = await this.connector.soap11Post(
      h.gemSign74 + "#ExternalAuthenticate",
      this.url,
      r
    );
    return n == null ? void 0 : n.signatureObject;
  }
}
class Rf {
  /**
   *
   * @param host Hostname with protocol prefix
   * @param context Connector Context information.
   * @param transportLayer Defines alternative Transport layer over which the connector will be reached.
   */
  constructor(e, t, r) {
    this.host = e, this.context = t, this.communicationService = new Ql(r);
  }
  /**
   * Gets information about the connector and its capabilities.
   */
  async init() {
    if (!this.connectorInformation) {
      try {
        if (this.connectorInformation = Js.getObject("Connector", "connectorInformation"), this.connectorInformation) {
          this.updateConnectorInformation();
          return;
        }
      } catch (e) {
        console.warn("unable to uses cached Connector information, loading life data", e);
      }
      Q.log("Bestimme Funktionen des Telematik-Konnektor"), await this.updateConnectorInformation();
    }
  }
  setTimeoutRead(e) {
    this.communicationService.setTimeoutRead(e);
  }
  async updateConnectorInformation() {
    let e = await this.communicationService.getString(`${this.host}/connector.sds`);
    this.connectorInformation = Ke.unmarshal(e), Js.set("Connector", "connectorInformation", this.connectorInformation);
  }
  getConnectorInformation() {
    return this.connectorInformation;
  }
  findServiceInformation(e) {
    var t, r;
    return (r = (t = this.connectorInformation) == null ? void 0 : t.serviceInformation) == null ? void 0 : r.find((n) => n.name === e);
  }
  findServiceEndpoint(e, t) {
    const r = this.findServiceInformation(e);
    if (!r)
      throw new Error(e + " is not supported by the connector.");
    const n = r.versions.find((s) => s.version === t);
    if (!n)
      throw new Error(e + " in Version " + t + "is not supported by the connector.");
    return n.endpointTLS.location;
  }
  getEventService() {
    return this.eventService || (this.eventService = new Vd(this, this.findServiceEndpoint("EventService", "7.2.0"))), this.eventService;
  }
  getCardService() {
    return this.cardService || (this.cardService = new ml(this, this.findServiceEndpoint("CardService", "8.1.2"))), this.cardService;
  }
  getPhrManagementService() {
    return this.phrManagementService || (this.phrManagementService = new mp(this, this.findServiceEndpoint("PHRManagementService", "2.0.1"))), this.phrManagementService;
  }
  getPhrService() {
    return this.phrService || (this.phrService = new Ag(this, this.findServiceEndpoint("PHRService", "2.0.1"))), this.phrService;
  }
  getCertificateService() {
    return this.certificateService || (this.certificateService = new Pl(this, this.findServiceEndpoint("CertificateService", "6.0.1"))), this.certificateService;
  }
  getEncryptionService() {
    return this.encryptionService || (this.encryptionService = new nd(this, this.findServiceEndpoint("EncryptionService", "6.1.1"))), this.encryptionService;
  }
  getSignatureService() {
    return this.signatureService || (this.signatureService = new Xg(this, this.findServiceEndpoint("SignatureService", "7.4.2"))), this.signatureService;
  }
  getVsdService() {
    return this.vsdService || (this.vsdService = new uf(this, this.findServiceEndpoint("VSDService", "5.2.0"))), this.vsdService;
  }
  getNfdService() {
    return this.nfdService || (this.nfdService = new Sf(this, this.findServiceEndpoint("NFDService", "1.0.0"))), this.nfdService;
  }
  getAuthSignatureService() {
    return this.authSignatureService || (this.authSignatureService = new Pf(this, this.findServiceEndpoint("AuthSignatureService", "7.4.1"))), this.authSignatureService;
  }
  async soap11Post(e, t, r) {
    return this.communicationService.soap11Post(e, t, r);
  }
}
var ot = /* @__PURE__ */ ((i) => (i.CONNECTOR = "CONNECTOR", i.KIM_SMTP = "KIM_SMTP", i.KIM_POP3 = "KIM_POP3", i.LDAP = "LDAP", i.KIM_ACCOUNT_MANAGER = "KIM_ACCOUNT_MANAGER", i.KIM_ATTACHMENT_STORAGE = "KIM_ATTACHMENT_STORAGE", i.KIM_FOREIGN_ATTACHMENT_STORAGE = "KIM_FOREIGN_ATTACHMENT_STORAGE", i.CARD_TERMINAL = "CARD_TERMINAL", i.CARD_TERMINAL_SMB_C = "CARD_TERMINAL_SMB_C", i))(ot || {});
class ja {
  constructor(e) {
    this.handlers = {}, this.ws = e, this.ws.onmessage = (t) => this.onMessage(t), this.connectPromise = new Promise((t, r) => {
      this.ws.readyState === WebSocket.OPEN ? t() : (this.ws.onopen = () => t(), this.ws.onerror = () => r());
    });
  }
  onMessage(e) {
    const t = JSON.parse(e.data);
    if (t.payload.error === "Invalid session Id") {
      document.cookie = "sessionId=", console.error(t), t.header.inReplyToId && this.handlers[t.header.inReplyToId] && (this.handlers[t.header.inReplyToId].reject(t), delete this.handlers[t.header.inReplyToId]);
      return;
    }
    t.header.inReplyToId && this.handlers[t.header.inReplyToId] && (this.handlers[t.header.inReplyToId].resolve(t), delete this.handlers[t.header.inReplyToId]);
  }
  async login(e, t) {
    await this.connectPromise;
    try {
      Q.log("Anmeldung am Kartenterminal");
      const r = await this.send("LoginRequest", {
        username: e,
        password: t
      });
      return this.sessionId = r.payload.sessionId, (await this.send("SmcbAuthenticationRequest", {})).payload.key;
    } catch (r) {
      throw Q.log("Fehler bei der Anmeldung am Kartenterminal"), r;
    } finally {
      try {
        await this.send("LogoutRequest", {});
      } catch {
      }
    }
  }
  static uid() {
    let e = "";
    for (let t = 0; t < 32; t++) {
      const r = Math.random() * 16;
      e += Math.floor(r).toString(16);
    }
    return e;
  }
  send(e, t) {
    return new Promise(
      (r, n) => {
        const s = this.newMessage(e, t);
        this.handlers[s.header.msgId] = { resolve: r, reject: n }, this.ws.send(JSON.stringify(s));
      }
    );
  }
  newMessage(e, t) {
    return {
      header: {
        msgId: ja.uid(),
        sessionId: this.getSessionId()
      },
      payloadType: e,
      payload: t
    };
  }
  getSessionId() {
    return this.sessionId;
  }
}
const di = class di {
  constructor(e, t) {
    this.webSocketAuthKey = t, this.ws = e, this.connectedPromise = new Promise(
      (r, n) => {
        this.connectedPromiseResolve = r, this.connectedPromiseReject = n;
      }
    ), this.ws.onmessage = (r) => this.receive(r), this.ws.onerror = () => this.connectedPromiseReject();
  }
  debug(...e) {
  }
  receive(e) {
    let t;
    if (typeof e.data == "string")
      this.debug("received from socket", e.data), t = JSON.parse(e.data);
    else {
      const r = new TextDecoder().decode(e.data);
      this.debug("received from socket", r), t = JSON.parse(r);
    }
    t.PayloadType === "AuthenticateRequest" ? this.AuthenticateRequest(t) : t.PayloadType === "Notify" ? this.Notify(t) : t.PayloadType === "InputPinRequest" ? this.InputPinRequest(t) : t.PayloadType === "OutputRequest" && Ft.debug(t.Payload.Message);
  }
  async enterPin(e, t) {
    await this.connectedPromise, this.pin = e;
    const r = await t();
    return this.ws.close(), r;
  }
  async AuthenticateRequest(e) {
    Ft.debug("Kartenterminal auf entfernte PIN Eingabe umstellen");
    const t = this.hex2array(this.webSocketAuthKey);
    this.webSocketAuthKey = "";
    const r = await this.simpleAES(t, new Uint8Array(16).fill(0)), n = new Uint8Array(r.slice(0, 16));
    let s = 0, o;
    for (let y = n.length - 1; y >= 0; y--)
      o = n[y], n[y] <<= 1, n[y] |= s, s = o >> 7;
    s == 1 && (n[n.length - 1] ^= 135);
    const u = this.hex2array(e.Payload.Challenge);
    for (let y = n.length - 1; y >= 0; y--)
      u[16 + y] ^= n[y];
    const l = await this.simpleAES(t, u), m = this.array2hex(l.slice(16, 32));
    this.ws.send(this.CreateMessage(e.Header.MsgId, "AuthenticateResponse", { Response: m }));
  }
  Notify(e) {
    const t = e.Payload.Code;
    if (t == 0) {
      const r = !this.sessionId && !!e.Header.SessionId;
      this.sessionId = e.Header.SessionId, r && (Ft.debug("PIN an Kartenterminal gesendet."), this.connectedPromiseResolve());
    } else
      Ft.error(di.errorCode[t]), this.connectedPromiseReject();
  }
  InputPinRequest(e) {
    this.pin ? (Ft.debug("PIN an Kartenterminal gesendet."), this.ws.send(this.CreateMessage(e.Header.MsgId, "InputPinResponse", { Code: "Pin", Pin: this.pin }))) : (Ft.debug("PIN nicht vorhanden"), this.ws.send(this.CreateMessage(e.Header.MsgId, "InputPinResponse", { Code: "CancelButton" })));
  }
  CreateMessage(e, t, r) {
    const s = {
      Header: {
        MsgId: ja.uid(),
        InReplyToId: e,
        SessionId: this.sessionId
      },
      PayloadType: t,
      Payload: r
    };
    return this.debug("CreateMessage", s), JSON.stringify(s);
  }
  hex2array(e) {
    return new Uint8Array(e.match(/[\da-f]{2}/gi).map((t) => parseInt(t, 16)));
  }
  array2hex(e) {
    return [...new Uint8Array(e)].map((t) => t.toString(16).padStart(2, "0")).join("");
  }
  async simpleAES(e, t) {
    const r = await window.crypto.subtle.importKey("raw", e, "AES-CBC", !0, ["encrypt"]);
    return window.crypto.subtle.encrypt({ name: "AES-CBC", iv: new Uint8Array(16).fill(0) }, r, t);
  }
};
di.errorCode = [
  "Unbekannter Fehler.",
  "Fehlerhafte JSON-Daten.",
  "Authentisierung ist nötig.",
  "Authentisierung fehlgeschlagen.",
  "Ungültige SessionId.",
  "Ungültiges oder fehlendes MessageId Feld.",
  "Ungültiger InReplyToId Wert.",
  "Feld InReplyToId fehlt.",
  "Ungültige Challenge-Antwort.",
  "Fehlendes PIN-Feld.",
  "Ungültiges PIN-Feld.",
  "Ungültige PIN-Länge.",
  "PIN-Daten waren unerwartet.",
  "Ungültiger Rückgabewert"
];
let wo = di;
class Of {
  constructor(e, t) {
    this.ti365Session = e, this.backendConnection = t, this.cardInformationMap = /* @__PURE__ */ new Map();
  }
  async getCardTerminals(e = !1) {
    if (!this.cardTerminals || e) {
      const t = await this.ti365Session.getConnector();
      this.cardTerminals = (await t.getEventService().getCardTerminals()).cardTerminals;
    }
    return this.cardTerminals;
  }
  async hasRemotePinInput(e) {
    if (e.type !== _.SMC_B)
      return !1;
    let t = this.cardInformationMap.get(e.iccsn);
    if (t)
      return t.remotePinCapable;
    const n = (await this.getCardTerminals()).find((o) => o.ctId === e.ctId);
    if (!(n != null && n.ipAddress))
      return !1;
    const s = await this.ti365Session.gatewayClient.get(`/card-terminal/remote-pin-capability/${n.ipAddress.ipv4Address}`);
    return t = { card: e, terminal: n, remotePinCapable: s.remotePinCapable }, this.cardInformationMap.set(e.iccsn, t), t.remotePinCapable;
  }
  /**
   * Starts the Progress of entering the PIN to the Card Terminal.
   *  1. Request Backend Channel to CARD_TERMINAL, Backend logins to terminal and creates Login key
   *  2. Client creates a channel & websocket connection to the terminal using the login key and activates the remote pin entry
   *  3. Request to connector to init the pin entry.
   *  4. Send pin via websocket
   * @param pin Pin needed for the defined Pin Type
   * @param pinType Pin Type to enter
   */
  async enterPinForSmcb(e, t) {
    if (e.type !== _.SMC_B)
      throw new Error("Only SMC-B cards can be used with remote PIN");
    if (!await this.hasRemotePinInput(e))
      throw new Error("The card terminal is not capable of remote PIN input");
    const n = this.cardInformationMap.get(e.iccsn), s = await this.ti365Session.getConnector(), o = () => s.getCardService().verifyPin(e.handle, "PIN.SMC");
    return this.enterPinForAction(n, t, o);
  }
  async enterPinForAction(e, t, r) {
    var s;
    const n = await this.backendConnection.createChannel({ serviceType: ot.CARD_TERMINAL, metadata: { ipAddress: (s = e.terminal.ipAddress) == null ? void 0 : s.ipv4Address } });
    return new Promise((o, u) => {
      let l = setTimeout(() => {
        u(new Error("Timeout"));
      }, 1e4);
      n.onmessage = async (m) => {
        const y = new TextDecoder().decode(m.data);
        clearTimeout(l);
        const A = JSON.parse(y);
        if (typeof A.key == "string") {
          const P = await this.enterPin(e, A.key, t, r);
          o(P);
        }
      }, n.onerror = u;
    });
  }
  async enterPin(e, t, r, n) {
    var m;
    await this.ti365Session.getConnector();
    const s = await this.ti365Session.cardService.getCard(_.SMC_KT), o = this.ti365Session.getHttpClient(ot.CARD_TERMINAL_SMB_C, s == null ? void 0 : s.iccsn, { ipAddress: (m = e.terminal.ipAddress) == null ? void 0 : m.ipv4Address });
    o.debugEnabled = Pr.debugTerminalLogin;
    const u = await o.webSocket("/", ["cobra-smcb"]);
    return new wo(u, t).enterPin(r, n);
  }
}
class Bc {
  constructor(e) {
    const t = e.indexOf(","), r = e.substring(0, t);
    this.isKasReady = r.endsWith("+"), this.version = parseFloat(r.replace("+", "")), this.mail = e.substring(t + 1);
  }
}
class Tf {
  constructor(e) {
    this.mail = [], this.userCertificate = [], this.professionOID = [], this.specialization = [], this.displayName = e.displayName || e.sn || e.cn, this.dn = e.dn, this.telematikID = e.telematikID, this.changeDateTime = new Date(e.changeDateTime), this.personalEntry = e.personalEntry == "TRUE", Array.isArray(e.komLeData) ? e.komLeData.forEach((t) => this.mail.push(new Bc(t))) : typeof e.komLeData == "string" && this.mail.push(new Bc(e.komLeData)), Array.isArray(e.userCertificate) ? e.userCertificate.forEach((t) => this.userCertificate.push(t)) : this.userCertificate.push(e.userCertificate), Array.isArray(e.professionOID) ? e.professionOID.forEach((t) => this.professionOID.push(t)) : e.professionOID && this.professionOID.push(e.professionOID), Array.isArray(e.specialization) ? e.specialization.forEach((t) => this.specialization.push(t)) : e.specialization && this.specialization.push(e.specialization), this.state = e.st, this.city = e.l, this.street = e.street, this.postcode = e.postalCode, this.organization = e.organization;
  }
  containsMailAddress(e) {
    e = e.toLocaleLowerCase();
    for (const t of this.mail)
      if (t.mail.toLocaleLowerCase() === e)
        return !0;
    return !1;
  }
  getCertificates() {
    return this.userCertificate.map((e) => new no({ schema: ro(e).result }));
  }
  getCertificate(e = 0) {
    return new no({ schema: ro(this.userCertificate[e]).result });
  }
}
class Nf {
}
class qw extends Nf {
  constructor() {
    super(...arguments), this.combinationMode = "AND";
  }
}
class xu {
  constructor(e) {
    this.ti365Session = e, this.cache = [];
  }
  async search(e, t) {
    const r = this.createLdapQuery(e, t);
    return r ? this.searchRaw(r) : [];
  }
  async searchWithLdapQuery(e, t) {
    return await this.searchRaw(e, t);
  }
  async searchRaw(e, t) {
    const r = await this.ti365Session.getLdapClient();
    await r.connect();
    const n = await r.search("", e, { sizeLimit: (t == null ? void 0 : t.maxEntries) ?? 100, timeLimit: (t == null ? void 0 : t.timeoutInSeconds) ?? 3, attributes: t == null ? void 0 : t.attributes });
    r.closeConnection();
    const s = n.searchEntries.map((o) => this.mapToVzdEntry(o));
    return s.forEach((o) => this.addToCache(o)), s;
  }
  mapToVzdEntry(e) {
    const t = e.toObject();
    return new Tf(t);
  }
  addToCache(e) {
    this.cache.push(e), this.cache.length > 100 && this.cache.shift();
  }
  // KOM-LE-A_2026 Cachen von Verschlüsselungszertifikaten
  // A_22340 Cachen vom KOM-LE-Versionen
  findInCache(e) {
    e = e.toLocaleLowerCase();
    for (let t = this.cache.length - 1; t >= 0; t--) {
      const r = this.cache[t];
      if (r.containsMailAddress(e))
        return r;
    }
  }
  async fetchByMail(e, t = !1) {
    let r = t ? void 0 : this.findInCache(e);
    if (r)
      return console.debug(`Vzd: Entry ${e} found in cache`, r), r;
    {
      const n = await this.search({ mail: e });
      if (n.length > 0)
        return console.debug(`Vzd: Entry ${e} fetched from Ldap`, n[0]), n[0];
    }
    console.debug(`Vzd: Entry ${e} not found`);
  }
  async fetchByMails(e) {
    const t = [];
    for (const n of e)
      t.push(this.fetchByMail(n));
    return (await Promise.all(t)).filter((n) => n !== void 0);
  }
  createLdapQuery(e, t) {
    let r = "", n = 0;
    for (const s in e)
      if (Object.prototype.hasOwnProperty.call(e, s)) {
        const o = e[s];
        o && (s === "profession" ? r += `(professionOID=${o.oid})` : r += `(${s}=${o.toString().trim()})`, n++);
      }
    if (n !== 0)
      return n > 1 && ((t == null ? void 0 : t.combinationMode) === "OR" ? r = "|" + r : r = "&" + r), r;
  }
}
var H;
(function(i) {
  i[i.Sequence = 0] = "Sequence", i[i.Set = 1] = "Set", i[i.Choice = 2] = "Choice";
})(H || (H = {}));
var I;
(function(i) {
  i[i.Any = 1] = "Any", i[i.Boolean = 2] = "Boolean", i[i.OctetString = 3] = "OctetString", i[i.BitString = 4] = "BitString", i[i.Integer = 5] = "Integer", i[i.Enumerated = 6] = "Enumerated", i[i.ObjectIdentifier = 7] = "ObjectIdentifier", i[i.Utf8String = 8] = "Utf8String", i[i.BmpString = 9] = "BmpString", i[i.UniversalString = 10] = "UniversalString", i[i.NumericString = 11] = "NumericString", i[i.PrintableString = 12] = "PrintableString", i[i.TeletexString = 13] = "TeletexString", i[i.VideotexString = 14] = "VideotexString", i[i.IA5String = 15] = "IA5String", i[i.GraphicString = 16] = "GraphicString", i[i.VisibleString = 17] = "VisibleString", i[i.GeneralString = 18] = "GeneralString", i[i.CharacterString = 19] = "CharacterString", i[i.UTCTime = 20] = "UTCTime", i[i.GeneralizedTime = 21] = "GeneralizedTime", i[i.DATE = 22] = "DATE", i[i.TimeOfDay = 23] = "TimeOfDay", i[i.DateTime = 24] = "DateTime", i[i.Duration = 25] = "Duration", i[i.TIME = 26] = "TIME", i[i.Null = 27] = "Null";
})(I || (I = {}));
/*!
 * MIT License
 * 
 * Copyright (c) 2017-2022 Peculiar Ventures, LLC
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 * 
 */
const xf = "[object ArrayBuffer]";
class De {
  static isArrayBuffer(e) {
    return Object.prototype.toString.call(e) === xf;
  }
  static toArrayBuffer(e) {
    return this.isArrayBuffer(e) ? e : e.byteLength === e.buffer.byteLength || e.byteOffset === 0 && e.byteLength === e.buffer.byteLength ? e.buffer : this.toUint8Array(e.buffer).slice(e.byteOffset, e.byteOffset + e.byteLength).buffer;
  }
  static toUint8Array(e) {
    return this.toView(e, Uint8Array);
  }
  static toView(e, t) {
    if (e.constructor === t)
      return e;
    if (this.isArrayBuffer(e))
      return new t(e);
    if (this.isArrayBufferView(e))
      return new t(e.buffer, e.byteOffset, e.byteLength);
    throw new TypeError("The provided value is not of type '(ArrayBuffer or ArrayBufferView)'");
  }
  static isBufferSource(e) {
    return this.isArrayBufferView(e) || this.isArrayBuffer(e);
  }
  static isArrayBufferView(e) {
    return ArrayBuffer.isView(e) || e && this.isArrayBuffer(e.buffer);
  }
  static isEqual(e, t) {
    const r = De.toUint8Array(e), n = De.toUint8Array(t);
    if (r.length !== n.byteLength)
      return !1;
    for (let s = 0; s < r.length; s++)
      if (r[s] !== n[s])
        return !1;
    return !0;
  }
  static concat(...e) {
    let t;
    Array.isArray(e[0]) && !(e[1] instanceof Function) || Array.isArray(e[0]) && e[1] instanceof Function ? t = e[0] : e[e.length - 1] instanceof Function ? t = e.slice(0, e.length - 1) : t = e;
    let r = 0;
    for (const o of t)
      r += o.byteLength;
    const n = new Uint8Array(r);
    let s = 0;
    for (const o of t) {
      const u = this.toUint8Array(o);
      n.set(u, s), s += u.length;
    }
    return e[e.length - 1] instanceof Function ? this.toView(n, e[e.length - 1]) : n.buffer;
  }
}
const eo = "string", Vf = /^[0-9a-f]+$/i, Uf = /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/, Lf = /^[a-zA-Z0-9-_]+$/;
class Mc {
  static fromString(e) {
    const t = unescape(encodeURIComponent(e)), r = new Uint8Array(t.length);
    for (let n = 0; n < t.length; n++)
      r[n] = t.charCodeAt(n);
    return r.buffer;
  }
  static toString(e) {
    const t = De.toUint8Array(e);
    let r = "";
    for (let s = 0; s < t.length; s++)
      r += String.fromCharCode(t[s]);
    return decodeURIComponent(escape(r));
  }
}
class Xe {
  static toString(e, t = !1) {
    const r = De.toArrayBuffer(e), n = new DataView(r);
    let s = "";
    for (let o = 0; o < r.byteLength; o += 2) {
      const u = n.getUint16(o, t);
      s += String.fromCharCode(u);
    }
    return s;
  }
  static fromString(e, t = !1) {
    const r = new ArrayBuffer(e.length * 2), n = new DataView(r);
    for (let s = 0; s < e.length; s++)
      n.setUint16(s * 2, e.charCodeAt(s), t);
    return r;
  }
}
class yt {
  static isHex(e) {
    return typeof e === eo && Vf.test(e);
  }
  static isBase64(e) {
    return typeof e === eo && Uf.test(e);
  }
  static isBase64Url(e) {
    return typeof e === eo && Lf.test(e);
  }
  static ToString(e, t = "utf8") {
    const r = De.toUint8Array(e);
    switch (t.toLowerCase()) {
      case "utf8":
        return this.ToUtf8String(r);
      case "binary":
        return this.ToBinary(r);
      case "hex":
        return this.ToHex(r);
      case "base64":
        return this.ToBase64(r);
      case "base64url":
        return this.ToBase64Url(r);
      case "utf16le":
        return Xe.toString(r, !0);
      case "utf16":
      case "utf16be":
        return Xe.toString(r);
      default:
        throw new Error(`Unknown type of encoding '${t}'`);
    }
  }
  static FromString(e, t = "utf8") {
    if (!e)
      return new ArrayBuffer(0);
    switch (t.toLowerCase()) {
      case "utf8":
        return this.FromUtf8String(e);
      case "binary":
        return this.FromBinary(e);
      case "hex":
        return this.FromHex(e);
      case "base64":
        return this.FromBase64(e);
      case "base64url":
        return this.FromBase64Url(e);
      case "utf16le":
        return Xe.fromString(e, !0);
      case "utf16":
      case "utf16be":
        return Xe.fromString(e);
      default:
        throw new Error(`Unknown type of encoding '${t}'`);
    }
  }
  static ToBase64(e) {
    const t = De.toUint8Array(e);
    if (typeof btoa < "u") {
      const r = this.ToString(t, "binary");
      return btoa(r);
    } else
      return Buffer.from(t).toString("base64");
  }
  static FromBase64(e) {
    const t = this.formatString(e);
    if (!t)
      return new ArrayBuffer(0);
    if (!yt.isBase64(t))
      throw new TypeError("Argument 'base64Text' is not Base64 encoded");
    return typeof atob < "u" ? this.FromBinary(atob(t)) : new Uint8Array(Buffer.from(t, "base64")).buffer;
  }
  static FromBase64Url(e) {
    const t = this.formatString(e);
    if (!t)
      return new ArrayBuffer(0);
    if (!yt.isBase64Url(t))
      throw new TypeError("Argument 'base64url' is not Base64Url encoded");
    return this.FromBase64(this.Base64Padding(t.replace(/\-/g, "+").replace(/\_/g, "/")));
  }
  static ToBase64Url(e) {
    return this.ToBase64(e).replace(/\+/g, "-").replace(/\//g, "_").replace(/\=/g, "");
  }
  static FromUtf8String(e, t = yt.DEFAULT_UTF8_ENCODING) {
    switch (t) {
      case "ascii":
        return this.FromBinary(e);
      case "utf8":
        return Mc.fromString(e);
      case "utf16":
      case "utf16be":
        return Xe.fromString(e);
      case "utf16le":
      case "usc2":
        return Xe.fromString(e, !0);
      default:
        throw new Error(`Unknown type of encoding '${t}'`);
    }
  }
  static ToUtf8String(e, t = yt.DEFAULT_UTF8_ENCODING) {
    switch (t) {
      case "ascii":
        return this.ToBinary(e);
      case "utf8":
        return Mc.toString(e);
      case "utf16":
      case "utf16be":
        return Xe.toString(e);
      case "utf16le":
      case "usc2":
        return Xe.toString(e, !0);
      default:
        throw new Error(`Unknown type of encoding '${t}'`);
    }
  }
  static FromBinary(e) {
    const t = e.length, r = new Uint8Array(t);
    for (let n = 0; n < t; n++)
      r[n] = e.charCodeAt(n);
    return r.buffer;
  }
  static ToBinary(e) {
    const t = De.toUint8Array(e);
    let r = "";
    for (let n = 0; n < t.length; n++)
      r += String.fromCharCode(t[n]);
    return r;
  }
  static ToHex(e) {
    const t = De.toUint8Array(e);
    let r = "";
    const n = t.length;
    for (let s = 0; s < n; s++) {
      const o = t[s];
      o < 16 && (r += "0"), r += o.toString(16);
    }
    return r;
  }
  static FromHex(e) {
    let t = this.formatString(e);
    if (!t)
      return new ArrayBuffer(0);
    if (!yt.isHex(t))
      throw new TypeError("Argument 'hexString' is not HEX encoded");
    t.length % 2 && (t = `0${t}`);
    const r = new Uint8Array(t.length / 2);
    for (let n = 0; n < t.length; n = n + 2) {
      const s = t.slice(n, n + 2);
      r[n / 2] = parseInt(s, 16);
    }
    return r.buffer;
  }
  static ToUtf16String(e, t = !1) {
    return Xe.toString(e, t);
  }
  static FromUtf16String(e, t = !1) {
    return Xe.fromString(e, t);
  }
  static Base64Padding(e) {
    const t = 4 - e.length % 4;
    if (t < 4)
      for (let r = 0; r < t; r++)
        e += "=";
    return e;
  }
  static formatString(e) {
    return (e == null ? void 0 : e.replace(/[\n\r\t ]/g, "")) || "";
  }
}
yt.DEFAULT_UTF8_ENCODING = "utf8";
function Ff(i, e) {
  if (!(i && e) || i.byteLength !== e.byteLength)
    return !1;
  const t = new Uint8Array(i), r = new Uint8Array(e);
  for (let n = 0; n < i.byteLength; n++)
    if (t[n] !== r[n])
      return !1;
  return !0;
}
class Vu {
  constructor(e, t = 0) {
    if (this.unusedBits = 0, this.value = new ArrayBuffer(0), e)
      if (typeof e == "number")
        this.fromNumber(e);
      else if (De.isBufferSource(e))
        this.unusedBits = t, this.value = De.toArrayBuffer(e);
      else
        throw TypeError("Unsupported type of 'params' argument for BitString");
  }
  fromASN(e) {
    if (!(e instanceof N.BitString))
      throw new TypeError("Argument 'asn' is not instance of ASN.1 BitString");
    return this.unusedBits = e.valueBlock.unusedBits, this.value = e.valueBlock.valueHex, this;
  }
  toASN() {
    return new N.BitString({ unusedBits: this.unusedBits, valueHex: this.value });
  }
  toSchema(e) {
    return new N.BitString({ name: e });
  }
  toNumber() {
    let e = "";
    const t = new Uint8Array(this.value);
    for (const r of t)
      e += r.toString(2).padStart(8, "0");
    return e = e.split("").reverse().join(""), this.unusedBits && (e = e.slice(this.unusedBits).padStart(this.unusedBits, "0")), parseInt(e, 2);
  }
  fromNumber(e) {
    let t = e.toString(2);
    const r = t.length + 7 >> 3;
    this.unusedBits = (r << 3) - t.length;
    const n = new Uint8Array(r);
    t = t.padStart(r << 3, "0").split("").reverse().join("");
    let s = 0;
    for (; s < r; )
      n[s] = parseInt(t.slice(s << 3, (s << 3) + 8), 2), s++;
    this.value = n.buffer;
  }
}
class Ha {
  get byteLength() {
    return this.buffer.byteLength;
  }
  get byteOffset() {
    return 0;
  }
  constructor(e) {
    typeof e == "number" ? this.buffer = new ArrayBuffer(e) : De.isBufferSource(e) ? this.buffer = De.toArrayBuffer(e) : Array.isArray(e) ? this.buffer = new Uint8Array(e) : this.buffer = new ArrayBuffer(0);
  }
  fromASN(e) {
    if (!(e instanceof N.OctetString))
      throw new TypeError("Argument 'asn' is not instance of ASN.1 OctetString");
    return this.buffer = e.valueBlock.valueHex, this;
  }
  toASN() {
    return new N.OctetString({ valueHex: this.buffer });
  }
  toSchema(e) {
    return new N.OctetString({ name: e });
  }
}
const Gf = {
  fromASN: (i) => i instanceof N.Null ? null : i.valueBeforeDecodeView,
  toASN: (i) => {
    if (i === null)
      return new N.Null();
    const e = N.fromBER(i);
    if (e.result.error)
      throw new Error(e.result.error);
    return e.result;
  }
}, Qf = {
  fromASN: (i) => i.valueBlock.valueHexView.byteLength >= 4 ? i.valueBlock.toString() : i.valueBlock.valueDec,
  toASN: (i) => new N.Integer({ value: +i })
}, jf = {
  fromASN: (i) => i.valueBlock.valueDec,
  toASN: (i) => new N.Enumerated({ value: i })
}, An = {
  fromASN: (i) => i.valueBlock.valueHexView,
  toASN: (i) => new N.Integer({ valueHex: i })
}, Hf = {
  fromASN: (i) => i.valueBlock.valueHexView,
  toASN: (i) => new N.BitString({ valueHex: i })
}, Kf = {
  fromASN: (i) => i.valueBlock.toString(),
  toASN: (i) => new N.ObjectIdentifier({ value: i })
}, kf = {
  fromASN: (i) => i.valueBlock.value,
  toASN: (i) => new N.Boolean({ value: i })
}, yo = {
  fromASN: (i) => i.valueBlock.valueHexView,
  toASN: (i) => new N.OctetString({ valueHex: i })
};
function Fe(i) {
  return {
    fromASN: (e) => e.valueBlock.value,
    toASN: (e) => new i({ value: e })
  };
}
const zf = Fe(N.Utf8String), Wf = Fe(N.BmpString), Zf = Fe(N.UniversalString), Yf = Fe(N.NumericString), $f = Fe(N.PrintableString), qf = Fe(N.TeletexString), Xf = Fe(N.VideotexString), _f = Fe(N.IA5String), Jf = Fe(N.GraphicString), em = Fe(N.VisibleString), tm = Fe(N.GeneralString), rm = Fe(N.CharacterString), nm = {
  fromASN: (i) => i.toDate(),
  toASN: (i) => new N.UTCTime({ valueDate: i })
}, sm = {
  fromASN: (i) => i.toDate(),
  toASN: (i) => new N.GeneralizedTime({ valueDate: i })
}, im = {
  fromASN: () => null,
  toASN: () => new N.Null()
};
function Uu(i) {
  switch (i) {
    case I.Any:
      return Gf;
    case I.BitString:
      return Hf;
    case I.BmpString:
      return Wf;
    case I.Boolean:
      return kf;
    case I.CharacterString:
      return rm;
    case I.Enumerated:
      return jf;
    case I.GeneralString:
      return tm;
    case I.GeneralizedTime:
      return sm;
    case I.GraphicString:
      return Jf;
    case I.IA5String:
      return _f;
    case I.Integer:
      return Qf;
    case I.Null:
      return im;
    case I.NumericString:
      return Yf;
    case I.ObjectIdentifier:
      return Kf;
    case I.OctetString:
      return yo;
    case I.PrintableString:
      return $f;
    case I.TeletexString:
      return qf;
    case I.UTCTime:
      return nm;
    case I.UniversalString:
      return Zf;
    case I.Utf8String:
      return zf;
    case I.VideotexString:
      return Xf;
    case I.VisibleString:
      return em;
    default:
      return null;
  }
}
function tr(i) {
  return typeof i == "function" && i.prototype ? i.prototype.toASN && i.prototype.fromASN ? !0 : tr(i.prototype) : !!(i && typeof i == "object" && "toASN" in i && "fromASN" in i);
}
function Lu(i) {
  var e;
  if (i) {
    const t = Object.getPrototypeOf(i);
    return ((e = t == null ? void 0 : t.prototype) === null || e === void 0 ? void 0 : e.constructor) === Array ? !0 : Lu(t);
  }
  return !1;
}
class om {
  constructor() {
    this.items = /* @__PURE__ */ new WeakMap();
  }
  has(e) {
    return this.items.has(e);
  }
  get(e, t = !1) {
    const r = this.items.get(e);
    if (!r)
      throw new Error(`Cannot get schema for '${e.prototype.constructor.name}' target`);
    if (t && !r.schema)
      throw new Error(`Schema '${e.prototype.constructor.name}' doesn't contain ASN.1 schema. Call 'AsnSchemaStorage.cache'.`);
    return r;
  }
  cache(e) {
    const t = this.get(e);
    t.schema || (t.schema = this.create(e, !0));
  }
  createDefault(e) {
    const t = {
      type: H.Sequence,
      items: {}
    }, r = this.findParentSchema(e);
    return r && (Object.assign(t, r), t.items = Object.assign({}, t.items, r.items)), t;
  }
  create(e, t) {
    const r = this.items.get(e) || this.createDefault(e), n = [];
    for (const s in r.items) {
      const o = r.items[s], u = t ? s : "";
      let l;
      if (typeof o.type == "number") {
        const y = I[o.type], A = N[y];
        if (!A)
          throw new Error(`Cannot get ASN1 class by name '${y}'`);
        l = new A({ name: u });
      } else
        tr(o.type) ? l = new o.type().toSchema(u) : o.optional ? this.get(o.type).type === H.Choice ? l = new N.Any({ name: u }) : (l = this.create(o.type, !1), l.name = u) : l = new N.Any({ name: u });
      const m = !!o.optional || o.defaultValue !== void 0;
      if (o.repeated) {
        l.name = "";
        const y = o.repeated === "set" ? N.Set : N.Sequence;
        l = new y({
          name: "",
          value: [
            new N.Repeated({
              name: u,
              value: l
            })
          ]
        });
      }
      if (o.context !== null && o.context !== void 0)
        if (o.implicit)
          if (typeof o.type == "number" || tr(o.type)) {
            const y = o.repeated ? N.Constructed : N.Primitive;
            n.push(new y({
              name: u,
              optional: m,
              idBlock: {
                tagClass: 3,
                tagNumber: o.context
              }
            }));
          } else {
            this.cache(o.type);
            const y = !!o.repeated;
            let A = y ? l : this.get(o.type, !0).schema;
            A = "valueBlock" in A ? A.valueBlock.value : A.value, n.push(new N.Constructed({
              name: y ? "" : u,
              optional: m,
              idBlock: {
                tagClass: 3,
                tagNumber: o.context
              },
              value: A
            }));
          }
        else
          n.push(new N.Constructed({
            optional: m,
            idBlock: {
              tagClass: 3,
              tagNumber: o.context
            },
            value: [l]
          }));
      else
        l.optional = m, n.push(l);
    }
    switch (r.type) {
      case H.Sequence:
        return new N.Sequence({ value: n, name: "" });
      case H.Set:
        return new N.Set({ value: n, name: "" });
      case H.Choice:
        return new N.Choice({ value: n, name: "" });
      default:
        throw new Error("Unsupported ASN1 type in use");
    }
  }
  set(e, t) {
    return this.items.set(e, t), this;
  }
  findParentSchema(e) {
    const t = Object.getPrototypeOf(e);
    return t ? this.items.get(t) || this.findParentSchema(t) : null;
  }
}
const tt = new om(), Z = (i) => (e) => {
  let t;
  tt.has(e) ? t = tt.get(e) : (t = tt.createDefault(e), tt.set(e, t)), Object.assign(t, i);
}, E = (i) => (e, t) => {
  let r;
  tt.has(e.constructor) ? r = tt.get(e.constructor) : (r = tt.createDefault(e.constructor), tt.set(e.constructor, r));
  const n = Object.assign({}, i);
  if (typeof n.type == "number" && !n.converter) {
    const s = Uu(i.type);
    if (!s)
      throw new Error(`Cannot get default converter for property '${t}' of ${e.constructor.name}`);
    n.converter = s;
  }
  r.items[t] = n;
};
class Pc extends Error {
  constructor() {
    super(...arguments), this.schemas = [];
  }
}
class Rc {
  static parse(e, t) {
    const r = N.fromBER(e);
    if (r.result.error)
      throw new Error(r.result.error);
    return this.fromASN(r.result, t);
  }
  static fromASN(e, t) {
    var r;
    try {
      if (tr(t))
        return new t().fromASN(e);
      const n = tt.get(t);
      tt.cache(t);
      let s = n.schema;
      if (e.constructor === N.Constructed && n.type !== H.Choice) {
        s = new N.Constructed({
          idBlock: {
            tagClass: 3,
            tagNumber: e.idBlock.tagNumber
          },
          value: n.schema.valueBlock.value
        });
        for (const l in n.items)
          delete e[l];
      }
      const o = N.compareSchema({}, e, s);
      if (!o.verified)
        throw new Pc(`Data does not match to ${t.name} ASN1 schema. ${o.result.error}`);
      const u = new t();
      if (Lu(t)) {
        if (!("value" in e.valueBlock && Array.isArray(e.valueBlock.value)))
          throw new Error("Cannot get items from the ASN.1 parsed value. ASN.1 object is not constructed.");
        const l = n.itemType;
        if (typeof l == "number") {
          const m = Uu(l);
          if (!m)
            throw new Error(`Cannot get default converter for array item of ${t.name} ASN1 schema`);
          return t.from(e.valueBlock.value, (y) => m.fromASN(y));
        } else
          return t.from(e.valueBlock.value, (m) => this.fromASN(m, l));
      }
      for (const l in n.items) {
        const m = o.result[l];
        if (!m)
          continue;
        const y = n.items[l], A = y.type;
        if (typeof A == "number" || tr(A)) {
          const P = (r = y.converter) !== null && r !== void 0 ? r : tr(A) ? new A() : null;
          if (!P)
            throw new Error("Converter is empty");
          if (y.repeated)
            if (y.implicit) {
              const M = y.repeated === "sequence" ? N.Sequence : N.Set, p = new M();
              p.valueBlock = m.valueBlock;
              const w = N.fromBER(p.toBER(!1));
              if (w.offset === -1)
                throw new Error(`Cannot parse the child item. ${w.result.error}`);
              if (!("value" in w.result.valueBlock && Array.isArray(w.result.valueBlock.value)))
                throw new Error("Cannot get items from the ASN.1 parsed value. ASN.1 object is not constructed.");
              const C = w.result.valueBlock.value;
              u[l] = Array.from(C, (D) => P.fromASN(D));
            } else
              u[l] = Array.from(m, (M) => P.fromASN(M));
          else {
            let M = m;
            if (y.implicit) {
              let p;
              if (tr(A))
                p = new A().toSchema("");
              else {
                const w = I[A], C = N[w];
                if (!C)
                  throw new Error(`Cannot get '${w}' class from asn1js module`);
                p = new C();
              }
              p.valueBlock = M.valueBlock, M = N.fromBER(p.toBER(!1)).result;
            }
            u[l] = P.fromASN(M);
          }
        } else if (y.repeated) {
          if (!Array.isArray(m))
            throw new Error("Cannot get list of items from the ASN.1 parsed value. ASN.1 value should be iterable.");
          u[l] = Array.from(m, (P) => this.fromASN(P, A));
        } else
          u[l] = this.fromASN(m, A);
      }
      return u;
    } catch (n) {
      throw n instanceof Pc && n.schemas.push(t.name), n;
    }
  }
}
class Ge extends Array {
  constructor(e = []) {
    if (typeof e == "number")
      super(e);
    else {
      super();
      for (const t of e)
        this.push(t);
    }
  }
}
function S(i, e, t, r) {
  var n = arguments.length, s = n < 3 ? e : r === null ? r = Object.getOwnPropertyDescriptor(e, t) : r, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    s = Reflect.decorate(i, e, t, r);
  else
    for (var u = i.length - 1; u >= 0; u--)
      (o = i[u]) && (s = (n < 3 ? o(s) : n > 3 ? o(e, t, s) : o(e, t)) || s);
  return n > 3 && s && Object.defineProperty(e, t, s), s;
}
var am = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, Fu = { exports: {} };
(function(i) {
  (function(e) {
    const t = "(0?\\d+|0x[a-f0-9]+)", r = {
      fourOctet: new RegExp(`^${t}\\.${t}\\.${t}\\.${t}$`, "i"),
      threeOctet: new RegExp(`^${t}\\.${t}\\.${t}$`, "i"),
      twoOctet: new RegExp(`^${t}\\.${t}$`, "i"),
      longValue: new RegExp(`^${t}$`, "i")
    }, n = new RegExp("^0[0-7]+$", "i"), s = new RegExp("^0x[a-f0-9]+$", "i"), o = "%[0-9a-z]{1,}", u = "(?:[0-9a-f]+::?)+", l = {
      zoneIndex: new RegExp(o, "i"),
      native: new RegExp(`^(::)?(${u})?([0-9a-f]+)?(::)?(${o})?$`, "i"),
      deprecatedTransitional: new RegExp(`^(?:::)(${t}\\.${t}\\.${t}\\.${t}(${o})?)$`, "i"),
      transitional: new RegExp(`^((?:${u})|(?:::)(?:${u})?)${t}\\.${t}\\.${t}\\.${t}(${o})?$`, "i")
    };
    function m(p, w) {
      if (p.indexOf("::") !== p.lastIndexOf("::"))
        return null;
      let C = 0, D = -1, R = (p.match(l.zoneIndex) || [])[0], O, F;
      for (R && (R = R.substring(1), p = p.replace(/%.+$/, "")); (D = p.indexOf(":", D + 1)) >= 0; )
        C++;
      if (p.substr(0, 2) === "::" && C--, p.substr(-2, 2) === "::" && C--, C > w)
        return null;
      for (F = w - C, O = ":"; F--; )
        O += "0:";
      return p = p.replace("::", O), p[0] === ":" && (p = p.slice(1)), p[p.length - 1] === ":" && (p = p.slice(0, -1)), w = function() {
        const Y = p.split(":"), ae = [];
        for (let dt = 0; dt < Y.length; dt++)
          ae.push(parseInt(Y[dt], 16));
        return ae;
      }(), {
        parts: w,
        zoneId: R
      };
    }
    function y(p, w, C, D) {
      if (p.length !== w.length)
        throw new Error("ipaddr: cannot match CIDR for objects with different lengths");
      let R = 0, O;
      for (; D > 0; ) {
        if (O = C - D, O < 0 && (O = 0), p[R] >> O !== w[R] >> O)
          return !1;
        D -= C, R += 1;
      }
      return !0;
    }
    function A(p) {
      if (s.test(p))
        return parseInt(p, 16);
      if (p[0] === "0" && !isNaN(parseInt(p[1], 10))) {
        if (n.test(p))
          return parseInt(p, 8);
        throw new Error(`ipaddr: cannot parse ${p} as octal`);
      }
      return parseInt(p, 10);
    }
    function P(p, w) {
      for (; p.length < w; )
        p = `0${p}`;
      return p;
    }
    const M = {};
    M.IPv4 = function() {
      function p(w) {
        if (w.length !== 4)
          throw new Error("ipaddr: ipv4 octet count should be 4");
        let C, D;
        for (C = 0; C < w.length; C++)
          if (D = w[C], !(0 <= D && D <= 255))
            throw new Error("ipaddr: ipv4 octet should fit in 8 bits");
        this.octets = w;
      }
      return p.prototype.SpecialRanges = {
        unspecified: [[new p([0, 0, 0, 0]), 8]],
        broadcast: [[new p([255, 255, 255, 255]), 32]],
        // RFC3171
        multicast: [[new p([224, 0, 0, 0]), 4]],
        // RFC3927
        linkLocal: [[new p([169, 254, 0, 0]), 16]],
        // RFC5735
        loopback: [[new p([127, 0, 0, 0]), 8]],
        // RFC6598
        carrierGradeNat: [[new p([100, 64, 0, 0]), 10]],
        // RFC1918
        private: [
          [new p([10, 0, 0, 0]), 8],
          [new p([172, 16, 0, 0]), 12],
          [new p([192, 168, 0, 0]), 16]
        ],
        // Reserved and testing-only ranges; RFCs 5735, 5737, 2544, 1700
        reserved: [
          [new p([192, 0, 0, 0]), 24],
          [new p([192, 0, 2, 0]), 24],
          [new p([192, 88, 99, 0]), 24],
          [new p([198, 18, 0, 0]), 15],
          [new p([198, 51, 100, 0]), 24],
          [new p([203, 0, 113, 0]), 24],
          [new p([240, 0, 0, 0]), 4]
        ]
      }, p.prototype.kind = function() {
        return "ipv4";
      }, p.prototype.match = function(w, C) {
        let D;
        if (C === void 0 && (D = w, w = D[0], C = D[1]), w.kind() !== "ipv4")
          throw new Error("ipaddr: cannot match ipv4 address with non-ipv4 one");
        return y(this.octets, w.octets, 8, C);
      }, p.prototype.prefixLengthFromSubnetMask = function() {
        let w = 0, C = !1;
        const D = {
          0: 8,
          128: 7,
          192: 6,
          224: 5,
          240: 4,
          248: 3,
          252: 2,
          254: 1,
          255: 0
        };
        let R, O, F;
        for (R = 3; R >= 0; R -= 1)
          if (O = this.octets[R], O in D) {
            if (F = D[O], C && F !== 0)
              return null;
            F !== 8 && (C = !0), w += F;
          } else
            return null;
        return 32 - w;
      }, p.prototype.range = function() {
        return M.subnetMatch(this, this.SpecialRanges);
      }, p.prototype.toByteArray = function() {
        return this.octets.slice(0);
      }, p.prototype.toIPv4MappedAddress = function() {
        return M.IPv6.parse(`::ffff:${this.toString()}`);
      }, p.prototype.toNormalizedString = function() {
        return this.toString();
      }, p.prototype.toString = function() {
        return this.octets.join(".");
      }, p;
    }(), M.IPv4.broadcastAddressFromCIDR = function(p) {
      try {
        const w = this.parseCIDR(p), C = w[0].toByteArray(), D = this.subnetMaskFromPrefixLength(w[1]).toByteArray(), R = [];
        let O = 0;
        for (; O < 4; )
          R.push(parseInt(C[O], 10) | parseInt(D[O], 10) ^ 255), O++;
        return new this(R);
      } catch {
        throw new Error("ipaddr: the address does not have IPv4 CIDR format");
      }
    }, M.IPv4.isIPv4 = function(p) {
      return this.parser(p) !== null;
    }, M.IPv4.isValid = function(p) {
      try {
        return new this(this.parser(p)), !0;
      } catch {
        return !1;
      }
    }, M.IPv4.isValidFourPartDecimal = function(p) {
      return !!(M.IPv4.isValid(p) && p.match(/^(0|[1-9]\d*)(\.(0|[1-9]\d*)){3}$/));
    }, M.IPv4.networkAddressFromCIDR = function(p) {
      let w, C, D, R, O;
      try {
        for (w = this.parseCIDR(p), D = w[0].toByteArray(), O = this.subnetMaskFromPrefixLength(w[1]).toByteArray(), R = [], C = 0; C < 4; )
          R.push(parseInt(D[C], 10) & parseInt(O[C], 10)), C++;
        return new this(R);
      } catch {
        throw new Error("ipaddr: the address does not have IPv4 CIDR format");
      }
    }, M.IPv4.parse = function(p) {
      const w = this.parser(p);
      if (w === null)
        throw new Error("ipaddr: string is not formatted like an IPv4 Address");
      return new this(w);
    }, M.IPv4.parseCIDR = function(p) {
      let w;
      if (w = p.match(/^(.+)\/(\d+)$/)) {
        const C = parseInt(w[2]);
        if (C >= 0 && C <= 32) {
          const D = [this.parse(w[1]), C];
          return Object.defineProperty(D, "toString", {
            value: function() {
              return this.join("/");
            }
          }), D;
        }
      }
      throw new Error("ipaddr: string is not formatted like an IPv4 CIDR range");
    }, M.IPv4.parser = function(p) {
      let w, C, D;
      if (w = p.match(r.fourOctet))
        return function() {
          const R = w.slice(1, 6), O = [];
          for (let F = 0; F < R.length; F++)
            C = R[F], O.push(A(C));
          return O;
        }();
      if (w = p.match(r.longValue)) {
        if (D = A(w[1]), D > 4294967295 || D < 0)
          throw new Error("ipaddr: address outside defined range");
        return function() {
          const R = [];
          let O;
          for (O = 0; O <= 24; O += 8)
            R.push(D >> O & 255);
          return R;
        }().reverse();
      } else
        return (w = p.match(r.twoOctet)) ? function() {
          const R = w.slice(1, 4), O = [];
          if (D = A(R[1]), D > 16777215 || D < 0)
            throw new Error("ipaddr: address outside defined range");
          return O.push(A(R[0])), O.push(D >> 16 & 255), O.push(D >> 8 & 255), O.push(D & 255), O;
        }() : (w = p.match(r.threeOctet)) ? function() {
          const R = w.slice(1, 5), O = [];
          if (D = A(R[2]), D > 65535 || D < 0)
            throw new Error("ipaddr: address outside defined range");
          return O.push(A(R[0])), O.push(A(R[1])), O.push(D >> 8 & 255), O.push(D & 255), O;
        }() : null;
    }, M.IPv4.subnetMaskFromPrefixLength = function(p) {
      if (p = parseInt(p), p < 0 || p > 32)
        throw new Error("ipaddr: invalid IPv4 prefix length");
      const w = [0, 0, 0, 0];
      let C = 0;
      const D = Math.floor(p / 8);
      for (; C < D; )
        w[C] = 255, C++;
      return D < 4 && (w[D] = Math.pow(2, p % 8) - 1 << 8 - p % 8), new this(w);
    }, M.IPv6 = function() {
      function p(w, C) {
        let D, R;
        if (w.length === 16)
          for (this.parts = [], D = 0; D <= 14; D += 2)
            this.parts.push(w[D] << 8 | w[D + 1]);
        else if (w.length === 8)
          this.parts = w;
        else
          throw new Error("ipaddr: ipv6 part count should be 8 or 16");
        for (D = 0; D < this.parts.length; D++)
          if (R = this.parts[D], !(0 <= R && R <= 65535))
            throw new Error("ipaddr: ipv6 part should fit in 16 bits");
        C && (this.zoneId = C);
      }
      return p.prototype.SpecialRanges = {
        // RFC4291, here and after
        unspecified: [new p([0, 0, 0, 0, 0, 0, 0, 0]), 128],
        linkLocal: [new p([65152, 0, 0, 0, 0, 0, 0, 0]), 10],
        multicast: [new p([65280, 0, 0, 0, 0, 0, 0, 0]), 8],
        loopback: [new p([0, 0, 0, 0, 0, 0, 0, 1]), 128],
        uniqueLocal: [new p([64512, 0, 0, 0, 0, 0, 0, 0]), 7],
        ipv4Mapped: [new p([0, 0, 0, 0, 0, 65535, 0, 0]), 96],
        // RFC6145
        rfc6145: [new p([0, 0, 0, 0, 65535, 0, 0, 0]), 96],
        // RFC6052
        rfc6052: [new p([100, 65435, 0, 0, 0, 0, 0, 0]), 96],
        // RFC3056
        "6to4": [new p([8194, 0, 0, 0, 0, 0, 0, 0]), 16],
        // RFC6052, RFC6146
        teredo: [new p([8193, 0, 0, 0, 0, 0, 0, 0]), 32],
        // RFC4291
        reserved: [[new p([8193, 3512, 0, 0, 0, 0, 0, 0]), 32]],
        benchmarking: [new p([8193, 2, 0, 0, 0, 0, 0, 0]), 48],
        amt: [new p([8193, 3, 0, 0, 0, 0, 0, 0]), 32],
        as112v6: [new p([8193, 4, 274, 0, 0, 0, 0, 0]), 48],
        deprecated: [new p([8193, 16, 0, 0, 0, 0, 0, 0]), 28],
        orchid2: [new p([8193, 32, 0, 0, 0, 0, 0, 0]), 28]
      }, p.prototype.isIPv4MappedAddress = function() {
        return this.range() === "ipv4Mapped";
      }, p.prototype.kind = function() {
        return "ipv6";
      }, p.prototype.match = function(w, C) {
        let D;
        if (C === void 0 && (D = w, w = D[0], C = D[1]), w.kind() !== "ipv6")
          throw new Error("ipaddr: cannot match ipv6 address with non-ipv6 one");
        return y(this.parts, w.parts, 16, C);
      }, p.prototype.prefixLengthFromSubnetMask = function() {
        let w = 0, C = !1;
        const D = {
          0: 16,
          32768: 15,
          49152: 14,
          57344: 13,
          61440: 12,
          63488: 11,
          64512: 10,
          65024: 9,
          65280: 8,
          65408: 7,
          65472: 6,
          65504: 5,
          65520: 4,
          65528: 3,
          65532: 2,
          65534: 1,
          65535: 0
        };
        let R, O;
        for (let F = 7; F >= 0; F -= 1)
          if (R = this.parts[F], R in D) {
            if (O = D[R], C && O !== 0)
              return null;
            O !== 16 && (C = !0), w += O;
          } else
            return null;
        return 128 - w;
      }, p.prototype.range = function() {
        return M.subnetMatch(this, this.SpecialRanges);
      }, p.prototype.toByteArray = function() {
        let w;
        const C = [], D = this.parts;
        for (let R = 0; R < D.length; R++)
          w = D[R], C.push(w >> 8), C.push(w & 255);
        return C;
      }, p.prototype.toFixedLengthString = function() {
        const w = (function() {
          const D = [];
          for (let R = 0; R < this.parts.length; R++)
            D.push(P(this.parts[R].toString(16), 4));
          return D;
        }).call(this).join(":");
        let C = "";
        return this.zoneId && (C = `%${this.zoneId}`), w + C;
      }, p.prototype.toIPv4Address = function() {
        if (!this.isIPv4MappedAddress())
          throw new Error("ipaddr: trying to convert a generic ipv6 address to ipv4");
        const w = this.parts.slice(-2), C = w[0], D = w[1];
        return new M.IPv4([C >> 8, C & 255, D >> 8, D & 255]);
      }, p.prototype.toNormalizedString = function() {
        const w = (function() {
          const D = [];
          for (let R = 0; R < this.parts.length; R++)
            D.push(this.parts[R].toString(16));
          return D;
        }).call(this).join(":");
        let C = "";
        return this.zoneId && (C = `%${this.zoneId}`), w + C;
      }, p.prototype.toRFC5952String = function() {
        const w = /((^|:)(0(:|$)){2,})/g, C = this.toNormalizedString();
        let D = 0, R = -1, O;
        for (; O = w.exec(C); )
          O[0].length > R && (D = O.index, R = O[0].length);
        return R < 0 ? C : `${C.substring(0, D)}::${C.substring(D + R)}`;
      }, p.prototype.toString = function() {
        return this.toRFC5952String();
      }, p;
    }(), M.IPv6.broadcastAddressFromCIDR = function(p) {
      try {
        const w = this.parseCIDR(p), C = w[0].toByteArray(), D = this.subnetMaskFromPrefixLength(w[1]).toByteArray(), R = [];
        let O = 0;
        for (; O < 16; )
          R.push(parseInt(C[O], 10) | parseInt(D[O], 10) ^ 255), O++;
        return new this(R);
      } catch (w) {
        throw new Error(`ipaddr: the address does not have IPv6 CIDR format (${w})`);
      }
    }, M.IPv6.isIPv6 = function(p) {
      return this.parser(p) !== null;
    }, M.IPv6.isValid = function(p) {
      if (typeof p == "string" && p.indexOf(":") === -1)
        return !1;
      try {
        const w = this.parser(p);
        return new this(w.parts, w.zoneId), !0;
      } catch {
        return !1;
      }
    }, M.IPv6.networkAddressFromCIDR = function(p) {
      let w, C, D, R, O;
      try {
        for (w = this.parseCIDR(p), D = w[0].toByteArray(), O = this.subnetMaskFromPrefixLength(w[1]).toByteArray(), R = [], C = 0; C < 16; )
          R.push(parseInt(D[C], 10) & parseInt(O[C], 10)), C++;
        return new this(R);
      } catch (F) {
        throw new Error(`ipaddr: the address does not have IPv6 CIDR format (${F})`);
      }
    }, M.IPv6.parse = function(p) {
      const w = this.parser(p);
      if (w.parts === null)
        throw new Error("ipaddr: string is not formatted like an IPv6 Address");
      return new this(w.parts, w.zoneId);
    }, M.IPv6.parseCIDR = function(p) {
      let w, C, D;
      if ((C = p.match(/^(.+)\/(\d+)$/)) && (w = parseInt(C[2]), w >= 0 && w <= 128))
        return D = [this.parse(C[1]), w], Object.defineProperty(D, "toString", {
          value: function() {
            return this.join("/");
          }
        }), D;
      throw new Error("ipaddr: string is not formatted like an IPv6 CIDR range");
    }, M.IPv6.parser = function(p) {
      let w, C, D, R, O, F;
      if (D = p.match(l.deprecatedTransitional))
        return this.parser(`::ffff:${D[1]}`);
      if (l.native.test(p))
        return m(p, 8);
      if ((D = p.match(l.transitional)) && (F = D[6] || "", w = m(D[1].slice(0, -1) + F, 6), w.parts)) {
        for (O = [
          parseInt(D[2]),
          parseInt(D[3]),
          parseInt(D[4]),
          parseInt(D[5])
        ], C = 0; C < O.length; C++)
          if (R = O[C], !(0 <= R && R <= 255))
            return null;
        return w.parts.push(O[0] << 8 | O[1]), w.parts.push(O[2] << 8 | O[3]), {
          parts: w.parts,
          zoneId: w.zoneId
        };
      }
      return null;
    }, M.IPv6.subnetMaskFromPrefixLength = function(p) {
      if (p = parseInt(p), p < 0 || p > 128)
        throw new Error("ipaddr: invalid IPv6 prefix length");
      const w = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
      let C = 0;
      const D = Math.floor(p / 8);
      for (; C < D; )
        w[C] = 255, C++;
      return D < 16 && (w[D] = Math.pow(2, p % 8) - 1 << 8 - p % 8), new this(w);
    }, M.fromByteArray = function(p) {
      const w = p.length;
      if (w === 4)
        return new M.IPv4(p);
      if (w === 16)
        return new M.IPv6(p);
      throw new Error("ipaddr: the binary input is neither an IPv6 nor IPv4 address");
    }, M.isValid = function(p) {
      return M.IPv6.isValid(p) || M.IPv4.isValid(p);
    }, M.parse = function(p) {
      if (M.IPv6.isValid(p))
        return M.IPv6.parse(p);
      if (M.IPv4.isValid(p))
        return M.IPv4.parse(p);
      throw new Error("ipaddr: the address has neither IPv6 nor IPv4 format");
    }, M.parseCIDR = function(p) {
      try {
        return M.IPv6.parseCIDR(p);
      } catch {
        try {
          return M.IPv4.parseCIDR(p);
        } catch {
          throw new Error("ipaddr: the address has neither IPv6 nor IPv4 CIDR format");
        }
      }
    }, M.process = function(p) {
      const w = this.parse(p);
      return w.kind() === "ipv6" && w.isIPv4MappedAddress() ? w.toIPv4Address() : w;
    }, M.subnetMatch = function(p, w, C) {
      let D, R, O, F;
      C == null && (C = "unicast");
      for (R in w)
        if (Object.prototype.hasOwnProperty.call(w, R)) {
          for (O = w[R], O[0] && !(O[0] instanceof Array) && (O = [O]), D = 0; D < O.length; D++)
            if (F = O[D], p.kind() === F[0].kind() && p.match.apply(p, F))
              return R;
        }
      return C;
    }, i.exports ? i.exports = M : e.ipaddr = M;
  })(am);
})(Fu);
var Oc = Fu.exports;
class Tc {
  static decodeIP(e) {
    if (e.length === 64 && parseInt(e, 16) === 0)
      return "::/0";
    if (e.length !== 16)
      return e;
    const t = parseInt(e.slice(8), 16).toString(2).split("").reduce((n, s) => n + +s, 0);
    let r = e.slice(0, 8).replace(/(.{2})/g, (n) => `${parseInt(n, 16)}.`);
    return r = r.slice(0, -1), `${r}/${t}`;
  }
  static toString(e) {
    if (e.byteLength === 4 || e.byteLength === 16) {
      const t = new Uint8Array(e);
      return Oc.fromByteArray(Array.from(t)).toString();
    }
    return this.decodeIP(yt.ToHex(e));
  }
  static fromString(e) {
    const t = Oc.parse(e);
    return new Uint8Array(t.toByteArray()).buffer;
  }
}
var Ao, So, vo;
let Ze = class {
  constructor(e = {}) {
    Object.assign(this, e);
  }
  toString() {
    return this.bmpString || this.printableString || this.teletexString || this.universalString || this.utf8String || "";
  }
};
S([
  E({ type: I.TeletexString })
], Ze.prototype, "teletexString", void 0);
S([
  E({ type: I.PrintableString })
], Ze.prototype, "printableString", void 0);
S([
  E({ type: I.UniversalString })
], Ze.prototype, "universalString", void 0);
S([
  E({ type: I.Utf8String })
], Ze.prototype, "utf8String", void 0);
S([
  E({ type: I.BmpString })
], Ze.prototype, "bmpString", void 0);
Ze = S([
  Z({ type: H.Choice })
], Ze);
let nn = class extends Ze {
  constructor(e = {}) {
    super(e), Object.assign(this, e);
  }
  toString() {
    return this.ia5String || (this.anyValue ? yt.ToHex(this.anyValue) : super.toString());
  }
};
S([
  E({ type: I.IA5String })
], nn.prototype, "ia5String", void 0);
S([
  E({ type: I.Any })
], nn.prototype, "anyValue", void 0);
nn = S([
  Z({ type: H.Choice })
], nn);
class Ka {
  constructor(e = {}) {
    this.type = "", this.value = new nn(), Object.assign(this, e);
  }
}
S([
  E({ type: I.ObjectIdentifier })
], Ka.prototype, "type", void 0);
S([
  E({ type: nn })
], Ka.prototype, "value", void 0);
let ti = Ao = class extends Ge {
  constructor(e) {
    super(e), Object.setPrototypeOf(this, Ao.prototype);
  }
};
ti = Ao = S([
  Z({ type: H.Set, itemType: Ka })
], ti);
let bo = So = class extends Ge {
  constructor(e) {
    super(e), Object.setPrototypeOf(this, So.prototype);
  }
};
bo = So = S([
  Z({ type: H.Sequence, itemType: ti })
], bo);
let Mt = vo = class extends bo {
  constructor(e) {
    super(e), Object.setPrototypeOf(this, vo.prototype);
  }
};
Mt = vo = S([
  Z({ type: H.Sequence })
], Mt);
const cm = {
  fromASN: (i) => Tc.toString(yo.fromASN(i)),
  toASN: (i) => yo.toASN(Tc.fromString(i))
};
class ka {
  constructor(e = {}) {
    this.typeId = "", this.value = new ArrayBuffer(0), Object.assign(this, e);
  }
}
S([
  E({ type: I.ObjectIdentifier })
], ka.prototype, "typeId", void 0);
S([
  E({ type: I.Any, context: 0 })
], ka.prototype, "value", void 0);
class za {
  constructor(e = {}) {
    this.partyName = new Ze(), Object.assign(this, e);
  }
}
S([
  E({ type: Ze, optional: !0, context: 0, implicit: !0 })
], za.prototype, "nameAssigner", void 0);
S([
  E({ type: Ze, context: 1, implicit: !0 })
], za.prototype, "partyName", void 0);
let ne = class {
  constructor(e = {}) {
    Object.assign(this, e);
  }
};
S([
  E({ type: ka, context: 0, implicit: !0 })
], ne.prototype, "otherName", void 0);
S([
  E({ type: I.IA5String, context: 1, implicit: !0 })
], ne.prototype, "rfc822Name", void 0);
S([
  E({ type: I.IA5String, context: 2, implicit: !0 })
], ne.prototype, "dNSName", void 0);
S([
  E({ type: I.Any, context: 3, implicit: !0 })
], ne.prototype, "x400Address", void 0);
S([
  E({ type: Mt, context: 4, implicit: !1 })
], ne.prototype, "directoryName", void 0);
S([
  E({ type: za, context: 5 })
], ne.prototype, "ediPartyName", void 0);
S([
  E({ type: I.IA5String, context: 6, implicit: !0 })
], ne.prototype, "uniformResourceIdentifier", void 0);
S([
  E({ type: I.OctetString, context: 7, implicit: !0, converter: cm })
], ne.prototype, "iPAddress", void 0);
S([
  E({ type: I.ObjectIdentifier, context: 8, implicit: !0 })
], ne.prototype, "registeredID", void 0);
ne = S([
  Z({ type: H.Choice })
], ne);
var Co;
class Qi {
  constructor(e = {}) {
    this.accessMethod = "", this.accessLocation = new ne(), Object.assign(this, e);
  }
}
S([
  E({ type: I.ObjectIdentifier })
], Qi.prototype, "accessMethod", void 0);
S([
  E({ type: ne })
], Qi.prototype, "accessLocation", void 0);
let Nc = Co = class extends Ge {
  constructor(e) {
    super(e), Object.setPrototypeOf(this, Co.prototype);
  }
};
Nc = Co = S([
  Z({ type: H.Sequence, itemType: Qi })
], Nc);
class um extends Ha {
}
class Wa {
  constructor(e = {}) {
    e && Object.assign(this, e);
  }
}
S([
  E({ type: um, context: 0, optional: !0, implicit: !0 })
], Wa.prototype, "keyIdentifier", void 0);
S([
  E({ type: ne, context: 1, optional: !0, implicit: !0, repeated: "sequence" })
], Wa.prototype, "authorityCertIssuer", void 0);
S([
  E({
    type: I.Integer,
    context: 2,
    optional: !0,
    implicit: !0,
    converter: An
  })
], Wa.prototype, "authorityCertSerialNumber", void 0);
class Gu {
  constructor(e = {}) {
    this.cA = !1, Object.assign(this, e);
  }
}
S([
  E({ type: I.Boolean, defaultValue: !1 })
], Gu.prototype, "cA", void 0);
S([
  E({ type: I.Integer, optional: !0 })
], Gu.prototype, "pathLenConstraint", void 0);
var Eo;
let cs = Eo = class extends Ge {
  constructor(e) {
    super(e), Object.setPrototypeOf(this, Eo.prototype);
  }
};
cs = Eo = S([
  Z({ type: H.Sequence, itemType: ne })
], cs);
var Do;
let xc = Do = class extends cs {
  constructor(e) {
    super(e), Object.setPrototypeOf(this, Do.prototype);
  }
};
xc = Do = S([
  Z({ type: H.Sequence })
], xc);
var Io;
let Pt = class {
  constructor(e = {}) {
    Object.assign(this, e);
  }
  toString() {
    return this.ia5String || this.visibleString || this.bmpString || this.utf8String || "";
  }
};
S([
  E({ type: I.IA5String })
], Pt.prototype, "ia5String", void 0);
S([
  E({ type: I.VisibleString })
], Pt.prototype, "visibleString", void 0);
S([
  E({ type: I.BmpString })
], Pt.prototype, "bmpString", void 0);
S([
  E({ type: I.Utf8String })
], Pt.prototype, "utf8String", void 0);
Pt = S([
  Z({ type: H.Choice })
], Pt);
class Za {
  constructor(e = {}) {
    this.organization = new Pt(), this.noticeNumbers = [], Object.assign(this, e);
  }
}
S([
  E({ type: Pt })
], Za.prototype, "organization", void 0);
S([
  E({ type: I.Integer, repeated: "sequence" })
], Za.prototype, "noticeNumbers", void 0);
class Ya {
  constructor(e = {}) {
    Object.assign(this, e);
  }
}
S([
  E({ type: Za, optional: !0 })
], Ya.prototype, "noticeRef", void 0);
S([
  E({ type: Pt, optional: !0 })
], Ya.prototype, "explicitText", void 0);
let ri = class {
  constructor(e = {}) {
    Object.assign(this, e);
  }
};
S([
  E({ type: I.IA5String })
], ri.prototype, "cPSuri", void 0);
S([
  E({ type: Ya })
], ri.prototype, "userNotice", void 0);
ri = S([
  Z({ type: H.Choice })
], ri);
class $a {
  constructor(e = {}) {
    this.policyQualifierId = "", this.qualifier = new ArrayBuffer(0), Object.assign(this, e);
  }
}
S([
  E({ type: I.ObjectIdentifier })
], $a.prototype, "policyQualifierId", void 0);
S([
  E({ type: I.Any })
], $a.prototype, "qualifier", void 0);
class qa {
  constructor(e = {}) {
    this.policyIdentifier = "", Object.assign(this, e);
  }
}
S([
  E({ type: I.ObjectIdentifier })
], qa.prototype, "policyIdentifier", void 0);
S([
  E({ type: $a, repeated: "sequence", optional: !0 })
], qa.prototype, "policyQualifiers", void 0);
let Vc = Io = class extends Ge {
  constructor(e) {
    super(e), Object.setPrototypeOf(this, Io.prototype);
  }
};
Vc = Io = S([
  Z({ type: H.Sequence, itemType: qa })
], Vc);
let ni = class {
  constructor(e = 0) {
    this.value = e;
  }
};
S([
  E({ type: I.Integer })
], ni.prototype, "value", void 0);
ni = S([
  Z({ type: H.Choice })
], ni);
let Uc = class extends ni {
};
Uc = S([
  Z({ type: H.Choice })
], Uc);
var Bo, je;
(function(i) {
  i[i.unused = 1] = "unused", i[i.keyCompromise = 2] = "keyCompromise", i[i.cACompromise = 4] = "cACompromise", i[i.affiliationChanged = 8] = "affiliationChanged", i[i.superseded = 16] = "superseded", i[i.cessationOfOperation = 32] = "cessationOfOperation", i[i.certificateHold = 64] = "certificateHold", i[i.privilegeWithdrawn = 128] = "privilegeWithdrawn", i[i.aACompromise = 256] = "aACompromise";
})(je || (je = {}));
class Qu extends Vu {
  toJSON() {
    const e = [], t = this.toNumber();
    return t & je.aACompromise && e.push("aACompromise"), t & je.affiliationChanged && e.push("affiliationChanged"), t & je.cACompromise && e.push("cACompromise"), t & je.certificateHold && e.push("certificateHold"), t & je.cessationOfOperation && e.push("cessationOfOperation"), t & je.keyCompromise && e.push("keyCompromise"), t & je.privilegeWithdrawn && e.push("privilegeWithdrawn"), t & je.superseded && e.push("superseded"), t & je.unused && e.push("unused"), e;
  }
  toString() {
    return `[${this.toJSON().join(", ")}]`;
  }
}
let sn = class {
  constructor(e = {}) {
    Object.assign(this, e);
  }
};
S([
  E({ type: ne, context: 0, repeated: "sequence", implicit: !0 })
], sn.prototype, "fullName", void 0);
S([
  E({ type: ti, context: 1, implicit: !0 })
], sn.prototype, "nameRelativeToCRLIssuer", void 0);
sn = S([
  Z({ type: H.Choice })
], sn);
class Ms {
  constructor(e = {}) {
    Object.assign(this, e);
  }
}
S([
  E({ type: sn, context: 0, optional: !0 })
], Ms.prototype, "distributionPoint", void 0);
S([
  E({ type: Qu, context: 1, optional: !0, implicit: !0 })
], Ms.prototype, "reasons", void 0);
S([
  E({ type: ne, context: 2, optional: !0, repeated: "sequence", implicit: !0 })
], Ms.prototype, "cRLIssuer", void 0);
let Mo = Bo = class extends Ge {
  constructor(e) {
    super(e), Object.setPrototypeOf(this, Bo.prototype);
  }
};
Mo = Bo = S([
  Z({ type: H.Sequence, itemType: Ms })
], Mo);
var Po;
let Lc = Po = class extends Mo {
  constructor(e) {
    super(e), Object.setPrototypeOf(this, Po.prototype);
  }
};
Lc = Po = S([
  Z({ type: H.Sequence, itemType: Ms })
], Lc);
class pe {
  constructor(e = {}) {
    this.onlyContainsUserCerts = pe.ONLY, this.onlyContainsCACerts = pe.ONLY, this.indirectCRL = pe.ONLY, this.onlyContainsAttributeCerts = pe.ONLY, Object.assign(this, e);
  }
}
pe.ONLY = !1;
S([
  E({ type: sn, context: 0, optional: !0 })
], pe.prototype, "distributionPoint", void 0);
S([
  E({ type: I.Boolean, context: 1, defaultValue: pe.ONLY, implicit: !0 })
], pe.prototype, "onlyContainsUserCerts", void 0);
S([
  E({ type: I.Boolean, context: 2, defaultValue: pe.ONLY, implicit: !0 })
], pe.prototype, "onlyContainsCACerts", void 0);
S([
  E({ type: Qu, context: 3, optional: !0, implicit: !0 })
], pe.prototype, "onlySomeReasons", void 0);
S([
  E({ type: I.Boolean, context: 4, defaultValue: pe.ONLY, implicit: !0 })
], pe.prototype, "indirectCRL", void 0);
S([
  E({ type: I.Boolean, context: 5, defaultValue: pe.ONLY, implicit: !0 })
], pe.prototype, "onlyContainsAttributeCerts", void 0);
var Dn;
(function(i) {
  i[i.unspecified = 0] = "unspecified", i[i.keyCompromise = 1] = "keyCompromise", i[i.cACompromise = 2] = "cACompromise", i[i.affiliationChanged = 3] = "affiliationChanged", i[i.superseded = 4] = "superseded", i[i.cessationOfOperation = 5] = "cessationOfOperation", i[i.certificateHold = 6] = "certificateHold", i[i.removeFromCRL = 8] = "removeFromCRL", i[i.privilegeWithdrawn = 9] = "privilegeWithdrawn", i[i.aACompromise = 10] = "aACompromise";
})(Dn || (Dn = {}));
let Ro = class {
  constructor(e = Dn.unspecified) {
    this.reason = Dn.unspecified, this.reason = e;
  }
  toJSON() {
    return Dn[this.reason];
  }
  toString() {
    return this.toJSON();
  }
};
S([
  E({ type: I.Enumerated })
], Ro.prototype, "reason", void 0);
Ro = S([
  Z({ type: H.Choice })
], Ro);
var Oo;
let Fc = Oo = class extends Ge {
  constructor(e) {
    super(e), Object.setPrototypeOf(this, Oo.prototype);
  }
};
Fc = Oo = S([
  Z({ type: H.Sequence, itemType: I.ObjectIdentifier })
], Fc);
let To = class {
  constructor(e = new ArrayBuffer(0)) {
    this.value = e;
  }
};
S([
  E({ type: I.Integer, converter: An })
], To.prototype, "value", void 0);
To = S([
  Z({ type: H.Choice })
], To);
let No = class {
  constructor(e) {
    this.value = /* @__PURE__ */ new Date(), e && (this.value = e);
  }
};
S([
  E({ type: I.GeneralizedTime })
], No.prototype, "value", void 0);
No = S([
  Z({ type: H.Choice })
], No);
var xo;
let Gc = xo = class extends cs {
  constructor(e) {
    super(e), Object.setPrototypeOf(this, xo.prototype);
  }
};
Gc = xo = S([
  Z({ type: H.Sequence })
], Gc);
var Qc;
(function(i) {
  i[i.digitalSignature = 1] = "digitalSignature", i[i.nonRepudiation = 2] = "nonRepudiation", i[i.keyEncipherment = 4] = "keyEncipherment", i[i.dataEncipherment = 8] = "dataEncipherment", i[i.keyAgreement = 16] = "keyAgreement", i[i.keyCertSign = 32] = "keyCertSign", i[i.cRLSign = 64] = "cRLSign", i[i.encipherOnly = 128] = "encipherOnly", i[i.decipherOnly = 256] = "decipherOnly";
})(Qc || (Qc = {}));
var Vo;
class ji {
  constructor(e = {}) {
    this.base = new ne(), this.minimum = 0, Object.assign(this, e);
  }
}
S([
  E({ type: ne })
], ji.prototype, "base", void 0);
S([
  E({ type: I.Integer, context: 0, defaultValue: 0, implicit: !0 })
], ji.prototype, "minimum", void 0);
S([
  E({ type: I.Integer, context: 1, optional: !0, implicit: !0 })
], ji.prototype, "maximum", void 0);
let si = Vo = class extends Ge {
  constructor(e) {
    super(e), Object.setPrototypeOf(this, Vo.prototype);
  }
};
si = Vo = S([
  Z({ type: H.Sequence, itemType: ji })
], si);
class ju {
  constructor(e = {}) {
    Object.assign(this, e);
  }
}
S([
  E({ type: si, context: 0, optional: !0, implicit: !0 })
], ju.prototype, "permittedSubtrees", void 0);
S([
  E({ type: si, context: 1, optional: !0, implicit: !0 })
], ju.prototype, "excludedSubtrees", void 0);
class Hu {
  constructor(e = {}) {
    Object.assign(this, e);
  }
}
S([
  E({
    type: I.Integer,
    context: 0,
    implicit: !0,
    optional: !0,
    converter: An
  })
], Hu.prototype, "requireExplicitPolicy", void 0);
S([
  E({
    type: I.Integer,
    context: 1,
    implicit: !0,
    optional: !0,
    converter: An
  })
], Hu.prototype, "inhibitPolicyMapping", void 0);
var Uo;
class Xa {
  constructor(e = {}) {
    this.issuerDomainPolicy = "", this.subjectDomainPolicy = "", Object.assign(this, e);
  }
}
S([
  E({ type: I.ObjectIdentifier })
], Xa.prototype, "issuerDomainPolicy", void 0);
S([
  E({ type: I.ObjectIdentifier })
], Xa.prototype, "subjectDomainPolicy", void 0);
let jc = Uo = class extends Ge {
  constructor(e) {
    super(e), Object.setPrototypeOf(this, Uo.prototype);
  }
};
jc = Uo = S([
  Z({ type: H.Sequence, itemType: Xa })
], jc);
var Lo;
let Hc = Lo = class extends cs {
  constructor(e) {
    super(e), Object.setPrototypeOf(this, Lo.prototype);
  }
};
Hc = Lo = S([
  Z({ type: H.Sequence })
], Hc);
class _a {
  constructor(e = {}) {
    this.type = "", this.values = [], Object.assign(this, e);
  }
}
S([
  E({ type: I.ObjectIdentifier })
], _a.prototype, "type", void 0);
S([
  E({ type: I.Any, repeated: "set" })
], _a.prototype, "values", void 0);
var Fo;
let Kc = Fo = class extends Ge {
  constructor(e) {
    super(e), Object.setPrototypeOf(this, Fo.prototype);
  }
};
Kc = Fo = S([
  Z({ type: H.Sequence, itemType: _a })
], Kc);
class Ku {
  constructor(e = {}) {
    Object.assign(this, e);
  }
}
S([
  E({ type: I.GeneralizedTime, context: 0, implicit: !0, optional: !0 })
], Ku.prototype, "notBefore", void 0);
S([
  E({ type: I.GeneralizedTime, context: 1, implicit: !0, optional: !0 })
], Ku.prototype, "notAfter", void 0);
var In;
(function(i) {
  i[i.keyUpdateAllowed = 1] = "keyUpdateAllowed", i[i.newExtensions = 2] = "newExtensions", i[i.pKIXCertificate = 4] = "pKIXCertificate";
})(In || (In = {}));
class ku extends Vu {
  toJSON() {
    const e = [], t = this.toNumber();
    return t & In.pKIXCertificate && e.push("pKIXCertificate"), t & In.newExtensions && e.push("newExtensions"), t & In.keyUpdateAllowed && e.push("keyUpdateAllowed"), e;
  }
  toString() {
    return `[${this.toJSON().join(", ")}]`;
  }
}
class zu {
  constructor(e = {}) {
    this.entrustVers = "", this.entrustInfoFlags = new ku(), Object.assign(this, e);
  }
}
S([
  E({ type: I.GeneralString })
], zu.prototype, "entrustVers", void 0);
S([
  E({ type: ku })
], zu.prototype, "entrustInfoFlags", void 0);
var Go;
let kc = Go = class extends Ge {
  constructor(e) {
    super(e), Object.setPrototypeOf(this, Go.prototype);
  }
};
kc = Go = S([
  Z({ type: H.Sequence, itemType: Qi })
], kc);
class Ce {
  constructor(e = {}) {
    this.algorithm = "", Object.assign(this, e);
  }
  isEqual(e) {
    return e instanceof Ce && e.algorithm == this.algorithm && (e.parameters && this.parameters && Ff(e.parameters, this.parameters) || e.parameters === this.parameters);
  }
}
S([
  E({
    type: I.ObjectIdentifier
  })
], Ce.prototype, "algorithm", void 0);
S([
  E({
    type: I.Any,
    optional: !0
  })
], Ce.prototype, "parameters", void 0);
class Hi {
  constructor(e = {}) {
    this.algorithm = new Ce(), this.subjectPublicKey = new ArrayBuffer(0), Object.assign(this, e);
  }
}
S([
  E({ type: Ce })
], Hi.prototype, "algorithm", void 0);
S([
  E({ type: I.BitString })
], Hi.prototype, "subjectPublicKey", void 0);
let we = class {
  constructor(e) {
    if (e)
      if (typeof e == "string" || typeof e == "number" || e instanceof Date) {
        const t = new Date(e);
        t.getUTCFullYear() > 2049 ? this.generalTime = t : this.utcTime = t;
      } else
        Object.assign(this, e);
  }
  getTime() {
    const e = this.utcTime || this.generalTime;
    if (!e)
      throw new Error("Cannot get time from CHOICE object");
    return e;
  }
};
S([
  E({
    type: I.UTCTime
  })
], we.prototype, "utcTime", void 0);
S([
  E({
    type: I.GeneralizedTime
  })
], we.prototype, "generalTime", void 0);
we = S([
  Z({ type: H.Choice })
], we);
class Ki {
  constructor(e) {
    this.notBefore = new we(/* @__PURE__ */ new Date()), this.notAfter = new we(/* @__PURE__ */ new Date()), e && (this.notBefore = new we(e.notBefore), this.notAfter = new we(e.notAfter));
  }
}
S([
  E({ type: we })
], Ki.prototype, "notBefore", void 0);
S([
  E({ type: we })
], Ki.prototype, "notAfter", void 0);
var Qo;
class at {
  constructor(e = {}) {
    this.extnID = "", this.critical = at.CRITICAL, this.extnValue = new Ha(), Object.assign(this, e);
  }
}
at.CRITICAL = !1;
S([
  E({ type: I.ObjectIdentifier })
], at.prototype, "extnID", void 0);
S([
  E({
    type: I.Boolean,
    defaultValue: at.CRITICAL
  })
], at.prototype, "critical", void 0);
S([
  E({ type: Ha })
], at.prototype, "extnValue", void 0);
let jo = Qo = class extends Ge {
  constructor(e) {
    super(e), Object.setPrototypeOf(this, Qo.prototype);
  }
};
jo = Qo = S([
  Z({ type: H.Sequence, itemType: at })
], jo);
var ii;
(function(i) {
  i[i.v1 = 0] = "v1", i[i.v2 = 1] = "v2", i[i.v3 = 2] = "v3";
})(ii || (ii = {}));
class Qe {
  constructor(e = {}) {
    this.version = ii.v1, this.serialNumber = new ArrayBuffer(0), this.signature = new Ce(), this.issuer = new Mt(), this.validity = new Ki(), this.subject = new Mt(), this.subjectPublicKeyInfo = new Hi(), Object.assign(this, e);
  }
}
S([
  E({
    type: I.Integer,
    context: 0,
    defaultValue: ii.v1
  })
], Qe.prototype, "version", void 0);
S([
  E({
    type: I.Integer,
    converter: An
  })
], Qe.prototype, "serialNumber", void 0);
S([
  E({ type: Ce })
], Qe.prototype, "signature", void 0);
S([
  E({ type: Mt })
], Qe.prototype, "issuer", void 0);
S([
  E({ type: Ki })
], Qe.prototype, "validity", void 0);
S([
  E({ type: Mt })
], Qe.prototype, "subject", void 0);
S([
  E({ type: Hi })
], Qe.prototype, "subjectPublicKeyInfo", void 0);
S([
  E({
    type: I.BitString,
    context: 1,
    implicit: !0,
    optional: !0
  })
], Qe.prototype, "issuerUniqueID", void 0);
S([
  E({ type: I.BitString, context: 2, implicit: !0, optional: !0 })
], Qe.prototype, "subjectUniqueID", void 0);
S([
  E({ type: jo, context: 3, optional: !0 })
], Qe.prototype, "extensions", void 0);
class Ja {
  constructor(e = {}) {
    this.tbsCertificate = new Qe(), this.signatureAlgorithm = new Ce(), this.signatureValue = new ArrayBuffer(0), Object.assign(this, e);
  }
}
S([
  E({ type: Qe })
], Ja.prototype, "tbsCertificate", void 0);
S([
  E({ type: Ce })
], Ja.prototype, "signatureAlgorithm", void 0);
S([
  E({ type: I.BitString })
], Ja.prototype, "signatureValue", void 0);
class ki {
  constructor(e = {}) {
    this.userCertificate = new ArrayBuffer(0), this.revocationDate = new we(), Object.assign(this, e);
  }
}
S([
  E({ type: I.Integer, converter: An })
], ki.prototype, "userCertificate", void 0);
S([
  E({ type: we })
], ki.prototype, "revocationDate", void 0);
S([
  E({ type: at, optional: !0, repeated: "sequence" })
], ki.prototype, "crlEntryExtensions", void 0);
class Ut {
  constructor(e = {}) {
    this.signature = new Ce(), this.issuer = new Mt(), this.thisUpdate = new we(), Object.assign(this, e);
  }
}
S([
  E({ type: I.Integer, optional: !0 })
], Ut.prototype, "version", void 0);
S([
  E({ type: Ce })
], Ut.prototype, "signature", void 0);
S([
  E({ type: Mt })
], Ut.prototype, "issuer", void 0);
S([
  E({ type: we })
], Ut.prototype, "thisUpdate", void 0);
S([
  E({ type: we, optional: !0 })
], Ut.prototype, "nextUpdate", void 0);
S([
  E({ type: ki, repeated: "sequence", optional: !0 })
], Ut.prototype, "revokedCertificates", void 0);
S([
  E({ type: at, optional: !0, context: 0, repeated: "sequence" })
], Ut.prototype, "crlExtensions", void 0);
class ec {
  constructor(e = {}) {
    this.tbsCertList = new Ut(), this.signatureAlgorithm = new Ce(), this.signature = new ArrayBuffer(0), Object.assign(this, e);
  }
}
S([
  E({ type: Ut })
], ec.prototype, "tbsCertList", void 0);
S([
  E({ type: Ce })
], ec.prototype, "signatureAlgorithm", void 0);
S([
  E({ type: I.BitString })
], ec.prototype, "signature", void 0);
var hm = Object.defineProperty, lm = Object.getOwnPropertyDescriptor, zi = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? lm(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && hm(e, t, n), n;
};
class Ps {
  constructor() {
    this.professionItems = [], this.registrationNumber = "";
  }
}
zi([
  E({ type: I.GeneralString, context: 0, implicit: !1, optional: !0 })
], Ps.prototype, "namingAuthority", 2);
zi([
  E({ type: I.Utf8String, repeated: "sequence" })
], Ps.prototype, "professionItems", 2);
zi([
  E({ type: I.ObjectIdentifier, repeated: "sequence", optional: !0 })
], Ps.prototype, "professionOIDs", 2);
zi([
  E({ type: I.PrintableString, optional: !0 })
], Ps.prototype, "registrationNumber", 2);
var dm = Object.defineProperty, pm = Object.getOwnPropertyDescriptor, tc = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? pm(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && dm(e, t, n), n;
};
class Rs {
  constructor() {
    this.professionInfos = [];
  }
}
tc([
  E({ type: I.GeneralString, context: 0, implicit: !1, optional: !0 })
], Rs.prototype, "admissionAuthority", 2);
tc([
  E({ type: I.GeneralString, context: 1, implicit: !1, optional: !0 })
], Rs.prototype, "namingAuthority", 2);
tc([
  E({ type: Ps, repeated: "sequence" })
], Rs.prototype, "professionInfos", 2);
var gm = Object.defineProperty, fm = Object.getOwnPropertyDescriptor, rc = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? fm(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && gm(e, t, n), n;
};
class nc {
  constructor() {
    this.contentsOfAdmissions = [];
  }
}
rc([
  E({ type: ne, optional: !0 })
], nc.prototype, "admissionAuthority", 2);
rc([
  E({ type: Rs, repeated: "sequence" })
], nc.prototype, "contentsOfAdmissions", 2);
var nr;
const Wu = (nr = class {
  constructor() {
    this.contentsOfAdmissions = [];
  }
  static readExtension(e) {
    const t = e.extensions.find((r) => r.type === nr.OID_ADMISSION);
    if (t)
      try {
        return Rc.parse(t.value, nr);
      } catch {
        try {
          return Rc.parse(t.value, nc);
        } catch (n) {
          console.error("X509AdmissionExtension could not be parsed, no telematik-id found:", n);
        }
      }
  }
}, nr.OID_ADMISSION = "1.3.36.8.3.3", nr);
rc([
  E({ type: Rs, repeated: "sequence" })
], Wu.prototype, "contentsOfAdmissions", 2);
let mm = Wu;
class us {
  constructor(e) {
    this.ti365Session = e, this.cardInstitutionMap = /* @__PURE__ */ new Map(), this.cardCertificateMap = /* @__PURE__ */ new Map();
  }
  static parseTelematikIdFromRawCertificate(e) {
    const t = new _e.X509Certificate(e), r = mm.readExtension(t);
    if (r != null)
      return r.contentsOfAdmissions[0].professionInfos[0].registrationNumber;
  }
  /**
   * Verifies a Certificate on the Connector.
   * @param raw DER, PEM, HEX, Base64, Base64Url
   * @returns VerificationStatus
   */
  async verifyCertificate(e) {
    const t = new _e.X509Certificate(e);
    return (await this.ti365Session.getConnector()).getCertificateService().verifyCertificate(t.toString("base64"));
  }
  async readCertificate(e, t, r = ir.RSA) {
    let n = t;
    if (!n)
      switch (e.type) {
        case _.EGK:
          t = [Pe.C_AUT];
          break;
        case _.HBAx:
        case _.HBA:
        case _.ZOD_2_0:
        case _.HBA_qSig:
          t = [Pe.C_AUT, Pe.C_ENC, Pe.C_QES];
          break;
        case _.SMC_B:
        case _.HSM_B:
        case _.SM_B:
          t = [Pe.C_AUT, Pe.C_ENC, Pe.C_SIG];
          break;
        default:
          throw new Error("certRefs could not be determined");
      }
    return this.readCertificateWithCardHandle(e.handle, n, r);
  }
  /**
   * Reads Certificate information from a card.
   * @param readCardHandle Card that should be read.
   * @param certRefs Types of Certs to read.
   * @returns List of Certificate Information.
   */
  async readCertificateWithCardHandle(e, t, r = ir.RSA) {
    return (await this.ti365Session.getConnector()).getCertificateService().readCardCertificate(e, t, r);
  }
  static parseTelematikIdFromCertInfoList(e) {
    for (const t of e) {
      const r = us.parseTelematikIdFromRawCertificate(t.x509Data.x509Certificate);
      if (r)
        return r;
    }
  }
  /**
   * Uses readCardCertificate to read a Certificate and parses it to extract the "Telematik-id" if possible.
   * @param readCardHandle Card that should be read.
   * @param certRefs Types of Certs to read.
   * @returns Telematik-ID if any could be found.
   */
  async readTelematikIdFromCertificate(e, t) {
    const r = await this.readCertificateWithCardHandle(e.handle, t);
    return us.parseTelematikIdFromCertInfoList(r);
  }
}
class wm {
  constructor(e) {
    this.ti365Session = e;
  }
  /* This section uses the event service of the connector */
  async getCard(e, t = !1) {
    return (await this.getCards(t)).find((n) => n.type === e);
  }
  async findCardWithIccsn(e, t = !1) {
    return (await this.getCards(t)).find((n) => n.iccsn === e);
  }
  async findCardWithCardHandle(e, t = !1) {
    return (await this.getCards(t)).find((n) => n.handle === e);
  }
  async getCards(e = !1) {
    if (!this.cards || e) {
      const r = await (await this.ti365Session.getConnector()).getEventService().getCards();
      this.cards = r.cards;
    }
    return this.cards;
  }
  /* This section uses the card service of the connector */
  async getPinStatus(e, t) {
    return (await this.ti365Session.getConnector()).getCardService().getPinStatus(e.handle, t);
  }
  async verifyPin(e, t) {
    return (await this.ti365Session.getConnector()).getCardService().verifyPin(e.handle, t);
  }
  async changePin(e, t) {
    return (await this.ti365Session.getConnector()).getCardService().changePin(e.handle, t);
  }
  async unblockPin(e, t, r = !1) {
    return (await this.ti365Session.getConnector()).getCardService().unblockPin(e.handle, t, r);
  }
  get certificateService() {
    return this._certificateService || (this._certificateService = new us(this.ti365Session)), this._certificateService;
  }
  async readTelematikIdFromCertificate(e, ...t) {
    return this.certificateService.readTelematikIdFromCertificate(e, t);
  }
  async verifyCertificate(e) {
    return this.certificateService.verifyCertificate(e);
  }
}
var ym = Object.defineProperty, Am = Object.getOwnPropertyDescriptor, Wi = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? Am(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && ym(e, t, n), n;
};
let fr = class {
};
Wi([
  c(String, "Kostentraegerkennung")
], fr.prototype, "kostentraegerkennung", 2);
Wi([
  c(String, "Kostentraegerlaendercode")
], fr.prototype, "kostentraegerlaendercode", 2);
Wi([
  c(String, "Name")
], fr.prototype, "Name", 2);
fr = Wi([
  b("AbrechnenderKostentraeger", h.gemAVersicherungsdaten52)
], fr);
var Sm = Object.defineProperty, vm = Object.getOwnPropertyDescriptor, Zu = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? vm(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && Sm(e, t, n), n;
};
let oi = class extends fr {
};
Zu([
  c(fr, "AbrechnenderKostentraeger")
], oi.prototype, "abrechnenderKostentraeger", 2);
oi = Zu([
  b("Kostentraeger", h.gemAVersicherungsdaten52)
], oi);
var bm = Object.defineProperty, Cm = Object.getOwnPropertyDescriptor, Zi = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? Cm(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && bm(e, t, n), n;
};
let on = class {
};
Zi([
  c(Date, "Beginn")
], on.prototype, "beginn", 2);
Zi([
  c(Date, "Ende")
], on.prototype, "ende", 2);
Zi([
  c(oi, "Kostentraeger")
], on.prototype, "kostentraeger", 2);
on = Zi([
  b("Versicherungsschutz", h.gemAVersicherungsdaten52)
], on);
var Em = Object.defineProperty, Dm = Object.getOwnPropertyDescriptor, Os = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? Dm(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && Em(e, t, n), n;
};
let mr = class {
};
Os([
  c(Number, "AerztlicheVersorgung")
], mr.prototype, "aerztlicheVersorgung", 2);
Os([
  c(Number, "ZahnaerztlicheVersorgung")
], mr.prototype, "zahnaerztlicheVersorgung", 2);
Os([
  c(Number, "StationaererBereich")
], mr.prototype, "stationaererBereich", 2);
Os([
  c(Number, "VeranlassteLeistungen")
], mr.prototype, "veranlassteLeistungen", 2);
mr = Os([
  b("Kostenerstattung", h.gemAVersicherungsdaten52)
], mr);
var Im = Object.defineProperty, Bm = Object.getOwnPropertyDescriptor, sc = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? Bm(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && Im(e, t, n), n;
};
let hs = class {
};
sc([
  c(mr, "Kostenerstattung")
], hs.prototype, "kostenerstattung", 2);
sc([
  c(String, "WOP")
], hs.prototype, "wop", 2);
hs = sc([
  b("Zusatzinfos_Abrechnung_GKV", h.gemAVersicherungsdaten52)
], hs);
var Mm = Object.defineProperty, Pm = Object.getOwnPropertyDescriptor, ic = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? Pm(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && Mm(e, t, n), n;
};
let ls = class {
};
ic([
  c(String, "Versichertenart")
], ls.prototype, "versichertenart", 2);
ic([
  c(hs, "Zusatzinfos_Abrechnung_GKV")
], ls.prototype, "zusatzinfosAbrechnungGKV", 2);
ls = ic([
  b("ZusatzinfosGKV", h.gemAVersicherungsdaten52)
], ls);
var Rm = Object.defineProperty, Om = Object.getOwnPropertyDescriptor, Yu = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? Om(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && Rm(e, t, n), n;
};
let ai = class {
};
Yu([
  c(ls, "ZusatzinfosGKV")
], ai.prototype, "zusatzinfosGKV", 2);
ai = Yu([
  b("Zusatzinfos", h.gemAVersicherungsdaten52)
], ai);
var Tm = Object.defineProperty, Nm = Object.getOwnPropertyDescriptor, oc = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? Nm(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && Tm(e, t, n), n;
};
let ds = class {
};
oc([
  c(on, "Versicherungsschutz")
], ds.prototype, "versicherungsschutz", 2);
oc([
  c(ai, "Zusatzinfos")
], ds.prototype, "zusatzinfos", 2);
ds = oc([
  b("Versicherter", h.gemAVersicherungsdaten52)
], ds);
var xm = Object.defineProperty, Vm = Object.getOwnPropertyDescriptor, ac = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? Vm(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && xm(e, t, n), n;
};
let ps = class {
};
ac([
  x("CDM_VERSION", String)
], ps.prototype, "cdmVersion", 2);
ac([
  c(ds, "Versicherter")
], ps.prototype, "versicherter", 2);
ps = ac([
  b("UC_AllgemeineVersicherungsdatenXML", h.gemAVersicherungsdaten52)
], ps);
var Um = Object.defineProperty, Lm = Object.getOwnPropertyDescriptor, $u = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? Lm(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && Um(e, t, n), n;
};
let gs = class {
};
$u([
  c(String, "Wohnsitzlaendercode")
], gs.prototype, "wohnsitzlaendercode", 2);
gs = $u([
  b("LandType", h.gemAVersicherungsdaten52)
], gs);
var Fm = Object.defineProperty, Gm = Object.getOwnPropertyDescriptor, Ts = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? Gm(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && Fm(e, t, n), n;
};
let wr = class {
};
Ts([
  c(String, "Postleitzahl")
], wr.prototype, "postleitzahl", 2);
Ts([
  c(String, "Ort")
], wr.prototype, "ort", 2);
Ts([
  c(String, "Postfach")
], wr.prototype, "postfach", 2);
Ts([
  c(gs, "Land")
], wr.prototype, "land", 2);
wr = Ts([
  b("PostfachAdresse", h.gemAVersicherungsdaten52)
], wr);
var Qm = Object.defineProperty, jm = Object.getOwnPropertyDescriptor, Dr = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? jm(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && Qm(e, t, n), n;
};
let Rt = class {
};
Dr([
  c(String, "Postleitzahl")
], Rt.prototype, "postleitzahl", 2);
Dr([
  c(String, "Ort")
], Rt.prototype, "ort", 2);
Dr([
  c(gs, "Land")
], Rt.prototype, "land", 2);
Dr([
  c(String, "Strasse")
], Rt.prototype, "strasse", 2);
Dr([
  c(String, "Hausnummer")
], Rt.prototype, "hausnummer", 2);
Dr([
  c(String, "Anschriftenzusatz")
], Rt.prototype, "anschriftenzusatz", 2);
Rt = Dr([
  b("StrassenAdresse", h.gemAVersicherungsdaten52)
], Rt);
var Hm = Object.defineProperty, Km = Object.getOwnPropertyDescriptor, lt = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? Km(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && Hm(e, t, n), n;
};
let Ve = class {
};
lt([
  c(Date, "Geburtsdatum")
], Ve.prototype, "geburtsdatum", 2);
lt([
  c(String, "Vorname")
], Ve.prototype, "vorname", 2);
lt([
  c(String, "Nachname")
], Ve.prototype, "nachname", 2);
lt([
  c(String, "Geschlecht")
], Ve.prototype, "geschlecht", 2);
lt([
  c(String, "Vorsatzwort")
], Ve.prototype, "vorsatzwort", 2);
lt([
  c(String, "Namenszusatz")
], Ve.prototype, "namenszusatz", 2);
lt([
  c(String, "Titel")
], Ve.prototype, "titel", 2);
lt([
  c(wr, "PostfachAdresse")
], Ve.prototype, "postfachAdresse", 2);
lt([
  c(Rt, "StrassenAdresse")
], Ve.prototype, "strassenAdresse", 2);
Ve = lt([
  b("Person", h.gemAVersicherungsdaten52)
], Ve);
var km = Object.defineProperty, zm = Object.getOwnPropertyDescriptor, cc = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? zm(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && km(e, t, n), n;
};
let fs = class {
};
cc([
  c(String, "Versicherten_ID")
], fs.prototype, "versichertenId", 2);
cc([
  c(Ve, "Person")
], fs.prototype, "person", 2);
fs = cc([
  b("Versicherter", h.gemAVersicherungsdaten52)
], fs);
var Wm = Object.defineProperty, Zm = Object.getOwnPropertyDescriptor, uc = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? Zm(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && Wm(e, t, n), n;
};
let ms = class {
};
uc([
  x("CDM_VERSION", String)
], ms.prototype, "cdmVersion", 2);
uc([
  c(fs, "Versicherter")
], ms.prototype, "versicherter", 2);
ms = uc([
  b("UC_PersoenlicheVersichertendatenXML", h.gemAVersicherungsdaten52)
], ms);
var Ym = Object.defineProperty, $m = Object.getOwnPropertyDescriptor, Yi = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? $m(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && Ym(e, t, n), n;
};
let an = class {
};
Yi([
  c(Date, "Beginn")
], an.prototype, "beginn", 2);
Yi([
  c(Date, "Ende")
], an.prototype, "ende", 2);
Yi([
  c(Number, "ArtDesRuhens")
], an.prototype, "artDesRuhens", 2);
an = Yi([
  b("RuhenderLeistungsanspruch", h.gemAVersicherungsdaten52)
], an);
var qm = Object.defineProperty, Xm = Object.getOwnPropertyDescriptor, $i = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? Xm(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && qm(e, t, n), n;
};
let cn = class {
};
$i([
  c(Number, "Aerztlich")
], cn.prototype, "aerztlich", 2);
$i([
  c(Number, "Zahnaerztlich")
], cn.prototype, "zahnaerztlich", 2);
$i([
  c(String, "Art")
], cn.prototype, "art", 2);
cn = $i([
  b("Selektivvertraege", h.gemAVersicherungsdaten52)
], cn);
var _m = Object.defineProperty, Jm = Object.getOwnPropertyDescriptor, hc = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? Jm(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && _m(e, t, n), n;
};
let ws = class {
};
hc([
  c(Number, "Status")
], ws.prototype, "status", 2);
hc([
  c(Date, "Gueltig_bis")
], ws.prototype, "gueltigBis", 2);
ws = hc([
  b("Zuzahlungsstatus", h.gemAVersicherungsdaten52)
], ws);
var ew = Object.defineProperty, tw = Object.getOwnPropertyDescriptor, Ir = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? tw(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && ew(e, t, n), n;
};
let Ot = class {
};
Ir([
  x("CDM_VERSION", String)
], Ot.prototype, "cdmVersion", 2);
Ir([
  c(ws, "Zuzahlungsstatus")
], Ot.prototype, "zuzahlungsstatus", 2);
Ir([
  c(Number, "BesonderePersonengruppe")
], Ot.prototype, "besonderePersonengruppe", 2);
Ir([
  c(Number, "DMP_Kennzeichnung")
], Ot.prototype, "dmpKennzeichnung", 2);
Ir([
  c(cn, "Selektivvertraege")
], Ot.prototype, "selektivvertraege", 2);
Ir([
  c(an, "RuhenderLeistungsanspruch")
], Ot.prototype, "ruhenderLeistungsanspruch", 2);
Ot = Ir([
  b("UC_GeschuetzteVersichertendatenXML", h.gemAVersicherungsdaten52)
], Ot);
class rw {
  constructor(e, t, r, n) {
    this.allgemein = e, this.persoenlich = t, this.geschuetzt = r, this.pruefungsnachweis = n;
  }
}
var nw = Object.defineProperty, sw = Object.getOwnPropertyDescriptor, Ns = (i, e, t, r) => {
  for (var n = r > 1 ? void 0 : r ? sw(e, t) : e, s = i.length - 1, o; s >= 0; s--)
    (o = i[s]) && (n = (r ? o(e, t, n) : o(n)) || n);
  return r && n && nw(e, t, n), n;
};
let yr = class {
};
Ns([
  c(Date, "TS")
], yr.prototype, "timestamp", 2);
Ns([
  c(Number, "E")
], yr.prototype, "ergebnis", 2);
Ns([
  c(Number, "EC")
], yr.prototype, "errorCode", 2);
Ns([
  c(Number, "PZ")
], yr.prototype, "pruefziffer", 2);
yr = Ns([
  b("PN", h.gemVsdPnw)
], yr);
const Gt = class Gt {
  constructor(e) {
    this.ti365Session = e;
  }
  async readVersichertenStammdaten(e, t, r = !1) {
    const s = await (await this.ti365Session.getConnector()).getVsdService().readVsd(e, t, r, r);
    new ps().cdmVersion = "", new ms().cdmVersion = "", new Ot().cdmVersion = "", new yr().ergebnis = 1;
    const o = Ke.unmarshal(Gt.toXml(s.allgemeineVersicherungsdaten)), u = Ke.unmarshal(Gt.toXml(s.persoenlicheVersichertendaten));
    let l;
    s.geschuetzteVersichertendaten && (l = Ke.unmarshal(Gt.toXml(s.geschuetzteVersichertendaten)));
    let m;
    return s.pruefungsnachweis && (m = Ke.unmarshal(Gt.toXml(s.pruefungsnachweis))), new rw(o, u, l, m);
  }
  static toXml(e) {
    const t = ye.toUint8Array(e);
    let r = this.decoderUtf.decode(Ac.inflate(t));
    return r.toLowerCase().indexOf('encoding="iso-8859-15"') != -1 && (r = this.decoderIso.decode(Ac.inflate(t))), r;
  }
};
Gt.decoderUtf = new TextDecoder(), Gt.decoderIso = new TextDecoder("iso-8859-15");
let Ho = Gt;
class iw {
  constructor(e, t, r) {
    this.gatewayClient = e, this.settings = t, this.cryptography = r, this.bucketCrypto = this.initialize();
  }
  async initialize() {
    if (this.settings.encryptedStorageKey) {
      const e = await this.cryptography.unwrapKey(this.settings.encryptedStorageKey, V.algorithms.symmetricEncryptionConfig, ["decrypt", "encrypt"]);
      return new Vr(e);
    } else if (this.settings.encryptedStorageKey && this.cryptography.asymmetric) {
      const e = await this.cryptography.asymmetric.unwrapKey(this.settings.encryptedStorageKey, V.algorithms.symmetricEncryptionConfig, ["decrypt", "encrypt"]);
      return new Vr(e);
    } else
      throw console.error("Missing Crypto Key for Storage ", this.settings), new Error("Storage can not be initialized, missing crypto key.");
  }
  async decrypt(e) {
    return (await this.bucketCrypto).decrypt(e);
  }
  async decryptObject(e) {
    const t = V.stringDecode(await this.decrypt(e));
    return X.deserialize(t);
  }
  async encrypt(e) {
    return (await this.bucketCrypto).encrypt(e);
  }
  async encryptObject(e) {
    const t = X.serialize(e);
    return this.encrypt(V.stringEncode(t));
  }
  async list(e = "", t = "desc") {
    return await this.gatewayClient.get("/storage/list/" + this.buildPath(e), { "sort-direction": t });
  }
  buildPath(e) {
    return this.settings.storageName + "/" + e;
  }
  async readObject(e) {
    const t = await this.read(e);
    return X.deserialize(V.stringDecode(t));
  }
  async read(e) {
    let t;
    typeof e == "string" ? t = e : t = e.path + "/" + e.name;
    const r = await this.gatewayClient.getRaw("/storage/read/" + this.buildPath(t));
    return (await this.bucketCrypto).decryptBlob(await r.arrayBuffer());
  }
  async readPlain(e) {
    let t;
    return typeof e == "string" ? t = e : t = e.path + "/" + e.name, (await this.gatewayClient.getRaw("/storage/read/" + this.buildPath(t))).arrayBuffer();
  }
  async delete(e) {
    let t;
    typeof e == "string" ? t = e : t = e.path + "/" + e.name, await this.gatewayClient.delete("/storage/delete/" + this.buildPath(t));
  }
  async writeObject(e, t, r, n) {
    return this.write(e, V.stringEncode(X.serialize(t)), r, n);
  }
  async write(e, t, r, n) {
    const o = await (await this.bucketCrypto).encryptBlob(t), u = {};
    return r && (u.metadata = X.serialize(r)), n && (u.sort = n), this.gatewayClient.post("/storage/store/" + this.buildPath(e), o, u);
  }
  async updateMeta(e, t) {
    const r = { metadata: X.serialize(t) };
    return this.gatewayClient.post("/storage/meta/" + this.buildPath(e), void 0, r);
  }
  async appendPlainText(e, t, r, n) {
    const s = {};
    return r && (s.metadata = X.serialize(r)), n && (s.sort = n), this.gatewayClient.post("/storage/append/" + this.buildPath(e), t, s);
  }
}
const lc = "1.2.276.0.76.4.173";
class Ht {
  static schema(e) {
    return new N.Sequence({
      name: "recipientEmail",
      value: [
        new N.IA5String({
          name: "emailAddress"
        }),
        xs.schema({ names: { blockName: "rid" } })
      ]
    });
  }
  equals(e) {
    let t = !0;
    return t = t && this.emailAddress.isEqual(e.emailAddress), this.rid.value instanceof _i && e.rid.value instanceof _i ? (t = t && this.rid.value.issuer.isEqual(e.rid.value.issuer), t = t && this.rid.value.serialNumber.isEqual(e.rid.value.serialNumber)) : this.rid.value instanceof N.OctetString && e.rid.value instanceof N.OctetString ? t = t && this.rid.value.isEqual(e.rid.value) : t = !1, t;
  }
  static create(e, t) {
    const r = new _i({ issuer: t.issuer, serialNumber: t.serialNumber }), n = new xs({ variant: 1, value: r });
    return new N.Sequence({ value: [new N.IA5String({ value: e }), n.toSchema()] });
  }
  constructor(e, t) {
    this.emailAddress = new N.IA5String({ value: e }), this.rid = new xs({ variant: 1, value: t });
  }
  static fromCMS(e) {
    const t = [];
    for (const r of e.unauthAttrs || [])
      if (r.type === lc)
        for (const n of r.values)
          t.push(Ht.fromSchema(n));
    return t;
  }
  static fromSchema(e) {
    const t = N.compareSchema(
      e,
      e,
      Ht.schema()
    ), r = new Ht("", {});
    return r.rid = new xs({ schema: t.result.rid }), r.emailAddress = t.result.emailAddress, r;
  }
}
class qi {
  constructor(e) {
    this.httpsClientFactory = e, this.timeout = 60 * 1e3;
  }
  setTimeoutRead(e) {
    this.timeout = e;
  }
  setVerifyTlsConnection(e) {
    this.onVerifyTlsConnection = e;
  }
  async fetch(e, t) {
    const r = new Request(e, t), n = new URL(r.url);
    let s;
    try {
      const o = this.httpsClientFactory(n.host);
      o.setTimeoutRead(this.timeout), this.onVerifyTlsConnection && (o.onVerifyTlsConnection = this.onVerifyTlsConnection);
      for (const l of r.headers)
        o.addHeader(l[0], l[1]);
      const u = await r.arrayBuffer();
      return s = await o.fetch(r.method, qi.getOriginForm(n), u), o.debugEnabled && console.log("Fetch Data", V.stringDecode(u)), new Response(s.statusCode === 204 ? null : s.data, { headers: s.headers.map((l) => [l.name, l.value]), status: s.statusCode, statusText: s.statusText });
    } catch (o) {
      throw new Tr("FETCH_ERROR", n.toString(), r, s, o);
    }
  }
  static getOriginForm(e) {
    return (e.pathname ?? "/") + (e.search ?? "");
  }
}
class ow {
  constructor(e) {
    this.connector = e, this.instances = /* @__PURE__ */ new Map();
  }
  async generateToken(e, t = !1) {
    const r = this.instances.get(e.iccsn);
    if (!t && r && r.creationTime.getTime() > (/* @__PURE__ */ new Date()).getTime() - 4 * 60 * 1e3)
      return r.jwt;
    this.instances.delete(e.iccsn);
    const s = await this.connector.getCertificateService().readCardCertificate(e.handle, [Pe.C_AUT]), o = JSON.stringify({ alg: "PS256", typ: "JWT", x5c: [s[0].x509Data.x509Certificate] }), u = JSON.stringify({ nbf: Math.floor((/* @__PURE__ */ new Date()).getTime() / 1e3) }), l = ye.toBase64(o, !0) + "." + ye.toBase64(u, !0), m = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(l)), y = ye.fromUint8Array(new Uint8Array(m), !1), P = await this.connector.getAuthSignatureService().externalAuthenticate(e.handle, y), M = l + "." + (P == null ? void 0 : P.base64Signature.base64Signature);
    return this.instances.set(e.iccsn, { creationTime: /* @__PURE__ */ new Date(), jwt: M }), M.replaceAll("+", "-").replaceAll("/", "_").replaceAll("=", "");
  }
}
class ce extends Error {
  constructor(e, t, r) {
    super(e), this.message = e, this.code = t, this.detail = r;
  }
}
class zc {
  constructor(e, t) {
    this.cardHandle = e, this.requiredPinType = t;
  }
}
class aw {
  constructor(e, t) {
    this.messageId = e, this.reason = t;
  }
}
class cw {
  constructor(e, t) {
    this.cmVersion = e, this.vzdKimVersion = t;
  }
}
const pi = class pi {
  constructor(e, t) {
    this.accountManagerResponse = e, this.bodyText = t;
  }
  get code() {
    return pi.CODE_MAP.get(this.accountManagerResponse.status) ?? "UNKNOWN";
  }
};
pi.CODE_MAP = /* @__PURE__ */ new Map([
  [400, "BAD_REQUEST"],
  [401, "UNAUTHORIZED"],
  [404, "ADDRESS_NOT_FOUND"],
  [409, "ACCOUNT_ALREADY_REGISTERED"],
  [420, "USERNAME_OR_PASSWORD_NOT_VALID"],
  [422, "UNSUPPORTED_KIM_VERSION"]
]);
let Ko = pi;
class uw {
  constructor() {
    this.recipientErrors = [];
  }
  addRecipientError(e) {
    this.recipientErrors.push(e);
  }
  get hasError() {
    return this.recipientErrors.length !== 0;
  }
}
class Us {
  constructor(e, t, r) {
    this.recipientAddress = e, this.errorCode = t, this.message = r;
  }
}
class Wc {
  constructor(e, t) {
    this.errorCode = e, this.data = t;
  }
}
const gi = class gi {
  constructor(e, t) {
    this.kasClientResponse = e, this.bodyText = t;
  }
  get code() {
    return gi.CODE_MAP.get(this.kasClientResponse.status) ?? "UNKNOWN";
  }
};
gi.CODE_MAP = /* @__PURE__ */ new Map([
  [400, "BAD_REQUEST"],
  [401, "UNAUTHORIZED"],
  [404, "MESSAGE_NOT_FOUND"],
  [413, "MESSAGE_TOO_LARGE"],
  [507, "STORAGE_FULL"]
]);
let ci = gi;
class ee {
  static log(e) {
    document.body.dispatchEvent(new CustomEvent("log", { bubbles: !0, detail: e }));
  }
  static error(e) {
    document.body.dispatchEvent(new CustomEvent("log", { bubbles: !0, detail: e }));
  }
}
class hw {
  constructor(e) {
    this.start = (/* @__PURE__ */ new Date()).getTime(), e ? this.id = e : (this.id = crypto.randomUUID(), this.id = this.id.substring(this.id.length - 8, this.id.length));
  }
  debug(...e) {
    k.debug(this.id, (/* @__PURE__ */ new Date()).getTime() - this.start, ...e);
  }
  error(...e) {
    k.error(this.id, (/* @__PURE__ */ new Date()).getTime() - this.start, ...e);
  }
}
const gt = class gt {
  static init(e) {
    this.remoteStorage = e, this.storeRemoteDelayed(), window.setTimeout(() => {
      var t;
      return (t = this.remoteStorage) == null ? void 0 : t.cleanupLogs();
    }, this.cleanupLogsDelay);
  }
  static getLogPeriod(e) {
    return (/* @__PURE__ */ new Date()).toISOString().substring(0, 10);
  }
  static log(...e) {
    this.logMemCache.length === 0 && (this.logMemCache = this.loadFromLocalStorage(this.getLogPeriod())), this.logMemCache.length > 0 && this.lastLogPeriod !== this.getLogPeriod() && (this.storeToLocalStorage(), this.lastLogPeriod = this.getLogPeriod(), this.logMemCache = []), this.logMemCache.push(e), this.storeLocalDelayed();
  }
  static loadFromLocalStorage(e) {
    const t = window.localStorage.getItem(this.KIM_LOG_PREFIX + e);
    return t ? JSON.parse(t) : [];
  }
  static storeToLocalStorage() {
    window.localStorage.setItem(this.KIM_LOG_PREFIX + this.lastLogPeriod, X.serialize(this.logMemCache));
  }
  static storeRemoteDelayed() {
    this.remoteStorageTimeoutId || (this.remoteStorageTimeoutId = window.setTimeout(
      async () => {
        if (this.remoteStorage) {
          this.logMemCache.length > 0 && (await this.remoteStorage.storeLogs(this.lastLogPeriod, this.logMemCache), window.localStorage.removeItem(this.KIM_LOG_PREFIX + this.lastLogPeriod), this.logMemCache = []);
          const e = this.findStoredLogs();
          for (const t of e) {
            const r = this.loadFromLocalStorage(t);
            await this.remoteStorage.storeLogs(this.lastLogPeriod, r), window.localStorage.removeItem(this.KIM_LOG_PREFIX + this.lastLogPeriod);
          }
        }
        this.remoteStorageTimeoutId = void 0;
      },
      this.remoteStorageIntervalTime
    ));
  }
  static findStoredLogs() {
    const e = [];
    for (let t = 0; t < window.localStorage.length; t++) {
      const r = window.localStorage.key(t);
      r != null && r.startsWith(this.KIM_LOG_PREFIX) && e.push(r.substring(this.KIM_LOG_PREFIX.length));
    }
    return e;
  }
  static storeLocalDelayed() {
    this.storeRemoteDelayed(), this.localStorageTimeoutId && window.clearTimeout(this.localStorageTimeoutId), this.localStorageTimeoutId = window.setTimeout(
      () => {
        this.storeToLocalStorage(), this.localStorageTimeoutId = void 0;
      },
      this.localStorageDebounceTime
    );
  }
  static timer(e) {
    return new hw(e);
  }
  static debug(...e) {
    this.log(/* @__PURE__ */ new Date(), "d", ...e), console.debug(...e);
  }
  static info(...e) {
    this.log(/* @__PURE__ */ new Date(), "i", ...e), console.info(...e);
  }
  static warn(...e) {
    this.log(/* @__PURE__ */ new Date(), "w", ...e), console.warn(...e);
  }
  static error(...e) {
    this.log(/* @__PURE__ */ new Date(), "e", ...e), console.error(...e);
  }
};
gt.KIM_LOG_PREFIX = "kim_log_", gt.remoteStorageIntervalTime = 30 * 1e3, gt.localStorageDebounceTime = 200, gt.cleanupLogsDelay = 90 * 1e3, gt.logMemCache = [], gt.lastLogPeriod = gt.getLogPeriod();
let k = gt;
class ys {
  constructor(e, t, r, n, s) {
    this.ti365session = e, this.tlsCertificateCheckService = t, this.settings = r, this.card = n, this.privateSettings = s, this.baseUrl = "https://" + `${this.settings.accountManagerUri}/AccountMgmt/v2.3`.replaceAll("//", "/"), this.limitBaseUrl = "https://" + `${this.settings.accountManagerUri}/AccountLimit/v1.1`.replaceAll("//", "/"), this.password = (s == null ? void 0 : s.password) ?? "";
  }
  static withPassword(e, t, r, n, s) {
    const o = new ys(e, t, r, n);
    return o.password = s ?? "", o;
  }
  static create(e, t, r, n, s) {
    return new ys(e, t, r, n, s);
  }
  async jwtAuthTokenService() {
    if (!this._jwtAuthTokenService) {
      const e = await this.ti365session.getConnector();
      this._jwtAuthTokenService = new ow(e);
    }
    return this._jwtAuthTokenService;
  }
  createFetchClient() {
    const e = new qi((t) => this.getAccountManagerHttpsClient(this.settings.kimAddress, t));
    return e.onVerifyTlsConnection = this.tlsCertificateCheckService.checkServerCert, e;
  }
  getAccountManagerHttpsClient(e, t) {
    let r;
    if (this.privateSettings) {
      const n = this.privateSettings.keys;
      r = { clientCertificate: n.certificatePem, clientPrivateKey: n.privateKeyPem };
    }
    return this.ti365session.getHttpClient(ot.KIM_ACCOUNT_MANAGER, t, { kimAccountAddress: e }, r);
  }
  async createHeaderWithJwtAndPasswordAuth(e) {
    return this.createHeadersWithJwtAuth({ password: this.password, ...e });
  }
  async createHeadersWithJwtAuth(e) {
    return {
      Authorization: "Bearer " + await this.createJwtAuth(),
      "Content-Type": "application/json",
      Accept: "application/json",
      ...e
    };
  }
  async createJwtAuth() {
    return (await this.jwtAuthTokenService()).generateToken(this.card);
  }
  async registerAccount(e, t, r) {
    const s = await this.createFetchClient().fetch(this.baseUrl + "/account", {
      method: "POST",
      headers: await this.createHeadersWithJwtAuth({ iniPassword: e }),
      body: JSON.stringify({ referenceID: t, password: r, kimVersion: "1.5", username: this.settings.kimAddress })
    });
    await this.handleResponse(s), this.password = r;
  }
  async handleResponse(e) {
    if (e.status < 200 || e.status > 299) {
      const t = await e.text().catch(() => "");
      throw k.debug("Received HTTP " + e.status, t), new ce("Error on calling account manager function", "ACCOUNT_MANAGER_ERROR", new Ko(e, t));
    }
  }
  /**
   * Updates data from the Account
   * @param password 
   * @param data 
   * @returns 
   */
  async setAccount(e) {
    const r = await this.createFetchClient().fetch(`${this.baseUrl}/account/${this.settings.kimAddress}`, {
      method: "PUT",
      headers: await this.createHeaderWithJwtAndPasswordAuth(),
      body: X.serialize(e)
    });
    await this.handleResponse(r);
  }
  /**
   * Reads the state of the account.
   * @returns 
   */
  async getAccount() {
    const t = await this.createFetchClient().fetch(`${this.baseUrl}/account/${this.settings.kimAddress}`, {
      method: "GET",
      headers: await this.createHeaderWithJwtAndPasswordAuth()
    });
    await this.handleResponse(t);
    const r = X.deserialize(await t.text());
    if (r.kimVersion !== void 0)
      return r;
  }
  /**
   * Diese Operation erzeugt für den KIM Account/e-Mail Adresse ein One Time Passwort (OTP), mit dem die e-Mail Adresse zu einer telematikID (Karte) portiert werden kann. Die Authentisierung erfolgt mit der bisherigen Karte.
   * @returns 
   */
  async getAccountTransferOtp() {
    const t = await this.createFetchClient().fetch(`${this.baseUrl}/account/${this.settings.kimAddress}/OTP`, {
      method: "GET",
      headers: await this.createHeaderWithJwtAndPasswordAuth()
    });
    await this.handleResponse(t);
    const r = await t.text(), n = X.deserialize(r);
    if (n.otp !== void 0)
      return n.otp;
    if (n.OTP !== void 0)
      return n.OTP;
  }
  /**
   *  Diese Operation entfernt die e-mail Adresse vom bisherigen VZD Eintrag und trägt die für den aktuellen VZD Eintrag (der den Authentisierungsdaten dieser Operation setTID entspricht) ein. Die Authentisierung erfolgt mit der neuen Karte.
   * @param transferPassword 
   * @returns 
   */
  async transferAccount(e) {
    const r = await this.createFetchClient().fetch(`${this.baseUrl}/account/${this.settings.kimAddress}/telematikID`, {
      method: "PUT",
      headers: await this.createHeaderWithJwtAndPasswordAuth({ otp: e })
    });
    await this.handleResponse(r);
  }
  /**
   * Deregistriert einen Mailaccount
   * @returns 
   */
  async deregisterAccount() {
    const t = await this.createFetchClient().fetch(`${this.baseUrl}/account/${this.settings.kimAddress}`, {
      method: "DELETE",
      headers: await this.createHeaderWithJwtAndPasswordAuth()
    });
    this.handleResponse(t);
  }
  /**
   * Deregistrierung des Accounts zurücknehmen 
   * @returns 
   */
  async revokeDeregisterAccount() {
    const t = await this.createFetchClient().fetch(`${this.baseUrl}/account/${this.settings.kimAddress}/revokeDeregistration`, {
      method: "PUT",
      headers: await this.createHeaderWithJwtAndPasswordAuth()
    });
    await this.handleResponse(t);
  }
  async getLimit(e) {
    const r = await this.createFetchClient().fetch(`${this.limitBaseUrl}/limit`, {
      method: "GET",
      headers: {
        Authorization: "Basic " + btoa(this.settings.kimAddress + ":" + e),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    });
    return await this.handleResponse(r), await r.json();
  }
  async getOutOfOffice() {
    const t = await this.createFetchClient().fetch(`${this.baseUrl}/account/${this.settings.kimAddress}/outofoffice`, {
      method: "GET",
      headers: await this.createHeaderWithJwtAndPasswordAuth()
    });
    await this.handleResponse(t);
    const r = X.deserialize(await t.text());
    if (r.active !== void 0)
      return r;
  }
  async setOutOfOffice(e) {
    const t = this.createFetchClient();
    let r = X.serialize(e).replaceAll(".000Z", "Z");
    const n = await t.fetch(`${this.baseUrl}/account/${this.settings.kimAddress}/outofoffice`, {
      method: "PUT",
      headers: await this.createHeaderWithJwtAndPasswordAuth(),
      body: r
    });
    await this.handleResponse(n);
  }
  async createCert() {
    const e = crypto.randomUUID(), t = ye.encode(e), r = this.createFetchClient();
    let n;
    n = JSON.stringify({ commonName: `yot-icm-ti365_${(/* @__PURE__ */ new Date()).getTime()}`, certPassword: t });
    const s = await r.fetch(`${this.baseUrl}/account/${this.settings.kimAddress}/cert`, {
      method: "POST",
      headers: await this.createHeaderWithJwtAndPasswordAuth(),
      body: n
    });
    await this.handleResponse(s);
    const o = (await s.json()).file;
    return await this.decryptRsaFromP12Container(o, e);
  }
  async decryptRsaFromP12Container(e, t) {
    const r = (await import("node-forge")).default, n = r.util.decode64(e), s = r.asn1.fromDer(n), o = r.pkcs12.pkcs12FromAsn1(s, t);
    return this.extractKeystore(r, o);
  }
  extractKeystore(e, t) {
    const r = t.getBags({ bagType: "1.2.840.113549.1.12.10.1.3" }), n = r["1.2.840.113549.1.12.10.1.3"].find((u) => {
      var l;
      return ((l = u.cert) == null ? void 0 : l.signatureOid) === "1.2.840.113549.1.1.11";
    }) || r["1.2.840.113549.1.12.10.1.3"][0], o = t.getBags({ localKeyId: n.attributes.localKeyId[0], bagType: "1.2.840.113549.1.12.10.1.2" }).localKeyId[0];
    if (n.cert)
      return this.extractRsaCertificate(e, t, n, o);
    {
      const u = `-----BEGIN CERTIFICATE-----
${e.util.encode64(e.asn1.toDer(n.asn1).getBytes(), 64)}
-----END CERTIFICATE-----`;
      return { privateKeyPem: `-----BEGIN PRIVATE KEY-----
${e.util.encode64(e.asn1.toDer(o.asn1).getBytes(), 64)}
-----END PRIVATE KEY-----`, certificatePem: u };
    }
  }
  extractRsaCertificate(e, t, r, n) {
    const s = r.cert, o = e.pki.certificateToPem(s), u = e.pki.privateKeyToAsn1(n.key), l = e.pki.wrapRsaPrivateKey(u);
    return { privateKeyPem: e.pki.privateKeyInfoToPem(l), certificatePem: o };
  }
  async updatePassword(e) {
    await this.setAccount({
      password: e
    }), this.password = e, ee.log("Passwort wurde geändert.");
  }
}
const ft = class ft {
  constructor() {
  }
  // done
};
ft.smtpTimeoutServer = 5 * 60 * 1e3, ft.pop3TimeoutServer = 5 * 60 * 1e3, ft.ttlEncCert = 12 * 60 * 60 * 1e3, ft.ttlProts = 30 * 24 * 60 * 60 * 1e3, ft.protPerf = !0, ft.cmKasTimeout = 30 * 1e3, ft.konnektorTimeout = 60 * 1e3;
let Kt = ft;
class j {
  constructor(e, t, r, n) {
    this.type = e, this.message = t, this.code = r, this._header = n;
  }
  static info(e, t) {
    return new j("info", e, t);
  }
  static infoWithHeader(e, t, r) {
    return new j("info", e, t, r);
  }
  static warn(e, t) {
    return new j("warn", e, t);
  }
  static warnHeader(e, t, r) {
    const n = new j("warn", e, r);
    return n.setHeader(t, r), n;
  }
  static error(e, t) {
    return new j("error", e, t);
  }
  static errorHeader(e, t, r) {
    const n = new j("error", e, r);
    return n.setHeader(t, r), n;
  }
  get header() {
    return this._header;
  }
  setHeader(e, t) {
    this._header = new q(e, t);
  }
}
class lw {
  constructor() {
    this.parts = [];
  }
  get boundary() {
    return this._boundary || (this._boundary = "------" + crypto.randomUUID().replaceAll("-", "")), this._boundary;
  }
  append(e, t, r = "", n = []) {
    const s = r ? `; filename="${r}"` : "", o = [`Content-Disposition: form-data; name="${e}"${s}`, ...n];
    t instanceof Blob && (o.push("Content-Type: application/octet-stream"), o.push(`Content-Length: ${t.size}`)), this.parts.push({ content: t, headers: o });
  }
  async getRawBody() {
    let e = [];
    const t = new TextEncoder();
    for (const n of this.parts) {
      let s = "--" + this.boundary + `\r
`;
      if (s += n.headers.join(`\r
`), s += `\r
\r
`, n.content instanceof Blob) {
        const o = t.encode(s);
        e.push(o);
        const u = new Uint8Array(await n.content.arrayBuffer());
        e.push(u), e.push(t.encode(`\r
`));
      } else {
        s += n.content + `\r
`;
        const o = t.encode(s);
        e.push(o);
      }
    }
    const r = t.encode("--" + this.boundary + `--\r
`);
    return e.push(r), me.concatUint8(...e);
  }
}
class dw {
  constructor(e, t, r, n, s) {
    if (this.ti365Session = e, this.kimSettings = t, this.kimCredentials = r, this.expireTimeoutSec = n, this.tlsCertificateCheckService = s, this.encryptionAlgorithm = {
      name: "AES-GCM",
      length: 256,
      iv: V.random(12)
    }, !t.kasHostname)
      throw new Error("KiM Settings from Server does not contain the Hostname for the KiM Attachment Storage");
    this.baseUrl = "https://" + t.kasUri + "attachments/v2.3/", this.ownKasClient = this.createKasFetchClient(ot.KIM_ATTACHMENT_STORAGE), this.foreignKasClient = this.createKasFetchClient(ot.KIM_FOREIGN_ATTACHMENT_STORAGE);
  }
  createKasFetchClient(e) {
    const t = (n) => this.ti365Session.getHttpClient(
      e,
      n,
      { kimAccountAddress: this.kimSettings.kimAddress, kasHost: n },
      {
        clientPrivateKey: this.kimCredentials.keys.privateKeyPem,
        clientCertificate: this.kimCredentials.keys.certificatePem
      }
    ), r = new qi(t);
    return r.setTimeoutRead(Kt.cmKasTimeout), r.onVerifyTlsConnection = this.tlsCertificateCheckService.checkServerCert, r;
  }
  getExpireTime() {
    const e = (/* @__PURE__ */ new Date()).getTime();
    return new Date(e + this.expireTimeoutSec * 1e3).toUTCString();
  }
  async createHash(e) {
    const t = await window.crypto.subtle.digest(
      {
        name: "SHA-256"
      },
      e
      //The data you want to hash as an ArrayBuffer
    );
    return V.uint8AsBase64(t);
  }
  async store(e, t, r) {
    const n = k.timer("kas_" + e);
    n.debug("hash and crypt start");
    const s = await this.createHash(r), o = await this.encrypt(r), u = new lw();
    u.append("messageID", e);
    for (const m of t)
      u.append("recipients", m);
    u.append("expires", this.getExpireTime()), u.append("attachment", new Blob([o.iv, o.uint8]), "blob"), n.debug("send to kas");
    const l = await this.ownKasClient.fetch(this.baseUrl + "attachment", {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: "Basic " + btoa(this.kimCredentials.address + ":" + this.kimCredentials.password),
        "Content-Type": `multipart/form-data; boundary=${u.boundary}`
      },
      body: await u.getRawBody()
    });
    if (n.debug("send to kas  done " + l.status), l.status === 200 || l.status === 201)
      return {
        link: (await l.json()).sharedLink,
        k: o.key,
        hash: s,
        size: r.byteLength
      };
    {
      const m = await l.text();
      throw ee.error("Der Server meldet einen Fehler beim Speichern der KiM Nachricht"), new ce("Error on calling kas client function", "KAS_CLIENT_ERROR", new ci(l, m));
    }
  }
  async load(e) {
    if (!e.link || !e.k)
      return j.error("Die KiM Attachment Storage Informationen entsprechen nicht einem gültigen Format. Verarbeitung wird abgebrochen.");
    const t = k.timer("kas_" + e.hash.substring(0, 6));
    t.debug("start download");
    const r = await this.foreignKasClient.fetch(e.link, {
      headers: {
        recipient: this.kimSettings.kimAddress
      }
    });
    if (r.status === 400) {
      const u = await r.text();
      return console.error(u), j.error("KiM Attachment Storage meldet 400: " + u);
    } else if (r.status === 401) {
      const u = j.error("Ihre Zugangsdaten werden vom KiM Attachment Storage Server abgewiesen.");
      return u.subject = "Die E-Mail-Daten konnten nicht abgerufen werden", u;
    } else if (r.status === 404) {
      const u = j.error("KiM Nachrichteninhalt ist nicht mehr verfügbar");
      return u.subject = "Die E-Mail-Daten konnten nicht abgerufen werden", u;
    } else if (r.status === 429) {
      Q.error("KiM Nachrichteninhalt wurde bereits zu oft heruntergeladen.");
      const u = j.errorHeader("Verschlüsselte E-Mail-Daten konnten nicht heruntergeladen werden, da durch zu häufigen Zugriff der KOM-LE-Attachment-Service den Abruf verweigert.", "X-KIM-Fehlermeldung", "4013 ");
      return u.subject = "Die E-Mail-Daten konnten nicht abgerufen werden", u;
    } else if (r.status > 400)
      throw console.error(r), new Error(`Server: ${r.status} Unknown Server Error`);
    t.debug("start decryption");
    const n = await r.arrayBuffer();
    let s;
    try {
      s = await this.decrypt(n, e);
    } catch {
      const l = j.errorHeader("Beim Entschlüsseln der E-Mail-Daten ist ein Fehler  aufgetreten", "X-KIM-Fehlermeldung", "4007");
      return l.subject = "Abgerufene E-Mail-Daten konnten nicht entschlüsselt werden.", l;
    }
    return t.debug("calculate hash"), await this.createHash(s) !== e.hash ? j.errorHeader(
      "Beim Empfang dieser KIM-Nachricht wurde eine Sicherheitsverletzung erkannt.  Dies kann eine technisches Ursache haben oder auf eine missbräuchliche Nutzung  des KIM-Dienstes hinweisen. Zu Ihrem Schutz wurde der Inhalt dieser Nachricht durch diesen Text ausgetauscht. Bitte antworten Sie nicht auf diese Nachricht.  Sie können diese Nachricht löschen. Die Prüfsumme der E-Mail-Daten stimmt nicht mit der beigefügten Prüfsumme überein. Die empfangene aufbereitete Client-Mail entspricht eventuell nicht der vom Sender auf dem KAS hinterlegten aufbereiteten Client-Mail.",
      "X-KIM-Fehlermeldung",
      "4012"
    ) : (t.debug("done"), s);
  }
  async delete(e) {
    const t = await this.ownKasClient.fetch(e, {
      method: "DELETE",
      headers: { Authorization: "Basic " + btoa(this.kimCredentials.address + ":" + this.kimCredentials.password) }
    });
    if (t.status >= 400) {
      const r = await t.text();
      throw new ce("Error on calling kas client function", "KAS_CLIENT_ERROR", new ci(t, r));
    }
  }
  async encrypt(e) {
    const t = await window.crypto.subtle.generateKey(this.encryptionAlgorithm, !0, ["encrypt"]), r = await window.crypto.subtle.exportKey("raw", t), n = {
      ...this.encryptionAlgorithm,
      iv: V.random(12)
    }, s = await window.crypto.subtle.encrypt(
      n,
      t,
      e
    );
    return {
      key: V.uint8AsBase64(r),
      iv: n.iv,
      uint8: s
    };
  }
  async decrypt(e, t) {
    const r = new Uint8Array(e, 0, 12), n = new Uint8Array(e, 12), s = V.uint8FromBase64(t.k), o = await window.crypto.subtle.importKey("raw", s, this.encryptionAlgorithm, !1, ["decrypt"]);
    try {
      const u = {
        ...this.encryptionAlgorithm,
        iv: r
      };
      return await window.crypto.subtle.decrypt(
        u,
        o,
        n
      );
    } catch {
      throw new ce("Data could not be decrypted, invalid key, data or iv!", "KAS_CLIENT_ERROR");
    }
  }
}
class dc {
  constructor(e) {
    this.asn1 = e;
  }
  get unauthAttrs() {
    return (this.asn1.unauthAttrs || []).map((e) => new bn({ schema: e }));
  }
  get authAttrs() {
    return (this.asn1.authAttrs || []).map((e) => new bn({ schema: e }));
  }
  get recipientInfos() {
    return (this.asn1.recipientInfos || []).map((e) => new mc({ schema: e }));
  }
  get originatorInfo() {
    return (this.asn1.originatorInfo || []).map((e) => new wc({ schema: e }));
  }
  static parse(e) {
    const t = new N.Sequence(
      {
        value: [
          new N.Integer({ name: "version" }),
          new N.Constructed({
            name: "originatorInfo",
            optional: !0,
            idBlock: {
              tagClass: 3,
              // CONTEXT-SPECIFIC
              tagNumber: 0
              // [0]
            },
            value: wc.schema().valueBlock.value
          }),
          new N.Set({
            value: [
              new N.Repeated({
                name: "recipientInfos",
                value: mc.schema()
              })
            ]
          }),
          sh.schema({}),
          new N.Constructed({
            optional: !0,
            idBlock: {
              tagClass: 3,
              // CONTEXT-SPECIFIC
              tagNumber: 1
              // [1]
            },
            value: [new N.Repeated({
              name: "authAttrs",
              value: bn.schema()
            })]
          }),
          new N.OctetString({ name: "mac" }),
          // MessageAuthenticationCode
          new N.Constructed({
            optional: !0,
            idBlock: {
              tagClass: 3,
              // CONTEXT-SPECIFIC
              tagNumber: 2
              // [2]
            },
            value: [new N.Repeated({
              name: "unauthAttrs",
              value: bn.schema()
            })]
          })
        ]
      }
    ), r = N.compareSchema(
      e,
      e,
      t
    );
    if (r.verified)
      return new dc(r.result);
    throw console.error("Error while parsing CMS", r), new Error("Invalid CMS Message");
  }
}
const Qt = class Qt {
};
Qt.VERSION_NAME = "X-KOM-LE-Version", Qt.VERSION_DEFAULT_VALUE = "1.0", Qt.DIENSTKENNUNG_NAME = "X-KIM-Dienstkennung", Qt.DIENSTKENNUNG_DEFAULT_VALUE = "KIM-Mail;Default;V1.0", Qt.SENDERSYSTEM_NAME = "X-KIM-Sendersystem", Qt.SUPPORT_NAME = "X-KIM-Support";
let St = Qt;
class Sn {
  constructor(e, t, r, n, s, o = !0) {
    this.serverUid = e, this.signatureVerified = t, this.outerHeaders = r, this.mail = n, this.logs = s, this.wasEncrypted = o;
  }
  hasProcessingErrors() {
    return !!this.logs.find((e) => e.type === "error");
  }
  async storeMail(e) {
    var A, P, M, p;
    const t = ((A = this.outerHeaders.getHeaderByName(St.VERSION_NAME)) == null ? void 0 : A.value) ?? St.DIENSTKENNUNG_DEFAULT_VALUE, r = ((P = this.outerHeaders.getHeaderByName(St.DIENSTKENNUNG_NAME)) == null ? void 0 : P.value) ?? St.DIENSTKENNUNG_DEFAULT_VALUE, n = k.timer();
    n.debug("prepare mail for storage");
    let s, o;
    this.mail.parts.length > 0 ? (s = (M = this.findMimePartByType("text/plain", this.mail.parts[0])) == null ? void 0 : M.getContentDecodedString(), o = (p = this.findMimePartByType("text/html", this.mail.parts[0])) == null ? void 0 : p.getContentDecodedString()) : (s = this.mail.contentType.value.startsWith("text/plain") ? this.mail.getContentDecodedString() : void 0, o = this.mail.contentType.value.startsWith("text/html") ? this.mail.getContentDecodedString() : void 0);
    const u = await this.findAttachments([this.mail]);
    o && (o = this.replaceCidUrlsWithAttachments(o, u));
    const l = {
      mailServerUid: this.serverUid,
      storageId: crypto.randomUUID(),
      receivedDate: /* @__PURE__ */ new Date(),
      isNew: !0,
      hasAttachments: u.length > 0,
      hasErrors: this.hasProcessingErrors(),
      isSignatureCorrect: this.signatureVerified,
      wasEncrypted: this.wasEncrypted,
      kimVersion: t,
      kimDienstkennung: r,
      outerHeadersMimeString: this.outerHeaders.toMimeString(),
      innerHeadersMimeString: this.mail.headers.toMimeString()
    };
    n.debug("store attachments");
    let m = await Promise.all(u.map((w) => this.storeAttachment(e, l.storageId, w)));
    n.debug("store mail");
    const y = {
      ...l,
      textContent: s,
      htmlContent: o,
      logs: this.logs,
      attachments: m
    };
    return await e.storeKimMail(y, l), n.debug("store done"), y;
  }
  /**
   * 
   * @param htmlContent 
   * @param attachmentBodyParts Attachments that will be included within the mail will be removed.
   * @returns 
   */
  replaceCidUrlsWithAttachments(e, t) {
    const r = [...e.matchAll(/(cid:([^"]+))/g)];
    for (const n of r) {
      const s = "<" + decodeURIComponent(n[2]) + ">";
      let o;
      for (const u of t) {
        const l = u.headers.getHeaderByName("Content-ID");
        if (l && l.value == s) {
          const m = u.contentType.value.indexOf(";");
          o = "data:" + u.contentType.value.substring(0, m <= 0 ? void 0 : m) + ";base64," + V.uint8AsBase64(u.getContentDecodedBinary()), t.splice(t.indexOf(u), 1);
          break;
        }
      }
      o && (e = e.replaceAll(n[1], o));
    }
    return e;
  }
  findMimePartByType(e, t) {
    if (t.contentType.value.toLowerCase().startsWith(e.toLowerCase()))
      return t;
    if (t.parts)
      for (const r of t.parts) {
        const n = this.findMimePartByType(e, r);
        if (n)
          return n;
      }
  }
  async findAttachments(e) {
    var r;
    const t = [];
    for (const n of e)
      if (((r = n.parts) == null ? void 0 : r.length) > 0)
        t.push(...await this.findAttachments(n.parts));
      else {
        const s = n.headers.getHeaderByName("Content-Disposition") != null, o = n.getRawContent() != null, u = n.contentType.value.toLocaleLowerCase().startsWith("text");
        o && (!u || s) && t.push(n);
      }
    return t;
  }
  async storeAttachment(e, t, r) {
    const n = r.headers.getHeaderByName("Content-Disposition"), s = r.getContentDecodedBinary();
    if (!s)
      throw new Error("Can not store attachment without content.");
    const o = r.headers.getHeaderByName("Content-ID");
    let u;
    o && (u = o.value);
    const l = r.headers.getHeaderByName("Content-Description"), m = r.contentType.value.indexOf(";"), A = {
      mimeType: r.contentType.value.substring(0, m <= 0 ? void 0 : m),
      size: s.length,
      contentId: u,
      title: (n == null ? void 0 : n.getParameter("filename")) || (l == null ? void 0 : l.value) || u || "unbekannter Anhang"
    };
    return await e.storeAttachment(t, A, s);
  }
}
class pw {
  constructor(e) {
    this.outerMail = e;
  }
  get from() {
    return this.outerMail.headers.from;
  }
  get sentDate() {
    return this.outerMail.headers.date;
  }
  get kimVersion() {
    var e;
    return ((e = this.outerMail.headers.getHeaderByName("X-KOM-LE-Version")) == null ? void 0 : e.value) ?? "1.0";
  }
  get kimDienstkennung() {
    var e;
    return ((e = this.outerMail.headers.getHeaderByName("X-KIM-Dienstkennung")) == null ? void 0 : e.value) ?? "KIM-Mail;Default;V1.0";
  }
  get headers() {
    return this.outerMail.headers;
  }
}
class gw {
  constructor(e, t, r) {
    this.ti365Session = e, this.kimStoredSettingsDto = t, this.kasClientGetter = r;
  }
  async initCardHandleCertificateSerialNumberCache() {
    let e = /* @__PURE__ */ new Map();
    const t = await this.ti365Session.getConnector();
    let r = await this.ti365Session.cardService.getCards();
    r = r.filter((n) => n.type === _.SMC_B || n.type === _.HBA);
    for (const n of r)
      e = await this.cacheCardCertificates(t, e, n.handle, ir.ECC), e = await this.cacheCardCertificates(t, e, n.handle, ir.RSA);
    return e;
  }
  async cacheCardCertificates(e, t, r, n) {
    try {
      const s = await e.getCertificateService().readCardCertificate(r, [Pe.C_ENC], n);
      for (const o of s)
        t.set(o.x509Data.x509IssuerSerial.x509SerialNumber, r);
    } catch {
      k.warn("could not read certificates from card for type " + n);
    }
    return t;
  }
  async parse(e, t, r) {
    const n = k.timer(e);
    n.debug("Start KimMessage parse");
    const s = [], o = t.headers.getHeaderByName("X-KOM-LE-Version");
    if (!o)
      return n.debug("Received non KiM mail"), s.push(j.warn("Mail wurde unverschlüsselt empfangen!")), new Sn(e, !1, t.headers, t, s, !1);
    if (o.value !== "1.0" && o.value !== "1.5") {
      n.error("Received mail with newer KiM version", o.value);
      const Y = j.error(`Das verwendete Clientmodul unterstützt die in der empfangenen Nachricht angegebene KIM-Version ${o.value} nicht.`);
      return Y.subject = "Die KIM-Version der empfangenen Nachricht wird nicht unterstützt", s.push(Y), new Sn(e, !1, t.headers, t, s);
    }
    n.debug("Parsing recipients from message");
    const u = this.loadRecipientInfosFromEncryptedCMS(t.getContentDecodedBinary()), l = await this.findCardHandleForEncryptedMail(u);
    if (!l)
      return s.push(j.errorHeader("Der für die Entschlüsselung der Nachricht benötigte Schlüssel wurde nicht gefunden. Überprüfen Sie ob die entsprechende Karte gesteckt ist und leiten Sie diese Nachricht an Ihre eigene E-Mail-Adresse weiter. Beim nächsten Abholen wird der Entschlüsselungsvorgang wiederholt.", "X-KIM-DecryptionResult", "01")), new Sn(e, !1, t.headers, t, s);
    n.debug("Start decryption of S/MIME"), setTimeout(() => r == null ? void 0 : r.onDecryptingNewMail(e, new pw(t)), 0);
    let m;
    try {
      m = await this.decryptMail(t, l);
    } catch (Y) {
      if (Y instanceof Tr && Y.detail instanceof ze && Y.detail.code === "4107")
        return s.push(j.errorHeader("Die Nachricht wurde als eine verschlüsselte KIM-Nachricht gekennzeichnet, konnte aber auf Grund des falschen Formats nicht entschlüsselt werden. Die Verschlüsselte Nachricht befindet sich im Anhang. Bitte kontaktieren Sie den Absender der Nachricht.", "X-KIM-DecryptionResult", "02")), new Sn(e, !1, t.headers, t, s);
      throw Y;
    }
    s.push(j.info("Die KOM-LE-Nachricht wurde erfolgreich entschlüsselt")), n.debug("Parsing decrypted mail");
    const y = new ih({ schema: yc.fromBER(m).content }), A = me.splitAtEmptyLine(new Uint8Array(y.encapContentInfo.eContent.getValue())).second;
    let P = Nr.parseBuffer(A);
    n.debug("Checking S/MIME signature"), setTimeout(() => r == null ? void 0 : r.onVerifyNewMail(e), 0);
    const M = await this.verifyMailSignature(m), p = M.find((Y) => Y.code === "verification_successful") !== void 0;
    s.push(...M);
    const w = this.verifyInnerHeaders(t, P);
    w && s.push(w);
    const C = this.loadRecipientInfosFromSignedData(y), D = this.compareRecipientEmailAttribute(u, C);
    D !== void 0 && s.push(D), n.debug("Check for KAS content.");
    let R = 0;
    for (const Y of P.parts)
      this.isKasBodyPart(Y) && R++;
    if (R > 0)
      n.error("Found multiple KAS Entries"), s.push(j.error("Nachricht konnte aufgrund uneindeutiger Informationen nicht abgerufen werden"));
    else if (this.isKasBodyPart(P))
      if (!this.kimStoredSettingsDto.isKasReady)
        n.error("Cannot receive KAS Content because of '+' setting"), s.push(j.error("Ihre Einstellungen erlauben das Empfangen von großen Nachrichten nicht. Um diese Nachricht abzurufen müssen Sie die Einstellungen entsprechend anpassen."));
      else {
        const Y = JSON.parse(P.getContentDecodedString() || "");
        if (!Y.link || !Y.k)
          n.debug("KAS Entry does not contain a link or an key."), s.push(j.error("Mail beinhaltet ungültige KiM Attachment Storage Datenstruktur."));
        else {
          n.debug("Downloading KAS content"), setTimeout(() => r == null ? void 0 : r.onDownloadingMailContent(e), 0);
          try {
            const dt = await (await this.kasClientGetter()).load(Y);
            dt instanceof j ? s.push(dt) : (n.debug("KAS Parsing decrypted KAS content"), P = Nr.parseBuffer(new Uint8Array(dt)));
          } catch (ae) {
            n.error("Error while loading KAS data", ae), s.push(j.error("Fehler beim lesen der Daten vom KiM Attachment Storage"));
          }
        }
      }
    P.headers.add(new q("X-KIM-DecryptionResult", "00"));
    const O = t.headers.getHeadersByName("received");
    O && O.forEach((Y) => P.headers.add(Y));
    const F = t.headers.getHeaderByName("Return-Path");
    return F && P.headers.set(F), n.debug("Finished KimMessage parser"), new Sn(e, p, t.headers, P, s);
  }
  compareRecipientEmailAttribute(e, t) {
    for (const r of e)
      if (!t.find((s) => r.equals(s)))
        return j.warnHeader("Die digitale Signatur ist mathematisch korrekt und der Zertifikatsstatus des Signaturzertifikats konnte erfolgreich geprüft werden, aber das recipient-emails-Attribut aus signerInfos enthält nicht die gleichen Werte wie das recipient-emails-Attribut aus dem enveloped-data CMS-Objekt.", "X-KIM-IntegrityCheckResult", "09");
  }
  loadRecipientInfosFromSignedData(e) {
    var r;
    const t = [];
    for (const n of e.signerInfos)
      for (const s of ((r = n.signedAttrs) == null ? void 0 : r.attributes) || [])
        if (s.type === lc)
          for (const o of s.values)
            t.push(Ht.fromSchema(o));
    return t;
  }
  loadRecipientInfosFromEncryptedCMS(e) {
    const t = yc.fromBER(e), r = dc.parse(t.content);
    return Ht.fromCMS(r);
  }
  async findCardHandleForEncryptedMail(e) {
    const t = e.filter((r) => r.emailAddress.getValue().toLocaleLowerCase() === this.kimStoredSettingsDto.address.toLocaleLowerCase());
    if (t) {
      const r = t.map((n) => n.rid.value.serialNumber.toBigInt() + "");
      return await this.findCardHandleByCertificateSerialNumber(r);
    } else
      return;
  }
  async findCardHandleByCertificateSerialNumber(e) {
    this.certificateSerialNumberCache || (this.certificateSerialNumberCache = this.initCardHandleCertificateSerialNumberCache());
    const t = await this.certificateSerialNumberCache;
    for (const r of t.keys())
      if (e.indexOf(r) > -1)
        return t.get(r);
  }
  async decryptMail(e, t) {
    const n = await (await this.ti365Session.getConnector()).getEncryptionService().decrypt(e.getRawContent(), t), s = V.uint8FromBase64(n.document[0].base64Data);
    return me.splitAtEmptyLine(s).second;
  }
  async verifyMailSignature(e) {
    const r = await (await this.ti365Session.getConnector()).getSignatureService().verifyCMSMessage(V.uint8AsBase64(e));
    let n;
    if (r.status.error)
      switch (r.status.error.trace.code) {
        case "4115":
          return n = j.errorHeader("Die Integrität der Nachricht wurde verletzt.", "X-KIM-IntegrityCheckResult", "02"), [n];
        case "4253":
          return n = j.errorHeader("Die digitale Signatur ist nicht vorhanden.", "X-KIM-IntegrityCheckResult", "03"), [n];
        case "4112":
          return n = j.errorHeader("Die digitale Signatur konnte aufgrund des falschen Formats nicht geprüft werden", "X-KIM-IntegrityCheckResult", "04"), [n];
        case "4206":
          return n = j.errorHeader("Der Zertifizierungspfad des Signaturzertifikats  kann nicht validiert werden.", "X-KIM-IntegrityCheckResult", "05"), [n];
        case "4264":
          return n = j.warnHeader("Die digitale Signatur ist mathematisch korrekt, der Zertifikatsstatus des Signaturzertifikats konnte aber nicht geprüft werden.", "X-KIM-IntegrityCheckResult", "07"), [n, j.info("Die Signatur wurde erfolgreich geprüft.")];
        default:
          return n = j.errorHeader("Die digitale Signatur konnte aufgrund eines nicht zuordenbaren Fehlercodes des Konnektors nicht geprüft werden.", "X-KIM-IntegrityCheckResult", "06"), [n];
      }
    else
      return r.verificationResult.highLevelResult === Mu.VALID ? (n = j.infoWithHeader("Die Signatur wurde erfolgreich geprüft.", "verification_successful", new q("X-KIM-IntegrityCheckResult", "01")), [n]) : [j.warn("Die Signatur konnte nicht eindeutig geprüft werden.")];
  }
  isKasBodyPart(e) {
    var t;
    return ((t = e.headers.getHeaderByName("Content-Disposition")) == null ? void 0 : t.value) === "x-kas";
  }
  verifyInnerHeaders(e, t) {
    const r = "Die digitale Signatur ist mathematisch korrekt und der Zertifikatsstatus des Signaturzertifikats konnte erfolgreich geprüft werden, aber beim Vergleich der Header-Elemente from, sender, reply-to, to und cc der äußeren Nachricht mit denen der inneren Nachricht wurden Abweichungen festgestellt";
    if (!this.compareAddressHeader(e.headers, t.headers, "from"))
      return j.errorHeader(r + `\r
 Fehler MIME-Header: From`, "X-KIM-IntegrityCheckResult", "08");
    if (!this.compareAddressHeader(e.headers, t.headers, "sender"))
      return j.errorHeader(r + `\r
 Fehler MIME-Header: Sender`, "X-KIM-IntegrityCheckResult", "08");
    if (!this.compareAddressHeader(e.headers, t.headers, "reply-to"))
      return j.errorHeader(r + `\r
 Fehler MIME-Header: reply-to`, "X-KIM-IntegrityCheckResult", "08");
    if (!this.compareAddressHeader(e.headers, t.headers, "to"))
      return j.errorHeader(r + `\r
 Fehler MIME-Header: to`, "X-KIM-IntegrityCheckResult", "08");
    if (!this.compareAddressHeader(e.headers, t.headers, "cc"))
      return j.errorHeader(r + `\r
 Fehler MIME-Header: cc`, "X-KIM-IntegrityCheckResult", "08");
  }
  compareAddressHeader(e, t, r) {
    const n = e.getHeaderByName(r), s = t.getHeaderByName(r);
    return n === void 0 && s === void 0 ? !0 : n !== void 0 && s === void 0 || n === void 0 && s !== void 0 ? !1 : n instanceof wt && s instanceof wt && n.addresses.length === s.addresses.length ? n.addresses.filter((u) => s.addresses.find((l) => u.address === l.address && u.name === l.name) === void 0).length === 0 : !1;
  }
}
class qu {
  constructor(e, t = []) {
    this.cardService = e, this.verifiedCerts = t, this.checkServerCert = async (r) => {
      const n = r.getServerCertificate();
      if (!n)
        throw k.error("Error while loading TLS Certificate from Server"), new Error("Server Certificate could not be loaded");
      const s = (/* @__PURE__ */ new Date()).getTime() - Kt.ttlEncCert, o = this.verifiedCerts.filter((y) => y.verificationTime > s);
      this.verifiedCerts.splice(0, this.verifiedCerts.length, ...o);
      for (const y of this.verifiedCerts)
        if (n.startsWith(y.certificateString))
          return;
      k.debug("Checking server TLS certificate");
      const u = n.split(`-----END CERTIFICATE-----
`).map((y) => y + `-----END CERTIFICATE-----
`);
      if (u.length < 1)
        throw k.error("Server TLS certificate is not valid"), new Error("Loaded Server Certificate is invalid");
      k.debug("Checking server TLS certificate");
      const l = u[0], m = await this.cardService.verifyCertificate(l);
      if (m.verificationResult === "VALID")
        k.debug("Server TLS certificate is valid"), this.verifiedCerts.push({
          verificationTime: (/* @__PURE__ */ new Date()).getTime(),
          certificateString: l
        });
      else
        throw k.error("Server TLS certificate is not valid", m), ee.error("Der KiM Mail Server antwortet mit einem ungültigen TLS Zertifikat."), new Error("Invalid TLS Certificate:" + JSON.stringify(m));
    };
  }
}
class fw {
  constructor(e) {
    this.attachment = e;
  }
  get storageId() {
    return this.attachment.storageId;
  }
  get contentId() {
    return this.attachment.contentId;
  }
  get title() {
    return this.attachment.title;
  }
  get mimeType() {
    return this.attachment.mimeType;
  }
  get size() {
    return this.attachment.size;
  }
}
class Xu {
  constructor(e) {
    this.mailInfo = e, this._outerHeaders = Te.parse(e.outerHeadersMimeString), this._innerHeaders = Te.parse(e.innerHeadersMimeString);
  }
  /**
   * The messageId of the mail
   */
  get pop3ServerUid() {
    return this.mailInfo.mailServerUid;
  }
  /**
   * The id of the mail in the storage
   */
  get storageId() {
    return this.mailInfo.storageId;
  }
  /**
   * The messageId of the mail
   */
  get messageId() {
    return this._outerHeaders.messageId;
  }
  /**
   * The date when the message was sent
   */
  get sentDate() {
    return this._outerHeaders.date;
  }
  /**
   * The date when the message was received
   */
  get receivedDate() {
    return this.mailInfo.receivedDate;
  }
  /**
   * Determines wether the mail has attachments
   */
  get hasAttachments() {
    return this.mailInfo.hasAttachments;
  }
  /**
   * Determines wether the mail was decrypted from an encrypted KIM mail
   */
  get hasMailBeenEncrypted() {
    return this.mailInfo.wasEncrypted;
  }
  /**
   * Determines wether the signature of mail was valid
   */
  get hasSignatureBeenValid() {
    return this.mailInfo.isSignatureCorrect;
  }
  /**
   * Determines wether there were processing errors
   */
  get hasErrors() {
    return this.mailInfo.hasErrors;
  }
  /**
   * The KIM Version specified in the mail header X-KOM-LE-Version
   */
  get kimVersion() {
    return this.mailInfo.kimVersion;
  }
  /**
   * The KIM Dienstkennung specified in the mail header X-KIM-Dienstkennung
   */
  get kimDienstkennung() {
    return this.mailInfo.kimDienstkennung;
  }
  /**
   * The sender of the mail
   */
  get from() {
    var e;
    return (e = this._innerHeaders.from.addresses) == null ? void 0 : e[0];
  }
  /**
   * The subject of the mail
   */
  get subject() {
    return this.kimDienstkennung.startsWith("KIM-Mail;Abwesend") ? "Abwesenheitsnotiz" : this._innerHeaders.subject;
  }
  /**
   * The recipients to-addresses to whom the mail was sent
   */
  get recipientsTo() {
    return this._innerHeaders.to.addresses ?? [];
  }
  /**
   * The recipients cc-addresses to whom the mail was sent
   */
  get recipientsCc() {
    return this._innerHeaders.cc.addresses ?? [];
  }
}
class Zc extends Xu {
  constructor(e) {
    super(e), this.mail = e;
  }
  /**
   * Determines wether the body is of type html or plain-text
   */
  get isHtmlBody() {
    return !!this.mail.htmlContent;
  }
  /**
   * The content of the mail (html or plain-text)
   */
  get body() {
    return this.mail.htmlContent ?? this.mail.textContent ?? "";
  }
  /**
   * The html content of the mail, if present
   */
  get bodyHtml() {
    return this.mail.htmlContent;
  }
  /**
   * The plain-text content of the mail, if present
   */
  get bodyText() {
    return this.mail.textContent;
  }
  /**
   * An array of log messages from the decryption and verification process of type 'info'
   */
  get processingInfos() {
    return this.mail.logs.filter((e) => e.type === "info");
  }
  /**
   * An array of log messages from the decryption and verification process of type 'warn'
   */
  get processingWarnings() {
    return this.mail.logs.filter((e) => e.type === "warn");
  }
  /**
   * An array of log messages from the decryption and verification process of type 'error'
   */
  get processingErrors() {
    return this.mail.logs.filter((e) => e.type === "error");
  }
  /**
   * An array of attachment information without the actual binary data
   */
  get attachmentInfos() {
    return this.mail.attachments.map((e) => new fw(e));
  }
  /**
   * The raw mail information in the storage after processing
   */
  get rawMail() {
    return this.mail;
  }
}
class mw {
  constructor(e, t) {
    this.mails = e, this.errors = t;
  }
}
class ww {
  constructor(e, t) {
    this.mailAddress = e, this.certificate = t;
  }
}
const vn = 1.5, yw = "YSHTQ", Aw = "1.5.2-1", Sw = "1.0.0-0", vw = yw + "_" + Aw, bw = `Content-Type: message/rfc822\r
\r
`, Cw = `MIME-Version: 1.0\r
Content-Type: application/pkcs7-mime; smime-type=signed-data; name=smime.p7m\r
Content-Transfer-Encoding: binary\r
Content-Disposition: attachment; filename=smime.p7m\r
\r
`, Ew = new TextEncoder(), to = Ew.encode(Cw);
class pc {
  constructor(e, t, r, n, s, o, u, l) {
    this.ti365Session = e, this.connector = t, this.card = r, this.kimStorage = n, this.kimSettings = s, this.kimPrivateSettings = o, this.tlsCertificateCheckService = u, this.accountManager = l, this.active = !0, this.checkVzdDone = !1, this.cardIsVerified = !1, this.deleteMailQueue = [], this.pop3Client = this.createPop3Client(), this.smtpClient = this.createSmtpClient(), this.vzdClient = new xu(this.ti365Session), t.setTimeoutRead(Kt.konnektorTimeout);
  }
  static async create(e, t, r) {
    const n = await t.readSettings();
    k.init(t);
    const s = await e.getConnector(), o = new qu(e.cardService, n.tlsCertificateCache), u = await e.cardService.findCardWithIccsn(r.cardIccsn);
    if (!u)
      throw k.error("No Card found with iccsn: ", r.cardIccsn), ee.error("Die Karte für diesen KiM Account konnte nicht gefunden werden."), new Error(" Card for KiM Account could not be found.");
    const l = ys.create(e, o, r, u, n), m = new pc(e, s, u, t, r, n, o, l);
    return await m.checkTlsCertificateRenewal(), await m.resyncAccountState(), m;
  }
  get isActive() {
    return this.active;
  }
  createPop3Client() {
    const e = new uh(this.createKimTcpSocket(ot.KIM_POP3, this.kimSettings.pop3Hostname));
    return e.setTimeoutRead(Kt.pop3TimeoutServer), e.onVerifyTlsConnection = this.tlsCertificateCheckService.checkServerCert, e;
  }
  createSmtpClient() {
    const e = new hh(this.createKimTcpSocket(ot.KIM_SMTP, this.kimSettings.smtpHostname));
    return e.setTimeoutRead(Kt.smtpTimeoutServer), e.onVerifyTlsConnection = this.tlsCertificateCheckService.checkServerCert, e;
  }
  createKimTcpSocket(e, t) {
    const r = {
      clientPrivateKey: this.kimPrivateSettings.keys.privateKeyPem,
      clientCertificate: this.kimPrivateSettings.keys.certificatePem
    };
    return this.ti365Session.getSocketProvider(
      e,
      t,
      { kimAccountAddress: this.kimSettings.kimAddress },
      r
    );
  }
  get kimMimeMessageParser() {
    return this._kimMimeMessageParser || (this._kimMimeMessageParser = new gw(this.ti365Session, this.kimPrivateSettings, () => this.getKasClient())), this._kimMimeMessageParser;
  }
  async checkTlsCertificateRenewal() {
    const e = ro(this.decodePem(this.kimPrivateSettings.keys.certificatePem)), t = new no({ schema: e.result }), r = /* @__PURE__ */ new Date();
    if (r.setDate(r.getDate() + 30), k.debug("Check expiry of stored TLS certificate ", t.notAfter.value), t.notAfter.value < r) {
      k.debug("TLS certificate update necessary"), ee.log("Das TLS Zertifikat für die Verbindung mit dem KiM Fachdienst läuft in den nächsten 30 Tagen aus. Es wird vom Fachdienst ein neues Zertifikat angefordert.");
      const n = await this.accountManager.createCert();
      n ? (this.kimPrivateSettings.keys = n, this.kimStorage.storeSettings(this.kimPrivateSettings), this.smtpClient = this.createSmtpClient(), this.pop3Client = this.createPop3Client(), ee.log("Das TLS Zertifikat für die Verbindung mit dem KiM Fachdienst wurde erneuert.")) : ee.error("Fehler beim erneuern des TLS Zertifikats für die Verbindung mit dem Fachdienst.");
    }
  }
  decodePem(e) {
    const t = e.replace(/(-----(BEGIN|END) CERTIFICATE-----|[\n\r])/g, "");
    return ye.toUint8Array(t);
  }
  async resyncAccountState() {
    var t, r;
    const e = await Promise.all([this.accountManager.getAccount(), this.loadOwnVzdEntry()]);
    if (this.accountDetails = e[0], this.ownVzdEntry = e[1], this.ownVzdEntry) {
      const n = this.ownVzdEntry.mail.find((s) => s.mail.toLocaleLowerCase() === this.kimSettings.kimAddress.toLocaleLowerCase());
      n.isKasReady !== this.kimPrivateSettings.isKasReady && (this.kimPrivateSettings.isKasReady = n.isKasReady, this.kimStorage.storeSettings(this.kimPrivateSettings));
    }
    this.active = ((t = this.accountDetails) == null ? void 0 : t.regStat) == "registered", (r = this.listener) == null || r.onActiveState(this.active);
  }
  getMailAddress() {
    return this.kimSettings.kimAddress;
  }
  async getKasClient() {
    if (!this.kasClient) {
      k.debug("Init Kas Client");
      const e = await this.getAccountLimit();
      this.kasClient = new dw(this.ti365Session, this.kimSettings, this.kimPrivateSettings, e.dataTimeToLive * 60 * 60 * 24, this.tlsCertificateCheckService);
    }
    return this.kasClient;
  }
  async fetchNewMails(e) {
    const t = k.timer();
    t.debug("Receiving new mails");
    const r = new mw([], []), n = await this.getPop3Session().catch(() => {
      throw new ce("Could not connect to POP3 Server", "POP3_ERROR");
    }), s = await n.listUids().catch(() => {
      throw new ce("Could not list uids", "POP3_ERROR");
    });
    t.debug("Mails found on server:", s.length);
    const u = (await this.kimStorage.listMails()).map((m) => m.mailServerUid);
    t.debug("Mails in Storage:", u.length);
    const l = s.filter((m) => u.indexOf(m.getUid()) === -1);
    if (t.debug("Mails to receive:", l.length), l.length > 0) {
      await this.checkCardPinState();
      const m = [];
      for (const A of l) {
        e == null || e.onFetchingNewMail(A.getUid());
        const P = await A.getMail().catch(() => {
        });
        if (P !== void 0) {
          t.debug("Loaded Mail from Server:", A.getUid());
          const M = this.processMail(A, P, e);
          m.push(M);
        } else
          e == null || e.onFetchingNewMailError(A.getUid(), "KIM Nachricht konnte nicht heruntergeladen werden");
      }
      const y = await Promise.allSettled(m);
      r.mails = y.filter((A) => A.status === "fulfilled").map((A) => A.value), r.errors = y.filter((A) => A.status === "rejected").map((A) => A.reason);
      for (const A of this.deleteMailQueue)
        await A.delete().catch((P) => k.error("Could not delete mail from pop3 server: " + A.getUid(), P));
      this.deleteMailQueue = [], t.debug("All mails Processed");
    } else
      t.debug("No new Mails available.");
    return await n.quit().catch((m) => k.error("Could not successfully quit pop3 session", m)), t.debug("Receiving Mails done"), r;
  }
  async getPop3Session() {
    try {
      return await this.pop3Client.login(this.kimSettings.kimAddress, this.kimPrivateSettings.password);
    } catch (e) {
      throw k.debug("Error while init Pop3 Connection", e), new ce("Error while init Pop3 Connection", "POP3_ERROR");
    }
  }
  async getSmtpSession() {
    return this.smtpClient.login(this.kimSettings.kimAddress, this.kimPrivateSettings.password);
  }
  async getAccountLimit(e = !1) {
    return this.accountLimitCache && !e ? this.accountLimitCache : (this.accountLimitCache = await this.accountManager.getLimit(this.kimPrivateSettings.password), this.accountLimitCache);
  }
  async loadOwnVzdEntry() {
    const e = await this.vzdClient.search({ mail: this.kimSettings.kimAddress });
    if (e.length !== 1) {
      k.info("Need exactly one VZD entry for my account address, but got " + e.length);
      return;
    }
    return e[0];
  }
  async checkVzdVersion() {
    if (this.checkVzdDone)
      return;
    if (k.debug("Check KIM Version of User stored within VZD"), !this.ownVzdEntry)
      throw new ce("No VZD entry found for kim address", "KIM_CONFIGURATION_ERROR");
    const e = this.ownVzdEntry.mail.find((t) => t.mail.toLocaleLowerCase() === this.kimSettings.kimAddress.toLocaleLowerCase());
    if (e.version > vn)
      throw k.error("KiM Version stored in VZD is to new: " + e.version), ee.error("Ihr KiM Account wird von einem anderen Client abgerufen welcher neuer und damit inkompatibel ist."), new ce("KiM Version stored in VZD is newer than this client module", "CM_VERSION_ERROR", new cw(vn, e.version));
    e.version < vn && (k.debug("KiM Version stored in VZD is outdated, update triggered. Stored Version:" + e.version), await this.accountManager.setAccount({ kimVersion: `${vn.toFixed(1)}${this.kimPrivateSettings.isKasReady ? "+" : ""}` }), k.debug("KiM Version stored in VZD updated to:" + vn.toFixed(1)), await this.resyncAccountState()), e.isKasReady && !this.kimPrivateSettings.isKasReady && (this.kimPrivateSettings.isKasReady = !0, this.kimStorage.storeSettings(this.kimPrivateSettings)), this.checkVzdDone = !0;
  }
  async searchReceiver(e, t = 20) {
    const r = e.toLocaleLowerCase(), n = tu.escape(r);
    return await this.vzdClient.searchWithLdapQuery(`(&(mail=*)(|(cn=*${n}*)(mail=*${n}*)))`, { maxEntries: t });
  }
  async getSenderCertificates() {
    if (!this.senderCertificates) {
      k.debug("Search own VZD entry");
      const e = await this.vzdClient.fetchByMail(this.kimSettings.kimAddress);
      if (!e)
        throw k.error("Search own VZD entry failed"), new ce("Search own VZD entry failed", "KIM_CONFIGURATION_ERROR");
      this.senderCertificates = e.getCertificates();
    }
    return this.senderCertificates;
  }
  async listMailInfos() {
    return (await this.kimStorage.listMails()).map((e) => new Xu(e));
  }
  async getMailContent(e) {
    return new Zc(await this.kimStorage.readKimMail(e));
  }
  getMailAttachment(e, t) {
    return this.kimStorage.readAttachment(e, t);
  }
  async checkCardPinState() {
    if (!this.cardIsVerified) {
      const e = this.card.type === _.SMC_B ? "PIN.SMC" : "PIN.CH";
      if ((await this.connector.getCardService().getPinStatus(this.card.handle, e)).pinStatus !== "VERIFIED")
        throw k.debug("Card Pin is not verified, requesting Pin entry for:", this.card.handle, e), new ce("Card pin not verified", "CARD_PIN_NOT_VERIFIED", new zc(this.card.handle, e));
      this.cardIsVerified = !0, this.smcbLocked || (this.smcbLocked = () => this.cardIsVerified = !1, Q.addSmcbLockedListener(this.smcbLocked));
    }
  }
  async deleteStoredMessage(e) {
    return this.kimStorage.deleteMail(e);
  }
  async processMail(e, t, r) {
    try {
      const n = await this.kimMimeMessageParser.parse(e.getUid(), t, r), s = await n.storeMail(this.kimStorage), o = new Zc(s);
      return !n.hasProcessingErrors() && Pr.deleteMailAfterProcessing && this.deleteMailQueue.push(e), r == null || r.onNewMailProcessed(o), o;
    } catch (n) {
      if (n instanceof iu) {
        k.error("Smbc Locked during decryption", n);
        const s = this.card.type === _.SMC_B ? "PIN.SMC" : "PIN.CH";
        throw new ce("Card pin not verified", "CARD_PIN_NOT_VERIFIED", new zc(this.card.handle, s));
      }
      throw k.error("error during mail processing", n), new ce("Could not process kim message", "MESSAGE_PROCESSING_ERROR", new aw(e.getUid(), n));
    }
  }
  /**
   * Sends Mail
   * Overrides the From header with the information from the account.
   * @param mail 
   */
  async sendMail(e, t) {
    const r = k.timer();
    r.debug("Begin mail send"), await this.checkVzdVersion(), r.debug("Get account limits ");
    const n = await this.getAccountLimit(), s = `${(/* @__PURE__ */ new Date()).getTime()}.${crypto.randomUUID()}@cm.kim.yoshteq`;
    e.headers.set(new q("Message-ID", "<" + s + ">")), e.headers.set(new wt("From", this.ti365Session.user.firstName + " " + this.ti365Session.user.lastName + " <" + this.getMailAddress() + ">")), e.headers.set(new q("Date", (/* @__PURE__ */ new Date()).toUTCString())), e.headers.getHeaderByName(St.DIENSTKENNUNG_NAME) || e.headers.set(new q(St.DIENSTKENNUNG_NAME, St.DIENSTKENNUNG_DEFAULT_VALUE));
    const o = e.toMimeString().length;
    let u = o > 15 * 1024 * 1024;
    if (u && r.debug("Mail will be transmitted to KAS"), o > n.maxMailSize)
      throw r.error("Mail size exceeds account limit"), new ce("Mailsize exceeds account limit", "MAIL_FORMAT_ERROR", new Wc("MAIL_SIZE_TOO_LARGE", { allowedSize: n.maxMailSize, mailSize: o }));
    if (u && n.remainQuota > -1 && o > n.remainQuota)
      throw r.error("Mail size exceeds remaining account memory"), new ce("Mailsize exceeds remain quota", "MAIL_FORMAT_ERROR", new Wc("MAIL_SIZE_TOO_LARGE", { allowedSize: n.remainQuota, mailSize: o }));
    r.debug("Find sender certificates");
    const l = await this.getSenderCertificates();
    r.debug("Find and check recipients certificates");
    const m = e.getAllRecipients().map((F) => F.address), y = await this.vzdClient.fetchByMails(m), A = [], P = new uw();
    for (let F of m) {
      const Y = y.find((ae) => ae.containsMailAddress(F));
      if (!Y) {
        r.error("Recipient not found ", F), P.addRecipientError(new Us(
          F,
          "RECIPIENT_NOT_FOUND",
          "Der Empfänger " + F + " kann nicht im KiM Adressbuch gefunden werden."
        ));
        continue;
      }
      if (Y.userCertificate.length === 0) {
        r.error("Recipient has no certificate ", F), P.addRecipientError(new Us(
          F,
          "RECIPIENT_NO_CERTIFICATE",
          "Sie können diese Nachricht nicht an " + F + " senden, der Empfänger kein kein Zertifikat hinterlegt hat."
        ));
        continue;
      }
      if (u) {
        for (const ae of Y.mail)
          if (ae.mail.toLocaleLowerCase() === F.toLocaleLowerCase() && !ae.isKasReady) {
            r.error("Receiver can not receive KAS Mails", F), P.addRecipientError(new Us(
              F,
              "RECIPIENT_NO_KAS_ALLOWED",
              "Sie können diese Nachricht nicht an " + F + " senden, da dieser Empfänger nur Nachrichten bis zu einer Größe von 15 MB unterstützt. "
            ));
            break;
          }
      }
      if (Y.userCertificate.length > 1) {
        r.debug("Recipient has multiple certificates, checking for telematik-id", F);
        let ae = "";
        for (const dt of Y.userCertificate) {
          const Xi = us.parseTelematikIdFromRawCertificate(dt);
          if (ae === "" && Xi && (ae = Xi), Xi !== ae) {
            r.error("Recipient has multiple certificates with different telematik-id", F), P.addRecipientError(new Us(
              F,
              "RECIPIENT_ADDRESS_ENTRY_ERROR",
              "Sie können diese Nachricht nicht an " + F + " senden, der Empfänger hat einen fehlerhaften Datensatz im Adressbuch von KiM. Keine eindeutige Telematik-ID mit Verschlüsselungszertifikat gefunden"
            ));
            break;
          }
        }
      }
      Y.getCertificates().map((ae) => new ww(F, ae)).forEach((ae) => A.push(ae));
    }
    if (P.hasError)
      throw new ce("Error in recipients found", "RECIPIENTS_ERROR", P);
    u ? (r.debug("Sending mail to KAS"), e = await this.createKasMail(s, e)) : e.headers.set(new q("X-KOM-LE-Version", "1.0")), r.debug("Preparing E-Mail encryption");
    const M = this.createRecipientsInfoAsn1Attribute(l, A);
    r.debug("Singing mail");
    const p = await this.signMail(e, M);
    r.debug("Encrypting mail");
    const w = await this.encryptMail(p, A, l, M);
    r.debug("Adding Outer headers"), ee.log("Versende verschlüsselte Nachricht");
    const C = Te.parse(e.headers.toMimeString());
    await this.setOuterMailHeaders(C);
    const D = /* @__PURE__ */ new Date();
    D.setDate(D.getDate() + n.dataTimeToLive), C.set(new q("Expires", D.toUTCString()));
    const R = C.toMimeString() + `\r
\r
` + w;
    ee.log("Nachricht wird an TI übergeben"), r.debug("Sending mail to SMTP server");
    const O = await this.getSmtpSession();
    t != null && t.requestSuccessDsn && O.setRequestDsnTypes(["SUCCESS", "DELAY", "FAILURE"]), await O.sendMessage(this.kimSettings.kimAddress, e.getAllRecipients().map((F) => F.address), R), await O.quit(), ee.log("Nachricht erfolgreich versendet");
  }
  createRecipientsInfoAsn1Attribute(e, t) {
    const r = [];
    for (const s of e)
      r.push(Ht.create(this.kimSettings.kimAddress, s));
    for (const s of t)
      r.push(Ht.create(s.mailAddress, s.certificate));
    return new bn({ type: lc, values: r }).toString("base64");
  }
  async createKasMail(e, t) {
    const r = await this.getKasClient(), n = [this.getMailAddress(), ...t.getAllRecipients().map((u) => u.address)], s = await r.store(e, n, V.stringEncode(t.toMimeString())), o = Te.parse(t.headers.toMimeString());
    return o.set(new rr("text/plain; charset=utf-8")), o.set(new q("Content-Disposition", "x-kas")), o.set(new q("X-KOM-LE-Version", "1.5")), o.set(new q("X-KIM-KAS-Size", s.size + "")), new Nr(o, [], X.serialize(s));
  }
  async setOuterMailHeaders(e) {
    e.set(new q("Subject", "KOM-LE-Nachricht")), e.set(new q("Return-Path", `${this.getMailAddress()}`)), e.set(new q("X-KIM-CMVersion", vw)), e.set(new q("X-KIM-PTVersion", Sw));
    const t = await this.getConnectorVersionString();
    e.set(new q("X-KIM-KONVersion", t)), e.set(new q("MIME-Version", "1.0")), e.set(new rr(`application/pkcs7-mime;\r
	smime-type=authenticated-enveloped-data; name=smime.p7m`)), e.set(new q("Content-Transfer-Encoding", "base64")), e.set(new q("Content-Disposition", "attachment; filename=smime.p7m"));
  }
  async getConnectorVersionString() {
    const e = this.connector.getConnectorInformation().productInformation, t = e.productIdentification.productVersion.local;
    return `<${e.productMiscellaneous.productName}><${e.productTypeInformation.productType}><${e.productTypeInformation.productTypeVersion}><${t == null ? void 0 : t.hwVersion}><${t == null ? void 0 : t.fwVersion}>`;
  }
  async signMail(e, t) {
    ee.log("Konnektor signiert Nachricht");
    const r = bw + e.toMimeString(), n = this.connector.getSignatureService();
    let s = this.card;
    if (this.card.type !== _.SMC_B && (s = await this.ti365Session.cardService.getCard(_.SMC_B)), !s)
      throw new ce("No SMC-B found", "KIM_CONFIGURATION_ERROR");
    const o = await n.signMimeMessage(s.handle, btoa(r), t);
    return ye.toUint8Array(o.base64Signature.base64Signature);
  }
  async encryptMail(e, t, r, n) {
    var m, y;
    ee.log("Verschlüssle Nachricht");
    const s = new Uint8Array(to.length + e.length);
    s.set(to), s.set(e, to.length);
    const o = this.connector.getEncryptionService(), u = t.map((A) => A.certificate.toString("base64"));
    return r.map((A) => A.toString("base64")).forEach((A) => u.push(A)), (y = (m = (await o.encryptMimeMessage(
      u,
      ye.fromUint8Array(s),
      n
    )).document[0].base64Data) == null ? void 0 : m.match(/.{1,76}/g)) == null ? void 0 : y.join(`\r
`);
  }
  passwordMatchesCurrent(e) {
    return this.kimPrivateSettings.password === e;
  }
  async updatePassword(e) {
    await this.accountManager.updatePassword(e), this.kimPrivateSettings.password = e, await this.kimStorage.storeSettings(this.kimPrivateSettings);
  }
  async deregisterAccount() {
    await this.accountManager.deregisterAccount(), await this.resyncAccountState();
  }
  async setOutOfOfficeNotice(e) {
    await this.accountManager.setOutOfOffice(e);
  }
  async getOutOfOfficeNotice() {
    return await this.accountManager.getOutOfOffice();
  }
  async createTransferPassword() {
    return await this.accountManager.getAccountTransferOtp();
  }
  async setAcceptKasMessages(e) {
    const t = e ? "1.5+" : "1.5";
    await this.accountManager.setAccount({ kimVersion: t }), this.kimPrivateSettings.isKasReady = e, await this.kimStorage.storeSettings(this.kimPrivateSettings), await this.resyncAccountState();
  }
  async reactivateAccount() {
    return await this.accountManager.revokeDeregisterAccount(), new Promise((e, t) => {
      setTimeout(() => {
        this.resyncAccountState().then(e).catch(t);
      }, 2e3);
    });
  }
}
class _u {
  constructor(e) {
    this.gatewayClient = e;
  }
  async getKimAccountSettings() {
    const e = await this.gatewayClient.getRaw("/kim");
    if (e.status === 404)
      return { error: "ACCOUNT_NOT_FOUND" };
    if (e.status === 200)
      return { result: await X.deserialize(await e.text()) };
    throw new Error("Error retrieving kim account settings: " + JSON.stringify(e));
  }
  async getKimAccountSettingsForAddress(e) {
    const t = await this.gatewayClient.getRaw("/kim/" + e);
    if (t.status === 404)
      return { error: "ACCOUNT_NOT_FOUND" };
    if (t.status === 409)
      return { error: "ACCOUNT_IN_USE" };
    if (t.status === 200)
      return { result: await X.deserialize(await t.text()) };
    throw new Error("Error retrieving kim account settings: " + JSON.stringify(t));
  }
  async setupKimAccount(e, t, r, n) {
    const s = await this.gatewayClient.postRaw("/kim/" + e, X.serialize({ referenceID: n, cardIccsn: t, encryptedStorageKey: r }));
    if (s.status === 409)
      return { error: "ACCOUNT_IN_USE" };
    if (s.status === 200)
      return { result: await X.deserialize(await s.text()) };
    throw new Error("Error retrieving kim account settings: " + JSON.stringify(s));
  }
}
const fc = class fc {
  constructor(e, t, r) {
    this.address = e, this.password = t, this.keys = r, this.isKasReady = !1;
  }
};
fc.FILE_NAME = "kim_settings.json";
let ui = fc;
class Ju {
  constructor(e) {
    this.storage = e;
  }
  async readSettings() {
    return this.storage.readObject(ui.FILE_NAME);
  }
  async storeSettings(e) {
    return this.storage.writeObject(ui.FILE_NAME, e);
  }
  async cleanupLogs() {
    const e = jt.get(), t = await this.storage.list(`kim/logs/${e}`), r = new Date((/* @__PURE__ */ new Date()).getTime() - Kt.ttlProts);
    for (const n of t)
      n.metadata && n.metadata.date < r && await this.storage.delete(n);
  }
  async storeLogs(e, t) {
    const r = jt.get(), n = t.map((s) => X.serialize(s)).join(`
`) + `
`;
    return this.storage.appendPlainText(`kim/logs/${r}/${e}.log`, n, { date: /* @__PURE__ */ new Date() });
  }
  async readLogs(e) {
    const t = jt.get(), r = await this.storage.readPlain(`kim/logs/${t}/${e}.log`);
    return new TextDecoder().decode(r);
  }
  async listMails() {
    const t = (await this.storage.list("kim/message/*/mail")).filter((r) => !!r.metadata).map((r) => this.decryptMetaData(r.metadata));
    return Promise.all(t);
  }
  async deleteMail(e) {
    await this.storage.delete(`kim/message/${e}*/*`);
  }
  async updateMeta(e) {
    const t = await this.encryptMetaData(e);
    await this.storage.updateMeta(`kim/message/${e.storageId}/mail`, t);
  }
  async encryptMetaData(e) {
    const { outerHeadersMimeString: t, innerHeadersMimeString: r, ...n } = e, s = await this.storage.encryptObject(t), o = await this.storage.encryptObject(r);
    return {
      ...n,
      outerHeaders: s,
      innerHeaders: o
    };
  }
  async decryptMetaData(e) {
    const { outerHeaders: t, innerHeaders: r, ...n } = e, s = await this.storage.decryptObject(t), o = await this.storage.decryptObject(r);
    return {
      ...n,
      outerHeadersMimeString: s,
      innerHeadersMimeString: o
    };
  }
  async storeKimMail(e, t) {
    const r = await this.encryptMetaData(t);
    await this.storage.writeObject(`kim/message/${e.storageId}/mail`, e, r);
  }
  async readKimMail(e) {
    return this.storage.readObject(`kim/message/${e}/mail`);
  }
  async readAttachment(e, t) {
    return this.storage.read(`kim/message/${e}/attachment/${t}`);
  }
  async storeAttachment(e, t, r) {
    const n = {
      ...t,
      storageId: crypto.randomUUID()
    };
    return await this.storage.write(`kim/message/${e}/attachment/${n.storageId}`, r), n;
  }
}
class Dw {
  constructor(e, t, r) {
    this.ti365Session = e, this.cryptography = t, this.stateChangeListener = r, this._state = "enterKimAddress", this.kimGatewayClient = new _u(e.gatewayClient);
  }
  get state() {
    return this._state;
  }
  set state(e) {
    this._state = e, this.stateChangeListener(this._state);
  }
  getAccountManager(e) {
    if (!this._accountManager) {
      const t = new qu(this.ti365Session.cardService, []);
      this._accountManager = ys.withPassword(this.ti365Session, t, this.accountSettings, this.kimAccountCard, e);
    }
    return this._accountManager;
  }
  async start() {
    var e;
    ee.log("Initialisiere KiM Einrichtung."), this.accountSettings = (await this.kimGatewayClient.getKimAccountSettings()).result, this.accountSettings ? this.accountSettings.kimAddress || !this.accountSettings.cardIccsn ? (this.kimAddress = (e = this.accountSettings) == null ? void 0 : e.kimAddress, this.referenceId = this.accountSettings.kimAddressReferenceId, this.initialPassword = this.accountSettings.kimAddressInitialPassword, await this.checkAddressState()) : this.accountSettings.kimAddress || !this.accountSettings.storageSettings ? ee.error("Das KiM Postfach '" + this.accountSettings.kimAddress + "' ist bereits für einen anderen Benutzer eingerichtet.") : ee.error("Das KiM Postfach '" + this.accountSettings.kimAddress + "' ist bereits eingerichtet.") : this.state = "enterKimAddress";
  }
  async checkAddressState() {
    const t = this.ti365Session.vzdService.search({ mail: this.accountSettings.kimAddress }, { attributes: ["telematikID"], combinationMode: "AND" }), r = this.ti365Session.cardService.getCards(), n = await Promise.all([t, r]);
    this.availableCards = n[1].filter((o) => o.type === _.SMC_B || o.type === _.HBA);
    const s = n[0];
    if (s.length === 1)
      this.kimAccountCard = await this.checkRegisteredCard(s[0]), this.kimAccountCard && (this.state = "setupAccount");
    else if (s.length === 0)
      this.state = "registerAccount";
    else
      throw console.error("VZD Returned multiple Entries for this Account", s), new Error("Invalid state of KIM Account");
  }
  async checkRegisteredCard(e) {
    const t = (await this.ti365Session.cardService.getCards()).filter((r) => r.type === _.SMC_B || r.type === _.HBA) || [];
    for (const r of t)
      if (await await this.ti365Session.cardService.readTelematikIdFromCertificate(r, Pe.C_AUT) === e.telematikID)
        return r;
    console.error("Card for which the KiM account was registered is not available", t, e), this.state = "migrateTelematikId";
  }
  async setKimAddress(e) {
    ee.log("Prüfe KiM Adresse"), this.kimAddress = e;
    const t = await this.kimGatewayClient.getKimAccountSettingsForAddress(e);
    return t.result ? (this.accountSettings = t.result, await this.checkAddressState(), !0) : !1;
  }
  async registerKimAddress(e, t, r, n) {
    return this.kimAccountCard = e, this.referenceId = t, this.initialPassword = r, ee.log("KiM Account wird für Sie registriert."), await this.getAccountManager().registerAccount(r, t, n), !!await this.setupKimAddress(n);
  }
  async setupKimAddress(e) {
    if (ee.log("KiM Account wird eingerichtet."), ee.log("Prüfe Login-Daten."), this.keyStore = await this.getAccountManager(e).createCert(), !this.keyStore)
      return !1;
    const t = await this.cryptography.createNewKey();
    ee.log("Speichere Account Konfiguration.");
    const r = await this.kimGatewayClient.setupKimAccount(this.kimAddress, this.kimAccountCard.iccsn, t, this.referenceId);
    if (this.accountSettings = r.result, !this.accountSettings)
      return !1;
    ee.log("Einrichten der persönlichen Verschlüsselung.");
    const n = new Ju(this.ti365Session.createStorageService(this.accountSettings.storageSettings)), s = {
      address: this.kimAddress,
      password: e,
      keys: this.keyStore,
      isKasReady: !1,
      tlsCertificateCache: []
    };
    return n.storeSettings(s), ee.log("KiM Account erfolgreich eingerichtet."), !0;
  }
  async reactivateKimAddress(e, t) {
    this.kimAccountCard = e, await this.getAccountManager(t).revokeDeregisterAccount(), await this.setupKimAddress(t);
  }
  async transferKimAddress(e, t, r) {
    return ee.log("Übertragen des Accounts auf die neue Telematik-ID."), this.kimAccountCard = e, await this.getAccountManager(t).transferAccount(r), await this.setupKimAddress(t);
  }
}
class Iw {
  constructor(e, t) {
    this.ti365Session = e, this.cryptography = t;
  }
  createKimSetupWizard(e) {
    return new Dw(this.ti365Session, this.cryptography, e);
  }
  async createKimClient() {
    const t = (await new _u(this.ti365Session.gatewayClient).getKimAccountSettings()).result;
    if (t != null && t.cardIccsn && t.storageSettings) {
      const r = new Ju(this.ti365Session.createStorageService(t.storageSettings));
      return pc.create(this.ti365Session, r, t);
    } else
      throw new ce("No KIM Account available", "KIM_ACCOUNT_NOT_CONFIGURED");
  }
}
class Bw {
  constructor(e) {
    this.gatewayClient = e;
  }
  async tryAutoAssignSmcb() {
    const e = await this.gatewayClient.postRaw("/config/try-auto-assign-smcb", void 0);
    if (e.status === 200)
      return (await X.deserialize(await e.text())).result;
    throw new Error("Error trying to auto assign SMC-B: " + JSON.stringify(e));
  }
}
class Mw {
  constructor(e) {
    this.ti365Session = e;
  }
  async getConnectorStatusInformation() {
    return (await (await this.ti365Session.getConnector()).getEventService().getResourceInformation()).connector;
  }
}
let Fs;
Fs = "konnektor.konlan";
class Pw {
  constructor(e, t, r) {
    this._gatewayClient = e, this.userSettings = t, this.cryptography = r;
    const n = this.gatewayClient.getWebsocketProxyUrl();
    this.backendConnection = new ph(n), this.backendConnection.debugEnabled = Pr.debugWebsocket, this.connectorTlsSettings = this.initConnectorTlsSettings();
  }
  async initConnectorTlsSettings() {
    return {
      clientPrivateKey: await this.cryptography.getTlsKeyAsPem(),
      clientCertificate: this.userSettings.connectorSettings.cryptographySettings.connectorTlsCertificate,
      limitCipherSuite: 49199,
      debug: Pr.debugTls
    };
  }
  get user() {
    return {
      username: this.userSettings.username,
      firstName: this.userSettings.firstName,
      lastName: this.userSettings.lastName,
      mailAddress: this.userSettings.mailAddress
    };
  }
  get gatewayClient() {
    return this._gatewayClient;
  }
  get configService() {
    return this._configService || (this._configService = new Bw(this.gatewayClient)), this._configService;
  }
  get statusService() {
    return this._statusService || (this._statusService = new Mw(this)), this._statusService;
  }
  get cardTerminalService() {
    return this._cardTerminalService || (this._cardTerminalService = new Of(this, this.backendConnection)), this._cardTerminalService;
  }
  get cardService() {
    return this._cardService || (this._cardService = new wm(this)), this._cardService;
  }
  get vzdService() {
    return this._vzdService || (this._vzdService = new xu(this)), this._vzdService;
  }
  get vsdmService() {
    return this._vsdmService || (this._vsdmService = new Ho(this)), this._vsdmService;
  }
  get kimService() {
    return this._kimService || (this._kimService = new Iw(this, this.cryptography)), this._kimService;
  }
  /**
   * gets a StorageService for the current user.
   * Only works if user is logged in.
   * @param storageSettings if undefined the user storage will be returned.
   */
  createStorageService(e) {
    if (!this.cryptography)
      throw new Error("User is not logged in, encrypted storage is not available");
    return new iw(this.gatewayClient, e, this.cryptography);
  }
  /**
   * If all Settings has been loaded this establishes a connection to the TI-Connector.
   * @returns
   */
  async getConnector() {
    if (this.connector)
      return this.connector;
    const e = this.userSettings.connectorSettings, t = this.getHttpClient(ot.CONNECTOR, Fs, void 0, await this.connectorTlsSettings), r = new $(e.tenantId, e.clientSystemId, e.workplaceId, e.userId);
    return this.connector = new Rf("https://" + Fs, r, t), await this.connector.init(), this.connector;
  }
  async getLdapClient() {
    const e = this.backendConnection.getSocketProvider(
      { serviceType: ot.LDAP },
      Fs,
      Hs[this.userSettings.connectorSettings.environment],
      await this.connectorTlsSettings
    );
    return new tu(e);
  }
  /**
   * Creates a HTTPs Client for one Service / Host behind the WebSocket Tunnel.
   * @param service
   * @param host
   * @param metadata
   * @param tlsOptions
   * @returns
   */
  getHttpClient(e, t, r, n = {}) {
    let s = t, o = t;
    if (s.indexOf(".") > -1) {
      const m = new URL("https://" + t);
      s = m.hostname, o = m.host;
    }
    const u = this.getSocketProvider(e, s, r, n), l = new Qs(o, u);
    return l.debugEnabled = Pr.debugHttp, l;
  }
  /**
  * Creates a Factory for creating WebSocket Channels for a specific service.
  */
  getSocketProvider(e, t, r, n = {}) {
    return n.debug = Pr.debugTls, this.backendConnection.getSocketProvider(
      {
        serviceType: e,
        metadata: r
      },
      t,
      Hs[this.userSettings.connectorSettings.environment],
      n
    );
  }
}
class Rw {
  constructor(e, t) {
    this.deviceToken = e, this.devicePin = t;
  }
}
class Ow {
  constructor(e, t, r, n) {
    this.A = e, this.M1 = t, this.deviceToken = r, this.userAgent = n;
  }
}
class Tw {
  constructor(e) {
    this.gatewayClient = e;
  }
  /**
   * Login to the Ti365 backend with username and password. 
   * This will do a SRP6a PAKE for authenticating the user without exposing the password to the backend.
   * 
   * @param username The Ti365 username
   * @param password The Ti365 password
   * 
   * @returns @see LoginResponse
   */
  async login(e, t) {
    const r = new er.SRPRoutines(js.SRP_CONFIG), s = await new er.SRPClientSession(r).step1(e, t), o = await this.gatewayClient.get("/login/step1/" + e);
    this.gatewayClient.sessionId = o.sessionId;
    const u = await s.step2(BigInt(o.s), BigInt(o.B)), l = new Ow(u.A.toString(), u.M1.toString(), jt.get(), navigator.userAgent), m = await this.gatewayClient.postRaw("/login/step2", l);
    if (m.status === 401)
      return { status: "LOGIN_FAILED" };
    const y = X.deserialize(await m.text());
    try {
      await u.step3(BigInt(y.srpM2 ?? ""));
    } catch (P) {
      return Ft.error(P), { status: "LOGIN_FAILED" };
    }
    const A = { status: y.status };
    return y.status === "SUCCESS" ? A.session = await this.createSession(y, t) : y.status === "MFA_REQUIRED" && (this.password = t), A;
  }
  async confirmMfa(e) {
    if (!this.password)
      throw new Error("login() must be called first");
    const t = await this.gatewayClient.post("/login/confirm-device", new Rw(jt.get(), e)), r = { status: t.status };
    return t.status === "SUCCESS" ? (r.session = await this.createSession(t, this.password), this.password = void 0) : t.status === "MFA_TRIES_EXCEEDED" && jt.reset(), r;
  }
  async createSession(e, t) {
    const r = await Or.loadKeys(t, e.userSettings);
    return new Pw(this.gatewayClient, e.userSettings, r);
  }
}
const mt = class mt {
  static get ti() {
    return this._tiState;
  }
  static get connection() {
    return this._connectionState;
  }
};
document.addEventListener("login", () => mt._connectionState = "ready"), document.addEventListener("logout", () => {
  mt._connectionState = "logout", mt._tiState = "unknown";
}), document.addEventListener("smbc-locked", () => mt._tiState = "card-locked"), document.addEventListener("smbc-unlocked", () => mt._tiState = "ready"), mt._tiState = "unknown", mt._connectionState = "logout";
let Yc = mt;
class B1 {
  constructor(e) {
    this.ti365Session = e, this.insurantHcidMap = /* @__PURE__ */ new Map();
  }
  async getAuthorizationList() {
    return (await (await this.ti365Session.getConnector()).getPhrManagementService().getAuthorizationList()).authorizationEntries.map((r) => this.mapAuthorizationEntry(r));
  }
  mapAuthorizationEntry(e) {
    return {
      insurantNumer: e.recordIdentifier.insurantId.insurantId,
      homeCommunityId: e.recordIdentifier.homeCommunityId,
      validTo: e.validTo
    };
  }
  async getHomeCommunityId(e) {
    var t, r, n;
    if (this.insurantHcidMap.has(e))
      return this.insurantHcidMap.get(e);
    try {
      const o = await (await this.ti365Session.getConnector()).getPhrManagementService().getHomeCommunityID(e);
      this.insurantHcidMap.set(e, o == null ? void 0 : o.homeCommunityId);
    } catch (s) {
      throw s instanceof Tr && ((n = (r = (t = s.detail) == null ? void 0 : t.element) == null ? void 0 : r.trace) == null || n.code, console.error(s)), s;
    }
  }
}
class Nw {
  constructor(e) {
    this.baseUrl = e;
  }
  set sessionId(e) {
    this._sessionId = e;
  }
  async post(e, t, r) {
    const n = await this.postRaw(e, t, r);
    return X.deserialize(await n.text());
  }
  async delete(e, t = {}) {
    return await fetch(this.baseUrl + e, {
      method: "DELETE",
      credentials: "include",
      headers: this.createHeaders(t)
    });
  }
  async postRaw(e, t, r = {}) {
    return t instanceof Blob || t instanceof ArrayBuffer || t instanceof Uint8Array || typeof t == "object" && (t = X.serialize(t)), await fetch(this.baseUrl + e, {
      method: "POST",
      credentials: "include",
      headers: this.createHeaders(r),
      body: t
    });
  }
  async get(e, t) {
    const r = await this.getRaw(e, t);
    return X.deserialize(await r.text());
  }
  async getRaw(e, t = {}) {
    return await fetch(this.baseUrl + e, {
      method: "GET",
      credentials: "include",
      headers: this.createHeaders(t, !1)
    });
  }
  getWebsocketProxyUrl() {
    return this.baseUrl.replace(/^http/, "ws") + "/proxy?wsgw-session-id=" + this._sessionId;
  }
  createHeaders(e, t = !0) {
    let r = {
      ...e
    };
    return t && (r["Content-Type"] = "application/json; charset=utf-8"), this._sessionId && (r["wsgw-session-id"] = this._sessionId), r;
  }
}
class eh {
  constructor(e) {
    this.baseUrl = e, this.gatewayClient = new Nw(this.baseUrl);
  }
  /**
   * Initialize Ti365 libarary for the single backend modus
   * 
   * @param baseUrl url to Ti365 backend
   */
  static init(e) {
    Ft.info("Initializing Ti365 with baseUrl", e), this._singleton = new eh(e);
  }
  static get() {
    if (!this._singleton)
      throw new Error("Ti365 not initialized. Call Ti365.init() before.");
    return this._singleton;
  }
  static createRegistrationService(e) {
    return this.get().createRegistrationService(e);
  }
  static createAuthenticationService() {
    return this.get().createAuthenticationService();
  }
  createRegistrationService(e) {
    return new js(this.gatewayClient, e);
  }
  createAuthenticationService() {
    return new Tw(this.gatewayClient);
  }
}
const B = class B {
  constructor(e, t) {
    this.oid = e, this.description = t;
  }
};
B.HBA_PROFESSIONS = [
  new B("1.2.276.0.76.4.30", "Ärztin/Arzt"),
  new B("1.2.276.0.76.4.31", "Zahnärztin/Zahnarzt"),
  new B("1.2.276.0.76.4.32", "Apotheker/-in"),
  new B("1.2.276.0.76.4.33", "Apothekerassistent/-in"),
  new B("1.2.276.0.76.4.34", "Pharmazieingenieur/-in"),
  new B("1.2.276.0.76.4.35", "pharmazeutisch-technische/-r Assistent/-in"),
  new B("1.2.276.0.76.4.36", "pharmazeutisch-kaufmännische/-r Angestellte"),
  new B("1.2.276.0.76.4.37", "Apothekenhelfer/-in"),
  new B("1.2.276.0.76.4.38", "Apothekenassistent/-in"),
  new B("1.2.276.0.76.4.39", "Pharmazeutische/-r Assistent/-in"),
  new B("1.2.276.0.76.4.40", "Apothekenfacharbeiter/-in"),
  new B("1.2.276.0.76.4.41", "Pharmaziepraktikant/-in"),
  new B("1.2.276.0.76.4.42", "Stud.pharm. oder Famulant/-in"),
  new B("1.2.276.0.76.4.43", "PTA-Praktikant/-in"),
  new B("1.2.276.0.76.4.44", "PKA Auszubildende/-r"),
  new B("1.2.276.0.76.4.45", "Psychotherapeut/-in"),
  new B("1.2.276.0.76.4.46", "Psychologische/-r Psychotherapeut/-in"),
  new B("1.2.276.0.76.4.47", "Kinder- und Jugendlichenpsychotherapeut/-in"),
  new B("1.2.276.0.76.4.48", "Rettungsassistent/-in"),
  new B("1.2.276.0.76.4.49", "Versicherte/-r"),
  new B("1.2.276.0.76.4.178", "Notfallsanitäter/-in"),
  new B("1.2.276.0.76.4.232", "Gesundheits- und Krankenpfleger/-in, Gesundheits- und Kinderkrankenpfleger/-in"),
  new B("1.2.276.0.76.4.233", "Altenpfleger/-in"),
  new B("1.2.276.0.76.4.234", "Pflegefachfrauen und Pflegefachmänner"),
  new B("1.2.276.0.76.4.235", "Hebamme"),
  new B("1.2.276.0.76.4.236", "Physiotherapeut/-in"),
  new B("1.2.276.0.76.4.237", "Augenoptiker/-in und Optometrist/-in"),
  new B("1.2.276.0.76.4.238", "Hörakustiker/-in"),
  new B("1.2.276.0.76.4.239", "Orthopädieschuhmacher/-in"),
  new B("1.2.276.0.76.4.240", "Orthopädietechniker/-in"),
  new B("1.2.276.0.76.4.241", "Zahntechniker/-in"),
  new B("1.2.276.0.76.4.274", "Ergotherapeut/-in"),
  new B("1.2.276.0.76.4.275", "Logopäde/Logopädin"),
  new B("1.2.276.0.76.4.276", "Podologe/Podologin"),
  new B("1.2.276.0.76.4.277", "Ernährungstherapeut/-in")
], B.SMCB_PROFESSIONS = [
  new B("1.2.276.0.76.4.50", "Betriebsstätte Arzt"),
  new B("1.2.276.0.76.4.51", "Zahnarztpraxis"),
  new B("1.2.276.0.76.4.52", "Betriebsstätte Psychotherapeut"),
  new B("1.2.276.0.76.4.53", "Krankenhaus"),
  new B("1.2.276.0.76.4.54", "Öffentliche Apotheke"),
  new B("1.2.276.0.76.4.55", "Krankenhausapotheke"),
  new B("1.2.276.0.76.4.56", "Bundeswehrapotheke"),
  new B("1.2.276.0.76.4.57", "Betriebsstätte Mobile Einrichtung Rettungsdienst"),
  new B("1.2.276.0.76.4.58", "Betriebsstätte gematik"),
  new B("1.2.276.0.76.4.59", "Betriebsstätte Kostenträger"),
  new B("1.2.276.0.76.4.187", "Betriebsstätte Leistungserbringerorganisation Vertragszahnärzte"),
  new B("1.2.276.0.76.4.190", "AdV-Umgebung bei Kostenträger"),
  new B("1.2.276.0.76.4.210", "Betriebsstätte Leistungserbringerorganisation Kassenärztliche Vereinigung"),
  new B("1.2.276.0.76.4.223", "Betriebsstätte GKV-Spitzenverband"),
  new B("1.2.276.0.76.4.226", "Betriebsstätte Mitgliedsverband der Krankenhäuser"),
  new B("1.2.276.0.76.4.227", "Betriebsstätte der Deutsche Krankenhaus TrustCenter und Informationsverarbeitung GmbH"),
  new B("1.2.276.0.76.4.228", "Betriebsstätte der Deutschen Krankenhausgesellschaft"),
  new B("1.2.276.0.76.4.224", "Betriebsstätte Apothekerverband"),
  new B("1.2.276.0.76.4.225", "Betriebsstätte Deutscher Apothekerverband"),
  new B("1.2.276.0.76.4.229", "Betriebsstätte der Bundesärztekammer"),
  new B("1.2.276.0.76.4.230", "Betriebsstätte einer Ärztekammer"),
  new B("1.2.276.0.76.4.231", "Betriebsstätte einer Zahnärztekammer"),
  new B("1.2.276.0.76.4.242", "Betriebsstätte der Kassenärztlichen Bundesvereinigung"),
  new B("1.2.276.0.76.4.243", "Betriebsstätte der Bundeszahnärztekammer"),
  new B("1.2.276.0.76.4.244", "Betriebsstätte der Kassenzahnärztlichen Bundesvereinigung"),
  new B("1.2.276.0.76.4.245", "Betriebsstätte Gesundheits-, Kranken- und Altenpflege"),
  new B("1.2.276.0.76.4.246", "Betriebsstätte Geburtshilfe"),
  new B("1.2.276.0.76.4.247", "Betriebsstätte Physiotherapie"),
  new B("1.2.276.0.76.4.248", "Betriebsstätte Augenoptiker"),
  new B("1.2.276.0.76.4.249", "Betriebsstätte Hörakustiker"),
  new B("1.2.276.0.76.4.250", "Betriebsstätte Orthopädieschuhmacher"),
  new B("1.2.276.0.76.4.251", "Betriebsstätte Orthopädietechniker"),
  new B("1.2.276.0.76.4.252", "Betriebsstätte Zahntechniker"),
  new B("1.2.276.0.76.4.253", "Rettungsleitstelle"),
  new B("1.2.276.0.76.4.254", "Betriebsstätte Sanitätsdienst Bundeswehr"),
  new B("1.2.276.0.76.4.255", "Betriebsstätte Öffentlicher Gesundheitsdienst"),
  new B("1.2.276.0.76.4.256", "Betriebsstätte Arbeitsmedizin"),
  new B("1.2.276.0.76.4.257", "Betriebsstätte Vorsorge- und Rehabilitation"),
  new B("1.2.276.0.76.4.273", "ePA KTR-Zugriffsautorisierung"),
  new B("1.2.276.0.76.4.262", "Betriebsstätte Pflegeberatung nach § 7a SGB XI"),
  new B("1.2.276.0.76.4.263", "Betriebsstätte Psychotherapeutenkammer"),
  new B("1.2.276.0.76.4.264", "Betriebsstätte Bundespsychotherapeutenkammer"),
  new B("1.2.276.0.76.4.265", "Betriebsstätte Landesapothekerkammer"),
  new B("1.2.276.0.76.4.266", "Betriebsstätte Bundesapothekerkammer"),
  new B("1.2.276.0.76.4.267", "Betriebsstätte elektronisches Gesundheitsberuferegister"),
  new B("1.2.276.0.76.4.268", "Betriebsstätte Handwerkskammer"),
  new B("1.2.276.0.76.4.269", "Betriebsstätte Register für Gesundheitsdaten"),
  new B("1.2.276.0.76.4.270", "Betriebsstätte Abrechnungsdienstleister"),
  new B("1.2.276.0.76.4.271", "Betriebsstätte PKV-Verband"),
  new B("1.2.276.0.76.4.278", "Ergotherapiepraxis"),
  new B("1.2.276.0.76.4.279", "Logopaedische Praxis"),
  new B("1.2.276.0.76.4.280", "Podologiepraxis"),
  new B("1.2.276.0.76.4.281", "Ernährungstherapeutische Praxis"),
  new B("1.2.276.0.76.4.284", "Betriebsstätte Weitere Kostenträger im Gesundheitswesen"),
  new B("1.2.276.0.76.4.285", "Weitere Organisationen der Gesundheitsversorgung"),
  new B("1.2.276.0.76.4.286", "KIM-Hersteller und -Anbieter")
];
let $c = B;
const M1 = {
  "application/pdf": "PDF",
  "image/jpeg": "Jpeg Bild",
  "image/png": "Png Bild",
  "image/tiff": "Tiff Bild",
  "text/plain": "Text",
  "text/rtf": "RTF",
  "application/xml": " XML",
  "application/hl7-v3": "HL7",
  "application/pkcs7-mime": "PKCS",
  "application/fhir+xml": "FHIR XML"
};
var xw = /* @__PURE__ */ ((i) => (i.ERROR = "ERROR", i.OK = "OK", i.REJECTED = "REJECTED", i.WASBLOCKED = "WASBLOCKED", i.NOWBLOCKED = "NOWBLOCKED", i.TRANSPORT_PIN = "TRANSPORT_PIN", i))(xw || {});
export {
  ds as AV_Versicherter,
  fr as AbrechnenderKostentraeger,
  fi as AbstractTlsConnection,
  Ko as AccountManagerErrorDetails,
  ps as AllgemeineVersicherungsdaten,
  me as ArrayBufferHelper,
  Tw as AuthenticationService,
  Pi as AuthorInstitution,
  Ri as AuthorPerson,
  Ys as AuthorRole,
  Yc as BackendState,
  Js as CacheService,
  Ie as Card,
  zc as CardPinNotVerifiedDetails,
  wm as CardService,
  Of as CardTerminalService,
  _ as CardType,
  Pe as CertRefEnum,
  us as CertificateService,
  Mn as ChangePinResponse,
  wo as CherryCardTerminalSmcb,
  ja as CherryLogin,
  se as ClassificationCodeScheme,
  oo as ConfidentialityCode,
  Bw as ConfigService,
  Rd as ConnectionStatus,
  Rf as Connector,
  Ws as ConnectorStatus,
  rr as ContentTypeHeader,
  jt as DeviceIdentification,
  co as DocumentClass,
  ao as DocumentFormatCode,
  uo as DocumentTypeCode,
  Pp as EpaFileAndFolderInfo,
  go as EpaFileInfo,
  Ic as EpaFolder,
  M1 as EpaMimeTypeName,
  B1 as EpaService,
  $s as FileAuthor,
  Ot as GeschuetzteVersichertendaten,
  lo as HealthcareFacilityType,
  Ae as HttpHeader,
  xr as HttpResponse,
  Qs as HttpsClient,
  X as JsonSerializer,
  ci as KasClientErrorDetails,
  pc as KiMClient,
  ce as KimClientError,
  pw as KimEncryptedMailInfo,
  ee as KimEvent,
  k as KimLog,
  Zc as KimMail,
  fw as KimMailAttachmentInfo,
  Xu as KimMailInfo,
  Iw as KimService,
  Dw as KimSetupWizard,
  mr as Kostenerstattung,
  oi as Kostentraeger,
  gs as LandType,
  tu as LdapClient,
  Ft as Log,
  Rw as LoginConfirmDeviceRequest,
  Nr as Mail,
  wt as MailAddressHeader,
  Gs as MailAddressValue,
  Ee as MailBodyPart,
  q as MailHeader,
  Te as MailHeaders,
  vt as MimeEncodedWord,
  fs as PV_Versicherter,
  ms as PersoenlicheVersichertendaten,
  Ve as Person,
  xw as PinResult,
  nu as PinStatus,
  uh as Pop3Client,
  Sc as Pop3Mail,
  ch as Pop3Session,
  wr as PostfachAdresse,
  po as PracticeSettingCode,
  $c as Profession,
  yr as Pruefungsnachweis,
  Us as RecipientErrorDetails,
  uw as RecipientsErrorDetails,
  bt as RecordIdentifier,
  js as RegistrationService,
  an as RuhenderLeistungsanspruch,
  cn as Selektivvertraege,
  hh as SmtpClient,
  vc as SmtpSession,
  oh as SocketReader,
  Ow as SrpStep2Request,
  Q as StatusEvent,
  iw as StorageService,
  Rt as StrassenAdresse,
  eh as Ti365,
  Nw as Ti365GatewayClient,
  _u as Ti365KimGatewayClient,
  Ju as Ti365KimStorage,
  Pw as Ti365Session,
  ph as TlsMultiplexedWebSocketConnection,
  Gw as TlsNativeWebSocketProvider,
  gh as TunneledWebSocket,
  jr as VerifyPinResponse,
  rw as VersichertenStammdaten,
  on as Versicherungsschutz,
  Gn as VpnTiStatus,
  Ho as VsdmService,
  Tf as VzdEntry,
  Bc as VzdEntryKomLe,
  Nf as VzdLdapSearchOptions,
  qw as VzdSearchOptions,
  xu as VzdService,
  ai as Zusatzinfos,
  hs as ZusatzinfosAbrechnungGKV,
  ls as ZusatzinfosGKV,
  ws as Zuzahlungsstatus
};
